// Generated by scripts/generate-nba-fixtures.mjs. Do not edit.
export const nbaFeedLabFixture = {
    "schemaVersion": 1,
    "scenarioId": "nba-2026-04-06-2135-et",
    "unitAppearance": {
        "schemaVersion": 1,
        "status": "demonstrator-authority",
        "scope": "rendered-feed-unit-interiors",
        "appearanceMode": "light-only",
        "adaptsToSystemAppearance": false,
        "darkModeTokens": null,
        "notes": [
            "The StoryOS review site uses its own dark visual system around the Prototype and Unit Library.",
            "Rendered feed-unit interiors retain the fixed neutral wireframe palette unless a canonical FeedItemKind declares an exact QA override.",
            "Only urgent-game-update has a dual-appearance contract in the current golden slice; other kinds remain light-only until individually proved."
        ],
        "cssCustomProperties": {
            "--unit-surface-primary": "#f8f8f6",
            "--unit-surface-editorial": "#f1f1ee",
            "--unit-surface-odds": "#f0f0ed",
            "--unit-surface-social": "#e4e4df",
            "--unit-text-primary": "#161616",
            "--unit-text-secondary": "#555552",
            "--unit-text-body-strong": "#3f3f3c",
            "--unit-text-tertiary": "#686866",
            "--unit-text-eyebrow": "#72726f",
            "--unit-border-primary": "#cececa",
            "--unit-border-unit": "#d7d7d3",
            "--unit-border-content": "#d0d0cb",
            "--unit-border-action": "#d3d3cf",
            "--unit-accent-strong": "#242424",
            "--unit-live-indicator": "#d91f2d",
            "--unit-overlay-text": "#ffffff",
            "--unit-overlay-scrim": "#121212"
        },
        "kindQaOverrides": {
            "urgent-game-update": {
                "appearanceModes": [
                    "light",
                    "dark"
                ],
                "darkModeTokens": {
                    "--unit-surface-primary": "#181a1d",
                    "--unit-text-primary": "#f7f7f4",
                    "--unit-text-secondary": "#c7c7c2",
                    "--unit-text-body-strong": "#e6e6e2",
                    "--unit-text-tertiary": "#b8b8b3",
                    "--unit-text-eyebrow": "#c3c3be",
                    "--unit-border-primary": "#51545a",
                    "--unit-border-unit": "#43464b",
                    "--unit-border-content": "#51545a",
                    "--unit-border-action": "#51545a",
                    "--unit-accent-strong": "#f7f7f4",
                    "--unit-live-indicator": "#ff4655"
                }
            }
        }
    },
    "generatedFrom": {
        "model": "research/home-feed/content-design/rich-model.mjs",
        "homeFeed": "research/home-feed/content-design/home-feed-2135-et.json",
        "manifest": "research/home-feed/content-design/fixture-manifest.json",
        "catalogue": "research/home-feed/content-design/feed-units.html",
        "feedItemKinds": "spec/core/feed-item-kinds.json",
        "approvedCopy": "research/home-feed/content-design/approved-fan-copy.json",
        "writingGuidance": "docs/feed-unit-writing-guidance.json",
        "inventory": "research/home-feed/inventory/2026-04-06-production-sample.json",
        "standings": "research/home-feed/content-design/standings-snapshots.json",
        "nbaInsightsCandidateRegister": "research/nba-insights-source-backed-examples/candidate-register.json"
    },
    "anchor": {
        "utc": "2026-04-07T01:35:00Z",
        "local": "2026-04-06 21:35:00 America/New_York",
        "meaning": "review arrival checkpoint, not feed birth",
        "status": "verified",
        "correction": "POR–DEN is Q1 0:00 at the cutoff; the period-end event and Q1 summary arrive at 9:36 p.m. ET.",
        "verificationReceiptIds": [
            "anchor-0022501143",
            "anchor-0022501144",
            "anchor-0022501145",
            "anchor-0022501146",
            "anchor-0022501147"
        ]
    },
    "end": {
        "utc": "2026-04-07T05:30:00Z",
        "meaning": "bounded end-of-night review checkpoint after all five finals and nightly wrap packaging",
        "status": "verified-source-window"
    },
    "articles": [
        {
            "id": "article-nyk-atl-pregame-2026-04-06",
            "gameId": "0022501143",
            "asOfUtc": "2026-04-06T21:30:00Z",
            "headline": "Knicks, Hawks get the first move in the East race",
            "dek": "New York starts Monday one game clear of Cleveland; Atlanta holds a two-game edge over Philadelphia and Toronto.",
            "byline": "NBA Editorial",
            "publishedAtUtc": "2026-04-06T21:30:00Z",
            "serviceLine": "New York Knicks at Atlanta Hawks · 7:00 p.m. ET · State Farm Arena · Peacock",
            "blocks": [
                {
                    "type": "image",
                    "id": "nyk-atl-pregame-arrivals",
                    "aspect": "2:3",
                    "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/96922571-d717-4a20-8ded-8ce543bb2789-getty-2269581088.jpg",
                    "alt": "Jalen Brunson arrives at State Farm Arena before the Knicks face the Hawks.",
                    "caption": "Brunson arrives in Atlanta before Monday’s game.",
                    "credit": "Joe Boatman/NBAE via Getty Images"
                },
                {
                    "type": "paragraph",
                    "text": "New York begins Monday 50–28 and third in the Eastern Conference, one game ahead of Cleveland with the tiebreaker."
                },
                {
                    "type": "paragraph",
                    "text": "Atlanta begins fifth at 45–33, two games ahead of Philadelphia and Toronto. The Hawks own the tiebreaker over Philadelphia but not Toronto."
                },
                {
                    "type": "heading",
                    "text": "Before the chasers tip"
                },
                {
                    "type": "paragraph",
                    "text": "New York and Atlanta start at 7:00 p.m. ET, an hour before Cleveland tips in Memphis and Philadelphia tips in San Antonio. A Knicks win ensures they cannot lose ground to Cleveland on Monday; a Hawks win preserves their two-game cushion over both Philadelphia and Toronto."
                },
                {
                    "type": "heading",
                    "text": "A late addition in Atlanta"
                },
                {
                    "type": "paragraph",
                    "text": "Atlanta signed center Tony Bradley earlier Monday. The Hawks’ release lists 4.1 points and 2.9 rebounds across 37 games with Indiana this season. His role against New York had not been confirmed when this preview was published."
                },
                {
                    "type": "image",
                    "id": "nyk-atl-previous-meeting",
                    "aspect": "3:2",
                    "imageUrl": "https://storypilotstorage.blob.core.windows.net/assets/assets/media-originals/NBA/2025/12/28/13cc00a8-8710-49b6-9601-b3fabf30e468-getty-2252977497.jpg",
                    "alt": "Jalen Brunson attacks the rim during New York’s previous visit to Atlanta.",
                    "caption": "Brunson attacks the rim during New York’s previous trip to Atlanta on Dec. 27.",
                    "credit": "Adam Hagy/NBAE via Getty Images"
                },
                {
                    "type": "paragraph",
                    "text": "Tipoff is scheduled for 7:00 p.m. ET on Peacock."
                }
            ]
        },
        {
            "id": "article-nyk-atl-postgame-2026-04-07",
            "gameId": "0022501143",
            "asOfUtc": "2026-04-07T03:08:09.8884871Z",
            "headline": "Brunson’s fourth quarter lifts New York past Atlanta",
            "dek": "He scores 17 in the fourth as the Knicks survive McCollum’s late answer and a reviewed heave.",
            "byline": "NBA Editorial",
            "publishedAtUtc": "2026-04-07T03:08:09.8884871Z",
            "serviceLine": "New York Knicks 108, Atlanta Hawks 105 · State Farm Arena",
            "blocks": [
                {
                    "type": "image",
                    "id": "nyk-atl-brunson-finish-placeholder",
                    "aspect": "16:9",
                    "alt": "Jalen Brunson drives against Nickeil Alexander-Walker late in New York’s win in Atlanta.",
                    "caption": "Brunson scores 17 in the fourth quarter as New York closes out Atlanta."
                },
                {
                    "type": "paragraph",
                    "text": "Jalen Brunson scored 17 of his 30 points in the fourth quarter, adding 13 assists as New York won 108–105 in Atlanta."
                },
                {
                    "type": "heading",
                    "text": "A finish that kept changing"
                },
                {
                    "type": "paragraph",
                    "text": "Brunson’s step-back put New York ahead with 29 seconds left. CJ McCollum answered, Brunson made two free throws, and McCollum’s final heave was overturned after review."
                },
                {
                    "type": "heading",
                    "text": "New York answers after halftime"
                },
                {
                    "type": "paragraph",
                    "text": "Atlanta closed the first half on a 21–10 run. The Knicks responded with a 17–6 finish to the third quarter, then leaned on Brunson to control the final period."
                },
                {
                    "type": "paragraph",
                    "text": "The win was New York’s third straight and ended Atlanta’s 13-game home winning streak."
                }
            ]
        }
    ],
    "gameScreens": {
        "0022501143": {
            "anchor": {
                "gameId": "0022501143",
                "stateLabel": "Q4 · 1.2",
                "awayCode": "NYK",
                "homeCode": "ATL",
                "periods": [
                    {
                        "label": "Q1",
                        "away": 32,
                        "home": 31
                    },
                    {
                        "label": "Q2",
                        "away": 21,
                        "home": 26
                    },
                    {
                        "label": "Q3",
                        "away": 28,
                        "home": 22
                    },
                    {
                        "label": "Q4",
                        "away": 25,
                        "home": 26
                    }
                ],
                "comparison": [
                    {
                        "label": "Field goals",
                        "away": "42/84 · 50.0%",
                        "home": "38/94 · 40.4%"
                    },
                    {
                        "label": "3-pointers",
                        "away": "11/33 · 33.3%",
                        "home": "16/41 · 39.0%"
                    },
                    {
                        "label": "Free throws",
                        "away": "11/15 · 73.3%",
                        "home": "13/17 · 76.5%"
                    },
                    {
                        "label": "Rebounds",
                        "away": "51",
                        "home": "58"
                    },
                    {
                        "label": "Offensive rebounds",
                        "away": "12",
                        "home": "19"
                    },
                    {
                        "label": "Assists",
                        "away": "29",
                        "home": "23"
                    },
                    {
                        "label": "Turnovers",
                        "away": "17",
                        "home": "15"
                    },
                    {
                        "label": "Points in paint",
                        "away": "52",
                        "home": "34"
                    },
                    {
                        "label": "Fast-break points",
                        "away": "12",
                        "home": "9"
                    },
                    {
                        "label": "Points off turnovers",
                        "away": "21",
                        "home": "15"
                    },
                    {
                        "label": "Blocks",
                        "away": "7",
                        "home": "4"
                    }
                ],
                "awayPlayers": [
                    {
                        "name": "Jalen Brunson",
                        "points": 28,
                        "rebounds": 3,
                        "assists": 13,
                        "fieldGoals": "11/26",
                        "threePointers": "3/8",
                        "freeThrows": "3/5"
                    },
                    {
                        "name": "OG Anunoby",
                        "points": 22,
                        "rebounds": 5,
                        "assists": 1,
                        "fieldGoals": "7/14",
                        "threePointers": "4/10",
                        "freeThrows": "4/4"
                    },
                    {
                        "name": "Karl-Anthony Towns",
                        "points": 21,
                        "rebounds": 12,
                        "assists": 6,
                        "fieldGoals": "9/12",
                        "threePointers": "2/4",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Mikal Bridges",
                        "points": 15,
                        "rebounds": 5,
                        "assists": 2,
                        "fieldGoals": "7/13",
                        "threePointers": "0/2",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Mitchell Robinson",
                        "points": 8,
                        "rebounds": 12,
                        "assists": 1,
                        "fieldGoals": "4/6",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Miles McBride",
                        "points": 6,
                        "rebounds": 2,
                        "assists": 2,
                        "fieldGoals": "2/6",
                        "threePointers": "2/5",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Jordan Clarkson",
                        "points": 3,
                        "rebounds": 2,
                        "assists": 0,
                        "fieldGoals": "1/2",
                        "threePointers": "0/1",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Josh Hart",
                        "points": 2,
                        "rebounds": 5,
                        "assists": 3,
                        "fieldGoals": "1/3",
                        "threePointers": "0/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Landry Shamet",
                        "points": 1,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "0/2",
                        "threePointers": "0/1",
                        "freeThrows": "1/2"
                    }
                ],
                "homePlayers": [
                    {
                        "name": "Nickeil Alexander-Walker",
                        "points": 36,
                        "rebounds": 2,
                        "assists": 3,
                        "fieldGoals": "12/19",
                        "threePointers": "7/11",
                        "freeThrows": "5/5"
                    },
                    {
                        "name": "Jalen Johnson",
                        "points": 21,
                        "rebounds": 11,
                        "assists": 5,
                        "fieldGoals": "8/19",
                        "threePointers": "3/5",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "CJ McCollum",
                        "points": 17,
                        "rebounds": 3,
                        "assists": 6,
                        "fieldGoals": "7/18",
                        "threePointers": "3/7",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Onyeka Okongwu",
                        "points": 12,
                        "rebounds": 8,
                        "assists": 1,
                        "fieldGoals": "4/13",
                        "threePointers": "2/7",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Dyson Daniels",
                        "points": 11,
                        "rebounds": 12,
                        "assists": 3,
                        "fieldGoals": "4/11",
                        "threePointers": "1/3",
                        "freeThrows": "2/4"
                    },
                    {
                        "name": "Jonathan Kuminga",
                        "points": 5,
                        "rebounds": 5,
                        "assists": 2,
                        "fieldGoals": "2/6",
                        "threePointers": "0/4",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Zaccharie Risacher",
                        "points": 3,
                        "rebounds": 2,
                        "assists": 0,
                        "fieldGoals": "1/4",
                        "threePointers": "0/2",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Gabe Vincent",
                        "points": 0,
                        "rebounds": 2,
                        "assists": 3,
                        "fieldGoals": "0/1",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Mouhamed Gueye",
                        "points": 0,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "0/1",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Tony Bradley",
                        "points": 0,
                        "rebounds": 2,
                        "assists": 0,
                        "fieldGoals": "0/2",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    }
                ],
                "shotProfile": [
                    {
                        "label": "At the rim",
                        "awayAttempts": 24,
                        "awayPercentage": "75.0%",
                        "homeAttempts": 26,
                        "homePercentage": "42.3%"
                    },
                    {
                        "label": "Above-break 3",
                        "awayAttempts": 23,
                        "awayPercentage": "34.8%",
                        "homeAttempts": 31,
                        "homePercentage": "41.9%"
                    },
                    {
                        "label": "Other",
                        "awayAttempts": 37,
                        "awayPercentage": "43.2%",
                        "homeAttempts": 37,
                        "homePercentage": "37.8%"
                    }
                ],
                "gameShape": [
                    {
                        "label": "Current run",
                        "value": "NYK 10–2 over the last 3:00"
                    },
                    {
                        "label": "Lead changes",
                        "value": "A one-possession finish"
                    },
                    {
                        "label": "Largest lead",
                        "value": "ATL 10 · NYK 7"
                    },
                    {
                        "label": "Estimated pace",
                        "value": "97.5 possessions"
                    }
                ]
            },
            "end": {
                "gameId": "0022501143",
                "stateLabel": "Final",
                "awayCode": "NYK",
                "homeCode": "ATL",
                "periods": [
                    {
                        "label": "Q1",
                        "away": 32,
                        "home": 31
                    },
                    {
                        "label": "Q2",
                        "away": 21,
                        "home": 26
                    },
                    {
                        "label": "Q3",
                        "away": 28,
                        "home": 22
                    },
                    {
                        "label": "Q4",
                        "away": 27,
                        "home": 26
                    }
                ],
                "comparison": [
                    {
                        "label": "Field goals",
                        "away": "42/84 · 50.0%",
                        "home": "38/95 · 40.0%"
                    },
                    {
                        "label": "3-pointers",
                        "away": "11/33 · 33.3%",
                        "home": "16/42 · 38.1%"
                    },
                    {
                        "label": "Free throws",
                        "away": "13/17 · 76.5%",
                        "home": "13/17 · 76.5%"
                    },
                    {
                        "label": "Rebounds",
                        "away": "51",
                        "home": "58"
                    },
                    {
                        "label": "Offensive rebounds",
                        "away": "12",
                        "home": "19"
                    },
                    {
                        "label": "Assists",
                        "away": "29",
                        "home": "23"
                    },
                    {
                        "label": "Turnovers",
                        "away": "17",
                        "home": "15"
                    },
                    {
                        "label": "Points in paint",
                        "away": "52",
                        "home": "34"
                    },
                    {
                        "label": "Fast-break points",
                        "away": "12",
                        "home": "9"
                    },
                    {
                        "label": "Points off turnovers",
                        "away": "21",
                        "home": "15"
                    },
                    {
                        "label": "Blocks",
                        "away": "7",
                        "home": "4"
                    }
                ],
                "awayPlayers": [
                    {
                        "name": "Jalen Brunson",
                        "points": 30,
                        "rebounds": 3,
                        "assists": 13,
                        "fieldGoals": "11/26",
                        "threePointers": "3/8",
                        "freeThrows": "5/7"
                    },
                    {
                        "name": "OG Anunoby",
                        "points": 22,
                        "rebounds": 5,
                        "assists": 1,
                        "fieldGoals": "7/14",
                        "threePointers": "4/10",
                        "freeThrows": "4/4"
                    },
                    {
                        "name": "Karl-Anthony Towns",
                        "points": 21,
                        "rebounds": 12,
                        "assists": 6,
                        "fieldGoals": "9/12",
                        "threePointers": "2/4",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Mikal Bridges",
                        "points": 15,
                        "rebounds": 5,
                        "assists": 2,
                        "fieldGoals": "7/13",
                        "threePointers": "0/2",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Mitchell Robinson",
                        "points": 8,
                        "rebounds": 12,
                        "assists": 1,
                        "fieldGoals": "4/6",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Miles McBride",
                        "points": 6,
                        "rebounds": 2,
                        "assists": 2,
                        "fieldGoals": "2/6",
                        "threePointers": "2/5",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Jordan Clarkson",
                        "points": 3,
                        "rebounds": 2,
                        "assists": 0,
                        "fieldGoals": "1/2",
                        "threePointers": "0/1",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Josh Hart",
                        "points": 2,
                        "rebounds": 5,
                        "assists": 3,
                        "fieldGoals": "1/3",
                        "threePointers": "0/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Landry Shamet",
                        "points": 1,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "0/2",
                        "threePointers": "0/1",
                        "freeThrows": "1/2"
                    }
                ],
                "homePlayers": [
                    {
                        "name": "Nickeil Alexander-Walker",
                        "points": 36,
                        "rebounds": 2,
                        "assists": 3,
                        "fieldGoals": "12/19",
                        "threePointers": "7/11",
                        "freeThrows": "5/5"
                    },
                    {
                        "name": "Jalen Johnson",
                        "points": 21,
                        "rebounds": 11,
                        "assists": 5,
                        "fieldGoals": "8/19",
                        "threePointers": "3/5",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "CJ McCollum",
                        "points": 17,
                        "rebounds": 3,
                        "assists": 6,
                        "fieldGoals": "7/19",
                        "threePointers": "3/8",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Onyeka Okongwu",
                        "points": 12,
                        "rebounds": 8,
                        "assists": 1,
                        "fieldGoals": "4/13",
                        "threePointers": "2/7",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Dyson Daniels",
                        "points": 11,
                        "rebounds": 12,
                        "assists": 3,
                        "fieldGoals": "4/11",
                        "threePointers": "1/3",
                        "freeThrows": "2/4"
                    },
                    {
                        "name": "Jonathan Kuminga",
                        "points": 5,
                        "rebounds": 5,
                        "assists": 2,
                        "fieldGoals": "2/6",
                        "threePointers": "0/4",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Zaccharie Risacher",
                        "points": 3,
                        "rebounds": 2,
                        "assists": 0,
                        "fieldGoals": "1/4",
                        "threePointers": "0/2",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Gabe Vincent",
                        "points": 0,
                        "rebounds": 2,
                        "assists": 3,
                        "fieldGoals": "0/1",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Mouhamed Gueye",
                        "points": 0,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "0/1",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Tony Bradley",
                        "points": 0,
                        "rebounds": 2,
                        "assists": 0,
                        "fieldGoals": "0/2",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    }
                ],
                "shotProfile": [
                    {
                        "label": "At the rim",
                        "awayAttempts": 24,
                        "awayPercentage": "75.0%",
                        "homeAttempts": 26,
                        "homePercentage": "42.3%"
                    },
                    {
                        "label": "Above-break 3",
                        "awayAttempts": 23,
                        "awayPercentage": "34.8%",
                        "homeAttempts": 32,
                        "homePercentage": "40.6%"
                    },
                    {
                        "label": "Other",
                        "awayAttempts": 37,
                        "awayPercentage": "43.2%",
                        "homeAttempts": 37,
                        "homePercentage": "37.8%"
                    }
                ],
                "gameShape": [
                    {
                        "label": "Decisive stretch",
                        "value": "NYK 10–2 over the final 3:00"
                    },
                    {
                        "label": "Fourth-quarter scorer",
                        "value": "Brunson · 17 points"
                    },
                    {
                        "label": "Largest lead",
                        "value": "ATL 10 · NYK 7"
                    },
                    {
                        "label": "Estimated pace",
                        "value": "97.5 possessions"
                    }
                ]
            }
        },
        "0022501147": {
            "anchor": {
                "gameId": "0022501147",
                "stateLabel": "Q1 · 0:00",
                "periodEndObserved": false,
                "awayCode": "POR",
                "homeCode": "DEN",
                "periods": [
                    {
                        "label": "Q1",
                        "away": 35,
                        "home": 31
                    }
                ],
                "comparison": [
                    {
                        "label": "Field goals",
                        "away": "11/25 · 44.0%",
                        "home": "14/27 · 51.9%"
                    },
                    {
                        "label": "3-pointers",
                        "away": "9/17 · 52.9%",
                        "home": "1/7 · 14.3%"
                    },
                    {
                        "label": "Free throws",
                        "away": "4/4 · 100%",
                        "home": "2/2 · 100%"
                    },
                    {
                        "label": "Rebounds",
                        "away": "13",
                        "home": "11"
                    },
                    {
                        "label": "Offensive rebounds",
                        "away": "5",
                        "home": "5"
                    },
                    {
                        "label": "Assists",
                        "away": "8",
                        "home": "8"
                    },
                    {
                        "label": "Turnovers",
                        "away": "5",
                        "home": "3"
                    },
                    {
                        "label": "Steals",
                        "away": "2",
                        "home": "4"
                    },
                    {
                        "label": "Blocks",
                        "away": "1",
                        "home": "1"
                    }
                ],
                "awayPlayers": [
                    {
                        "name": "Toumani Camara",
                        "points": 12,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "4/5",
                        "threePointers": "4/4",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Matisse Thybulle",
                        "points": 9,
                        "rebounds": 0,
                        "assists": 1,
                        "fieldGoals": "3/3",
                        "threePointers": "3/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Donovan Clingan",
                        "points": 5,
                        "rebounds": 5,
                        "assists": 0,
                        "fieldGoals": "1/4",
                        "threePointers": "1/3",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Deni Avdija",
                        "points": 4,
                        "rebounds": 1,
                        "assists": 4,
                        "fieldGoals": "1/4",
                        "threePointers": "0/2",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Scoot Henderson",
                        "points": 3,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "1/3",
                        "threePointers": "1/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Robert Williams III",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "1/1",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Jrue Holiday",
                        "points": 0,
                        "rebounds": 3,
                        "assists": 2,
                        "fieldGoals": "0/5",
                        "threePointers": "0/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Kris Murray",
                        "points": 0,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "0/0",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Sidy Cissoko",
                        "points": 0,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "0/0",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    }
                ],
                "homePlayers": [
                    {
                        "name": "Nikola Jokić",
                        "points": 12,
                        "rebounds": 6,
                        "assists": 4,
                        "fieldGoals": "6/10",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Cameron Johnson",
                        "points": 6,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "3/5",
                        "threePointers": "0/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Aaron Gordon",
                        "points": 5,
                        "rebounds": 3,
                        "assists": 2,
                        "fieldGoals": "2/5",
                        "threePointers": "1/4",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Christian Braun",
                        "points": 4,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "2/2",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Jamal Murray",
                        "points": 2,
                        "rebounds": 0,
                        "assists": 1,
                        "fieldGoals": "1/2",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Bruce Brown",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "0/2",
                        "threePointers": "0/1",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Tim Hardaway Jr.",
                        "points": 0,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "0/1",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Julian Strawther",
                        "points": 0,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "0/0",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    }
                ],
                "shotProfile": [
                    {
                        "label": "3-point shots",
                        "awayAttempts": 17,
                        "awayPercentage": "52.9%",
                        "homeAttempts": 7,
                        "homePercentage": "14.3%"
                    },
                    {
                        "label": "2-point shots",
                        "awayAttempts": 8,
                        "awayPercentage": "25.0%",
                        "homeAttempts": 20,
                        "homePercentage": "65.0%"
                    },
                    {
                        "label": "Free throws",
                        "awayAttempts": 4,
                        "awayPercentage": "100%",
                        "homeAttempts": 2,
                        "homePercentage": "100%"
                    }
                ],
                "gameShape": [
                    {
                        "label": "Three-point swing",
                        "value": "POR 9 makes · DEN 1"
                    },
                    {
                        "label": "Hot hands",
                        "value": "Camara 4/4 · Thybulle 3/3 from three"
                    },
                    {
                        "label": "Largest lead",
                        "value": "Portland · 8 points"
                    },
                    {
                        "label": "Live state",
                        "value": "Q1 0:00 · period end pending"
                    }
                ]
            },
            "end": {
                "gameId": "0022501147",
                "stateLabel": "Final/OT",
                "awayCode": "POR",
                "homeCode": "DEN",
                "periods": [
                    {
                        "label": "Q1",
                        "away": 35,
                        "home": 31
                    },
                    {
                        "label": "Q2",
                        "away": 37,
                        "home": 27
                    },
                    {
                        "label": "Q3",
                        "away": 29,
                        "home": 29
                    },
                    {
                        "label": "Q4",
                        "away": 24,
                        "home": 38
                    },
                    {
                        "label": "OT",
                        "away": 7,
                        "home": 12
                    }
                ],
                "comparison": [
                    {
                        "label": "Field goals",
                        "away": "42/89 · 47.2%",
                        "home": "52/101 · 51.5%"
                    },
                    {
                        "label": "3-pointers",
                        "away": "25/52 · 48.1%",
                        "home": "12/38 · 31.6%"
                    },
                    {
                        "label": "Free throws",
                        "away": "23/28 · 82.1%",
                        "home": "21/24 · 87.5%"
                    },
                    {
                        "label": "Rebounds",
                        "away": "50",
                        "home": "55"
                    },
                    {
                        "label": "Offensive rebounds",
                        "away": "11",
                        "home": "17"
                    },
                    {
                        "label": "Assists",
                        "away": "29",
                        "home": "37"
                    },
                    {
                        "label": "Turnovers",
                        "away": "18",
                        "home": "12"
                    },
                    {
                        "label": "Points in paint",
                        "away": "32",
                        "home": "66"
                    },
                    {
                        "label": "Fast-break points",
                        "away": "18",
                        "home": "13"
                    },
                    {
                        "label": "Points off turnovers",
                        "away": "16",
                        "home": "20"
                    },
                    {
                        "label": "Blocks",
                        "away": "5",
                        "home": "5"
                    }
                ],
                "awayPlayers": [
                    {
                        "name": "Toumani Camara",
                        "points": 30,
                        "rebounds": 5,
                        "assists": 0,
                        "fieldGoals": "10/16",
                        "threePointers": "8/13",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Deni Avdija",
                        "points": 26,
                        "rebounds": 4,
                        "assists": 7,
                        "fieldGoals": "6/15",
                        "threePointers": "1/6",
                        "freeThrows": "13/14"
                    },
                    {
                        "name": "Jrue Holiday",
                        "points": 19,
                        "rebounds": 6,
                        "assists": 11,
                        "fieldGoals": "7/19",
                        "threePointers": "5/12",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Scoot Henderson",
                        "points": 18,
                        "rebounds": 3,
                        "assists": 3,
                        "fieldGoals": "6/14",
                        "threePointers": "4/8",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Donovan Clingan",
                        "points": 18,
                        "rebounds": 12,
                        "assists": 0,
                        "fieldGoals": "6/13",
                        "threePointers": "3/6",
                        "freeThrows": "3/4"
                    },
                    {
                        "name": "Matisse Thybulle",
                        "points": 14,
                        "rebounds": 1,
                        "assists": 3,
                        "fieldGoals": "5/7",
                        "threePointers": "4/6",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Robert Williams III",
                        "points": 6,
                        "rebounds": 6,
                        "assists": 3,
                        "fieldGoals": "2/4",
                        "threePointers": "0/0",
                        "freeThrows": "2/4"
                    },
                    {
                        "name": "Kris Murray",
                        "points": 1,
                        "rebounds": 1,
                        "assists": 2,
                        "fieldGoals": "0/0",
                        "threePointers": "0/0",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Sidy Cissoko",
                        "points": 0,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "0/1",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    }
                ],
                "homePlayers": [
                    {
                        "name": "Nikola Jokić",
                        "points": 35,
                        "rebounds": 14,
                        "assists": 13,
                        "fieldGoals": "15/31",
                        "threePointers": "1/5",
                        "freeThrows": "4/4"
                    },
                    {
                        "name": "Aaron Gordon",
                        "points": 23,
                        "rebounds": 9,
                        "assists": 5,
                        "fieldGoals": "8/14",
                        "threePointers": "4/9",
                        "freeThrows": "3/4"
                    },
                    {
                        "name": "Jamal Murray",
                        "points": 20,
                        "rebounds": 1,
                        "assists": 7,
                        "fieldGoals": "7/15",
                        "threePointers": "3/7",
                        "freeThrows": "3/3"
                    },
                    {
                        "name": "Cameron Johnson",
                        "points": 17,
                        "rebounds": 6,
                        "assists": 7,
                        "fieldGoals": "6/9",
                        "threePointers": "1/3",
                        "freeThrows": "4/5"
                    },
                    {
                        "name": "Jonas Valančiūnas",
                        "points": 14,
                        "rebounds": 3,
                        "assists": 1,
                        "fieldGoals": "6/7",
                        "threePointers": "1/2",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Julian Strawther",
                        "points": 11,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "4/5",
                        "threePointers": "1/2",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Christian Braun",
                        "points": 8,
                        "rebounds": 6,
                        "assists": 1,
                        "fieldGoals": "4/7",
                        "threePointers": "0/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Bruce Brown",
                        "points": 6,
                        "rebounds": 5,
                        "assists": 2,
                        "fieldGoals": "1/6",
                        "threePointers": "0/2",
                        "freeThrows": "4/4"
                    },
                    {
                        "name": "Tim Hardaway Jr.",
                        "points": 3,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "1/7",
                        "threePointers": "1/5",
                        "freeThrows": "0/0"
                    }
                ],
                "shotProfile": [
                    {
                        "label": "At the rim",
                        "awayAttempts": 20,
                        "awayPercentage": "55.0%",
                        "homeAttempts": 30,
                        "homePercentage": "73.3%"
                    },
                    {
                        "label": "Above-break 3",
                        "awayAttempts": 43,
                        "awayPercentage": "48.8%",
                        "homeAttempts": 31,
                        "homePercentage": "32.3%"
                    },
                    {
                        "label": "Other",
                        "awayAttempts": 26,
                        "awayPercentage": "38.5%",
                        "homeAttempts": 40,
                        "homePercentage": "50.0%"
                    }
                ],
                "gameShape": [
                    {
                        "label": "Regulation close",
                        "value": "DEN wins Q4 38–24"
                    },
                    {
                        "label": "Overtime",
                        "value": "DEN 12–7"
                    },
                    {
                        "label": "Largest lead",
                        "value": "POR 18 · DEN 7"
                    },
                    {
                        "label": "Estimated pace",
                        "value": "107.4 possessions"
                    }
                ]
            }
        },
        "0022501144": {
            "anchor": {
                "gameId": "0022501144",
                "stateLabel": "Q4 · 55.2",
                "awayCode": "DET",
                "homeCode": "ORL",
                "periods": [
                    {
                        "label": "Q1",
                        "away": 28,
                        "home": 30
                    },
                    {
                        "label": "Q2",
                        "away": 27,
                        "home": 39
                    },
                    {
                        "label": "Q3",
                        "away": 21,
                        "home": 29
                    },
                    {
                        "label": "Q4",
                        "away": 31,
                        "home": 25
                    }
                ],
                "comparison": [
                    {
                        "label": "Field goals",
                        "away": "42/85 · 49.4%",
                        "home": "41/79 · 51.9%"
                    },
                    {
                        "label": "3-pointers",
                        "away": "10/30 · 33.3%",
                        "home": "11/25 · 44.0%"
                    },
                    {
                        "label": "Free throws",
                        "away": "13/19 · 68.4%",
                        "home": "30/40 · 75.0%"
                    },
                    {
                        "label": "Rebounds",
                        "away": "35",
                        "home": "35"
                    },
                    {
                        "label": "Offensive rebounds",
                        "away": "8",
                        "home": "6"
                    },
                    {
                        "label": "Assists",
                        "away": "32",
                        "home": "28"
                    },
                    {
                        "label": "Turnovers",
                        "away": "19",
                        "home": "14"
                    },
                    {
                        "label": "Blocks",
                        "away": "6",
                        "home": "9"
                    }
                ],
                "awayPlayers": [
                    {
                        "name": "Jalen Duren",
                        "points": 18,
                        "rebounds": 9,
                        "assists": 4,
                        "fieldGoals": "7/9",
                        "threePointers": "0/0",
                        "freeThrows": "4/7"
                    },
                    {
                        "name": "Daniss Jenkins",
                        "points": 18,
                        "rebounds": 2,
                        "assists": 7,
                        "fieldGoals": "6/11",
                        "threePointers": "1/3",
                        "freeThrows": "5/5"
                    },
                    {
                        "name": "Javonte Green",
                        "points": 17,
                        "rebounds": 6,
                        "assists": 2,
                        "fieldGoals": "6/13",
                        "threePointers": "3/8",
                        "freeThrows": "2/3"
                    },
                    {
                        "name": "Kevin Huerter",
                        "points": 17,
                        "rebounds": 3,
                        "assists": 5,
                        "fieldGoals": "7/14",
                        "threePointers": "3/7",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Paul Reed",
                        "points": 9,
                        "rebounds": 6,
                        "assists": 2,
                        "fieldGoals": "4/7",
                        "threePointers": "1/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Ausar Thompson",
                        "points": 8,
                        "rebounds": 3,
                        "assists": 6,
                        "fieldGoals": "4/5",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Tolu Smith",
                        "points": 8,
                        "rebounds": 3,
                        "assists": 1,
                        "fieldGoals": "3/5",
                        "threePointers": "0/0",
                        "freeThrows": "2/4"
                    },
                    {
                        "name": "Marcus Sasser",
                        "points": 5,
                        "rebounds": 2,
                        "assists": 4,
                        "fieldGoals": "2/8",
                        "threePointers": "1/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Ronald Holland II",
                        "points": 5,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "2/6",
                        "threePointers": "1/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Chaz Lanier",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "1/7",
                        "threePointers": "0/4",
                        "freeThrows": "0/0"
                    }
                ],
                "homePlayers": [
                    {
                        "name": "Paolo Banchero",
                        "points": 31,
                        "rebounds": 5,
                        "assists": 3,
                        "fieldGoals": "10/16",
                        "threePointers": "1/2",
                        "freeThrows": "10/10"
                    },
                    {
                        "name": "Desmond Bane",
                        "points": 25,
                        "rebounds": 3,
                        "assists": 1,
                        "fieldGoals": "9/17",
                        "threePointers": "4/7",
                        "freeThrows": "3/5"
                    },
                    {
                        "name": "Anthony Black",
                        "points": 14,
                        "rebounds": 1,
                        "assists": 2,
                        "fieldGoals": "4/11",
                        "threePointers": "1/4",
                        "freeThrows": "5/7"
                    },
                    {
                        "name": "Jalen Suggs",
                        "points": 12,
                        "rebounds": 6,
                        "assists": 12,
                        "fieldGoals": "4/9",
                        "threePointers": "2/3",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Tristan da Silva",
                        "points": 12,
                        "rebounds": 4,
                        "assists": 1,
                        "fieldGoals": "5/10",
                        "threePointers": "1/4",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Wendell Carter Jr.",
                        "points": 12,
                        "rebounds": 3,
                        "assists": 3,
                        "fieldGoals": "2/4",
                        "threePointers": "1/2",
                        "freeThrows": "7/8"
                    },
                    {
                        "name": "Goga Bitadze",
                        "points": 9,
                        "rebounds": 4,
                        "assists": 1,
                        "fieldGoals": "4/6",
                        "threePointers": "0/0",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Jamal Cain",
                        "points": 3,
                        "rebounds": 2,
                        "assists": 1,
                        "fieldGoals": "1/1",
                        "threePointers": "1/1",
                        "freeThrows": "0/2"
                    },
                    {
                        "name": "Jase Richardson",
                        "points": 3,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "1/1",
                        "threePointers": "0/0",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Moritz Wagner",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "1/1",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Jevon Carter",
                        "points": 0,
                        "rebounds": 4,
                        "assists": 3,
                        "fieldGoals": "0/3",
                        "threePointers": "0/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Colin Castleton",
                        "points": 0,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "0/0",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    }
                ],
                "shotProfile": [
                    {
                        "label": "At rim · 0–5 FT",
                        "awayAttempts": 37,
                        "awayPercentage": "73.0%",
                        "homeAttempts": 37,
                        "homePercentage": "62.2%"
                    },
                    {
                        "label": "2PT beyond 5 FT",
                        "awayAttempts": 18,
                        "awayPercentage": "27.8%",
                        "homeAttempts": 17,
                        "homePercentage": "41.2%"
                    },
                    {
                        "label": "3-pointers",
                        "awayAttempts": 30,
                        "awayPercentage": "33.3%",
                        "homeAttempts": 25,
                        "homePercentage": "44.0%"
                    }
                ],
                "gameShape": [
                    {
                        "label": "Orlando's peak",
                        "value": "26-point lead"
                    },
                    {
                        "label": "Detroit's push",
                        "value": "26→3 before an 8–0 answer"
                    },
                    {
                        "label": "Ball pressure",
                        "value": "19 DET turnovers"
                    }
                ]
            },
            "end": {
                "gameId": "0022501144",
                "stateLabel": "FINAL",
                "awayCode": "DET",
                "homeCode": "ORL",
                "periods": [
                    {
                        "label": "Q1",
                        "away": 28,
                        "home": 30
                    },
                    {
                        "label": "Q2",
                        "away": 27,
                        "home": 39
                    },
                    {
                        "label": "Q3",
                        "away": 21,
                        "home": 29
                    },
                    {
                        "label": "Q4",
                        "away": 31,
                        "home": 25
                    }
                ],
                "comparison": [
                    {
                        "label": "Field goals",
                        "away": "42/85 · 49.4%",
                        "home": "41/81 · 50.6%"
                    },
                    {
                        "label": "3-pointers",
                        "away": "10/30 · 33.3%",
                        "home": "11/26 · 42.3%"
                    },
                    {
                        "label": "Free throws",
                        "away": "13/19 · 68.4%",
                        "home": "30/40 · 75.0%"
                    },
                    {
                        "label": "Rebounds",
                        "away": "35",
                        "home": "35"
                    },
                    {
                        "label": "Offensive rebounds",
                        "away": "8",
                        "home": "6"
                    },
                    {
                        "label": "Assists",
                        "away": "32",
                        "home": "28"
                    },
                    {
                        "label": "Turnovers",
                        "away": "19",
                        "home": "14"
                    },
                    {
                        "label": "Blocks",
                        "away": "7",
                        "home": "9"
                    }
                ],
                "awayPlayers": [
                    {
                        "name": "Jalen Duren",
                        "points": 18,
                        "rebounds": 9,
                        "assists": 4,
                        "fieldGoals": "7/9",
                        "threePointers": "0/0",
                        "freeThrows": "4/7"
                    },
                    {
                        "name": "Daniss Jenkins",
                        "points": 18,
                        "rebounds": 2,
                        "assists": 7,
                        "fieldGoals": "6/11",
                        "threePointers": "1/3",
                        "freeThrows": "5/5"
                    },
                    {
                        "name": "Javonte Green",
                        "points": 17,
                        "rebounds": 6,
                        "assists": 2,
                        "fieldGoals": "6/13",
                        "threePointers": "3/8",
                        "freeThrows": "2/3"
                    },
                    {
                        "name": "Kevin Huerter",
                        "points": 17,
                        "rebounds": 3,
                        "assists": 5,
                        "fieldGoals": "7/14",
                        "threePointers": "3/7",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Paul Reed",
                        "points": 9,
                        "rebounds": 6,
                        "assists": 2,
                        "fieldGoals": "4/7",
                        "threePointers": "1/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Ausar Thompson",
                        "points": 8,
                        "rebounds": 3,
                        "assists": 6,
                        "fieldGoals": "4/5",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Tolu Smith",
                        "points": 8,
                        "rebounds": 3,
                        "assists": 1,
                        "fieldGoals": "3/5",
                        "threePointers": "0/0",
                        "freeThrows": "2/4"
                    },
                    {
                        "name": "Marcus Sasser",
                        "points": 5,
                        "rebounds": 2,
                        "assists": 4,
                        "fieldGoals": "2/8",
                        "threePointers": "1/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Ronald Holland II",
                        "points": 5,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "2/6",
                        "threePointers": "1/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Chaz Lanier",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "1/7",
                        "threePointers": "0/4",
                        "freeThrows": "0/0"
                    }
                ],
                "homePlayers": [
                    {
                        "name": "Paolo Banchero",
                        "points": 31,
                        "rebounds": 5,
                        "assists": 3,
                        "fieldGoals": "10/16",
                        "threePointers": "1/2",
                        "freeThrows": "10/10"
                    },
                    {
                        "name": "Desmond Bane",
                        "points": 25,
                        "rebounds": 3,
                        "assists": 1,
                        "fieldGoals": "9/17",
                        "threePointers": "4/7",
                        "freeThrows": "3/5"
                    },
                    {
                        "name": "Anthony Black",
                        "points": 14,
                        "rebounds": 1,
                        "assists": 2,
                        "fieldGoals": "4/11",
                        "threePointers": "1/4",
                        "freeThrows": "5/7"
                    },
                    {
                        "name": "Jalen Suggs",
                        "points": 12,
                        "rebounds": 6,
                        "assists": 12,
                        "fieldGoals": "4/9",
                        "threePointers": "2/3",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Tristan da Silva",
                        "points": 12,
                        "rebounds": 4,
                        "assists": 1,
                        "fieldGoals": "5/10",
                        "threePointers": "1/4",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Wendell Carter Jr.",
                        "points": 12,
                        "rebounds": 3,
                        "assists": 3,
                        "fieldGoals": "2/4",
                        "threePointers": "1/2",
                        "freeThrows": "7/8"
                    },
                    {
                        "name": "Goga Bitadze",
                        "points": 9,
                        "rebounds": 4,
                        "assists": 1,
                        "fieldGoals": "4/6",
                        "threePointers": "0/0",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Jamal Cain",
                        "points": 3,
                        "rebounds": 2,
                        "assists": 1,
                        "fieldGoals": "1/1",
                        "threePointers": "1/1",
                        "freeThrows": "0/2"
                    },
                    {
                        "name": "Jase Richardson",
                        "points": 3,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "1/1",
                        "threePointers": "0/0",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Moritz Wagner",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "1/1",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Jevon Carter",
                        "points": 0,
                        "rebounds": 4,
                        "assists": 3,
                        "fieldGoals": "0/3",
                        "threePointers": "0/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Colin Castleton",
                        "points": 0,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "0/0",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Alex Morales",
                        "points": 0,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "0/1",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Noah Penda",
                        "points": 0,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "0/1",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    }
                ],
                "shotProfile": [
                    {
                        "label": "At rim · 0–5 FT",
                        "awayAttempts": 37,
                        "awayPercentage": "73.0%",
                        "homeAttempts": 38,
                        "homePercentage": "60.5%"
                    },
                    {
                        "label": "2PT beyond 5 FT",
                        "awayAttempts": 18,
                        "awayPercentage": "27.8%",
                        "homeAttempts": 17,
                        "homePercentage": "41.2%"
                    },
                    {
                        "label": "3-pointers",
                        "awayAttempts": 30,
                        "awayPercentage": "33.3%",
                        "homeAttempts": 26,
                        "homePercentage": "42.3%"
                    }
                ],
                "gameShape": [
                    {
                        "label": "Paolo Banchero",
                        "value": "31 PTS"
                    },
                    {
                        "label": "Jalen Suggs",
                        "value": "12 AST"
                    },
                    {
                        "label": "Orlando control",
                        "value": "+16"
                    }
                ]
            }
        },
        "0022501145": {
            "anchor": {
                "gameId": "0022501145",
                "stateLabel": "Q3 · 4:49",
                "awayCode": "CLE",
                "homeCode": "MEM",
                "periods": [
                    {
                        "label": "Q1",
                        "away": 24,
                        "home": 36
                    },
                    {
                        "label": "Q2",
                        "away": 44,
                        "home": 28
                    },
                    {
                        "label": "Q3",
                        "away": 21,
                        "home": 13
                    }
                ],
                "comparison": [
                    {
                        "label": "Field goals",
                        "away": "33/63 · 52.4%",
                        "home": "28/62 · 45.2%"
                    },
                    {
                        "label": "3-pointers",
                        "away": "8/23 · 34.8%",
                        "home": "16/36 · 44.4%"
                    },
                    {
                        "label": "Free throws",
                        "away": "15/16 · 93.8%",
                        "home": "5/8 · 62.5%"
                    },
                    {
                        "label": "Rebounds",
                        "away": "36",
                        "home": "23"
                    },
                    {
                        "label": "Offensive rebounds",
                        "away": "9",
                        "home": "5"
                    },
                    {
                        "label": "Assists",
                        "away": "22",
                        "home": "22"
                    },
                    {
                        "label": "Turnovers",
                        "away": "7",
                        "home": "8"
                    },
                    {
                        "label": "Blocks",
                        "away": "4",
                        "home": "3"
                    }
                ],
                "awayPlayers": [
                    {
                        "name": "Dennis Schröder",
                        "points": 17,
                        "rebounds": 4,
                        "assists": 9,
                        "fieldGoals": "6/10",
                        "threePointers": "1/2",
                        "freeThrows": "4/4"
                    },
                    {
                        "name": "Keon Ellis",
                        "points": 16,
                        "rebounds": 2,
                        "assists": 5,
                        "fieldGoals": "6/10",
                        "threePointers": "3/5",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Evan Mobley",
                        "points": 14,
                        "rebounds": 5,
                        "assists": 3,
                        "fieldGoals": "5/7",
                        "threePointers": "1/2",
                        "freeThrows": "3/4"
                    },
                    {
                        "name": "Sam Merrill",
                        "points": 11,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "3/10",
                        "threePointers": "2/7",
                        "freeThrows": "3/3"
                    },
                    {
                        "name": "Jarrett Allen",
                        "points": 9,
                        "rebounds": 9,
                        "assists": 1,
                        "fieldGoals": "4/6",
                        "threePointers": "0/0",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Craig Porter Jr.",
                        "points": 9,
                        "rebounds": 2,
                        "assists": 2,
                        "fieldGoals": "4/7",
                        "threePointers": "1/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Larry Nance Jr.",
                        "points": 6,
                        "rebounds": 3,
                        "assists": 0,
                        "fieldGoals": "3/5",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Nae'Qwan Tomlin",
                        "points": 5,
                        "rebounds": 8,
                        "assists": 0,
                        "fieldGoals": "2/5",
                        "threePointers": "0/1",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Tyrese Proctor",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 1,
                        "fieldGoals": "0/3",
                        "threePointers": "0/2",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Tristan Enaruna",
                        "points": 0,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "0/0",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    }
                ],
                "homePlayers": [
                    {
                        "name": "Dariq Whitehead",
                        "points": 17,
                        "rebounds": 2,
                        "assists": 1,
                        "fieldGoals": "6/13",
                        "threePointers": "5/10",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Olivier-Maxence Prosper",
                        "points": 13,
                        "rebounds": 3,
                        "assists": 0,
                        "fieldGoals": "6/7",
                        "threePointers": "1/2",
                        "freeThrows": "0/1"
                    },
                    {
                        "name": "Cedric Coward",
                        "points": 12,
                        "rebounds": 3,
                        "assists": 2,
                        "fieldGoals": "5/6",
                        "threePointers": "2/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "GG Jackson",
                        "points": 11,
                        "rebounds": 4,
                        "assists": 3,
                        "fieldGoals": "3/7",
                        "threePointers": "1/2",
                        "freeThrows": "4/4"
                    },
                    {
                        "name": "Cam Spencer",
                        "points": 9,
                        "rebounds": 1,
                        "assists": 6,
                        "fieldGoals": "3/4",
                        "threePointers": "2/2",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Lucas Williamson",
                        "points": 6,
                        "rebounds": 4,
                        "assists": 2,
                        "fieldGoals": "2/7",
                        "threePointers": "2/5",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Adama Bal",
                        "points": 3,
                        "rebounds": 4,
                        "assists": 0,
                        "fieldGoals": "1/7",
                        "threePointers": "1/5",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Walter Clayton Jr.",
                        "points": 3,
                        "rebounds": 1,
                        "assists": 8,
                        "fieldGoals": "1/6",
                        "threePointers": "1/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Toby Okani",
                        "points": 3,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "1/5",
                        "threePointers": "1/4",
                        "freeThrows": "0/2"
                    }
                ],
                "shotProfile": [
                    {
                        "label": "At rim · 0–5 FT",
                        "awayAttempts": 28,
                        "awayPercentage": "67.9%",
                        "homeAttempts": 16,
                        "homePercentage": "37.5%"
                    },
                    {
                        "label": "2PT beyond 5 FT",
                        "awayAttempts": 12,
                        "awayPercentage": "50.0%",
                        "homeAttempts": 10,
                        "homePercentage": "60.0%"
                    },
                    {
                        "label": "3-pointers",
                        "awayAttempts": 23,
                        "awayPercentage": "34.8%",
                        "homeAttempts": 36,
                        "homePercentage": "44.4%"
                    }
                ],
                "gameShape": [
                    {
                        "label": "First-quarter barrage",
                        "value": "MEM 10 threes"
                    },
                    {
                        "label": "Cleveland's answer",
                        "value": "31–12 run"
                    },
                    {
                        "label": "Score swing",
                        "value": "17 down→12 up"
                    }
                ]
            },
            "end": {
                "gameId": "0022501145",
                "stateLabel": "FINAL",
                "awayCode": "CLE",
                "homeCode": "MEM",
                "periods": [
                    {
                        "label": "Q1",
                        "away": 24,
                        "home": 36
                    },
                    {
                        "label": "Q2",
                        "away": 44,
                        "home": 28
                    },
                    {
                        "label": "Q3",
                        "away": 33,
                        "home": 26
                    },
                    {
                        "label": "Q4",
                        "away": 41,
                        "home": 36
                    }
                ],
                "comparison": [
                    {
                        "label": "Field goals",
                        "away": "52/89 · 58.4%",
                        "home": "45/94 · 47.9%"
                    },
                    {
                        "label": "3-pointers",
                        "away": "12/32 · 37.5%",
                        "home": "29/59 · 49.2%"
                    },
                    {
                        "label": "Free throws",
                        "away": "26/37 · 70.3%",
                        "home": "7/10 · 70.0%"
                    },
                    {
                        "label": "Rebounds",
                        "away": "48",
                        "home": "31"
                    },
                    {
                        "label": "Offensive rebounds",
                        "away": "13",
                        "home": "8"
                    },
                    {
                        "label": "Assists",
                        "away": "36",
                        "home": "32"
                    },
                    {
                        "label": "Turnovers",
                        "away": "12",
                        "home": "13"
                    },
                    {
                        "label": "Blocks",
                        "away": "5",
                        "home": "4"
                    }
                ],
                "awayPlayers": [
                    {
                        "name": "Evan Mobley",
                        "points": 24,
                        "rebounds": 6,
                        "assists": 4,
                        "fieldGoals": "9/11",
                        "threePointers": "1/2",
                        "freeThrows": "5/8"
                    },
                    {
                        "name": "Dennis Schröder",
                        "points": 22,
                        "rebounds": 5,
                        "assists": 11,
                        "fieldGoals": "8/12",
                        "threePointers": "1/2",
                        "freeThrows": "5/6"
                    },
                    {
                        "name": "Sam Merrill",
                        "points": 21,
                        "rebounds": 2,
                        "assists": 2,
                        "fieldGoals": "7/16",
                        "threePointers": "4/11",
                        "freeThrows": "3/4"
                    },
                    {
                        "name": "Keon Ellis",
                        "points": 19,
                        "rebounds": 3,
                        "assists": 8,
                        "fieldGoals": "7/11",
                        "threePointers": "3/5",
                        "freeThrows": "2/3"
                    },
                    {
                        "name": "Jarrett Allen",
                        "points": 13,
                        "rebounds": 9,
                        "assists": 1,
                        "fieldGoals": "5/7",
                        "threePointers": "0/0",
                        "freeThrows": "3/5"
                    },
                    {
                        "name": "Craig Porter Jr.",
                        "points": 11,
                        "rebounds": 8,
                        "assists": 6,
                        "fieldGoals": "4/7",
                        "threePointers": "1/3",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Nae'Qwan Tomlin",
                        "points": 10,
                        "rebounds": 9,
                        "assists": 2,
                        "fieldGoals": "4/7",
                        "threePointers": "1/2",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Larry Nance Jr.",
                        "points": 10,
                        "rebounds": 3,
                        "assists": 1,
                        "fieldGoals": "5/8",
                        "threePointers": "0/2",
                        "freeThrows": "0/2"
                    },
                    {
                        "name": "Tyrese Proctor",
                        "points": 10,
                        "rebounds": 2,
                        "assists": 1,
                        "fieldGoals": "2/8",
                        "threePointers": "1/4",
                        "freeThrows": "5/6"
                    },
                    {
                        "name": "Tristan Enaruna",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "1/2",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    }
                ],
                "homePlayers": [
                    {
                        "name": "Olivier-Maxence Prosper",
                        "points": 24,
                        "rebounds": 3,
                        "assists": 0,
                        "fieldGoals": "10/12",
                        "threePointers": "4/5",
                        "freeThrows": "0/1"
                    },
                    {
                        "name": "Adama Bal",
                        "points": 20,
                        "rebounds": 6,
                        "assists": 0,
                        "fieldGoals": "7/14",
                        "threePointers": "6/11",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Dariq Whitehead",
                        "points": 20,
                        "rebounds": 3,
                        "assists": 1,
                        "fieldGoals": "7/15",
                        "threePointers": "6/12",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Lucas Williamson",
                        "points": 17,
                        "rebounds": 5,
                        "assists": 4,
                        "fieldGoals": "5/15",
                        "threePointers": "5/12",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Cedric Coward",
                        "points": 12,
                        "rebounds": 5,
                        "assists": 3,
                        "fieldGoals": "5/6",
                        "threePointers": "2/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "GG Jackson",
                        "points": 11,
                        "rebounds": 5,
                        "assists": 3,
                        "fieldGoals": "3/9",
                        "threePointers": "1/3",
                        "freeThrows": "4/4"
                    },
                    {
                        "name": "Walter Clayton Jr.",
                        "points": 10,
                        "rebounds": 1,
                        "assists": 11,
                        "fieldGoals": "4/10",
                        "threePointers": "2/5",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Cam Spencer",
                        "points": 9,
                        "rebounds": 1,
                        "assists": 9,
                        "fieldGoals": "3/5",
                        "threePointers": "2/3",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Toby Okani",
                        "points": 3,
                        "rebounds": 2,
                        "assists": 1,
                        "fieldGoals": "1/8",
                        "threePointers": "1/5",
                        "freeThrows": "0/2"
                    }
                ],
                "shotProfile": [
                    {
                        "label": "At rim · 0–5 FT",
                        "awayAttempts": 41,
                        "awayPercentage": "75.6%",
                        "homeAttempts": 22,
                        "homePercentage": "45.5%"
                    },
                    {
                        "label": "2PT beyond 5 FT",
                        "awayAttempts": 16,
                        "awayPercentage": "56.3%",
                        "homeAttempts": 13,
                        "homePercentage": "46.2%"
                    },
                    {
                        "label": "3-pointers",
                        "awayAttempts": 32,
                        "awayPercentage": "37.5%",
                        "homeAttempts": 59,
                        "homePercentage": "49.2%"
                    }
                ],
                "gameShape": [
                    {
                        "label": "Record volume",
                        "value": "MEM 29 threes"
                    },
                    {
                        "label": "Cleveland response",
                        "value": "142 points · 50th win"
                    },
                    {
                        "label": "Dennis Schröder",
                        "value": "22 PTS · 11 AST"
                    }
                ]
            }
        },
        "0022501146": {
            "anchor": {
                "gameId": "0022501146",
                "stateLabel": "Q3 · 8:17",
                "awayCode": "PHI",
                "homeCode": "SAS",
                "periods": [
                    {
                        "label": "Q1",
                        "away": 28,
                        "home": 29
                    },
                    {
                        "label": "Q2",
                        "away": 27,
                        "home": 33
                    },
                    {
                        "label": "Q3",
                        "away": 10,
                        "home": 12
                    }
                ],
                "comparison": [
                    {
                        "label": "Field goals",
                        "away": "21/48 · 43.8%",
                        "home": "30/56 · 53.6%"
                    },
                    {
                        "label": "3-pointers",
                        "away": "8/19 · 42.1%",
                        "home": "7/18 · 38.9%"
                    },
                    {
                        "label": "Free throws",
                        "away": "15/19 · 78.9%",
                        "home": "7/10 · 70.0%"
                    },
                    {
                        "label": "Rebounds",
                        "away": "24",
                        "home": "28"
                    },
                    {
                        "label": "Offensive rebounds",
                        "away": "7",
                        "home": "6"
                    },
                    {
                        "label": "Assists",
                        "away": "12",
                        "home": "23"
                    },
                    {
                        "label": "Turnovers",
                        "away": "9",
                        "home": "6"
                    },
                    {
                        "label": "Blocks",
                        "away": "3",
                        "home": "3"
                    }
                ],
                "awayPlayers": [
                    {
                        "name": "Joel Embiid",
                        "points": 25,
                        "rebounds": 8,
                        "assists": 1,
                        "fieldGoals": "8/15",
                        "threePointers": "2/5",
                        "freeThrows": "7/9"
                    },
                    {
                        "name": "Paul George",
                        "points": 16,
                        "rebounds": 2,
                        "assists": 2,
                        "fieldGoals": "5/11",
                        "threePointers": "4/5",
                        "freeThrows": "2/4"
                    },
                    {
                        "name": "VJ Edgecombe",
                        "points": 7,
                        "rebounds": 4,
                        "assists": 2,
                        "fieldGoals": "3/6",
                        "threePointers": "1/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Kelly Oubre Jr.",
                        "points": 5,
                        "rebounds": 5,
                        "assists": 0,
                        "fieldGoals": "2/4",
                        "threePointers": "0/1",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Quentin Grimes",
                        "points": 3,
                        "rebounds": 2,
                        "assists": 0,
                        "fieldGoals": "1/3",
                        "threePointers": "1/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Andre Drummond",
                        "points": 3,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "1/2",
                        "threePointers": "0/0",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Tyrese Maxey",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 7,
                        "fieldGoals": "0/5",
                        "threePointers": "0/2",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Dominick Barlow",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "0/0",
                        "threePointers": "0/0",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Justin Edwards",
                        "points": 2,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "1/2",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    }
                ],
                "homePlayers": [
                    {
                        "name": "Victor Wembanyama",
                        "points": 17,
                        "rebounds": 5,
                        "assists": 1,
                        "fieldGoals": "7/11",
                        "threePointers": "1/3",
                        "freeThrows": "2/4"
                    },
                    {
                        "name": "De'Aaron Fox",
                        "points": 11,
                        "rebounds": 0,
                        "assists": 3,
                        "fieldGoals": "5/8",
                        "threePointers": "1/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Stephon Castle",
                        "points": 10,
                        "rebounds": 7,
                        "assists": 8,
                        "fieldGoals": "3/7",
                        "threePointers": "0/1",
                        "freeThrows": "4/4"
                    },
                    {
                        "name": "Dylan Harper",
                        "points": 9,
                        "rebounds": 2,
                        "assists": 3,
                        "fieldGoals": "4/7",
                        "threePointers": "1/1",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Devin Vassell",
                        "points": 7,
                        "rebounds": 2,
                        "assists": 4,
                        "fieldGoals": "3/6",
                        "threePointers": "1/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Keldon Johnson",
                        "points": 6,
                        "rebounds": 5,
                        "assists": 1,
                        "fieldGoals": "2/6",
                        "threePointers": "1/2",
                        "freeThrows": "1/2"
                    },
                    {
                        "name": "Julian Champagnie",
                        "points": 5,
                        "rebounds": 4,
                        "assists": 2,
                        "fieldGoals": "2/4",
                        "threePointers": "1/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Luke Kornet",
                        "points": 4,
                        "rebounds": 2,
                        "assists": 0,
                        "fieldGoals": "2/3",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Lindy Waters III",
                        "points": 3,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "1/2",
                        "threePointers": "1/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Harrison Barnes",
                        "points": 2,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "1/2",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Carter Bryant",
                        "points": 0,
                        "rebounds": 0,
                        "assists": 1,
                        "fieldGoals": "0/0",
                        "threePointers": "0/0",
                        "freeThrows": "0/0"
                    }
                ],
                "shotProfile": [
                    {
                        "label": "At rim · 0–5 FT",
                        "awayAttempts": 13,
                        "awayPercentage": "76.9%",
                        "homeAttempts": 26,
                        "homePercentage": "65.4%"
                    },
                    {
                        "label": "2PT beyond 5 FT",
                        "awayAttempts": 16,
                        "awayPercentage": "18.8%",
                        "homeAttempts": 12,
                        "homePercentage": "50.0%"
                    },
                    {
                        "label": "3-pointers",
                        "awayAttempts": 19,
                        "awayPercentage": "42.1%",
                        "homeAttempts": 18,
                        "homePercentage": "38.9%"
                    }
                ],
                "gameShape": [
                    {
                        "label": "Star duel",
                        "value": "Embiid 25 · Wembanyama 17"
                    },
                    {
                        "label": "Playmaking",
                        "value": "Castle 8 AST"
                    },
                    {
                        "label": "Rim protection",
                        "value": "PHI 3 · SAS 3 blocks"
                    }
                ]
            },
            "end": {
                "gameId": "0022501146",
                "stateLabel": "FINAL",
                "awayCode": "PHI",
                "homeCode": "SAS",
                "periods": [
                    {
                        "label": "Q1",
                        "away": 28,
                        "home": 29
                    },
                    {
                        "label": "Q2",
                        "away": 27,
                        "home": 33
                    },
                    {
                        "label": "Q3",
                        "away": 30,
                        "home": 30
                    },
                    {
                        "label": "Q4",
                        "away": 17,
                        "home": 23
                    }
                ],
                "comparison": [
                    {
                        "label": "Field goals",
                        "away": "34/88 · 38.6%",
                        "home": "44/89 · 49.4%"
                    },
                    {
                        "label": "3-pointers",
                        "away": "10/31 · 32.3%",
                        "home": "11/32 · 34.4%"
                    },
                    {
                        "label": "Free throws",
                        "away": "24/29 · 82.8%",
                        "home": "16/22 · 72.7%"
                    },
                    {
                        "label": "Rebounds",
                        "away": "48",
                        "home": "47"
                    },
                    {
                        "label": "Offensive rebounds",
                        "away": "17",
                        "home": "9"
                    },
                    {
                        "label": "Assists",
                        "away": "17",
                        "home": "31"
                    },
                    {
                        "label": "Turnovers",
                        "away": "11",
                        "home": "9"
                    },
                    {
                        "label": "Blocks",
                        "away": "5",
                        "home": "5"
                    }
                ],
                "awayPlayers": [
                    {
                        "name": "Joel Embiid",
                        "points": 34,
                        "rebounds": 12,
                        "assists": 1,
                        "fieldGoals": "8/19",
                        "threePointers": "2/6",
                        "freeThrows": "16/19"
                    },
                    {
                        "name": "Paul George",
                        "points": 16,
                        "rebounds": 4,
                        "assists": 4,
                        "fieldGoals": "5/15",
                        "threePointers": "4/5",
                        "freeThrows": "2/4"
                    },
                    {
                        "name": "Tyrese Maxey",
                        "points": 15,
                        "rebounds": 3,
                        "assists": 8,
                        "fieldGoals": "6/16",
                        "threePointers": "1/4",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "VJ Edgecombe",
                        "points": 14,
                        "rebounds": 8,
                        "assists": 3,
                        "fieldGoals": "6/15",
                        "threePointers": "2/7",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Dominick Barlow",
                        "points": 6,
                        "rebounds": 8,
                        "assists": 0,
                        "fieldGoals": "2/3",
                        "threePointers": "0/0",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Kelly Oubre Jr.",
                        "points": 5,
                        "rebounds": 8,
                        "assists": 0,
                        "fieldGoals": "2/7",
                        "threePointers": "0/3",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Andre Drummond",
                        "points": 5,
                        "rebounds": 3,
                        "assists": 1,
                        "fieldGoals": "2/4",
                        "threePointers": "0/1",
                        "freeThrows": "1/1"
                    },
                    {
                        "name": "Quentin Grimes",
                        "points": 5,
                        "rebounds": 2,
                        "assists": 0,
                        "fieldGoals": "2/7",
                        "threePointers": "1/4",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Justin Edwards",
                        "points": 2,
                        "rebounds": 0,
                        "assists": 0,
                        "fieldGoals": "1/2",
                        "threePointers": "0/1",
                        "freeThrows": "0/0"
                    }
                ],
                "homePlayers": [
                    {
                        "name": "Stephon Castle",
                        "points": 19,
                        "rebounds": 10,
                        "assists": 13,
                        "fieldGoals": "6/13",
                        "threePointers": "1/2",
                        "freeThrows": "6/6"
                    },
                    {
                        "name": "Victor Wembanyama",
                        "points": 17,
                        "rebounds": 5,
                        "assists": 1,
                        "fieldGoals": "7/11",
                        "threePointers": "1/3",
                        "freeThrows": "2/4"
                    },
                    {
                        "name": "Dylan Harper",
                        "points": 17,
                        "rebounds": 3,
                        "assists": 4,
                        "fieldGoals": "7/11",
                        "threePointers": "3/3",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Keldon Johnson",
                        "points": 13,
                        "rebounds": 9,
                        "assists": 1,
                        "fieldGoals": "4/14",
                        "threePointers": "1/5",
                        "freeThrows": "4/6"
                    },
                    {
                        "name": "De'Aaron Fox",
                        "points": 13,
                        "rebounds": 0,
                        "assists": 4,
                        "fieldGoals": "6/12",
                        "threePointers": "1/5",
                        "freeThrows": "0/2"
                    },
                    {
                        "name": "Luke Kornet",
                        "points": 10,
                        "rebounds": 3,
                        "assists": 1,
                        "fieldGoals": "4/6",
                        "threePointers": "0/0",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Devin Vassell",
                        "points": 9,
                        "rebounds": 4,
                        "assists": 4,
                        "fieldGoals": "4/9",
                        "threePointers": "1/4",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Julian Champagnie",
                        "points": 7,
                        "rebounds": 9,
                        "assists": 2,
                        "fieldGoals": "3/6",
                        "threePointers": "1/4",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Carter Bryant",
                        "points": 5,
                        "rebounds": 2,
                        "assists": 1,
                        "fieldGoals": "1/2",
                        "threePointers": "1/2",
                        "freeThrows": "2/2"
                    },
                    {
                        "name": "Lindy Waters III",
                        "points": 3,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "1/2",
                        "threePointers": "1/2",
                        "freeThrows": "0/0"
                    },
                    {
                        "name": "Harrison Barnes",
                        "points": 2,
                        "rebounds": 1,
                        "assists": 0,
                        "fieldGoals": "1/3",
                        "threePointers": "0/2",
                        "freeThrows": "0/0"
                    }
                ],
                "shotProfile": [
                    {
                        "label": "At rim · 0–5 FT",
                        "awayAttempts": 31,
                        "awayPercentage": "54.8%",
                        "homeAttempts": 37,
                        "homePercentage": "67.6%"
                    },
                    {
                        "label": "2PT beyond 5 FT",
                        "awayAttempts": 26,
                        "awayPercentage": "26.9%",
                        "homeAttempts": 20,
                        "homePercentage": "40.0%"
                    },
                    {
                        "label": "3-pointers",
                        "awayAttempts": 31,
                        "awayPercentage": "32.3%",
                        "homeAttempts": 32,
                        "homePercentage": "34.4%"
                    }
                ],
                "gameShape": [
                    {
                        "label": "Stephon Castle",
                        "value": "19 PTS · 10 REB · 13 AST"
                    },
                    {
                        "label": "Joel Embiid",
                        "value": "34 PTS · 12 REB"
                    },
                    {
                        "label": "San Antonio control",
                        "value": "+13"
                    }
                ]
            }
        }
    },
    "watchScenarios": {
        "0022501143": {
            "scenarioId": "nyk-atl-external-peacock",
            "viewerContext": "NBA-app user with no in-app Peacock playback",
            "access": "broadcast-only",
            "primaryBroadcaster": "Peacock",
            "presentation": "external-action",
            "basis": "Official broadcaster truth belongs to the game; access remains external to this demonstrator."
        },
        "0022501147": {
            "scenarioId": "0022501147-us-out-of-market",
            "viewerContext": "US demonstrator viewer outside both teams' local markets",
            "basis": "The official schedule has no national broadcaster. Under the NBA's 2025-26 policy, an entitled viewer outside the local markets can watch live on League Pass.",
            "variants": {
                "league-pass": {
                    "access": "league-pass",
                    "presentation": "mounted-player"
                },
                "league-pass-signed-out": {
                    "access": "league-pass-signed-out",
                    "presentation": "sign-in-action"
                },
                "league-pass-unentitled": {
                    "access": "league-pass-unentitled",
                    "presentation": "subscription-action"
                }
            }
        },
        "0022501144": {
            "scenarioId": "0022501144-us-out-of-market",
            "viewerContext": "US demonstrator viewer outside both teams' local markets",
            "basis": "The official schedule has no national broadcaster. Under the NBA's 2025-26 policy, an entitled viewer outside the local markets can watch live on League Pass.",
            "variants": {
                "league-pass": {
                    "access": "league-pass",
                    "presentation": "mounted-player"
                },
                "league-pass-signed-out": {
                    "access": "league-pass-signed-out",
                    "presentation": "sign-in-action"
                },
                "league-pass-unentitled": {
                    "access": "league-pass-unentitled",
                    "presentation": "subscription-action"
                }
            }
        },
        "0022501145": {
            "scenarioId": "0022501145-us-out-of-market",
            "viewerContext": "US demonstrator viewer outside both teams' local markets",
            "basis": "The official schedule has no national broadcaster. Under the NBA's 2025-26 policy, an entitled viewer outside the local markets can watch live on League Pass.",
            "variants": {
                "league-pass": {
                    "access": "league-pass",
                    "presentation": "mounted-player"
                },
                "league-pass-signed-out": {
                    "access": "league-pass-signed-out",
                    "presentation": "sign-in-action"
                },
                "league-pass-unentitled": {
                    "access": "league-pass-unentitled",
                    "presentation": "subscription-action"
                }
            }
        },
        "0022501146": {
            "scenarioId": "0022501146-us-out-of-market",
            "viewerContext": "US demonstrator viewer outside both teams' local markets",
            "basis": "The official schedule has no national broadcaster. Under the NBA's 2025-26 policy, an entitled viewer outside the local markets can watch live on League Pass.",
            "variants": {
                "league-pass": {
                    "access": "league-pass",
                    "presentation": "mounted-player"
                },
                "league-pass-signed-out": {
                    "access": "league-pass-signed-out",
                    "presentation": "sign-in-action"
                },
                "league-pass-unentitled": {
                    "access": "league-pass-unentitled",
                    "presentation": "subscription-action"
                }
            }
        }
    },
    "games": [
        {
            "id": "0022501143",
            "short": "NYK @ ATL",
            "matchup": "New York Knicks at Atlanta Hawks",
            "tipoff": "7:00 p.m. ET",
            "anchor": "NYK 106–105 ATL · Q4 · 1.2",
            "final": "NYK 108–105 ATL · FINAL",
            "storyTitle": "Knicks Win Thriller In Atlanta",
            "away": {
                "code": "NYK",
                "name": "Knicks",
                "record": "50–28",
                "finalRecord": "51–28"
            },
            "home": {
                "code": "ATL",
                "name": "Hawks",
                "record": "45–33",
                "finalRecord": "45–34"
            },
            "venue": "State Farm Arena",
            "location": "Atlanta, GA",
            "broadcasters": [
                "Peacock",
                "NBC Sports Network",
                "Gotham"
            ],
            "nationalBroadcasters": [
                "Peacock",
                "NBC Sports Network"
            ],
            "role": "Immediate live priority",
            "question": "Can New York survive the final 1.2 seconds?"
        },
        {
            "id": "0022501144",
            "short": "DET @ ORL",
            "matchup": "Detroit Pistons at Orlando Magic",
            "tipoff": "7:00 p.m. ET",
            "anchor": "DET 107–123 ORL · Q4 · 55.2",
            "final": "DET 107–123 ORL · FINAL",
            "storyTitle": "Magic Beat Pistons Behind Banchero",
            "away": {
                "code": "DET",
                "name": "Pistons",
                "record": "57–21",
                "finalRecord": "57–22"
            },
            "home": {
                "code": "ORL",
                "name": "Magic",
                "record": "42–36",
                "finalRecord": "43–36"
            },
            "venue": "Kia Center",
            "location": "Orlando, FL",
            "broadcasters": [
                "FanDuel Sports Network – Detroit",
                "FanDuel Sports Network – Florida"
            ],
            "nationalBroadcasters": [],
            "role": "Near-final compression",
            "question": "How did Orlando turn pressure into control?"
        },
        {
            "id": "0022501145",
            "short": "CLE @ MEM",
            "matchup": "Cleveland Cavaliers at Memphis Grizzlies",
            "tipoff": "8:00 p.m. ET",
            "anchor": "CLE 89–77 MEM · Q3 · 4:49",
            "final": "CLE 142–126 MEM · FINAL",
            "storyTitle": "Cavaliers Rally Past Grizzlies",
            "away": {
                "code": "CLE",
                "name": "Cavaliers",
                "record": "49–29",
                "finalRecord": "50–29"
            },
            "home": {
                "code": "MEM",
                "name": "Grizzlies",
                "record": "25–53",
                "finalRecord": "25–54"
            },
            "venue": "FedExForum",
            "location": "Memphis, TN",
            "broadcasters": [
                "FanDuel Sports Network – Ohio",
                "FanDuel Sports Network – Southeast – Memphis"
            ],
            "nationalBroadcasters": [],
            "role": "Comeback, then record collision",
            "question": "Can Memphis’ three-point volume overcome Cleveland’s response?"
        },
        {
            "id": "0022501146",
            "short": "PHI @ SAS",
            "matchup": "Philadelphia 76ers at San Antonio Spurs",
            "tipoff": "8:00 p.m. ET",
            "anchor": "PHI 65–74 SAS · Q3 · 8:17",
            "final": "PHI 102–115 SAS · FINAL",
            "storyTitle": "Spurs Handle 76ers",
            "away": {
                "code": "PHI",
                "name": "76ers",
                "record": "43–35",
                "finalRecord": "43–36"
            },
            "home": {
                "code": "SAS",
                "name": "Spurs",
                "record": "59–19",
                "finalRecord": "60–19"
            },
            "venue": "Frost Bank Center",
            "location": "San Antonio, TX",
            "broadcasters": [
                "NBC Sports Philadelphia",
                "FanDuel Sports Network – Southwest"
            ],
            "nationalBroadcasters": [],
            "role": "Star matchup becomes a playmaking story",
            "question": "Can Philadelphia close the gap, and who drives San Antonio after halftime?"
        },
        {
            "id": "0022501147",
            "short": "POR @ DEN",
            "matchup": "Portland Trail Blazers at Denver Nuggets",
            "tipoff": "9:00 p.m. ET",
            "anchor": "POR 35–31 DEN · Q1 · 0:00",
            "final": "POR 132–137 DEN · FINAL/OT",
            "storyTitle": "Nuggets Storm Back vs. Blazers",
            "away": {
                "code": "POR",
                "name": "Trail Blazers",
                "record": "40–38",
                "finalRecord": "40–39"
            },
            "home": {
                "code": "DEN",
                "name": "Nuggets",
                "record": "50–28",
                "finalRecord": "51–28"
            },
            "venue": "Ball Arena",
            "location": "Denver, CO",
            "broadcasters": [
                "KUNP",
                "ALT/KTVD",
                "BlazerVision"
            ],
            "nationalBroadcasters": [],
            "role": "Emerging game that becomes the late-night epic",
            "question": "Will Portland’s hot shooting hold up?"
        }
    ],
    "feedBehavior": {
        "availableAtAnchor": 50,
        "availableAfterFinals": 97,
        "newlyAvailableAfterAnchor": 47,
        "olderItemsRemainReachable": true,
        "pagination": {
            "mode": "opaque-cursor",
            "initialPageSize": 12,
            "olderPageSize": 12,
            "prefetchThresholdViewports": 2,
            "accessibleLoadMore": true
        },
        "newItems": {
            "delivery": "automatic",
            "whenAtTop": "insert-and-reveal",
            "whenAwayFromTop": "stage-preserve-anchor-and-show-count",
            "affordanceAction": "integrate-and-scroll-to-top"
        },
        "refresh": {
            "pullToRefresh": true,
            "role": "manual-newer-cursor-fallback"
        },
        "scroll": {
            "preserveAnchorOnPrepend": true,
            "restoreOnReturn": true
        }
    },
    "home": {
        "storiesTray": {
            "anchor": [
                {
                    "id": "stories-nyk-atl-live",
                    "label": "NYK–ATL",
                    "monogram": "NYK",
                    "thumbnail": {
                        "primary": "NYK",
                        "secondary": "ATL"
                    },
                    "status": "LIVE · Q4",
                    "state": "unseen",
                    "destination": {
                        "type": "story-snapshot",
                        "id": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9@2026-04-07T01:35:00Z"
                    }
                },
                {
                    "id": "stories-det-orl-live",
                    "label": "DET–ORL",
                    "monogram": "ORL",
                    "thumbnail": {
                        "primary": "DET",
                        "secondary": "ORL"
                    },
                    "status": "LIVE · Q4",
                    "state": "updated",
                    "destination": {
                        "type": "story-snapshot",
                        "id": "4981dbb8-56e8-cc0d-387b-3a20500cb3eb@2026-04-07T01:35:00Z"
                    }
                },
                {
                    "id": "stories-cle-mem-live",
                    "label": "CLE–MEM",
                    "monogram": "CLE",
                    "thumbnail": {
                        "primary": "CLE",
                        "secondary": "MEM"
                    },
                    "status": "LIVE · Q3",
                    "state": "unseen",
                    "destination": {
                        "type": "story-snapshot",
                        "id": "9edf2454-015f-28a7-9247-3a20500cae6e@2026-04-07T01:35:00Z"
                    }
                },
                {
                    "id": "stories-phi-sas-live",
                    "label": "PHI–SAS",
                    "monogram": "SAS",
                    "thumbnail": {
                        "primary": "PHI",
                        "secondary": "SAS"
                    },
                    "status": "LIVE · Q3",
                    "state": "updated",
                    "destination": {
                        "type": "story-snapshot",
                        "id": "8bc8d022-f0af-662b-3761-3a20500ca56c@2026-04-07T01:35:00Z"
                    }
                },
                {
                    "id": "stories-phi-sas-access",
                    "label": "All Access",
                    "monogram": "AA",
                    "thumbnail": {
                        "primary": "PHI",
                        "secondary": "SAS"
                    },
                    "status": "PHI–SAS",
                    "state": "unseen",
                    "destination": {
                        "type": "story-snapshot",
                        "id": "4701c6e4-c661-46e7-234b-3a2073da5482@2026-04-07T01:35:00Z"
                    }
                },
                {
                    "id": "stories-por-den-live",
                    "label": "POR–DEN",
                    "monogram": "DEN",
                    "thumbnail": {
                        "primary": "POR",
                        "secondary": "DEN"
                    },
                    "status": "LIVE · Q1",
                    "state": "unseen",
                    "destination": {
                        "type": "game-screen",
                        "id": "0022501147"
                    }
                }
            ],
            "end": [
                {
                    "id": "stories-por-den-final",
                    "label": "POR–DEN",
                    "monogram": "DEN",
                    "thumbnail": {
                        "primary": "POR",
                        "secondary": "DEN"
                    },
                    "status": "FINAL · OT",
                    "state": "unseen",
                    "destination": {
                        "type": "story",
                        "id": "38ec1b86-4776-291b-ccf2-3a20500cbfe9"
                    }
                },
                {
                    "id": "stories-phi-sas-final",
                    "label": "PHI–SAS",
                    "monogram": "SAS",
                    "thumbnail": {
                        "primary": "PHI",
                        "secondary": "SAS"
                    },
                    "status": "FINAL",
                    "state": "unseen",
                    "destination": {
                        "type": "story",
                        "id": "8bc8d022-f0af-662b-3761-3a20500ca56c"
                    }
                },
                {
                    "id": "stories-cle-mem-final",
                    "label": "CLE–MEM",
                    "monogram": "CLE",
                    "thumbnail": {
                        "primary": "CLE",
                        "secondary": "MEM"
                    },
                    "status": "FINAL",
                    "state": "updated",
                    "destination": {
                        "type": "story",
                        "id": "9edf2454-015f-28a7-9247-3a20500cae6e"
                    }
                },
                {
                    "id": "stories-det-orl-final",
                    "label": "DET–ORL",
                    "monogram": "ORL",
                    "thumbnail": {
                        "primary": "DET",
                        "secondary": "ORL"
                    },
                    "status": "FINAL",
                    "state": "seen",
                    "destination": {
                        "type": "story",
                        "id": "4981dbb8-56e8-cc0d-387b-3a20500cb3eb"
                    }
                },
                {
                    "id": "stories-nyk-atl-final",
                    "label": "NYK–ATL",
                    "monogram": "NYK",
                    "thumbnail": {
                        "primary": "NYK",
                        "secondary": "ATL"
                    },
                    "status": "FINAL",
                    "state": "seen",
                    "destination": {
                        "type": "story",
                        "id": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9"
                    }
                },
                {
                    "id": "stories-phi-sas-access",
                    "label": "All Access",
                    "monogram": "AA",
                    "thumbnail": {
                        "primary": "PHI",
                        "secondary": "SAS"
                    },
                    "status": "PHI–SAS",
                    "state": "seen",
                    "destination": {
                        "type": "story-snapshot",
                        "id": "4701c6e4-c661-46e7-234b-3a2073da5482@2026-04-07T01:35:00Z"
                    }
                }
            ]
        },
        "anchor": {
            "label": "Arrival · 9:35 p.m. ET",
            "total": 50,
            "pages": [
                [
                    {
                        "kind": "live-event-status",
                        "id": "nyk-atl-live-anchor",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "nyk-atl-live-anchor",
                            "unitType": "live",
                            "eyebrow": null,
                            "headline": "Atlanta has one possession.",
                            "dek": "Anunoby made both after the review; McCollum answered from three. Brunson is headed to the line with 1.2 seconds left.",
                            "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "nyk-atl-brunson-bucket-clip",
                        "availableAtUtc": "2026-04-07T01:32:23.8500897Z",
                        "display": {
                            "id": "nyk-atl-brunson-bucket-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Brunson’s step-back puts New York ahead.",
                            "dek": "He creates room and knocks down the 18-footer with 29 seconds left.",
                            "scoreLockup": "NYK 104–102 ATL · Q4 · 0:29",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": 42,
                                "shares": 12
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "a2ab872c-313e-149e-b249-3a2077be939c",
                                "gameId": "0022501143"
                            },
                            "accessibleName": "Open Brunson’s step-back puts New York ahead. in the full-screen player"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-robinson-hustle-source",
                        "availableAtUtc": "2026-04-07T01:27:11Z",
                        "occurredAtUtc": "2026-04-07T01:11:52Z",
                        "display": {
                            "id": "nyk-atl-robinson-hustle-source",
                            "unitType": "source-video",
                            "eyebrow": null,
                            "headline": "Robinson does the dirty work at both ends.",
                            "dek": "He blocks a three, then wins two offensive rebounds and tips in the tying basket.",
                            "scoreLockup": "NYK 91–91 ATL · Q4 · 5:28",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869708573119115243/vid_1_thumb.jpg",
                                "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869708573119115243/vid_1.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "story-snapshot",
                        "id": "nyk-atl-live-story-snapshot",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "nyk-atl-live-story-snapshot",
                            "unitType": "story-slice",
                            "eyebrow": "FOLLOW LIVE",
                            "headline": "The whole night from inside State Farm Arena.",
                            "dek": "Go from New York’s arrival to the final possession, with every big play in between.",
                            "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                            "action": "Follow live",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story-snapshot",
                                "id": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9@2026-04-07T01:35:00Z",
                                "gameId": "0022501143"
                            },
                            "accessibleName": "Open The whole night from inside State Farm Arena."
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-jalen-johnson-poster-source",
                        "availableAtUtc": "2026-04-07T01:02:42Z",
                        "occurredAtUtc": "2026-04-07T00:39:02Z",
                        "display": {
                            "id": "nyk-atl-jalen-johnson-poster-source",
                            "unitType": "source-video",
                            "eyebrow": null,
                            "headline": "Jalen Johnson detonates at the rim.",
                            "dek": "The driving dunk gives Atlanta a 10-point lead midway through the third.",
                            "scoreLockup": "NYK 61–71 ATL · Q3 · 6:44",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869696247502280917/vid_1_thumb.jpg",
                                "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869696247502280917/vid_1.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "phi-sas-wemby-dunk-clip",
                        "availableAtUtc": "2026-04-07T01:05:23.7892618Z",
                        "display": {
                            "id": "phi-sas-wemby-dunk-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Vassell lifts it. Wembanyama finishes with two hands.",
                            "dek": "The alley-oop puts San Antonio ahead with 4:50 left in the half.",
                            "scoreLockup": "PHI 49–51 SAS · Q2 · 4:50",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "95e60eee-ffd2-6f06-d30b-3a2077a5da3a",
                                "gameId": "0022501146"
                            },
                            "accessibleName": "Open Vassell lifts it. Wembanyama finishes with two hands. in the full-screen player"
                        }
                    },
                    {
                        "kind": "live-event-status",
                        "id": "det-orl-live-anchor",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "det-orl-live-anchor",
                            "unitType": "live",
                            "eyebrow": null,
                            "headline": "Orlando has stopped Detroit’s comeback.",
                            "dek": "The Magic answer a rally that cut their lead to three and restore a 16-point cushion.",
                            "scoreLockup": "DET 107–123 ORL · Q4 · 55.2",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "id": "cle-mem-mobley-dunk-clip",
                        "availableAtUtc": "2026-04-07T01:32:16.3529053Z",
                        "display": {
                            "id": "cle-mem-mobley-dunk-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Mobley hammers home Cleveland’s comeback.",
                            "dek": "The alley-oop gives Cleveland a six-point lead after it trailed by 17.",
                            "scoreLockup": "CLE 80–74 MEM · Q3 · 8:08",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "e78d99a8-52e4-a2a2-e739-3a2077be75d0",
                                "gameId": "0022501145"
                            },
                            "accessibleName": "Open Mobley hammers home Cleveland’s comeback. in the full-screen player"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "por-den-camara-three-clip",
                        "availableAtUtc": "2026-04-07T01:32:27.3778765Z",
                        "display": {
                            "id": "por-den-camara-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Camara starts 4-for-4 from deep.",
                            "dek": "His fourth make gives him 12 points before the quarter is over.",
                            "scoreLockup": "POR 30–23 DEN · Q1 · 3:24",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "5445169b-f7b6-e3d0-6792-3a2077bea035",
                                "gameId": "0022501147"
                            },
                            "accessibleName": "Open Camara starts 4-for-4 from deep. in the full-screen player"
                        }
                    },
                    {
                        "kind": "captioned-image",
                        "id": "por-den-camara-live-photo",
                        "availableAtUtc": "2026-04-07T01:32:28.9981794Z",
                        "display": {
                            "id": "por-den-camara-live-photo",
                            "unitType": "source-image",
                            "eyebrow": "FIRST QUARTER",
                            "headline": "Camara has Denver scrambling.",
                            "dek": "Four threes in less than nine minutes turn Portland’s fast start into an immediate problem for Denver.",
                            "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "image",
                                "aspect": "wide"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "nyk-atl-naw-three-clip",
                        "availableAtUtc": "2026-04-07T01:26:02.4211074Z",
                        "display": {
                            "id": "nyk-atl-naw-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "NAW splashes the three in a frantic fourth.",
                            "dek": "His seventh make from deep keeps Atlanta in front late.",
                            "scoreLockup": "NYK 95–100 ATL · Q4 · 3:15",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "3760a47f-6aac-9545-4895-3a2077b8bfd8",
                                "gameId": "0022501143"
                            },
                            "accessibleName": "Open NAW splashes the three in a frantic fourth. in the full-screen player"
                        }
                    },
                    {
                        "kind": "live-scoreboard",
                        "id": "night-live-five",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "night-live-five",
                            "unitType": "scoreboard",
                            "eyebrow": "NBA TONIGHT",
                            "headline": "Five games live",
                            "dek": "New York leads Atlanta by one with 1.2 seconds left.",
                            "scoreLockup": null,
                            "action": "View games",
                            "games": [
                                {
                                    "gameId": "0022501143",
                                    "state": "Q4 · 1.2",
                                    "phase": "live",
                                    "emphasis": true,
                                    "away": {
                                        "name": "Knicks",
                                        "record": "50–28",
                                        "finalRecord": "51–28",
                                        "code": "NYK",
                                        "score": "106"
                                    },
                                    "home": {
                                        "name": "Hawks",
                                        "record": "45–33",
                                        "finalRecord": "45–34",
                                        "code": "ATL",
                                        "score": "105"
                                    },
                                    "venue": "State Farm Arena",
                                    "location": "Atlanta, GA",
                                    "broadcasters": [
                                        "Peacock"
                                    ]
                                },
                                {
                                    "gameId": "0022501144",
                                    "state": "Q4 · 55.2",
                                    "phase": "live",
                                    "emphasis": false,
                                    "away": {
                                        "name": "Pistons",
                                        "record": "57–21",
                                        "finalRecord": "57–22",
                                        "code": "DET",
                                        "score": "107"
                                    },
                                    "home": {
                                        "name": "Magic",
                                        "record": "42–36",
                                        "finalRecord": "43–36",
                                        "code": "ORL",
                                        "score": "123"
                                    },
                                    "venue": "Kia Center",
                                    "location": "Orlando, FL",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501145",
                                    "state": "Q3 · 4:49",
                                    "phase": "live",
                                    "emphasis": false,
                                    "away": {
                                        "name": "Cavaliers",
                                        "record": "49–29",
                                        "finalRecord": "50–29",
                                        "code": "CLE",
                                        "score": "89"
                                    },
                                    "home": {
                                        "name": "Grizzlies",
                                        "record": "25–53",
                                        "finalRecord": "25–54",
                                        "code": "MEM",
                                        "score": "77"
                                    },
                                    "venue": "FedExForum",
                                    "location": "Memphis, TN",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501146",
                                    "state": "Q3 · 8:17",
                                    "phase": "live",
                                    "emphasis": false,
                                    "away": {
                                        "name": "76ers",
                                        "record": "43–35",
                                        "finalRecord": "43–36",
                                        "code": "PHI",
                                        "score": "65"
                                    },
                                    "home": {
                                        "name": "Spurs",
                                        "record": "59–19",
                                        "finalRecord": "60–19",
                                        "code": "SAS",
                                        "score": "74"
                                    },
                                    "venue": "Frost Bank Center",
                                    "location": "San Antonio, TX",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501147",
                                    "state": "Q1 · 0:00",
                                    "phase": "live",
                                    "emphasis": false,
                                    "away": {
                                        "name": "Trail Blazers",
                                        "record": "40–38",
                                        "finalRecord": "40–39",
                                        "code": "POR",
                                        "score": "35"
                                    },
                                    "home": {
                                        "name": "Nuggets",
                                        "record": "50–28",
                                        "finalRecord": "51–28",
                                        "code": "DEN",
                                        "score": "31"
                                    },
                                    "venue": "Ball Arena",
                                    "location": "Denver, CO",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                }
                            ],
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "inline"
                            },
                            "accessibleName": null
                        }
                    }
                ],
                [
                    {
                        "kind": "story-snapshot",
                        "id": "phi-sas-all-access-story",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "phi-sas-all-access-story",
                            "unitType": "story-slice",
                            "eyebrow": "FOLLOW LIVE",
                            "headline": "From the tunnel to San Antonio’s nine-point lead.",
                            "dek": "See arrivals, warmups, crowd atmosphere and live action at Frost Bank Center.",
                            "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                            "action": "Follow live",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story-snapshot",
                                "id": "4701c6e4-c661-46e7-234b-3a2073da5482@2026-04-07T01:35:00Z",
                                "gameId": "0022501146"
                            },
                            "accessibleName": "Open From the tunnel to San Antonio’s nine-point lead."
                        }
                    },
                    {
                        "id": "det-orl-jenkins-three-clip",
                        "availableAtUtc": "2026-04-07T01:31:50.6128395Z",
                        "display": {
                            "id": "det-orl-jenkins-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Jenkins keeps Detroit’s rally alive.",
                            "dek": "The three cuts Orlando’s lead to four with 4:07 left.",
                            "scoreLockup": "DET 105–109 ORL · Q4 · 4:07",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "804d3eb5-f647-b26a-1705-3a2077be0f9f",
                                "gameId": "0022501144"
                            },
                            "accessibleName": "Open Jenkins keeps Detroit’s rally alive. in the full-screen player"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "por-den-clingan-three-clip",
                        "availableAtUtc": "2026-04-07T01:27:26.7448463Z",
                        "display": {
                            "id": "por-den-clingan-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Clingan joins Portland’s opening barrage.",
                            "dek": "The seven-footer’s make gives Portland a four-point lead midway through the first.",
                            "scoreLockup": "POR 21–17 DEN · Q1 · 5:37",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "f753c2ee-381f-d425-a966-3a2077ba0a29",
                                "gameId": "0022501147"
                            },
                            "accessibleName": "Open Clingan joins Portland’s opening barrage. in the full-screen player"
                        }
                    },
                    {
                        "id": "phi-sas-embiid-three-clip",
                        "availableAtUtc": "2026-04-07T01:11:33.5922256Z",
                        "display": {
                            "id": "phi-sas-embiid-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Embiid steps out and knocks down the three.",
                            "dek": "His 20th point pulls Philadelphia within five before halftime.",
                            "scoreLockup": "PHI 54–59 SAS · Q2 · 1:06",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "0ef3941e-f4e0-2d90-2689-3a2077ab7b58",
                                "gameId": "0022501146"
                            },
                            "accessibleName": "Open Embiid steps out and knocks down the three. in the full-screen player"
                        }
                    },
                    {
                        "id": "cle-mem-allen-and1-clip",
                        "availableAtUtc": "2026-04-07T00:56:33.116848Z",
                        "display": {
                            "id": "cle-mem-allen-and1-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Allen muscles through for the and-one.",
                            "dek": "The three-point play cuts Memphis’s lead to eight with 4:56 left in the half.",
                            "scoreLockup": "CLE 44–52 MEM · Q2 · 4:56",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "39ae3bc8-17a8-663b-7756-3a20779dc078",
                                "gameId": "0022501145"
                            },
                            "accessibleName": "Open Allen muscles through for the and-one. in the full-screen player"
                        }
                    },
                    {
                        "id": "det-orl-paolo-dunk-clip",
                        "availableAtUtc": "2026-04-07T00:50:07.2822256Z",
                        "display": {
                            "id": "det-orl-paolo-dunk-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Banchero clears the lane and throws it down.",
                            "dek": "His 25th point stretches Orlando’s lead to 21 midway through the third.",
                            "scoreLockup": "DET 63–84 ORL · Q3 · 5:50",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": 17,
                                "shares": 2
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "12878501-1b0f-788d-6c4c-3a207797d777",
                                "gameId": "0022501144"
                            },
                            "accessibleName": "Open Banchero clears the lane and throws it down. in the full-screen player"
                        }
                    },
                    {
                        "id": "phi-sas-wemby-block-clip",
                        "availableAtUtc": "2026-04-07T00:38:33.5247374Z",
                        "display": {
                            "id": "phi-sas-wemby-block-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Wembanyama turns Embiid away at the rim.",
                            "dek": "His second block keeps San Antonio within one late in the first.",
                            "scoreLockup": "PHI 26–25 SAS · Q1 · 1:40",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "5076e737-9009-2649-ce88-3a20778d4879",
                                "gameId": "0022501146"
                            },
                            "accessibleName": "Open Wembanyama turns Embiid away at the rim. in the full-screen player"
                        }
                    },
                    {
                        "kind": "period-checkpoint",
                        "id": "nyk-atl-q3",
                        "availableAtUtc": "2026-04-07T00:56:00Z",
                        "display": {
                            "id": "nyk-atl-q3",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q3",
                            "headline": "New York takes the lead back.",
                            "dek": "The Knicks close the quarter on a 17–6 run; Towns scores 14 in the third.",
                            "scoreLockup": "NYK 81–79 ATL · END Q3",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "id": "det-orl-q3",
                        "availableAtUtc": "2026-04-07T01:00:00Z",
                        "display": {
                            "id": "det-orl-q3",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q3",
                            "headline": "Orlando’s defense stretches the lead to 22.",
                            "dek": "Thirteen steals and seven blocks hold Detroit to 76 through three.",
                            "scoreLockup": "DET 76–98 ORL · END Q3",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "id": "nyk-atl-half",
                        "availableAtUtc": "2026-04-07T00:13:00Z",
                        "display": {
                            "id": "nyk-atl-half",
                            "unitType": "checkpoint",
                            "eyebrow": "HALFTIME",
                            "headline": "Atlanta flips the half behind NAW.",
                            "dek": "The Hawks turn a seven-point deficit into a four-point halftime lead with a 21–10 close.",
                            "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "id": "det-orl-half",
                        "availableAtUtc": "2026-04-07T00:19:00Z",
                        "display": {
                            "id": "det-orl-half",
                            "unitType": "checkpoint",
                            "eyebrow": "HALFTIME",
                            "headline": "Orlando’s pressure breaks the half open.",
                            "dek": "Banchero has 21, Bane is 4-for-4 from three, and the Magic force 12 turnovers.",
                            "scoreLockup": "DET 55–69 ORL · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "kind": "period-checkpoint",
                        "id": "phi-sas-half",
                        "availableAtUtc": "2026-04-07T01:11:00Z",
                        "display": {
                            "id": "phi-sas-half",
                            "unitType": "checkpoint",
                            "eyebrow": "HALFTIME",
                            "headline": "Wemby and Embiid own the half.",
                            "dek": "Wembanyama has 17, five and three blocks; Embiid has 20.",
                            "scoreLockup": "PHI 55–62 SAS · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    }
                ],
                [
                    {
                        "id": "cle-mem-half",
                        "availableAtUtc": "2026-04-07T01:05:00Z",
                        "display": {
                            "id": "cle-mem-half",
                            "unitType": "checkpoint",
                            "eyebrow": "HALFTIME",
                            "headline": "Cleveland erases 17 down before halftime.",
                            "dek": "A 31–12 swing gives the Cavaliers a 68–64 lead.",
                            "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "kind": "period-checkpoint",
                        "id": "nyk-atl-q1",
                        "availableAtUtc": "2026-04-06T23:42:00Z",
                        "display": {
                            "id": "nyk-atl-q1",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q1",
                            "headline": "Bridges’ tip gives New York the edge after one.",
                            "dek": "Five lead changes and two ties leave the Knicks up one.",
                            "scoreLockup": "NYK 32–31 ATL · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "id": "det-orl-q1",
                        "availableAtUtc": "2026-04-06T23:44:00Z",
                        "display": {
                            "id": "det-orl-q1",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q1",
                            "headline": "Banchero gives Orlando the early edge.",
                            "dek": "Paolo scores 10 as the Magic lead 30–28 after one.",
                            "scoreLockup": "DET 28–30 ORL · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "id": "phi-sas-q1",
                        "availableAtUtc": "2026-04-07T00:36:00Z",
                        "display": {
                            "id": "phi-sas-q1",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q1",
                            "headline": "The bigs trade blocks; San Antonio leads by one.",
                            "dek": "Paul George scores 11; Wembanyama has nine and two blocks.",
                            "scoreLockup": "PHI 28–29 SAS · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "cle-mem-q1",
                        "availableAtUtc": "2026-04-07T00:35:00Z",
                        "display": {
                            "id": "cle-mem-q1",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q1",
                            "headline": "Memphis rains in 10 threes.",
                            "dek": "Seven Grizzlies hit from deep as Memphis leads 36–24.",
                            "scoreLockup": "CLE 24–36 MEM · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "kind": "momentum-swing",
                        "id": "cle-mem-halftime-comeback",
                        "availableAtUtc": "2026-04-07T01:05:00Z",
                        "occurredAtUtc": "2026-04-07T01:05:00Z",
                        "display": {
                            "id": "cle-mem-halftime-comeback",
                            "unitType": "run",
                            "eyebrow": "GAME CHANGER",
                            "headline": "A 31–12 run flips a 17-point deficit.",
                            "dek": "Cleveland turns Memphis’s ten-three opening quarter into a four-point halftime lead.",
                            "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "metrics": [
                                {
                                    "label": "Largest deficit",
                                    "value": "17"
                                },
                                {
                                    "label": "Cleveland run",
                                    "value": "31–12"
                                },
                                {
                                    "label": "Halftime lead",
                                    "value": "+4"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "id": "det-orl-half-pressure",
                        "availableAtUtc": "2026-04-07T00:19:00Z",
                        "occurredAtUtc": "2026-04-07T00:19:00Z",
                        "display": {
                            "id": "det-orl-half-pressure",
                            "unitType": "insight",
                            "eyebrow": "THE STORY SO FAR",
                            "headline": "Twelve turnovers tell the first-half story.",
                            "dek": "Orlando converts defensive pressure into a 14-point halftime lead.",
                            "scoreLockup": "DET 55–69 ORL · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "kind": "game-insight",
                        "id": "phi-sas-q1-duel",
                        "availableAtUtc": "2026-04-07T00:36:00Z",
                        "occurredAtUtc": "2026-04-07T00:36:00Z",
                        "display": {
                            "id": "phi-sas-q1-duel",
                            "unitType": "insight",
                            "eyebrow": "END Q1",
                            "headline": "Embiid and Wembanyama trade two blocks each.",
                            "dek": "San Antonio takes a 29–28 lead out of the opening quarter.",
                            "scoreLockup": "PHI 28–29 SAS · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "metrics": [
                                {
                                    "label": "Embiid blocks",
                                    "value": "2"
                                },
                                {
                                    "label": "Wemby blocks",
                                    "value": "2"
                                },
                                {
                                    "label": "Q1 margin",
                                    "value": "SAS +1"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-naw-blender-source",
                        "availableAtUtc": "2026-04-07T00:13:02Z",
                        "occurredAtUtc": "2026-04-07T00:13:02Z",
                        "display": {
                            "id": "nyk-atl-naw-blender-source",
                            "unitType": "source-video",
                            "eyebrow": null,
                            "headline": "NAW takes New York through the blender.",
                            "dek": "Alexander-Walker scores 10 during Atlanta’s 21–10 finish and reaches 20 by halftime.",
                            "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869669830534761975/vid_1_thumb.jpg",
                                "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869669830534761975/vid_1.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "captioned-image",
                        "id": "nyk-atl-brunson-naw-photo",
                        "availableAtUtc": "2026-04-07T00:14:42Z",
                        "occurredAtUtc": "2026-04-07T00:14:42Z",
                        "display": {
                            "id": "nyk-atl-brunson-naw-photo",
                            "unitType": "source-image",
                            "eyebrow": "HALFTIME",
                            "headline": "Atlanta turns a seven-point hole into a halftime lead.",
                            "dek": "A 21–10 close gives the Hawks a 57–53 edge at the break.",
                            "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "image",
                                "aspect": "wide",
                                "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/07/07cc15e7-4b58-468d-af28-9b6288a21839-getty-2269586567.jpg"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "por-den-opening-atmosphere-source",
                        "availableAtUtc": "2026-04-07T01:01:22Z",
                        "display": {
                            "id": "por-den-opening-atmosphere-source",
                            "unitType": "source-video",
                            "eyebrow": "GAME ON",
                            "headline": "The late game tips at Ball Arena.",
                            "dek": "Hear Portland’s opening possession from courtside.",
                            "scoreLockup": "POR @ DEN · Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "pregame-scene-setter",
                        "id": "por-den-pregame",
                        "availableAtUtc": "2026-04-07T00:11:00.000Z",
                        "display": {
                            "id": "por-den-pregame",
                            "unitType": "pregame",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Denver chases a ninth straight win.",
                            "dek": "The final game of the slate tips at Ball Arena.",
                            "scoreLockup": "POR @ DEN · 9:00 p.m. ET",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    }
                ],
                [
                    {
                        "kind": "gallery",
                        "id": "por-den-arrivals-gallery-source",
                        "availableAtUtc": "2026-04-06T23:47:00Z",
                        "display": {
                            "id": "por-den-arrivals-gallery-source",
                            "unitType": "gallery",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Portland arrives at Ball Arena.",
                            "dek": "Tunnel arrivals give way to warmups before the night’s final tip.",
                            "scoreLockup": "POR @ DEN · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "gallery",
                                "aspect": "wide",
                                "frameCount": 13
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "id": "phi-sas-arena-love-source",
                        "availableAtUtc": "2026-04-07T00:08:34Z",
                        "display": {
                            "id": "phi-sas-arena-love-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "San Antonio shows Wemby love",
                            "dek": "The Frost Bank Center crowd welcomes him through warmups.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "phi-sas-wemby-locking-in-source",
                        "availableAtUtc": "2026-04-06T23:29:00Z",
                        "display": {
                            "id": "phi-sas-wemby-locking-in-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Wemby locks in",
                            "dek": "Final warm-up reps before the night’s biggest individual matchup.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "phi-sas-maxey-halfcourt-source",
                        "availableAtUtc": "2026-04-06T23:18:04Z",
                        "display": {
                            "id": "phi-sas-maxey-halfcourt-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Maxey splashes one from half court",
                            "dek": "The shot drops during Philadelphia’s warmups in San Antonio.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "phi-sas-pregame-slams-source",
                        "availableAtUtc": "2026-04-06T23:18:04Z",
                        "display": {
                            "id": "phi-sas-pregame-slams-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Warmups turn into a dunk show.",
                            "dek": "Philadelphia and San Antonio trade above-the-rim finishes before tip.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "phi-sas-philly-arrival-source",
                        "availableAtUtc": "2026-04-06T22:44:35Z",
                        "display": {
                            "id": "phi-sas-philly-arrival-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Philly is in the building",
                            "dek": "Philadelphia arrives in San Antonio before the big-man matchup.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "kind": "captioned-image",
                        "id": "phi-sas-castle-warmup-source",
                        "availableAtUtc": "2026-04-06T22:44:35Z",
                        "display": {
                            "id": "phi-sas-castle-warmup-source",
                            "unitType": "source-image",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Castle’s final reps before tip.",
                            "dek": "San Antonio is one win from 60 as Castle gets loose.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "image",
                                "aspect": "wide"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "cle-mem-mobley-pregame-source",
                        "availableAtUtc": "2026-04-06T23:11:00.000Z",
                        "display": {
                            "id": "cle-mem-mobley-pregame-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Mobley arrives at FedExForum.",
                            "dek": "Cleveland can reach 50 wins in Memphis’s home finale.",
                            "scoreLockup": "CLE @ MEM · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "id": "det-orl-paolo-pregame-source",
                        "availableAtUtc": "2026-04-06T22:12:00.000Z",
                        "display": {
                            "id": "det-orl-paolo-pregame-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Paolo before tip",
                            "dek": "Banchero works through his final warm-up reps at Kia Center.",
                            "scoreLockup": "DET @ ORL · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "kind": "captioned-image",
                        "id": "nyk-atl-locker-room-source",
                        "availableAtUtc": "2026-04-06T22:13:00.000Z",
                        "display": {
                            "id": "nyk-atl-locker-room-source",
                            "unitType": "source-image",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Inside New York’s locker room.",
                            "dek": "The Knicks get set in Atlanta with a third straight win in reach.",
                            "scoreLockup": "NYK @ ATL · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "image",
                                "aspect": "wide"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-brunson-pregame-source",
                        "availableAtUtc": "2026-04-06T22:13:00.000Z",
                        "display": {
                            "id": "nyk-atl-brunson-pregame-source",
                            "unitType": "source-video",
                            "eyebrow": "PLAYER TO WATCH",
                            "headline": "Brunson brings 26.0 points and 6.7 assists per game into Atlanta.",
                            "dek": "Atlanta has to contain New York’s leading scorer and playmaker.",
                            "scoreLockup": "NYK @ ATL · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://storyteller-assets.nba.com/assets/pages/d180db88-1617-5b52-b6cb-3a2073ed79d8/90604b05-5ed3-3b44-34c0-3a2073ee9856/Playcard_Thumbnail.jpeg",
                                "playbackUrl": "https://storyteller-assets.nba.com/assets/pages/d180db88-1617-5b52-b6cb-3a2073ed79d8/69a0cca7-3dc0-8d88-2780-3a2073ee9aec/asset.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "gallery",
                        "id": "nyk-atl-east-race-carousel",
                        "availableAtUtc": "2026-04-06T22:17:00Z",
                        "display": {
                            "id": "nyk-atl-east-race-carousel",
                            "unitType": "gallery",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "The night begins in the tunnel.",
                            "dek": "Karl-Anthony Towns and Jalen Johnson arrive at State Farm Arena before New York and Atlanta meet.",
                            "scoreLockup": "NYK @ ATL · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "gallery",
                                "aspect": "portrait",
                                "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc8a2f7e-6690-4057-a2d5-46f166c4dc31-getty-2269581028.jpg",
                                "frameCount": 2,
                                "imageUrls": [
                                    "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc8a2f7e-6690-4057-a2d5-46f166c4dc31-getty-2269581028.jpg",
                                    "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc5f2bb3-07da-489e-8d9f-1fe242c1937d-getty-2269580834.jpg"
                                ]
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    }
                ],
                [
                    {
                        "kind": "event-slate",
                        "id": "night-open",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "night-open",
                            "unitType": "slate",
                            "eyebrow": "NBA TONIGHT",
                            "headline": "Five games tonight",
                            "dek": "All times ET",
                            "scoreLockup": null,
                            "action": null,
                            "games": [
                                {
                                    "gameId": "0022501143",
                                    "time": "7:00 PM",
                                    "phase": "pregame",
                                    "away": {
                                        "name": "Knicks",
                                        "record": "50–28",
                                        "finalRecord": "51–28"
                                    },
                                    "home": {
                                        "name": "Hawks",
                                        "record": "45–33",
                                        "finalRecord": "45–34"
                                    },
                                    "venue": "State Farm Arena",
                                    "location": "Atlanta, GA",
                                    "broadcasters": [
                                        "Peacock"
                                    ]
                                },
                                {
                                    "gameId": "0022501144",
                                    "time": "7:00 PM",
                                    "phase": "pregame",
                                    "away": {
                                        "name": "Pistons",
                                        "record": "57–21",
                                        "finalRecord": "57–22"
                                    },
                                    "home": {
                                        "name": "Magic",
                                        "record": "42–36",
                                        "finalRecord": "43–36"
                                    },
                                    "venue": "Kia Center",
                                    "location": "Orlando, FL",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501145",
                                    "time": "8:00 PM",
                                    "phase": "pregame",
                                    "away": {
                                        "name": "Cavaliers",
                                        "record": "49–29",
                                        "finalRecord": "50–29"
                                    },
                                    "home": {
                                        "name": "Grizzlies",
                                        "record": "25–53",
                                        "finalRecord": "25–54"
                                    },
                                    "venue": "FedExForum",
                                    "location": "Memphis, TN",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501146",
                                    "time": "8:00 PM",
                                    "phase": "pregame",
                                    "away": {
                                        "name": "76ers",
                                        "record": "43–35",
                                        "finalRecord": "43–36"
                                    },
                                    "home": {
                                        "name": "Spurs",
                                        "record": "59–19",
                                        "finalRecord": "60–19"
                                    },
                                    "venue": "Frost Bank Center",
                                    "location": "San Antonio, TX",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501147",
                                    "time": "9:00 PM",
                                    "phase": "pregame",
                                    "away": {
                                        "name": "Trail Blazers",
                                        "record": "40–38",
                                        "finalRecord": "40–39"
                                    },
                                    "home": {
                                        "name": "Nuggets",
                                        "record": "50–28",
                                        "finalRecord": "51–28"
                                    },
                                    "venue": "Ball Arena",
                                    "location": "Denver, CO",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                }
                            ],
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-list"
                            },
                            "accessibleName": "Open games"
                        }
                    },
                    {
                        "kind": "standings",
                        "id": "night-standings-pregame",
                        "availableAtUtc": "2026-04-06T22:55:00Z",
                        "display": {
                            "id": "night-standings-pregame",
                            "unitType": "standings",
                            "eyebrow": "AS IT STANDS",
                            "headline": "Where tonight’s ten teams stand.",
                            "dek": "Detroit leads the East; San Antonio starts second in the West.",
                            "scoreLockup": null,
                            "action": null,
                            "games": null,
                            "media": null,
                            "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                            "standingsGroups": [
                                {
                                    "conference": "EAST",
                                    "rows": [
                                        {
                                            "code": "DET",
                                            "name": "Pistons",
                                            "rank": "1",
                                            "record": "57–21",
                                            "percentage": ".731",
                                            "gamesBack": "—",
                                            "result": null
                                        },
                                        {
                                            "code": "NYK",
                                            "name": "Knicks",
                                            "rank": "3",
                                            "record": "50–28",
                                            "percentage": ".641",
                                            "gamesBack": "7",
                                            "result": null
                                        },
                                        {
                                            "code": "CLE",
                                            "name": "Cavaliers",
                                            "rank": "4",
                                            "record": "49–29",
                                            "percentage": ".628",
                                            "gamesBack": "8",
                                            "result": null
                                        },
                                        {
                                            "code": "ATL",
                                            "name": "Hawks",
                                            "rank": "5",
                                            "record": "45–33",
                                            "percentage": ".577",
                                            "gamesBack": "12",
                                            "result": null
                                        },
                                        {
                                            "code": "PHI",
                                            "name": "76ers",
                                            "rank": "6",
                                            "record": "43–35",
                                            "percentage": ".551",
                                            "gamesBack": "14",
                                            "result": null
                                        },
                                        {
                                            "code": "ORL",
                                            "name": "Magic",
                                            "rank": "9",
                                            "record": "42–36",
                                            "percentage": ".538",
                                            "gamesBack": "15",
                                            "result": null
                                        }
                                    ]
                                },
                                {
                                    "conference": "WEST",
                                    "rows": [
                                        {
                                            "code": "SAS",
                                            "name": "Spurs",
                                            "rank": "2",
                                            "record": "59–19",
                                            "percentage": ".756",
                                            "gamesBack": "3",
                                            "result": null
                                        },
                                        {
                                            "code": "DEN",
                                            "name": "Nuggets",
                                            "rank": "T3",
                                            "record": "50–28",
                                            "percentage": ".641",
                                            "gamesBack": "12",
                                            "result": null
                                        },
                                        {
                                            "code": "POR",
                                            "name": "Trail Blazers",
                                            "rank": "T8",
                                            "record": "40–38",
                                            "percentage": ".513",
                                            "gamesBack": "22",
                                            "result": null
                                        },
                                        {
                                            "code": "MEM",
                                            "name": "Grizzlies",
                                            "rank": "T11",
                                            "record": "25–53",
                                            "percentage": ".321",
                                            "gamesBack": "37",
                                            "result": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": "standings"
                        },
                        "interaction": {
                            "destination": {
                                "type": "inline"
                            },
                            "accessibleName": null
                        }
                    }
                ]
            ]
        },
        "end": {
            "label": "End of night",
            "total": 97,
            "newBatchCount": 47,
            "pages": [
                [
                    {
                        "kind": "winner-gallery",
                        "id": "night-winners-carousel",
                        "availableAtUtc": "2026-04-07T04:37:01Z",
                        "display": {
                            "id": "night-winners-carousel",
                            "unitType": "gallery",
                            "eyebrow": null,
                            "headline": "The performances that decided the night.",
                            "dek": "Brunson owns the fourth, Banchero scores 31, Castle posts a triple-double and Jokić completes Denver’s comeback; Schröder helps Cleveland reach 50 wins.",
                            "scoreLockup": "WHOLE NIGHT",
                            "action": "Swipe",
                            "games": null,
                            "media": {
                                "type": "gallery",
                                "aspect": "wide",
                                "frameCount": 5
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "inline"
                            },
                            "accessibleName": null
                        }
                    },
                    {
                        "kind": "gallery",
                        "id": "por-den-jokic-final-carousel-source",
                        "availableAtUtc": "2026-04-07T04:28:00Z",
                        "display": {
                            "id": "por-den-jokic-final-carousel-source",
                            "unitType": "gallery",
                            "eyebrow": null,
                            "headline": "Jokić finishes the comeback with 35, 14 and 13.",
                            "dek": "Denver erases a 16-point fourth-quarter deficit, then outscores Portland 12–7 in overtime.",
                            "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "gallery",
                                "aspect": "wide",
                                "frameCount": 9
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "captioned-image",
                        "id": "por-den-celebration-photo",
                        "availableAtUtc": "2026-04-07T04:04:56.7809874Z",
                        "display": {
                            "id": "por-den-celebration-photo",
                            "unitType": "source-image",
                            "eyebrow": "FINAL",
                            "headline": "Denver gets the last word in overtime.",
                            "dek": "Murray, Gordon and Jokić turn a 16-point fourth-quarter deficit into a ninth straight win.",
                            "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "image",
                                "aspect": "wide"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "ranked-video-recap",
                        "id": "por-den-jokic-ot-clip",
                        "availableAtUtc": "2026-04-07T03:54:15.5547311Z",
                        "display": {
                            "id": "por-den-jokic-ot-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Jokić pushes Denver seven clear in overtime.",
                            "dek": "His 35-point triple-double has the Nuggets closing on a ninth straight win.",
                            "scoreLockup": "POR 130–137 DEN · OT · 1:26",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": 53,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "8b5b797c-1747-17f3-a784-3a2078407463",
                                "gameId": "0022501147"
                            },
                            "accessibleName": "Open Jokić pushes Denver seven clear in overtime. in the full-screen player"
                        }
                    },
                    {
                        "kind": "final-outcome",
                        "id": "por-den-final",
                        "availableAtUtc": "2026-04-07T03:49:00Z",
                        "display": {
                            "id": "por-den-final",
                            "unitType": "checkpoint",
                            "eyebrow": "FINAL",
                            "headline": "Denver finishes a 16-point fourth-quarter comeback in overtime.",
                            "dek": "Nikola Jokić posts 35 points, 14 rebounds and 13 assists as the Nuggets win their ninth straight.",
                            "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-fantastic-finish-source",
                        "availableAtUtc": "2026-04-07T03:35:03Z",
                        "display": {
                            "id": "nyk-atl-fantastic-finish-source",
                            "unitType": "source-video",
                            "eyebrow": null,
                            "headline": "Brunson, McCollum and one last review.",
                            "dek": "A step-back, McCollum’s answer, Brunson’s free throws and an overturned heave settle it in the final 29 seconds.",
                            "scoreLockup": "NYK 108–105 ATL · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869772281266994148/vid_1_thumb.jpg",
                                "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869772281266994148/vid_1.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "por-den-gordon-tie-clip",
                        "availableAtUtc": "2026-04-07T03:32:07.9430558Z",
                        "display": {
                            "id": "por-den-gordon-tie-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Gordon’s corner three makes it 123–123.",
                            "dek": "Denver has erased a 16-point fourth-quarter deficit with 1:12 left.",
                            "scoreLockup": "POR 123–123 DEN · Q4 · 1:12",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "f5724d72-adeb-9f53-a055-3a20782c31e0",
                                "gameId": "0022501147"
                            },
                            "accessibleName": "Open Gordon’s corner three makes it 123–123. in the full-screen player"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-cj-halfcourt-near-miss-source",
                        "availableAtUtc": "2026-04-07T02:31:34Z",
                        "display": {
                            "id": "nyk-atl-cj-halfcourt-near-miss-source",
                            "unitType": "source-video",
                            "eyebrow": null,
                            "headline": "The heave goes in. The review takes it away.",
                            "dek": "McCollum appears to steal it at the buzzer, but replay shows the ball left his hand too late.",
                            "scoreLockup": "NYK 108–105 ATL · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869740974629227263/vid_1_thumb.jpg",
                                "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869740974629227263/vid_1.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "live-scoreboard",
                        "id": "night-standings-consequence",
                        "availableAtUtc": "2026-04-07T04:46:01Z",
                        "display": {
                            "id": "night-standings-consequence",
                            "unitType": "scoreboard",
                            "eyebrow": "AROUND THE LEAGUE",
                            "headline": "Denver gets nine straight. San Antonio gets win No. 60.",
                            "dek": "New York, Cleveland and Orlando each make it three wins in a row.",
                            "scoreLockup": null,
                            "action": "View games",
                            "games": [
                                {
                                    "gameId": "0022501143",
                                    "state": "FINAL",
                                    "phase": "final",
                                    "emphasis": false,
                                    "away": {
                                        "name": "Knicks",
                                        "record": "50–28",
                                        "finalRecord": "51–28",
                                        "code": "NYK",
                                        "score": "108"
                                    },
                                    "home": {
                                        "name": "Hawks",
                                        "record": "45–33",
                                        "finalRecord": "45–34",
                                        "code": "ATL",
                                        "score": "105"
                                    },
                                    "venue": "State Farm Arena",
                                    "location": "Atlanta, GA",
                                    "broadcasters": [
                                        "Peacock"
                                    ]
                                },
                                {
                                    "gameId": "0022501144",
                                    "state": "FINAL",
                                    "phase": "final",
                                    "emphasis": false,
                                    "away": {
                                        "name": "Pistons",
                                        "record": "57–21",
                                        "finalRecord": "57–22",
                                        "code": "DET",
                                        "score": "107"
                                    },
                                    "home": {
                                        "name": "Magic",
                                        "record": "42–36",
                                        "finalRecord": "43–36",
                                        "code": "ORL",
                                        "score": "123"
                                    },
                                    "venue": "Kia Center",
                                    "location": "Orlando, FL",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501145",
                                    "state": "FINAL",
                                    "phase": "final",
                                    "emphasis": false,
                                    "away": {
                                        "name": "Cavaliers",
                                        "record": "49–29",
                                        "finalRecord": "50–29",
                                        "code": "CLE",
                                        "score": "142"
                                    },
                                    "home": {
                                        "name": "Grizzlies",
                                        "record": "25–53",
                                        "finalRecord": "25–54",
                                        "code": "MEM",
                                        "score": "126"
                                    },
                                    "venue": "FedExForum",
                                    "location": "Memphis, TN",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501146",
                                    "state": "FINAL",
                                    "phase": "final",
                                    "emphasis": false,
                                    "away": {
                                        "name": "76ers",
                                        "record": "43–35",
                                        "finalRecord": "43–36",
                                        "code": "PHI",
                                        "score": "102"
                                    },
                                    "home": {
                                        "name": "Spurs",
                                        "record": "59–19",
                                        "finalRecord": "60–19",
                                        "code": "SAS",
                                        "score": "115"
                                    },
                                    "venue": "Frost Bank Center",
                                    "location": "San Antonio, TX",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501147",
                                    "state": "FINAL · OT",
                                    "phase": "final",
                                    "emphasis": false,
                                    "away": {
                                        "name": "Trail Blazers",
                                        "record": "40–38",
                                        "finalRecord": "40–39",
                                        "code": "POR",
                                        "score": "132"
                                    },
                                    "home": {
                                        "name": "Nuggets",
                                        "record": "50–28",
                                        "finalRecord": "51–28",
                                        "code": "DEN",
                                        "score": "137"
                                    },
                                    "venue": "Ball Arena",
                                    "location": "Denver, CO",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                }
                            ],
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "inline"
                            },
                            "accessibleName": null
                        }
                    },
                    {
                        "kind": "standings",
                        "id": "night-standings-final",
                        "availableAtUtc": "2026-04-07T04:46:01Z",
                        "display": {
                            "id": "night-standings-final",
                            "unitType": "standings",
                            "eyebrow": "AS IT STANDS",
                            "headline": "San Antonio reaches 60. Denver takes third.",
                            "dek": "Orlando climbs into a three-way tie for seventh in the East.",
                            "scoreLockup": null,
                            "action": null,
                            "games": null,
                            "media": null,
                            "standingsAsOf": "After the last final · 12:46 a.m. ET",
                            "standingsGroups": [
                                {
                                    "conference": "EAST",
                                    "rows": [
                                        {
                                            "code": "DET",
                                            "name": "Pistons",
                                            "rank": "1",
                                            "record": "57–22",
                                            "percentage": ".722",
                                            "gamesBack": "—",
                                            "result": "L"
                                        },
                                        {
                                            "code": "NYK",
                                            "name": "Knicks",
                                            "rank": "3",
                                            "record": "51–28",
                                            "percentage": ".646",
                                            "gamesBack": "6",
                                            "result": "W"
                                        },
                                        {
                                            "code": "CLE",
                                            "name": "Cavaliers",
                                            "rank": "4",
                                            "record": "50–29",
                                            "percentage": ".633",
                                            "gamesBack": "7",
                                            "result": "W"
                                        },
                                        {
                                            "code": "ATL",
                                            "name": "Hawks",
                                            "rank": "5",
                                            "record": "45–34",
                                            "percentage": ".570",
                                            "gamesBack": "12",
                                            "result": "L"
                                        },
                                        {
                                            "code": "ORL",
                                            "name": "Magic",
                                            "rank": "T7",
                                            "record": "43–36",
                                            "percentage": ".544",
                                            "gamesBack": "14",
                                            "result": "W"
                                        },
                                        {
                                            "code": "PHI",
                                            "name": "76ers",
                                            "rank": "T7",
                                            "record": "43–36",
                                            "percentage": ".544",
                                            "gamesBack": "14",
                                            "result": "L"
                                        }
                                    ]
                                },
                                {
                                    "conference": "WEST",
                                    "rows": [
                                        {
                                            "code": "SAS",
                                            "name": "Spurs",
                                            "rank": "2",
                                            "record": "60–19",
                                            "percentage": ".759",
                                            "gamesBack": "2.5",
                                            "result": "W"
                                        },
                                        {
                                            "code": "DEN",
                                            "name": "Nuggets",
                                            "rank": "3",
                                            "record": "51–28",
                                            "percentage": ".646",
                                            "gamesBack": "11.5",
                                            "result": "W"
                                        },
                                        {
                                            "code": "POR",
                                            "name": "Trail Blazers",
                                            "rank": "9",
                                            "record": "40–39",
                                            "percentage": ".506",
                                            "gamesBack": "22.5",
                                            "result": "L"
                                        },
                                        {
                                            "code": "MEM",
                                            "name": "Grizzlies",
                                            "rank": "T12",
                                            "record": "25–54",
                                            "percentage": ".316",
                                            "gamesBack": "37.5",
                                            "result": "L"
                                        }
                                    ]
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": "standings"
                        },
                        "interaction": {
                            "destination": {
                                "type": "inline"
                            },
                            "accessibleName": null
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-brunson-q4-takeover-source",
                        "availableAtUtc": "2026-04-07T01:51:56Z",
                        "display": {
                            "id": "nyk-atl-brunson-q4-takeover-source",
                            "unitType": "source-video",
                            "eyebrow": null,
                            "headline": "Seventeen in the fourth.",
                            "dek": "He ties it, puts New York ahead twice and closes the win at the line.",
                            "scoreLockup": "NYK 108–105 ATL · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869720602551146626/vid_1_thumb.jpg",
                                "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869720602551146626/vid_1.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "record",
                        "id": "por-den-record-threes",
                        "availableAtUtc": "2026-04-07T03:49:00Z",
                        "display": {
                            "id": "por-den-record-threes",
                            "unitType": "record",
                            "eyebrow": "RECORD",
                            "headline": "Portland makes 25 threes—and still loses.",
                            "dek": "The Blazers set a franchise record from deep, but Denver survives the barrage and takes over inside.",
                            "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "metrics": [
                                {
                                    "label": "Portland threes",
                                    "value": "25"
                                },
                                {
                                    "label": "Camara threes",
                                    "value": "8"
                                },
                                {
                                    "label": "Camara points",
                                    "value": "30"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    }
                ],
                [
                    {
                        "kind": "game-flow",
                        "id": "por-den-game-flow",
                        "availableAtUtc": "2026-04-07T03:49:00Z",
                        "display": {
                            "id": "por-den-game-flow",
                            "unitType": "flow",
                            "eyebrow": "HOW IT HAPPENED",
                            "headline": "Sixteen down becomes five up",
                            "dek": "Portland leads by 16 in the fourth before Denver forces overtime and takes over there.",
                            "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "flowPoints": [
                                {
                                    "label": "Q1",
                                    "value": "POR +4"
                                },
                                {
                                    "label": "HALF",
                                    "value": "POR +14"
                                },
                                {
                                    "label": "Q4 HIGH",
                                    "value": "POR +16"
                                },
                                {
                                    "label": "REGULATION",
                                    "value": "TIED"
                                },
                                {
                                    "label": "FINAL/OT",
                                    "value": "DEN +5"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "complete-story",
                        "id": "por-den-game-story",
                        "availableAtUtc": "2026-04-07T03:49:00Z",
                        "display": {
                            "id": "por-den-game-story",
                            "unitType": "story",
                            "eyebrow": "GAME STORY",
                            "headline": "Denver storms back to beat Portland in overtime.",
                            "dek": "Relive Portland’s record 25 threes and Denver forcing overtime after trailing by 16 in the fourth.",
                            "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                            "action": "View story",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story",
                                "id": "38ec1b86-4776-291b-ccf2-3a20500cbfe9",
                                "gameId": "0022501147"
                            },
                            "accessibleName": "Open Denver storms back to beat Portland in overtime."
                        }
                    },
                    {
                        "kind": "story-package",
                        "id": "por-den-portland-25-threes-story",
                        "availableAtUtc": "2026-04-07T03:49:00Z",
                        "display": {
                            "id": "por-den-portland-25-threes-story",
                            "unitType": "story-package",
                            "eyebrow": "WATCH MORE",
                            "headline": "All 25 Portland threes",
                            "dek": "Camara supplies eight in Portland’s franchise-record shooting night.",
                            "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                            "action": "View story",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story",
                                "id": "a9aca63a-6e28-cdb2-0b99-3a20784b9cb4",
                                "gameId": "0022501147"
                            },
                            "accessibleName": "Open All 25 Portland threes"
                        }
                    },
                    {
                        "id": "phi-sas-final",
                        "availableAtUtc": "2026-04-07T02:31:00Z",
                        "display": {
                            "id": "phi-sas-final",
                            "unitType": "checkpoint",
                            "eyebrow": "FINAL",
                            "headline": "San Antonio reaches 60 wins.",
                            "dek": "The Spurs beat Philadelphia 115–102 despite Embiid’s 34 points and 12 rebounds.",
                            "scoreLockup": "PHI 102–115 SAS · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "kind": "milestone",
                        "id": "phi-sas-castle-triple-double",
                        "availableAtUtc": "2026-04-07T02:31:00Z",
                        "display": {
                            "id": "phi-sas-castle-triple-double",
                            "unitType": "milestone",
                            "eyebrow": "MILESTONE",
                            "headline": "Castle’s fifth triple-double: 19, 10 and 13.",
                            "dek": "He takes control after halftime and carries San Antonio to its 60th win.",
                            "scoreLockup": "PHI 102–115 SAS · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "metrics": [
                                {
                                    "label": "Points",
                                    "value": "19"
                                },
                                {
                                    "label": "Rebounds",
                                    "value": "10"
                                },
                                {
                                    "label": "Assists",
                                    "value": "13"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "phi-sas-game-story",
                        "availableAtUtc": "2026-04-07T02:31:00Z",
                        "display": {
                            "id": "phi-sas-game-story",
                            "unitType": "story",
                            "eyebrow": "GAME STORY",
                            "headline": "Castle’s triple-double carries San Antonio past Philadelphia.",
                            "dek": "Relive Embiid’s 34, Wembanyama’s early exit and Castle’s second-half command.",
                            "scoreLockup": "PHI 102–115 SAS · FINAL",
                            "action": "View story",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story",
                                "id": "8bc8d022-f0af-662b-3761-3a20500ca56c",
                                "gameId": "0022501146"
                            },
                            "accessibleName": "Open Castle’s triple-double carries San Antonio past Philadelphia."
                        }
                    },
                    {
                        "kind": "official-status",
                        "id": "phi-sas-wemby-injury",
                        "availableAtUtc": "2026-04-07T02:31:00Z",
                        "display": {
                            "id": "phi-sas-wemby-injury",
                            "unitType": "status",
                            "eyebrow": "STATUS UPDATE",
                            "headline": "Wembanyama exits with a left rib contusion.",
                            "dek": "Wembanyama plays 15:40 before leaving the game.",
                            "scoreLockup": "PHI 102–115 SAS · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "cle-mem-final",
                        "availableAtUtc": "2026-04-07T02:20:00Z",
                        "display": {
                            "id": "cle-mem-final",
                            "unitType": "checkpoint",
                            "eyebrow": "FINAL",
                            "headline": "Cleveland reaches 50 with a season-high 142.",
                            "dek": "The Cavaliers shoot 58.4% and hand out a season-high 36 assists.",
                            "scoreLockup": "CLE 142–126 MEM · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "kind": "record",
                        "id": "cle-mem-record-29-threes",
                        "availableAtUtc": "2026-04-07T02:20:00Z",
                        "display": {
                            "id": "cle-mem-record-29-threes",
                            "unitType": "record",
                            "eyebrow": "RECORD",
                            "headline": "Memphis ties the NBA record with 29 threes.",
                            "dek": "All nine Grizzlies who played hit at least one.",
                            "scoreLockup": "CLE 142–126 MEM · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "metrics": [
                                {
                                    "label": "Memphis threes",
                                    "value": "29"
                                },
                                {
                                    "label": "Cleveland threes",
                                    "value": "23"
                                },
                                {
                                    "label": "Combined threes",
                                    "value": "52"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "id": "cle-mem-game-flow",
                        "availableAtUtc": "2026-04-07T02:20:00Z",
                        "display": {
                            "id": "cle-mem-game-flow",
                            "unitType": "flow",
                            "eyebrow": "HOW IT HAPPENED",
                            "headline": "Seventeen down becomes a season-high 142.",
                            "dek": "A 31–12 second-quarter run erases the deficit; Cleveland leads by 11 after three and wins by 16.",
                            "scoreLockup": "CLE 142–126 MEM · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "kind": "milestone",
                        "id": "cle-mem-fifty-wins",
                        "availableAtUtc": "2026-04-07T02:20:00Z",
                        "display": {
                            "id": "cle-mem-fifty-wins",
                            "unitType": "milestone",
                            "eyebrow": "MILESTONE",
                            "headline": "Fifty wins, and home court secured.",
                            "dek": "A 17-point comeback and season-high 142 secure Cleveland’s first-round advantage.",
                            "scoreLockup": "CLE 142–126 MEM · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "metrics": [
                                {
                                    "label": "Cleveland wins",
                                    "value": "50"
                                },
                                {
                                    "label": "Franchise occurrence",
                                    "value": "14th"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "id": "cle-mem-record-three-clip",
                        "availableAtUtc": "2026-04-07T02:16:08.5335405Z",
                        "display": {
                            "id": "cle-mem-record-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Bal hits Memphis’s record-tying 29th three.",
                            "dek": "The make ties the NBA single-game record with 1:41 left.",
                            "scoreLockup": "CLE 136–126 MEM · Q4 · 1:41",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": 17,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "456dd37e-923d-2353-9fdd-3a2077e69f7d",
                                "gameId": "0022501145"
                            },
                            "accessibleName": "Open Bal hits Memphis’s record-tying 29th three. in the full-screen player"
                        }
                    }
                ],
                [
                    {
                        "id": "cle-mem-game-story",
                        "availableAtUtc": "2026-04-07T02:20:00Z",
                        "display": {
                            "id": "cle-mem-game-story",
                            "unitType": "story",
                            "eyebrow": "GAME STORY",
                            "headline": "Cavaliers Rally Past Grizzlies",
                            "dek": "Relive Cleveland’s comeback and Memphis’ record-tying night from three.",
                            "scoreLockup": "CLE 142–126 MEM · FINAL",
                            "action": "View story",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story",
                                "id": "9edf2454-015f-28a7-9247-3a20500cae6e",
                                "gameId": "0022501145"
                            },
                            "accessibleName": "Open Cavaliers Rally Past Grizzlies"
                        }
                    },
                    {
                        "kind": "story-package",
                        "id": "cle-mem-29-threes-story",
                        "availableAtUtc": "2026-04-07T02:20:00Z",
                        "display": {
                            "id": "cle-mem-29-threes-story",
                            "unitType": "story-package",
                            "eyebrow": "WATCH MORE",
                            "headline": "All 29 Memphis threes",
                            "dek": "Nine Grizzlies contribute to the record-tying total.",
                            "scoreLockup": "CLE 142–126 MEM · FINAL",
                            "action": "View story",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story",
                                "id": "65113432-5711-6f04-5748-3a2077f686aa",
                                "gameId": "0022501145"
                            },
                            "accessibleName": "Open All 29 Memphis threes"
                        }
                    },
                    {
                        "id": "det-orl-final",
                        "availableAtUtc": "2026-04-07T01:37:00Z",
                        "display": {
                            "id": "det-orl-final",
                            "unitType": "checkpoint",
                            "eyebrow": "FINAL",
                            "headline": "Magic close it out, 123–107.",
                            "dek": "Detroit finishes with 21 turnovers, and Orlando stops the rally with a 10–0 answer.",
                            "scoreLockup": "DET 107–123 ORL · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "id": "det-orl-defense",
                        "availableAtUtc": "2026-04-07T01:37:00Z",
                        "display": {
                            "id": "det-orl-defense",
                            "unitType": "insight",
                            "eyebrow": "DEFENSIVE PRESSURE",
                            "headline": "Sixteen steals. Nine blocks.",
                            "dek": "The season-high totals power Orlando’s third straight win.",
                            "scoreLockup": "DET 107–123 ORL · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "kind": "evidence-receipt",
                        "id": "det-orl-defense-receipt",
                        "availableAtUtc": "2026-04-07T01:37:00Z",
                        "display": {
                            "id": "det-orl-defense-receipt",
                            "unitType": "receipt",
                            "eyebrow": "BY THE NUMBERS",
                            "headline": "Orlando piles up 25 steals and blocks.",
                            "dek": "The Magic set season highs in both and win their third straight.",
                            "scoreLockup": "DET 107–123 ORL · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "metrics": [
                                {
                                    "label": "Orlando steals",
                                    "value": "16"
                                },
                                {
                                    "label": "Orlando blocks",
                                    "value": "9"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "id": "det-orl-game-story",
                        "availableAtUtc": "2026-04-07T01:37:00Z",
                        "display": {
                            "id": "det-orl-game-story",
                            "unitType": "story",
                            "eyebrow": "GAME STORY",
                            "headline": "Magic Beat Pistons Behind Banchero",
                            "dek": "Relive Banchero’s 31 and the defensive pressure that put Orlando in control.",
                            "scoreLockup": "DET 107–123 ORL · FINAL",
                            "action": "View story",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story",
                                "id": "4981dbb8-56e8-cc0d-387b-3a20500cb3eb",
                                "gameId": "0022501144"
                            },
                            "accessibleName": "Open Magic Beat Pistons Behind Banchero"
                        }
                    },
                    {
                        "kind": "final-outcome",
                        "id": "nyk-atl-final",
                        "availableAtUtc": "2026-04-07T01:38:00Z",
                        "display": {
                            "id": "nyk-atl-final",
                            "unitType": "checkpoint",
                            "eyebrow": "FINAL",
                            "headline": "New York ends Atlanta’s 13-game home streak.",
                            "dek": "Brunson scores 17 in the fourth as the Knicks win their third straight.",
                            "scoreLockup": "NYK 108–105 ATL · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "game-insight",
                        "id": "nyk-atl-brunson-fourth",
                        "availableAtUtc": "2026-04-07T01:38:00Z",
                        "display": {
                            "id": "nyk-atl-brunson-fourth",
                            "unitType": "insight",
                            "eyebrow": "FOURTH QUARTER",
                            "headline": "Brunson owns the fourth.",
                            "dek": "He scores 17 in the period, including the go-ahead basket and two free throws in the final 1.2 seconds.",
                            "scoreLockup": "NYK 108–105 ATL · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "metrics": [
                                {
                                    "label": "Fourth quarter",
                                    "value": "17 PTS"
                                },
                                {
                                    "label": "Game total",
                                    "value": "30 PTS"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "possession-sequence",
                        "id": "nyk-atl-final-sequence",
                        "availableAtUtc": "2026-04-07T01:38:00Z",
                        "display": {
                            "id": "nyk-atl-final-sequence",
                            "unitType": "sequence",
                            "eyebrow": "THE FINISH",
                            "headline": "How the final 1.2 seconds decided it.",
                            "dek": null,
                            "scoreLockup": "NYK 108–105 ATL · FINAL",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "sequenceSteps": [
                                {
                                    "label": "1.2",
                                    "headline": "Atlanta fouls",
                                    "state": "NYK 106–105"
                                },
                                {
                                    "label": "1.2",
                                    "headline": "Brunson makes both",
                                    "state": "NYK 108–105"
                                },
                                {
                                    "label": "0.0",
                                    "headline": "McCollum’s heave is late",
                                    "state": "FINAL"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "complete-story",
                        "id": "nyk-atl-game-story",
                        "availableAtUtc": "2026-04-07T01:38:00Z",
                        "display": {
                            "id": "nyk-atl-game-story",
                            "unitType": "story",
                            "eyebrow": "GAME STORY",
                            "headline": "Knicks Win Thriller In Atlanta",
                            "dek": "Relive Atlanta’s halftime surge, New York’s third-quarter answer and every turn of the finish.",
                            "scoreLockup": "NYK 108–105 ATL · FINAL",
                            "action": "View story",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story",
                                "id": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9",
                                "gameId": "0022501143"
                            },
                            "accessibleName": "Open Knicks Win Thriller In Atlanta"
                        }
                    },
                    {
                        "kind": "urgent-game-update",
                        "id": "por-den-regulation-tie",
                        "availableAtUtc": "2026-04-07T03:35:00Z",
                        "display": {
                            "id": "por-den-regulation-tie",
                            "unitType": "urgent",
                            "eyebrow": "OVERTIME",
                            "headline": "Avdija answers Gordon; regulation ends level.",
                            "dek": "Gordon ties it at 123, scores again, then Avdija’s layup sends the game to overtime at 125.",
                            "scoreLockup": "POR 125–125 DEN · END Q4",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "period-checkpoint",
                        "id": "por-den-q3",
                        "availableAtUtc": "2026-04-07T02:54:00Z",
                        "display": {
                            "id": "por-den-q3",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q3",
                            "headline": "Portland hits 20 threes through three.",
                            "dek": null,
                            "scoreLockup": "POR 101–87 DEN · END Q3",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    }
                ],
                [
                    {
                        "kind": "vertical-clip",
                        "id": "por-den-camara-later-clip",
                        "availableAtUtc": "2026-04-07T02:49:23.4566259Z",
                        "display": {
                            "id": "por-den-camara-later-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Camara drills his eighth three.",
                            "dek": "He reaches 28 points and stretches Portland’s lead to 17.",
                            "scoreLockup": "POR 95–78 DEN · Q3 · 2:48",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "252bc6fa-6f0c-4ee9-757c-3a207805102d",
                                "gameId": "0022501147"
                            },
                            "accessibleName": "Open Camara drills his eighth three. in the full-screen player"
                        }
                    },
                    {
                        "kind": "period-checkpoint",
                        "id": "por-den-half",
                        "availableAtUtc": "2026-04-07T02:14:00Z",
                        "display": {
                            "id": "por-den-half",
                            "unitType": "checkpoint",
                            "eyebrow": "HALFTIME",
                            "headline": "Sixteen threes send Portland to the half up 14.",
                            "dek": "Camara has 20 and the Blazers have assists on 18 of 21 field goals.",
                            "scoreLockup": "POR 72–58 DEN · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "por-den-thybulle-three-clip",
                        "availableAtUtc": "2026-04-07T01:35:37.4488343Z",
                        "display": {
                            "id": "por-den-thybulle-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Thybulle starts 3-for-3 from deep.",
                            "dek": "He and Camara are 7-for-7 from deep late in the first.",
                            "scoreLockup": "POR 33–27 DEN · Q1 · 1:54",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "25b31b3e-0603-1b3c-3728-3a2077c1866d",
                                "gameId": "0022501147"
                            },
                            "accessibleName": "Open Thybulle starts 3-for-3 from deep. in the full-screen player"
                        }
                    },
                    {
                        "kind": "ranked-video-recap",
                        "id": "night-top-ten-video",
                        "availableAtUtc": "2026-04-07T05:22:53Z",
                        "display": {
                            "id": "night-top-ten-video",
                            "unitType": "source-video",
                            "eyebrow": null,
                            "headline": "The night’s top ten",
                            "dek": "Jalen Johnson’s dunk and Jokić’s no-look baseball pass lead the countdown.",
                            "scoreLockup": "WHOLE NIGHT",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "wide",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "inline"
                            },
                            "accessibleName": null
                        }
                    },
                    {
                        "id": "phi-sas-q3",
                        "availableAtUtc": "2026-04-07T01:57:00Z",
                        "display": {
                            "id": "phi-sas-q3",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q3",
                            "headline": "Castle drives San Antonio through the third.",
                            "dek": "The Spurs lead 92–85 as Castle closes in on a triple-double.",
                            "scoreLockup": "PHI 85–92 SAS · END Q3",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "phi-sas-castle-three-clip",
                        "availableAtUtc": "2026-04-07T01:47:15.6872909Z",
                        "display": {
                            "id": "phi-sas-castle-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Castle steps into the three.",
                            "dek": "His 13th point pushes San Antonio’s lead to 11 midway through the third.",
                            "scoreLockup": "PHI 70–81 SAS · Q3 · 6:19",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "24c0b833-9c37-50f9-5624-3a2077cc2e23",
                                "gameId": "0022501146"
                            },
                            "accessibleName": "Open Castle steps into the three. in the full-screen player"
                        }
                    },
                    {
                        "id": "cle-mem-q3",
                        "availableAtUtc": "2026-04-07T01:49:00Z",
                        "display": {
                            "id": "cle-mem-q3",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q3",
                            "headline": "Cleveland keeps control; Memphis keeps firing.",
                            "dek": "The Cavaliers lead 101–90 after three despite an 8–0 Memphis close.",
                            "scoreLockup": "CLE 101–90 MEM · END Q3",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "id": "cle-mem-schroder-three-clip",
                        "availableAtUtc": "2026-04-07T01:42:33.9245027Z",
                        "display": {
                            "id": "cle-mem-schroder-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Schröder pulls up from deep.",
                            "dek": "The make pushes Cleveland’s lead to 12 midway through the third.",
                            "scoreLockup": "CLE 89–77 MEM · Q3 · 5:02",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "a4e11fe3-42dc-8800-080e-3a2077c7e318",
                                "gameId": "0022501145"
                            },
                            "accessibleName": "Open Schröder pulls up from deep. in the full-screen player"
                        }
                    },
                    {
                        "id": "nyk-atl-cj-three-clip",
                        "availableAtUtc": "2026-04-07T01:36:09.0097713Z",
                        "display": {
                            "id": "nyk-atl-cj-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "McCollum makes it a one-point game.",
                            "dek": "Atlanta is within one with two seconds left.",
                            "scoreLockup": "NYK 106–105 ATL · Q4 · 0:02",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "3151c888-ea2a-cb5a-1564-3a2077c20198",
                                "gameId": "0022501143"
                            },
                            "accessibleName": "Open McCollum makes it a one-point game. in the full-screen player"
                        }
                    },
                    {
                        "id": "det-orl-bane-late-block-clip",
                        "availableAtUtc": "2026-04-07T01:35:12.3184722Z",
                        "display": {
                            "id": "det-orl-bane-late-block-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Bane turns Detroit away at the rim.",
                            "dek": "His third block protects a 14-point Orlando lead with 2:20 left.",
                            "scoreLockup": "DET 105–119 ORL · Q4 · 2:20",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "c1ffa0f8-a97b-4b70-698b-3a2077c126b1",
                                "gameId": "0022501144"
                            },
                            "accessibleName": "Open Bane turns Detroit away at the rim. in the full-screen player"
                        }
                    },
                    {
                        "kind": "period-checkpoint",
                        "id": "por-den-q1",
                        "availableAtUtc": "2026-04-07T01:36:00Z",
                        "display": {
                            "id": "por-den-q1",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q1",
                            "headline": "Camara and Thybulle torch Denver from deep.",
                            "dek": "They combine to go 7-for-7 as Portland scores 35 in the opening quarter.",
                            "scoreLockup": "POR 35–31 DEN · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "live-event-status",
                        "id": "nyk-atl-live-anchor",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "nyk-atl-live-anchor",
                            "unitType": "live",
                            "eyebrow": null,
                            "headline": "Atlanta has one possession.",
                            "dek": "Anunoby made both after the review; McCollum answered from three. Brunson is headed to the line with 1.2 seconds left.",
                            "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    }
                ],
                [
                    {
                        "kind": "vertical-clip",
                        "id": "nyk-atl-brunson-bucket-clip",
                        "availableAtUtc": "2026-04-07T01:32:23.8500897Z",
                        "display": {
                            "id": "nyk-atl-brunson-bucket-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Brunson’s step-back puts New York ahead.",
                            "dek": "He creates room and knocks down the 18-footer with 29 seconds left.",
                            "scoreLockup": "NYK 104–102 ATL · Q4 · 0:29",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": 42,
                                "shares": 12
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "a2ab872c-313e-149e-b249-3a2077be939c",
                                "gameId": "0022501143"
                            },
                            "accessibleName": "Open Brunson’s step-back puts New York ahead. in the full-screen player"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-robinson-hustle-source",
                        "availableAtUtc": "2026-04-07T01:27:11Z",
                        "occurredAtUtc": "2026-04-07T01:11:52Z",
                        "display": {
                            "id": "nyk-atl-robinson-hustle-source",
                            "unitType": "source-video",
                            "eyebrow": null,
                            "headline": "Robinson does the dirty work at both ends.",
                            "dek": "He blocks a three, then wins two offensive rebounds and tips in the tying basket.",
                            "scoreLockup": "NYK 91–91 ATL · Q4 · 5:28",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869708573119115243/vid_1_thumb.jpg",
                                "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869708573119115243/vid_1.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "story-snapshot",
                        "id": "nyk-atl-live-story-snapshot",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "nyk-atl-live-story-snapshot",
                            "unitType": "story-slice",
                            "eyebrow": "FOLLOW LIVE",
                            "headline": "The whole night from inside State Farm Arena.",
                            "dek": "Go from New York’s arrival to the final possession, with every big play in between.",
                            "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                            "action": "Follow live",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story-snapshot",
                                "id": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9@2026-04-07T01:35:00Z",
                                "gameId": "0022501143"
                            },
                            "accessibleName": "Open The whole night from inside State Farm Arena."
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-jalen-johnson-poster-source",
                        "availableAtUtc": "2026-04-07T01:02:42Z",
                        "occurredAtUtc": "2026-04-07T00:39:02Z",
                        "display": {
                            "id": "nyk-atl-jalen-johnson-poster-source",
                            "unitType": "source-video",
                            "eyebrow": null,
                            "headline": "Jalen Johnson detonates at the rim.",
                            "dek": "The driving dunk gives Atlanta a 10-point lead midway through the third.",
                            "scoreLockup": "NYK 61–71 ATL · Q3 · 6:44",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869696247502280917/vid_1_thumb.jpg",
                                "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869696247502280917/vid_1.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "phi-sas-wemby-dunk-clip",
                        "availableAtUtc": "2026-04-07T01:05:23.7892618Z",
                        "display": {
                            "id": "phi-sas-wemby-dunk-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Vassell lifts it. Wembanyama finishes with two hands.",
                            "dek": "The alley-oop puts San Antonio ahead with 4:50 left in the half.",
                            "scoreLockup": "PHI 49–51 SAS · Q2 · 4:50",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "95e60eee-ffd2-6f06-d30b-3a2077a5da3a",
                                "gameId": "0022501146"
                            },
                            "accessibleName": "Open Vassell lifts it. Wembanyama finishes with two hands. in the full-screen player"
                        }
                    },
                    {
                        "kind": "live-event-status",
                        "id": "det-orl-live-anchor",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "det-orl-live-anchor",
                            "unitType": "live",
                            "eyebrow": null,
                            "headline": "Orlando has stopped Detroit’s comeback.",
                            "dek": "The Magic answer a rally that cut their lead to three and restore a 16-point cushion.",
                            "scoreLockup": "DET 107–123 ORL · Q4 · 55.2",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "id": "cle-mem-mobley-dunk-clip",
                        "availableAtUtc": "2026-04-07T01:32:16.3529053Z",
                        "display": {
                            "id": "cle-mem-mobley-dunk-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Mobley hammers home Cleveland’s comeback.",
                            "dek": "The alley-oop gives Cleveland a six-point lead after it trailed by 17.",
                            "scoreLockup": "CLE 80–74 MEM · Q3 · 8:08",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "e78d99a8-52e4-a2a2-e739-3a2077be75d0",
                                "gameId": "0022501145"
                            },
                            "accessibleName": "Open Mobley hammers home Cleveland’s comeback. in the full-screen player"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "por-den-camara-three-clip",
                        "availableAtUtc": "2026-04-07T01:32:27.3778765Z",
                        "display": {
                            "id": "por-den-camara-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Camara starts 4-for-4 from deep.",
                            "dek": "His fourth make gives him 12 points before the quarter is over.",
                            "scoreLockup": "POR 30–23 DEN · Q1 · 3:24",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "5445169b-f7b6-e3d0-6792-3a2077bea035",
                                "gameId": "0022501147"
                            },
                            "accessibleName": "Open Camara starts 4-for-4 from deep. in the full-screen player"
                        }
                    },
                    {
                        "kind": "captioned-image",
                        "id": "por-den-camara-live-photo",
                        "availableAtUtc": "2026-04-07T01:32:28.9981794Z",
                        "display": {
                            "id": "por-den-camara-live-photo",
                            "unitType": "source-image",
                            "eyebrow": "FIRST QUARTER",
                            "headline": "Camara has Denver scrambling.",
                            "dek": "Four threes in less than nine minutes turn Portland’s fast start into an immediate problem for Denver.",
                            "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "image",
                                "aspect": "wide"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "nyk-atl-naw-three-clip",
                        "availableAtUtc": "2026-04-07T01:26:02.4211074Z",
                        "display": {
                            "id": "nyk-atl-naw-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "NAW splashes the three in a frantic fourth.",
                            "dek": "His seventh make from deep keeps Atlanta in front late.",
                            "scoreLockup": "NYK 95–100 ATL · Q4 · 3:15",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "3760a47f-6aac-9545-4895-3a2077b8bfd8",
                                "gameId": "0022501143"
                            },
                            "accessibleName": "Open NAW splashes the three in a frantic fourth. in the full-screen player"
                        }
                    },
                    {
                        "kind": "live-scoreboard",
                        "id": "night-live-five",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "night-live-five",
                            "unitType": "scoreboard",
                            "eyebrow": "NBA TONIGHT",
                            "headline": "Five games live",
                            "dek": "New York leads Atlanta by one with 1.2 seconds left.",
                            "scoreLockup": null,
                            "action": "View games",
                            "games": [
                                {
                                    "gameId": "0022501143",
                                    "state": "Q4 · 1.2",
                                    "phase": "live",
                                    "emphasis": true,
                                    "away": {
                                        "name": "Knicks",
                                        "record": "50–28",
                                        "finalRecord": "51–28",
                                        "code": "NYK",
                                        "score": "106"
                                    },
                                    "home": {
                                        "name": "Hawks",
                                        "record": "45–33",
                                        "finalRecord": "45–34",
                                        "code": "ATL",
                                        "score": "105"
                                    },
                                    "venue": "State Farm Arena",
                                    "location": "Atlanta, GA",
                                    "broadcasters": [
                                        "Peacock"
                                    ]
                                },
                                {
                                    "gameId": "0022501144",
                                    "state": "Q4 · 55.2",
                                    "phase": "live",
                                    "emphasis": false,
                                    "away": {
                                        "name": "Pistons",
                                        "record": "57–21",
                                        "finalRecord": "57–22",
                                        "code": "DET",
                                        "score": "107"
                                    },
                                    "home": {
                                        "name": "Magic",
                                        "record": "42–36",
                                        "finalRecord": "43–36",
                                        "code": "ORL",
                                        "score": "123"
                                    },
                                    "venue": "Kia Center",
                                    "location": "Orlando, FL",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501145",
                                    "state": "Q3 · 4:49",
                                    "phase": "live",
                                    "emphasis": false,
                                    "away": {
                                        "name": "Cavaliers",
                                        "record": "49–29",
                                        "finalRecord": "50–29",
                                        "code": "CLE",
                                        "score": "89"
                                    },
                                    "home": {
                                        "name": "Grizzlies",
                                        "record": "25–53",
                                        "finalRecord": "25–54",
                                        "code": "MEM",
                                        "score": "77"
                                    },
                                    "venue": "FedExForum",
                                    "location": "Memphis, TN",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501146",
                                    "state": "Q3 · 8:17",
                                    "phase": "live",
                                    "emphasis": false,
                                    "away": {
                                        "name": "76ers",
                                        "record": "43–35",
                                        "finalRecord": "43–36",
                                        "code": "PHI",
                                        "score": "65"
                                    },
                                    "home": {
                                        "name": "Spurs",
                                        "record": "59–19",
                                        "finalRecord": "60–19",
                                        "code": "SAS",
                                        "score": "74"
                                    },
                                    "venue": "Frost Bank Center",
                                    "location": "San Antonio, TX",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501147",
                                    "state": "Q1 · 0:00",
                                    "phase": "live",
                                    "emphasis": false,
                                    "away": {
                                        "name": "Trail Blazers",
                                        "record": "40–38",
                                        "finalRecord": "40–39",
                                        "code": "POR",
                                        "score": "35"
                                    },
                                    "home": {
                                        "name": "Nuggets",
                                        "record": "50–28",
                                        "finalRecord": "51–28",
                                        "code": "DEN",
                                        "score": "31"
                                    },
                                    "venue": "Ball Arena",
                                    "location": "Denver, CO",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                }
                            ],
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "inline"
                            },
                            "accessibleName": null
                        }
                    },
                    {
                        "kind": "story-snapshot",
                        "id": "phi-sas-all-access-story",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "phi-sas-all-access-story",
                            "unitType": "story-slice",
                            "eyebrow": "FOLLOW LIVE",
                            "headline": "From the tunnel to San Antonio’s nine-point lead.",
                            "dek": "See arrivals, warmups, crowd atmosphere and live action at Frost Bank Center.",
                            "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                            "action": "Follow live",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "story-snapshot",
                                "id": "4701c6e4-c661-46e7-234b-3a2073da5482@2026-04-07T01:35:00Z",
                                "gameId": "0022501146"
                            },
                            "accessibleName": "Open From the tunnel to San Antonio’s nine-point lead."
                        }
                    }
                ],
                [
                    {
                        "id": "det-orl-jenkins-three-clip",
                        "availableAtUtc": "2026-04-07T01:31:50.6128395Z",
                        "display": {
                            "id": "det-orl-jenkins-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Jenkins keeps Detroit’s rally alive.",
                            "dek": "The three cuts Orlando’s lead to four with 4:07 left.",
                            "scoreLockup": "DET 105–109 ORL · Q4 · 4:07",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "804d3eb5-f647-b26a-1705-3a2077be0f9f",
                                "gameId": "0022501144"
                            },
                            "accessibleName": "Open Jenkins keeps Detroit’s rally alive. in the full-screen player"
                        }
                    },
                    {
                        "kind": "vertical-clip",
                        "id": "por-den-clingan-three-clip",
                        "availableAtUtc": "2026-04-07T01:27:26.7448463Z",
                        "display": {
                            "id": "por-den-clingan-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Clingan joins Portland’s opening barrage.",
                            "dek": "The seven-footer’s make gives Portland a four-point lead midway through the first.",
                            "scoreLockup": "POR 21–17 DEN · Q1 · 5:37",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "f753c2ee-381f-d425-a966-3a2077ba0a29",
                                "gameId": "0022501147"
                            },
                            "accessibleName": "Open Clingan joins Portland’s opening barrage. in the full-screen player"
                        }
                    },
                    {
                        "id": "phi-sas-embiid-three-clip",
                        "availableAtUtc": "2026-04-07T01:11:33.5922256Z",
                        "display": {
                            "id": "phi-sas-embiid-three-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Embiid steps out and knocks down the three.",
                            "dek": "His 20th point pulls Philadelphia within five before halftime.",
                            "scoreLockup": "PHI 54–59 SAS · Q2 · 1:06",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "0ef3941e-f4e0-2d90-2689-3a2077ab7b58",
                                "gameId": "0022501146"
                            },
                            "accessibleName": "Open Embiid steps out and knocks down the three. in the full-screen player"
                        }
                    },
                    {
                        "id": "cle-mem-allen-and1-clip",
                        "availableAtUtc": "2026-04-07T00:56:33.116848Z",
                        "display": {
                            "id": "cle-mem-allen-and1-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Allen muscles through for the and-one.",
                            "dek": "The three-point play cuts Memphis’s lead to eight with 4:56 left in the half.",
                            "scoreLockup": "CLE 44–52 MEM · Q2 · 4:56",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "39ae3bc8-17a8-663b-7756-3a20779dc078",
                                "gameId": "0022501145"
                            },
                            "accessibleName": "Open Allen muscles through for the and-one. in the full-screen player"
                        }
                    },
                    {
                        "id": "det-orl-paolo-dunk-clip",
                        "availableAtUtc": "2026-04-07T00:50:07.2822256Z",
                        "display": {
                            "id": "det-orl-paolo-dunk-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Banchero clears the lane and throws it down.",
                            "dek": "His 25th point stretches Orlando’s lead to 21 midway through the third.",
                            "scoreLockup": "DET 63–84 ORL · Q3 · 5:50",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": 17,
                                "shares": 2
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "12878501-1b0f-788d-6c4c-3a207797d777",
                                "gameId": "0022501144"
                            },
                            "accessibleName": "Open Banchero clears the lane and throws it down. in the full-screen player"
                        }
                    },
                    {
                        "id": "phi-sas-wemby-block-clip",
                        "availableAtUtc": "2026-04-07T00:38:33.5247374Z",
                        "display": {
                            "id": "phi-sas-wemby-block-clip",
                            "unitType": "clip",
                            "eyebrow": null,
                            "headline": "Wembanyama turns Embiid away at the rim.",
                            "dek": "His second block keeps San Antonio within one late in the first.",
                            "scoreLockup": "PHI 26–25 SAS · Q1 · 1:40",
                            "action": null,
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "clip",
                                "id": "5076e737-9009-2649-ce88-3a20778d4879",
                                "gameId": "0022501146"
                            },
                            "accessibleName": "Open Wembanyama turns Embiid away at the rim. in the full-screen player"
                        }
                    },
                    {
                        "kind": "period-checkpoint",
                        "id": "nyk-atl-q3",
                        "availableAtUtc": "2026-04-07T00:56:00Z",
                        "display": {
                            "id": "nyk-atl-q3",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q3",
                            "headline": "New York takes the lead back.",
                            "dek": "The Knicks close the quarter on a 17–6 run; Towns scores 14 in the third.",
                            "scoreLockup": "NYK 81–79 ATL · END Q3",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "id": "det-orl-q3",
                        "availableAtUtc": "2026-04-07T01:00:00Z",
                        "display": {
                            "id": "det-orl-q3",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q3",
                            "headline": "Orlando’s defense stretches the lead to 22.",
                            "dek": "Thirteen steals and seven blocks hold Detroit to 76 through three.",
                            "scoreLockup": "DET 76–98 ORL · END Q3",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "id": "nyk-atl-half",
                        "availableAtUtc": "2026-04-07T00:13:00Z",
                        "display": {
                            "id": "nyk-atl-half",
                            "unitType": "checkpoint",
                            "eyebrow": "HALFTIME",
                            "headline": "Atlanta flips the half behind NAW.",
                            "dek": "The Hawks turn a seven-point deficit into a four-point halftime lead with a 21–10 close.",
                            "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "id": "det-orl-half",
                        "availableAtUtc": "2026-04-07T00:19:00Z",
                        "display": {
                            "id": "det-orl-half",
                            "unitType": "checkpoint",
                            "eyebrow": "HALFTIME",
                            "headline": "Orlando’s pressure breaks the half open.",
                            "dek": "Banchero has 21, Bane is 4-for-4 from three, and the Magic force 12 turnovers.",
                            "scoreLockup": "DET 55–69 ORL · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "kind": "period-checkpoint",
                        "id": "phi-sas-half",
                        "availableAtUtc": "2026-04-07T01:11:00Z",
                        "display": {
                            "id": "phi-sas-half",
                            "unitType": "checkpoint",
                            "eyebrow": "HALFTIME",
                            "headline": "Wemby and Embiid own the half.",
                            "dek": "Wembanyama has 17, five and three blocks; Embiid has 20.",
                            "scoreLockup": "PHI 55–62 SAS · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "cle-mem-half",
                        "availableAtUtc": "2026-04-07T01:05:00Z",
                        "display": {
                            "id": "cle-mem-half",
                            "unitType": "checkpoint",
                            "eyebrow": "HALFTIME",
                            "headline": "Cleveland erases 17 down before halftime.",
                            "dek": "A 31–12 swing gives the Cavaliers a 68–64 lead.",
                            "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    }
                ],
                [
                    {
                        "kind": "period-checkpoint",
                        "id": "nyk-atl-q1",
                        "availableAtUtc": "2026-04-06T23:42:00Z",
                        "display": {
                            "id": "nyk-atl-q1",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q1",
                            "headline": "Bridges’ tip gives New York the edge after one.",
                            "dek": "Five lead changes and two ties leave the Knicks up one.",
                            "scoreLockup": "NYK 32–31 ATL · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "id": "det-orl-q1",
                        "availableAtUtc": "2026-04-06T23:44:00Z",
                        "display": {
                            "id": "det-orl-q1",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q1",
                            "headline": "Banchero gives Orlando the early edge.",
                            "dek": "Paolo scores 10 as the Magic lead 30–28 after one.",
                            "scoreLockup": "DET 28–30 ORL · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "id": "phi-sas-q1",
                        "availableAtUtc": "2026-04-07T00:36:00Z",
                        "display": {
                            "id": "phi-sas-q1",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q1",
                            "headline": "The bigs trade blocks; San Antonio leads by one.",
                            "dek": "Paul George scores 11; Wembanyama has nine and two blocks.",
                            "scoreLockup": "PHI 28–29 SAS · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "cle-mem-q1",
                        "availableAtUtc": "2026-04-07T00:35:00Z",
                        "display": {
                            "id": "cle-mem-q1",
                            "unitType": "checkpoint",
                            "eyebrow": "END Q1",
                            "headline": "Memphis rains in 10 threes.",
                            "dek": "Seven Grizzlies hit from deep as Memphis leads 36–24.",
                            "scoreLockup": "CLE 24–36 MEM · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "kind": "momentum-swing",
                        "id": "cle-mem-halftime-comeback",
                        "availableAtUtc": "2026-04-07T01:05:00Z",
                        "occurredAtUtc": "2026-04-07T01:05:00Z",
                        "display": {
                            "id": "cle-mem-halftime-comeback",
                            "unitType": "run",
                            "eyebrow": "GAME CHANGER",
                            "headline": "A 31–12 run flips a 17-point deficit.",
                            "dek": "Cleveland turns Memphis’s ten-three opening quarter into a four-point halftime lead.",
                            "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "metrics": [
                                {
                                    "label": "Largest deficit",
                                    "value": "17"
                                },
                                {
                                    "label": "Cleveland run",
                                    "value": "31–12"
                                },
                                {
                                    "label": "Halftime lead",
                                    "value": "+4"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "id": "det-orl-half-pressure",
                        "availableAtUtc": "2026-04-07T00:19:00Z",
                        "occurredAtUtc": "2026-04-07T00:19:00Z",
                        "display": {
                            "id": "det-orl-half-pressure",
                            "unitType": "insight",
                            "eyebrow": "THE STORY SO FAR",
                            "headline": "Twelve turnovers tell the first-half story.",
                            "dek": "Orlando converts defensive pressure into a 14-point halftime lead.",
                            "scoreLockup": "DET 55–69 ORL · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "kind": "game-insight",
                        "id": "phi-sas-q1-duel",
                        "availableAtUtc": "2026-04-07T00:36:00Z",
                        "occurredAtUtc": "2026-04-07T00:36:00Z",
                        "display": {
                            "id": "phi-sas-q1-duel",
                            "unitType": "insight",
                            "eyebrow": "END Q1",
                            "headline": "Embiid and Wembanyama trade two blocks each.",
                            "dek": "San Antonio takes a 29–28 lead out of the opening quarter.",
                            "scoreLockup": "PHI 28–29 SAS · END Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": null,
                            "metrics": [
                                {
                                    "label": "Embiid blocks",
                                    "value": "2"
                                },
                                {
                                    "label": "Wemby blocks",
                                    "value": "2"
                                },
                                {
                                    "label": "Q1 margin",
                                    "value": "SAS +1"
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-naw-blender-source",
                        "availableAtUtc": "2026-04-07T00:13:02Z",
                        "occurredAtUtc": "2026-04-07T00:13:02Z",
                        "display": {
                            "id": "nyk-atl-naw-blender-source",
                            "unitType": "source-video",
                            "eyebrow": null,
                            "headline": "NAW takes New York through the blender.",
                            "dek": "Alexander-Walker scores 10 during Atlanta’s 21–10 finish and reaches 20 by halftime.",
                            "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869669830534761975/vid_1_thumb.jpg",
                                "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869669830534761975/vid_1.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "captioned-image",
                        "id": "nyk-atl-brunson-naw-photo",
                        "availableAtUtc": "2026-04-07T00:14:42Z",
                        "occurredAtUtc": "2026-04-07T00:14:42Z",
                        "display": {
                            "id": "nyk-atl-brunson-naw-photo",
                            "unitType": "source-image",
                            "eyebrow": "HALFTIME",
                            "headline": "Atlanta turns a seven-point hole into a halftime lead.",
                            "dek": "A 21–10 close gives the Hawks a 57–53 edge at the break.",
                            "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "image",
                                "aspect": "wide",
                                "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/07/07cc15e7-4b58-468d-af28-9b6288a21839-getty-2269586567.jpg"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "por-den-opening-atmosphere-source",
                        "availableAtUtc": "2026-04-07T01:01:22Z",
                        "display": {
                            "id": "por-den-opening-atmosphere-source",
                            "unitType": "source-video",
                            "eyebrow": "GAME ON",
                            "headline": "The late game tips at Ball Arena.",
                            "dek": "Hear Portland’s opening possession from courtside.",
                            "scoreLockup": "POR @ DEN · Q1",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "pregame-scene-setter",
                        "id": "por-den-pregame",
                        "availableAtUtc": "2026-04-07T00:11:00.000Z",
                        "display": {
                            "id": "por-den-pregame",
                            "unitType": "pregame",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Denver chases a ninth straight win.",
                            "dek": "The final game of the slate tips at Ball Arena.",
                            "scoreLockup": "POR @ DEN · 9:00 p.m. ET",
                            "action": "Follow game",
                            "games": null,
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    },
                    {
                        "kind": "gallery",
                        "id": "por-den-arrivals-gallery-source",
                        "availableAtUtc": "2026-04-06T23:47:00Z",
                        "display": {
                            "id": "por-den-arrivals-gallery-source",
                            "unitType": "gallery",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Portland arrives at Ball Arena.",
                            "dek": "Tunnel arrivals give way to warmups before the night’s final tip.",
                            "scoreLockup": "POR @ DEN · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "gallery",
                                "aspect": "wide",
                                "frameCount": 13
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501147",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                        }
                    }
                ],
                [
                    {
                        "id": "phi-sas-arena-love-source",
                        "availableAtUtc": "2026-04-07T00:08:34Z",
                        "display": {
                            "id": "phi-sas-arena-love-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "San Antonio shows Wemby love",
                            "dek": "The Frost Bank Center crowd welcomes him through warmups.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "phi-sas-wemby-locking-in-source",
                        "availableAtUtc": "2026-04-06T23:29:00Z",
                        "display": {
                            "id": "phi-sas-wemby-locking-in-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Wemby locks in",
                            "dek": "Final warm-up reps before the night’s biggest individual matchup.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "phi-sas-maxey-halfcourt-source",
                        "availableAtUtc": "2026-04-06T23:18:04Z",
                        "display": {
                            "id": "phi-sas-maxey-halfcourt-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Maxey splashes one from half court",
                            "dek": "The shot drops during Philadelphia’s warmups in San Antonio.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "phi-sas-pregame-slams-source",
                        "availableAtUtc": "2026-04-06T23:18:04Z",
                        "display": {
                            "id": "phi-sas-pregame-slams-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Warmups turn into a dunk show.",
                            "dek": "Philadelphia and San Antonio trade above-the-rim finishes before tip.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "phi-sas-philly-arrival-source",
                        "availableAtUtc": "2026-04-06T22:44:35Z",
                        "display": {
                            "id": "phi-sas-philly-arrival-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Philly is in the building",
                            "dek": "Philadelphia arrives in San Antonio before the big-man matchup.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "kind": "captioned-image",
                        "id": "phi-sas-castle-warmup-source",
                        "availableAtUtc": "2026-04-06T22:44:35Z",
                        "display": {
                            "id": "phi-sas-castle-warmup-source",
                            "unitType": "source-image",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Castle’s final reps before tip.",
                            "dek": "San Antonio is one win from 60 as Castle gets loose.",
                            "scoreLockup": "PHI @ SAS · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "image",
                                "aspect": "wide"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501146",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                        }
                    },
                    {
                        "id": "cle-mem-mobley-pregame-source",
                        "availableAtUtc": "2026-04-06T23:11:00.000Z",
                        "display": {
                            "id": "cle-mem-mobley-pregame-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Mobley arrives at FedExForum.",
                            "dek": "Cleveland can reach 50 wins in Memphis’s home finale.",
                            "scoreLockup": "CLE @ MEM · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501145",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                        }
                    },
                    {
                        "id": "det-orl-paolo-pregame-source",
                        "availableAtUtc": "2026-04-06T22:12:00.000Z",
                        "display": {
                            "id": "det-orl-paolo-pregame-source",
                            "unitType": "source-video",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Paolo before tip",
                            "dek": "Banchero works through his final warm-up reps at Kia Center.",
                            "scoreLockup": "DET @ ORL · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501144",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                        }
                    },
                    {
                        "kind": "captioned-image",
                        "id": "nyk-atl-locker-room-source",
                        "availableAtUtc": "2026-04-06T22:13:00.000Z",
                        "display": {
                            "id": "nyk-atl-locker-room-source",
                            "unitType": "source-image",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "Inside New York’s locker room.",
                            "dek": "The Knicks get set in Atlanta with a third straight win in reach.",
                            "scoreLockup": "NYK @ ATL · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "image",
                                "aspect": "wide"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "source-video",
                        "id": "nyk-atl-brunson-pregame-source",
                        "availableAtUtc": "2026-04-06T22:13:00.000Z",
                        "display": {
                            "id": "nyk-atl-brunson-pregame-source",
                            "unitType": "source-video",
                            "eyebrow": "PLAYER TO WATCH",
                            "headline": "Brunson brings 26.0 points and 6.7 assists per game into Atlanta.",
                            "dek": "Atlanta has to contain New York’s leading scorer and playmaker.",
                            "scoreLockup": "NYK @ ATL · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "video",
                                "aspect": "portrait",
                                "likes": null,
                                "shares": null,
                                "posterUrl": "https://storyteller-assets.nba.com/assets/pages/d180db88-1617-5b52-b6cb-3a2073ed79d8/90604b05-5ed3-3b44-34c0-3a2073ee9856/Playcard_Thumbnail.jpeg",
                                "playbackUrl": "https://storyteller-assets.nba.com/assets/pages/d180db88-1617-5b52-b6cb-3a2073ed79d8/69a0cca7-3dc0-8d88-2780-3a2073ee9aec/asset.mp4"
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "gallery",
                        "id": "nyk-atl-east-race-carousel",
                        "availableAtUtc": "2026-04-06T22:17:00Z",
                        "display": {
                            "id": "nyk-atl-east-race-carousel",
                            "unitType": "gallery",
                            "eyebrow": "BEFORE THE GAME",
                            "headline": "The night begins in the tunnel.",
                            "dek": "Karl-Anthony Towns and Jalen Johnson arrive at State Farm Arena before New York and Atlanta meet.",
                            "scoreLockup": "NYK @ ATL · PREGAME",
                            "action": "Follow game",
                            "games": null,
                            "media": {
                                "type": "gallery",
                                "aspect": "portrait",
                                "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc8a2f7e-6690-4057-a2d5-46f166c4dc31-getty-2269581028.jpg",
                                "frameCount": 2,
                                "imageUrls": [
                                    "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc8a2f7e-6690-4057-a2d5-46f166c4dc31-getty-2269581028.jpg",
                                    "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc5f2bb3-07da-489e-8d9f-1fe242c1937d-getty-2269580834.jpg"
                                ]
                            }
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-screen",
                                "gameId": "0022501143",
                                "mode": "feed",
                                "entry": "top"
                            },
                            "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                        }
                    },
                    {
                        "kind": "event-slate",
                        "id": "night-open",
                        "availableAtUtc": "2026-04-07T01:35:00Z",
                        "display": {
                            "id": "night-open",
                            "unitType": "slate",
                            "eyebrow": "NBA TONIGHT",
                            "headline": "Five games tonight",
                            "dek": "All times ET",
                            "scoreLockup": null,
                            "action": null,
                            "games": [
                                {
                                    "gameId": "0022501143",
                                    "time": "7:00 PM",
                                    "phase": "pregame",
                                    "away": {
                                        "name": "Knicks",
                                        "record": "50–28",
                                        "finalRecord": "51–28"
                                    },
                                    "home": {
                                        "name": "Hawks",
                                        "record": "45–33",
                                        "finalRecord": "45–34"
                                    },
                                    "venue": "State Farm Arena",
                                    "location": "Atlanta, GA",
                                    "broadcasters": [
                                        "Peacock"
                                    ]
                                },
                                {
                                    "gameId": "0022501144",
                                    "time": "7:00 PM",
                                    "phase": "pregame",
                                    "away": {
                                        "name": "Pistons",
                                        "record": "57–21",
                                        "finalRecord": "57–22"
                                    },
                                    "home": {
                                        "name": "Magic",
                                        "record": "42–36",
                                        "finalRecord": "43–36"
                                    },
                                    "venue": "Kia Center",
                                    "location": "Orlando, FL",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501145",
                                    "time": "8:00 PM",
                                    "phase": "pregame",
                                    "away": {
                                        "name": "Cavaliers",
                                        "record": "49–29",
                                        "finalRecord": "50–29"
                                    },
                                    "home": {
                                        "name": "Grizzlies",
                                        "record": "25–53",
                                        "finalRecord": "25–54"
                                    },
                                    "venue": "FedExForum",
                                    "location": "Memphis, TN",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501146",
                                    "time": "8:00 PM",
                                    "phase": "pregame",
                                    "away": {
                                        "name": "76ers",
                                        "record": "43–35",
                                        "finalRecord": "43–36"
                                    },
                                    "home": {
                                        "name": "Spurs",
                                        "record": "59–19",
                                        "finalRecord": "60–19"
                                    },
                                    "venue": "Frost Bank Center",
                                    "location": "San Antonio, TX",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                },
                                {
                                    "gameId": "0022501147",
                                    "time": "9:00 PM",
                                    "phase": "pregame",
                                    "away": {
                                        "name": "Trail Blazers",
                                        "record": "40–38",
                                        "finalRecord": "40–39"
                                    },
                                    "home": {
                                        "name": "Nuggets",
                                        "record": "50–28",
                                        "finalRecord": "51–28"
                                    },
                                    "venue": "Ball Arena",
                                    "location": "Denver, CO",
                                    "broadcasters": [
                                        "League Pass"
                                    ]
                                }
                            ],
                            "media": null
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": null
                        },
                        "interaction": {
                            "destination": {
                                "type": "game-list"
                            },
                            "accessibleName": "Open games"
                        }
                    }
                ],
                [
                    {
                        "kind": "standings",
                        "id": "night-standings-pregame",
                        "availableAtUtc": "2026-04-06T22:55:00Z",
                        "display": {
                            "id": "night-standings-pregame",
                            "unitType": "standings",
                            "eyebrow": "AS IT STANDS",
                            "headline": "Where tonight’s ten teams stand.",
                            "dek": "Detroit leads the East; San Antonio starts second in the West.",
                            "scoreLockup": null,
                            "action": null,
                            "games": null,
                            "media": null,
                            "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                            "standingsGroups": [
                                {
                                    "conference": "EAST",
                                    "rows": [
                                        {
                                            "code": "DET",
                                            "name": "Pistons",
                                            "rank": "1",
                                            "record": "57–21",
                                            "percentage": ".731",
                                            "gamesBack": "—",
                                            "result": null
                                        },
                                        {
                                            "code": "NYK",
                                            "name": "Knicks",
                                            "rank": "3",
                                            "record": "50–28",
                                            "percentage": ".641",
                                            "gamesBack": "7",
                                            "result": null
                                        },
                                        {
                                            "code": "CLE",
                                            "name": "Cavaliers",
                                            "rank": "4",
                                            "record": "49–29",
                                            "percentage": ".628",
                                            "gamesBack": "8",
                                            "result": null
                                        },
                                        {
                                            "code": "ATL",
                                            "name": "Hawks",
                                            "rank": "5",
                                            "record": "45–33",
                                            "percentage": ".577",
                                            "gamesBack": "12",
                                            "result": null
                                        },
                                        {
                                            "code": "PHI",
                                            "name": "76ers",
                                            "rank": "6",
                                            "record": "43–35",
                                            "percentage": ".551",
                                            "gamesBack": "14",
                                            "result": null
                                        },
                                        {
                                            "code": "ORL",
                                            "name": "Magic",
                                            "rank": "9",
                                            "record": "42–36",
                                            "percentage": ".538",
                                            "gamesBack": "15",
                                            "result": null
                                        }
                                    ]
                                },
                                {
                                    "conference": "WEST",
                                    "rows": [
                                        {
                                            "code": "SAS",
                                            "name": "Spurs",
                                            "rank": "2",
                                            "record": "59–19",
                                            "percentage": ".756",
                                            "gamesBack": "3",
                                            "result": null
                                        },
                                        {
                                            "code": "DEN",
                                            "name": "Nuggets",
                                            "rank": "T3",
                                            "record": "50–28",
                                            "percentage": ".641",
                                            "gamesBack": "12",
                                            "result": null
                                        },
                                        {
                                            "code": "POR",
                                            "name": "Trail Blazers",
                                            "rank": "T8",
                                            "record": "40–38",
                                            "percentage": ".513",
                                            "gamesBack": "22",
                                            "result": null
                                        },
                                        {
                                            "code": "MEM",
                                            "name": "Grizzlies",
                                            "rank": "T11",
                                            "record": "25–53",
                                            "percentage": ".321",
                                            "gamesBack": "37",
                                            "result": null
                                        }
                                    ]
                                }
                            ]
                        },
                        "presentation": {
                            "density": "comfortable",
                            "layout": "standings"
                        },
                        "interaction": {
                            "destination": {
                                "type": "inline"
                            },
                            "accessibleName": null
                        }
                    }
                ]
            ]
        }
    },
    "companions": [
        {
            "gameId": "0022501143",
            "matchup": "New York Knicks at Atlanta Hawks",
            "editorialRole": "Immediate live priority",
            "governingQuestion": "Can New York survive the final 1.2 seconds?",
            "anchorState": "NYK 106–105 ATL · Q4 · 1.2",
            "finalState": "NYK 108–105 ATL · FINAL",
            "entryVideoCandidateIds": {
                "anchor": "nyk-atl-brunson-bucket-clip",
                "end": "nyk-atl-fantastic-finish-source"
            },
            "anchor": [
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-final-possession",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-final-possession",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 1.2",
                            "relationshipLabel": "On Atlanta’s last possession",
                            "format": "text",
                            "statement": "ONE point. ONE possession. 1.2 seconds. Atlanta has one chance to steal this, and New York has one job: do not give up a clean look 😮‍💨"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "live-event-status",
                    "id": "nyk-atl-live-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "nyk-atl-live-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "Atlanta has one possession.",
                        "dek": "Anunoby made both after the review; McCollum answered from three. Brunson is headed to the line with 1.2 seconds left.",
                        "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "live"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "catch-up-summary",
                    "id": "nyk-atl-catch-up",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "nyk-atl-catch-up",
                        "unitType": "catch-up",
                        "eyebrow": "CATCH UP",
                        "headline": "How the lead changed hands",
                        "dek": null,
                        "scoreLockup": null,
                        "action": null,
                        "bullets": [
                            "Atlanta closed the final 8:14 of the half on a 21–10 run; Alexander-Walker scored 10 of those points to reach 20.",
                            "New York answered with a 17–6 run to take an 81–79 lead into the fourth.",
                            "Brunson has 28 points and 13 assists; Alexander-Walker has 36 points and seven threes.",
                            "New York has 52 paint points and 29 assists; Atlanta has 16 threes and 19 offensive rebounds."
                        ],
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "bullets"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "contextual-odds",
                    "id": "0022501143-contextual-live-odds",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "0022501143-contextual-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:0022501143",
                            "subject": "Jalen Brunson",
                            "marketLine": "Over 29.5 points",
                            "progress": "28 PTS",
                            "progressSummary": "Needs 2 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:0022501143:demonstrator"
                        },
                        "accessibleName": "Live odds. NYK 106–105 ATL · Q4 · 1.2. Jalen Brunson. 28 PTS current. Over 29.5 points selection. Needs 2 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-attributed-text",
                    "availableAtUtc": "2026-04-07T01:33:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-attributed-text",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 104–102 ATL · Q4 · 0:29",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 0:29",
                            "relationshipLabel": "On Brunson’s late bucket",
                            "format": "text",
                            "statement": "WOW! I can’t believe he got to that spot that clean 😮‍💨 Brunson gets Atlanta leaning, rejects the screen and walks right into it. Cold."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-brunson-bucket-clip",
                    "availableAtUtc": "2026-04-07T01:32:23.8500897Z",
                    "display": {
                        "id": "nyk-atl-brunson-bucket-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Brunson’s step-back puts New York ahead.",
                        "dek": "He creates room and knocks down the 18-footer with 29 seconds left.",
                        "scoreLockup": "NYK 104–102 ATL · Q4 · 0:29",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": 42,
                            "shares": 12
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "a2ab872c-313e-149e-b249-3a2077be939c",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Brunson’s step-back puts New York ahead. in the full-screen player"
                    }
                },
                {
                    "kind": "possession-sequence",
                    "id": "nyk-atl-brunson-seven-straight",
                    "availableAtUtc": "2026-04-07T01:23:26Z",
                    "occurredAtUtc": "2026-04-07T01:23:26Z",
                    "display": {
                        "id": "nyk-atl-brunson-seven-straight",
                        "unitType": "sequence",
                        "eyebrow": "THE TURN",
                        "headline": "Seven straight from Brunson flips it.",
                        "dek": "Three scores in 53 seconds turn a five-point hole into a 102–100 New York lead.",
                        "scoreLockup": "NYK 102–100 ATL · Q4 · 2:01",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "sequenceSteps": [
                            {
                                "label": "3:35",
                                "headline": "Brunson starts the answer",
                                "state": "ATL +2"
                            },
                            {
                                "label": "2:36",
                                "headline": "Brunson ties it",
                                "state": "100–100"
                            },
                            {
                                "label": "2:01",
                                "headline": "Brunson puts New York ahead",
                                "state": "NYK +2"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "sequence"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-naw-seventh-three",
                    "availableAtUtc": "2026-04-07T01:26:30Z",
                    "display": {
                        "id": "nyk-atl-jesser-naw-seventh-three",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 95–100 ATL · Q4 · 3:15",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 3:15",
                            "relationshipLabel": "On Alexander-Walker’s seventh three",
                            "format": "text",
                            "statement": "SEVEN threes. I have run out of things to yell. New York needs to take this personally right now."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-naw-three-clip",
                    "availableAtUtc": "2026-04-07T01:26:02.4211074Z",
                    "display": {
                        "id": "nyk-atl-naw-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "NAW splashes the three in a frantic fourth.",
                        "dek": "His seventh make from deep keeps Atlanta in front late.",
                        "scoreLockup": "NYK 95–100 ATL · Q4 · 3:15",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "3760a47f-6aac-9545-4895-3a2077b8bfd8",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open NAW splashes the three in a frantic fourth. in the full-screen player"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "nyk-atl-robinson-hustle-source",
                    "availableAtUtc": "2026-04-07T01:27:11Z",
                    "occurredAtUtc": "2026-04-07T01:11:52Z",
                    "display": {
                        "id": "nyk-atl-robinson-hustle-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "Robinson does the dirty work at both ends.",
                        "dek": "He blocks a three, then wins two offensive rebounds and tips in the tying basket.",
                        "scoreLockup": "NYK 91–91 ATL · Q4 · 5:28",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869708573119115243/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869708573119115243/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-q3-whiplash",
                    "availableAtUtc": "2026-04-07T00:56:30Z",
                    "display": {
                        "id": "nyk-atl-jesser-q3-whiplash",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 81–79 ATL · END Q3",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "End Q3",
                            "relationshipLabel": "On the third-quarter whiplash",
                            "format": "text",
                            "statement": "Jalen Johnson tried to end a man’s whole career and New York has the lead by the buzzer?? This game has zero respect for momentum and I love it."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "momentum-swing",
                    "id": "nyk-atl-q3-run",
                    "availableAtUtc": "2026-04-07T00:56:00Z",
                    "occurredAtUtc": "2026-04-07T00:56:00Z",
                    "display": {
                        "id": "nyk-atl-q3-run",
                        "unitType": "insight",
                        "eyebrow": "THE STORY SO FAR",
                        "headline": "The six-minute swing that reset the game.",
                        "dek": "New York closes the third 17–6; Towns scores 14 in the quarter.",
                        "scoreLockup": "NYK 81–79 ATL · END Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Closing stretch",
                                "value": "NYK 17–6"
                            },
                            {
                                "label": "Third quarter",
                                "value": "NYK 28–22"
                            },
                            {
                                "label": "Resulting lead",
                                "value": "NYK +2"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-brunson-q3-lead-clip",
                    "availableAtUtc": "2026-04-07T00:57:07.2113466Z",
                    "occurredAtUtc": "2026-04-07T00:52:35Z",
                    "display": {
                        "id": "nyk-atl-brunson-q3-lead-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Brunson gives New York breathing room.",
                        "dek": "His three stretches the Knicks’ first lead of the half to four.",
                        "scoreLockup": "NYK 79–75 ATL · Q3 · 1:27",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "52f7cad9-8c5c-1f7d-407b-3a20779e46c0",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Brunson gives New York breathing room. in the full-screen player"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "nyk-atl-jalen-johnson-poster-source",
                    "availableAtUtc": "2026-04-07T01:02:42Z",
                    "occurredAtUtc": "2026-04-07T00:39:02Z",
                    "display": {
                        "id": "nyk-atl-jalen-johnson-poster-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "Jalen Johnson detonates at the rim.",
                        "dek": "The driving dunk gives Atlanta a 10-point lead midway through the third.",
                        "scoreLockup": "NYK 61–71 ATL · Q3 · 6:44",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869696247502280917/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869696247502280917/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "captioned-image",
                    "id": "nyk-atl-brunson-naw-photo",
                    "availableAtUtc": "2026-04-07T00:14:42Z",
                    "occurredAtUtc": "2026-04-07T00:14:42Z",
                    "display": {
                        "id": "nyk-atl-brunson-naw-photo",
                        "unitType": "source-image",
                        "eyebrow": "HALFTIME",
                        "headline": "Atlanta turns a seven-point hole into a halftime lead.",
                        "dek": "A 21–10 close gives the Hawks a 57–53 edge at the break.",
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide",
                            "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/07/07cc15e7-4b58-468d-af28-9b6288a21839-getty-2269586567.jpg"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-halftime-extra-possessions",
                    "availableAtUtc": "2026-04-07T00:14:15Z",
                    "display": {
                        "id": "nyk-atl-jesser-halftime-extra-possessions",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Halftime",
                            "relationshipLabel": "At halftime",
                            "format": "text",
                            "statement": "Twelve offensive rebounds in one half is not a stat, it’s a cry for help 😭 New York shot it better and still trails. Somebody has to put a body on somebody."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "source-video",
                    "id": "nyk-atl-naw-blender-source",
                    "availableAtUtc": "2026-04-07T00:13:02Z",
                    "occurredAtUtc": "2026-04-07T00:13:02Z",
                    "display": {
                        "id": "nyk-atl-naw-blender-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "NAW takes New York through the blender.",
                        "dek": "Alexander-Walker scores 10 during Atlanta’s 21–10 finish and reaches 20 by halftime.",
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869669830534761975/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869669830534761975/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-q2-hawks-answer",
                    "availableAtUtc": "2026-04-07T00:04:15Z",
                    "display": {
                        "id": "nyk-atl-jesser-q2-hawks-answer",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 43–46 ATL · Q2 · 5:57",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q2 · 5:57",
                            "relationshipLabel": "On Atlanta’s answer",
                            "format": "text",
                            "statement": "Seven-point lead, gone. Atlanta didn’t just answer—it stole the energy right back. This building is awake now."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-atl-10-0-run",
                    "availableAtUtc": "2026-04-07T00:03:52.3239316Z",
                    "occurredAtUtc": "2026-04-06T23:59:15Z",
                    "display": {
                        "id": "nyk-atl-atl-10-0-run",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Atlanta answers with 10 straight.",
                        "dek": "Okongwu starts it from three; Alexander-Walker scores five as the Hawks turn seven down into a 46–43 lead.",
                        "scoreLockup": "NYK 43–46 ATL · Q2 · 5:57",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "34fc8f4d-a5bc-617d-2f01-3a20776d8544",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Atlanta answers with 10 straight. in the full-screen player"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-clarkson-q2-clip",
                    "availableAtUtc": "2026-04-06T23:55:17.7974053Z",
                    "occurredAtUtc": "2026-04-06T23:52:13Z",
                    "display": {
                        "id": "nyk-atl-clarkson-q2-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "New York’s bench opens a seven-point gap.",
                        "dek": "McBride’s three and Clarkson’s three-point play lead an 11–5 start to the second.",
                        "scoreLockup": "NYK 43–36 ATL · Q2 · 8:14",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "fa8a5d58-6626-ca4b-2942-3a207765ac78",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open New York’s bench opens a seven-point gap. in the full-screen player"
                    }
                },
                {
                    "kind": "period-checkpoint",
                    "id": "nyk-atl-q1",
                    "availableAtUtc": "2026-04-06T23:42:00Z",
                    "display": {
                        "id": "nyk-atl-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "Bridges’ tip gives New York the edge after one.",
                        "dek": "Five lead changes and two ties leave the Knicks up one.",
                        "scoreLockup": "NYK 32–31 ATL · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-naw-q1-answer",
                    "availableAtUtc": "2026-04-06T23:38:06.0514689Z",
                    "occurredAtUtc": "2026-04-06T23:30:50Z",
                    "display": {
                        "id": "nyk-atl-naw-q1-answer",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Alexander-Walker pulls Atlanta back in front.",
                        "dek": "Eight points in 78 seconds—from the line, a step-back and a three—turn a five-point deficit into a one-point lead.",
                        "scoreLockup": "NYK 24–25 ATL · Q1 · 3:35",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "44e97989-2632-3911-714d-3a207755edac",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Alexander-Walker pulls Atlanta back in front. in the full-screen player"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-q1-knicks-counter",
                    "availableAtUtc": "2026-04-06T23:27:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-q1-knicks-counter",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 16–10 ATL · Q1 · 6:24",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q1 · 6:24",
                            "relationshipLabel": "On the 11–0 run",
                            "format": "text",
                            "statement": "Down five, then 11 straight?? That’s the fastest ‘we’re fine’ you’ll ever see. Brunson and McBride just changed the temperature in here."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "momentum-swing",
                    "id": "nyk-atl-nyk-11-0-run",
                    "availableAtUtc": "2026-04-06T23:26:34Z",
                    "occurredAtUtc": "2026-04-06T23:26:34Z",
                    "display": {
                        "id": "nyk-atl-nyk-11-0-run",
                        "unitType": "insight",
                        "eyebrow": "THE FIRST SWING",
                        "headline": "New York answers Atlanta’s start with 11 straight.",
                        "dek": "Brunson and McBride finish the run after the Hawks go five up.",
                        "scoreLockup": "NYK 16–10 ATL · Q1 · 6:24",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "New York run",
                                "value": "11–0"
                            },
                            {
                                "label": "Score after",
                                "value": "NYK +6"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "event-start",
                    "id": "nyk-atl-tip",
                    "availableAtUtc": "2026-04-06T23:13:00Z",
                    "display": {
                        "id": "nyk-atl-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Knicks–Hawks is underway, with East seeding on the line.",
                        "dek": null,
                        "scoreLockup": "NYK 0–0 ATL · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-pregame-matchup",
                    "availableAtUtc": "2026-04-06T23:01:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-pregame-matchup",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Pregame",
                            "relationshipLabel": "On tonight’s matchup",
                            "format": "text",
                            "statement": "Atlanta brings four straight into a 50-win Knicks team. Nobody gets a warm-up tonight—this one starts loud 👀"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "pregame-scene-setter",
                    "id": "nyk-atl-pregame-form-vs-record",
                    "availableAtUtc": "2026-04-06T23:00:00Z",
                    "display": {
                        "id": "nyk-atl-pregame-form-vs-record",
                        "unitType": "editorial",
                        "eyebrow": "BEFORE TIP-OFF",
                        "headline": "Atlanta is hot. New York still has the edge.",
                        "dek": "The Hawks have won four straight. The Knicks arrive 50–28, five wins clear of Atlanta, but have lost three of their last five.",
                        "scoreLockup": "NYK @ ATL · 7:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "gallery",
                    "id": "nyk-atl-east-race-carousel",
                    "availableAtUtc": "2026-04-06T22:17:00Z",
                    "display": {
                        "id": "nyk-atl-east-race-carousel",
                        "unitType": "gallery",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "The night begins in the tunnel.",
                        "dek": "Karl-Anthony Towns and Jalen Johnson arrive at State Farm Arena before New York and Atlanta meet.",
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "portrait",
                            "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc8a2f7e-6690-4057-a2d5-46f166c4dc31-getty-2269581028.jpg",
                            "frameCount": 2,
                            "imageUrls": [
                                "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc8a2f7e-6690-4057-a2d5-46f166c4dc31-getty-2269581028.jpg",
                                "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc5f2bb3-07da-489e-8d9f-1fe242c1937d-getty-2269580834.jpg"
                            ]
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "nyk-atl-brunson-pregame-source",
                    "availableAtUtc": "2026-04-06T22:13:00.000Z",
                    "display": {
                        "id": "nyk-atl-brunson-pregame-source",
                        "unitType": "source-video",
                        "eyebrow": "PLAYER TO WATCH",
                        "headline": "Brunson brings 26.0 points and 6.7 assists per game into Atlanta.",
                        "dek": "Atlanta has to contain New York’s leading scorer and playmaker.",
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://storyteller-assets.nba.com/assets/pages/d180db88-1617-5b52-b6cb-3a2073ed79d8/90604b05-5ed3-3b44-34c0-3a2073ee9856/Playcard_Thumbnail.jpeg",
                            "playbackUrl": "https://storyteller-assets.nba.com/assets/pages/d180db88-1617-5b52-b6cb-3a2073ed79d8/69a0cca7-3dc0-8d88-2780-3a2073ee9aec/asset.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "authored-card",
                    "id": "nyk-atl-pregame-article-card",
                    "availableAtUtc": "2026-04-06T21:30:00Z",
                    "display": {
                        "id": "nyk-atl-pregame-article-card",
                        "unitType": "card",
                        "eyebrow": null,
                        "headline": "Knicks, Hawks get the first move in the East race",
                        "dek": "New York starts Monday one game clear of Cleveland; Atlanta holds a two-game edge over Philadelphia and Toronto.",
                        "scoreLockup": "NYK @ ATL · 7:00 p.m. ET",
                        "action": "Read preview",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "square",
                            "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/96922571-d717-4a20-8ded-8ce543bb2789-getty-2269581088.jpg"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "card"
                    },
                    "interaction": {
                        "destination": {
                            "type": "article",
                            "id": "article-nyk-atl-pregame-2026-04-06",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Read pregame preview for New York Knicks at Atlanta Hawks"
                    }
                }
            ],
            "end": [
                {
                    "kind": "source-video",
                    "id": "nyk-atl-fantastic-finish-source",
                    "availableAtUtc": "2026-04-07T03:35:03Z",
                    "display": {
                        "id": "nyk-atl-fantastic-finish-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "Brunson, McCollum and one last review.",
                        "dek": "A step-back, McCollum’s answer, Brunson’s free throws and an overturned heave settle it in the final 29 seconds.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869772281266994148/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869772281266994148/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-final-review",
                    "availableAtUtc": "2026-04-07T01:39:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-final-review",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Final",
                            "relationshipLabel": "On the final review",
                            "format": "text",
                            "statement": "That half-court shot went in and STILL didn’t count. Knicks fans just aged five years in five seconds 😭 Brunson walks out with the win anyway. Ridiculous."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "final-outcome",
                    "id": "nyk-atl-final",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "nyk-atl-final",
                        "unitType": "checkpoint",
                        "eyebrow": "FINAL",
                        "headline": "New York ends Atlanta’s 13-game home streak.",
                        "dek": "Brunson scores 17 in the fourth as the Knicks win their third straight.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "complete-story",
                    "id": "nyk-atl-game-story",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "nyk-atl-game-story",
                        "unitType": "story",
                        "eyebrow": "GAME STORY",
                        "headline": "Knicks Win Thriller In Atlanta",
                        "dek": "Relive Atlanta’s halftime surge, New York’s third-quarter answer and every turn of the finish.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story"
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Knicks Win Thriller In Atlanta"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501143-standings-final",
                    "availableAtUtc": "2026-04-07T04:46:01Z",
                    "display": {
                        "id": "0022501143-standings-final",
                        "unitType": "standings",
                        "eyebrow": "AFTER THE NIGHT",
                        "headline": "New York tightens its grip on third.",
                        "dek": "The win moves the Knicks one game closer to Detroit; Atlanta stays fifth.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "After the last final · 12:46 a.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "NYK",
                                        "name": "Knicks",
                                        "rank": "3",
                                        "record": "51–28",
                                        "percentage": ".646",
                                        "gamesBack": "6",
                                        "result": "W"
                                    },
                                    {
                                        "code": "ATL",
                                        "name": "Hawks",
                                        "rank": "5",
                                        "record": "45–34",
                                        "percentage": ".570",
                                        "gamesBack": "12",
                                        "result": "L"
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "captioned-image",
                    "id": "nyk-atl-brunson-finish-photo",
                    "availableAtUtc": "2026-04-07T03:08:09.8884871Z",
                    "display": {
                        "id": "nyk-atl-brunson-finish-photo",
                        "unitType": "source-image",
                        "eyebrow": "FINAL",
                        "headline": "Brunson gets downhill when Atlanta needs a stop.",
                        "dek": null,
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "nyk-atl-cj-halfcourt-near-miss-source",
                    "availableAtUtc": "2026-04-07T02:31:34Z",
                    "display": {
                        "id": "nyk-atl-cj-halfcourt-near-miss-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "The heave goes in. The review takes it away.",
                        "dek": "McCollum appears to steal it at the buzzer, but replay shows the ball left his hand too late.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869740974629227263/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869740974629227263/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "game-flow",
                    "id": "nyk-atl-game-flow",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "nyk-atl-game-flow",
                        "unitType": "flow",
                        "eyebrow": "HOW IT HAPPENED",
                        "headline": "Atlanta’s half. New York’s third. Brunson’s fourth.",
                        "dek": "Atlanta closes the half 21–10; New York answers 17–6 after the break; Brunson controls the finish.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "flowPoints": [
                            {
                                "label": "Q1",
                                "value": "NYK +1"
                            },
                            {
                                "label": "HALF",
                                "value": "ATL +4"
                            },
                            {
                                "label": "Q3",
                                "value": "NYK +2"
                            },
                            {
                                "label": "FINAL",
                                "value": "NYK +3"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "flow"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-final-possession",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-final-possession",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 1.2",
                            "relationshipLabel": "On Atlanta’s last possession",
                            "format": "text",
                            "statement": "ONE point. ONE possession. 1.2 seconds. Atlanta has one chance to steal this, and New York has one job: do not give up a clean look 😮‍💨"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-attributed-text",
                    "availableAtUtc": "2026-04-07T01:33:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-attributed-text",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 104–102 ATL · Q4 · 0:29",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 0:29",
                            "relationshipLabel": "On Brunson’s late bucket",
                            "format": "text",
                            "statement": "WOW! I can’t believe he got to that spot that clean 😮‍💨 Brunson gets Atlanta leaning, rejects the screen and walks right into it. Cold."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-brunson-bucket-clip",
                    "availableAtUtc": "2026-04-07T01:32:23.8500897Z",
                    "display": {
                        "id": "nyk-atl-brunson-bucket-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Brunson’s step-back puts New York ahead.",
                        "dek": "He creates room and knocks down the 18-footer with 29 seconds left.",
                        "scoreLockup": "NYK 104–102 ATL · Q4 · 0:29",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": 42,
                            "shares": 12
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "a2ab872c-313e-149e-b249-3a2077be939c",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Brunson’s step-back puts New York ahead. in the full-screen player"
                    }
                },
                {
                    "kind": "possession-sequence",
                    "id": "nyk-atl-brunson-seven-straight",
                    "availableAtUtc": "2026-04-07T01:23:26Z",
                    "occurredAtUtc": "2026-04-07T01:23:26Z",
                    "display": {
                        "id": "nyk-atl-brunson-seven-straight",
                        "unitType": "sequence",
                        "eyebrow": "THE TURN",
                        "headline": "Seven straight from Brunson flips it.",
                        "dek": "Three scores in 53 seconds turn a five-point hole into a 102–100 New York lead.",
                        "scoreLockup": "NYK 102–100 ATL · Q4 · 2:01",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "sequenceSteps": [
                            {
                                "label": "3:35",
                                "headline": "Brunson starts the answer",
                                "state": "ATL +2"
                            },
                            {
                                "label": "2:36",
                                "headline": "Brunson ties it",
                                "state": "100–100"
                            },
                            {
                                "label": "2:01",
                                "headline": "Brunson puts New York ahead",
                                "state": "NYK +2"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "sequence"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-naw-seventh-three",
                    "availableAtUtc": "2026-04-07T01:26:30Z",
                    "display": {
                        "id": "nyk-atl-jesser-naw-seventh-three",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 95–100 ATL · Q4 · 3:15",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 3:15",
                            "relationshipLabel": "On Alexander-Walker’s seventh three",
                            "format": "text",
                            "statement": "SEVEN threes. I have run out of things to yell. New York needs to take this personally right now."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-naw-three-clip",
                    "availableAtUtc": "2026-04-07T01:26:02.4211074Z",
                    "display": {
                        "id": "nyk-atl-naw-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "NAW splashes the three in a frantic fourth.",
                        "dek": "His seventh make from deep keeps Atlanta in front late.",
                        "scoreLockup": "NYK 95–100 ATL · Q4 · 3:15",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "3760a47f-6aac-9545-4895-3a2077b8bfd8",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open NAW splashes the three in a frantic fourth. in the full-screen player"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "nyk-atl-robinson-hustle-source",
                    "availableAtUtc": "2026-04-07T01:27:11Z",
                    "occurredAtUtc": "2026-04-07T01:11:52Z",
                    "display": {
                        "id": "nyk-atl-robinson-hustle-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "Robinson does the dirty work at both ends.",
                        "dek": "He blocks a three, then wins two offensive rebounds and tips in the tying basket.",
                        "scoreLockup": "NYK 91–91 ATL · Q4 · 5:28",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869708573119115243/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869708573119115243/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-q3-whiplash",
                    "availableAtUtc": "2026-04-07T00:56:30Z",
                    "display": {
                        "id": "nyk-atl-jesser-q3-whiplash",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 81–79 ATL · END Q3",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "End Q3",
                            "relationshipLabel": "On the third-quarter whiplash",
                            "format": "text",
                            "statement": "Jalen Johnson tried to end a man’s whole career and New York has the lead by the buzzer?? This game has zero respect for momentum and I love it."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "momentum-swing",
                    "id": "nyk-atl-q3-run",
                    "availableAtUtc": "2026-04-07T00:56:00Z",
                    "occurredAtUtc": "2026-04-07T00:56:00Z",
                    "display": {
                        "id": "nyk-atl-q3-run",
                        "unitType": "insight",
                        "eyebrow": "THE STORY SO FAR",
                        "headline": "The six-minute swing that reset the game.",
                        "dek": "New York closes the third 17–6; Towns scores 14 in the quarter.",
                        "scoreLockup": "NYK 81–79 ATL · END Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Closing stretch",
                                "value": "NYK 17–6"
                            },
                            {
                                "label": "Third quarter",
                                "value": "NYK 28–22"
                            },
                            {
                                "label": "Resulting lead",
                                "value": "NYK +2"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-brunson-q3-lead-clip",
                    "availableAtUtc": "2026-04-07T00:57:07.2113466Z",
                    "occurredAtUtc": "2026-04-07T00:52:35Z",
                    "display": {
                        "id": "nyk-atl-brunson-q3-lead-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Brunson gives New York breathing room.",
                        "dek": "His three stretches the Knicks’ first lead of the half to four.",
                        "scoreLockup": "NYK 79–75 ATL · Q3 · 1:27",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "52f7cad9-8c5c-1f7d-407b-3a20779e46c0",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Brunson gives New York breathing room. in the full-screen player"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "nyk-atl-jalen-johnson-poster-source",
                    "availableAtUtc": "2026-04-07T01:02:42Z",
                    "occurredAtUtc": "2026-04-07T00:39:02Z",
                    "display": {
                        "id": "nyk-atl-jalen-johnson-poster-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "Jalen Johnson detonates at the rim.",
                        "dek": "The driving dunk gives Atlanta a 10-point lead midway through the third.",
                        "scoreLockup": "NYK 61–71 ATL · Q3 · 6:44",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869696247502280917/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869696247502280917/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "captioned-image",
                    "id": "nyk-atl-brunson-naw-photo",
                    "availableAtUtc": "2026-04-07T00:14:42Z",
                    "occurredAtUtc": "2026-04-07T00:14:42Z",
                    "display": {
                        "id": "nyk-atl-brunson-naw-photo",
                        "unitType": "source-image",
                        "eyebrow": "HALFTIME",
                        "headline": "Atlanta turns a seven-point hole into a halftime lead.",
                        "dek": "A 21–10 close gives the Hawks a 57–53 edge at the break.",
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide",
                            "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/07/07cc15e7-4b58-468d-af28-9b6288a21839-getty-2269586567.jpg"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-halftime-extra-possessions",
                    "availableAtUtc": "2026-04-07T00:14:15Z",
                    "display": {
                        "id": "nyk-atl-jesser-halftime-extra-possessions",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Halftime",
                            "relationshipLabel": "At halftime",
                            "format": "text",
                            "statement": "Twelve offensive rebounds in one half is not a stat, it’s a cry for help 😭 New York shot it better and still trails. Somebody has to put a body on somebody."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "source-video",
                    "id": "nyk-atl-naw-blender-source",
                    "availableAtUtc": "2026-04-07T00:13:02Z",
                    "occurredAtUtc": "2026-04-07T00:13:02Z",
                    "display": {
                        "id": "nyk-atl-naw-blender-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "NAW takes New York through the blender.",
                        "dek": "Alexander-Walker scores 10 during Atlanta’s 21–10 finish and reaches 20 by halftime.",
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869669830534761975/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869669830534761975/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-q2-hawks-answer",
                    "availableAtUtc": "2026-04-07T00:04:15Z",
                    "display": {
                        "id": "nyk-atl-jesser-q2-hawks-answer",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 43–46 ATL · Q2 · 5:57",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q2 · 5:57",
                            "relationshipLabel": "On Atlanta’s answer",
                            "format": "text",
                            "statement": "Seven-point lead, gone. Atlanta didn’t just answer—it stole the energy right back. This building is awake now."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-atl-10-0-run",
                    "availableAtUtc": "2026-04-07T00:03:52.3239316Z",
                    "occurredAtUtc": "2026-04-06T23:59:15Z",
                    "display": {
                        "id": "nyk-atl-atl-10-0-run",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Atlanta answers with 10 straight.",
                        "dek": "Okongwu starts it from three; Alexander-Walker scores five as the Hawks turn seven down into a 46–43 lead.",
                        "scoreLockup": "NYK 43–46 ATL · Q2 · 5:57",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "34fc8f4d-a5bc-617d-2f01-3a20776d8544",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Atlanta answers with 10 straight. in the full-screen player"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-clarkson-q2-clip",
                    "availableAtUtc": "2026-04-06T23:55:17.7974053Z",
                    "occurredAtUtc": "2026-04-06T23:52:13Z",
                    "display": {
                        "id": "nyk-atl-clarkson-q2-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "New York’s bench opens a seven-point gap.",
                        "dek": "McBride’s three and Clarkson’s three-point play lead an 11–5 start to the second.",
                        "scoreLockup": "NYK 43–36 ATL · Q2 · 8:14",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "fa8a5d58-6626-ca4b-2942-3a207765ac78",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open New York’s bench opens a seven-point gap. in the full-screen player"
                    }
                },
                {
                    "kind": "period-checkpoint",
                    "id": "nyk-atl-q1",
                    "availableAtUtc": "2026-04-06T23:42:00Z",
                    "display": {
                        "id": "nyk-atl-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "Bridges’ tip gives New York the edge after one.",
                        "dek": "Five lead changes and two ties leave the Knicks up one.",
                        "scoreLockup": "NYK 32–31 ATL · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "nyk-atl-naw-q1-answer",
                    "availableAtUtc": "2026-04-06T23:38:06.0514689Z",
                    "occurredAtUtc": "2026-04-06T23:30:50Z",
                    "display": {
                        "id": "nyk-atl-naw-q1-answer",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Alexander-Walker pulls Atlanta back in front.",
                        "dek": "Eight points in 78 seconds—from the line, a step-back and a three—turn a five-point deficit into a one-point lead.",
                        "scoreLockup": "NYK 24–25 ATL · Q1 · 3:35",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "44e97989-2632-3911-714d-3a207755edac",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Alexander-Walker pulls Atlanta back in front. in the full-screen player"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-q1-knicks-counter",
                    "availableAtUtc": "2026-04-06T23:27:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-q1-knicks-counter",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 16–10 ATL · Q1 · 6:24",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q1 · 6:24",
                            "relationshipLabel": "On the 11–0 run",
                            "format": "text",
                            "statement": "Down five, then 11 straight?? That’s the fastest ‘we’re fine’ you’ll ever see. Brunson and McBride just changed the temperature in here."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "momentum-swing",
                    "id": "nyk-atl-nyk-11-0-run",
                    "availableAtUtc": "2026-04-06T23:26:34Z",
                    "occurredAtUtc": "2026-04-06T23:26:34Z",
                    "display": {
                        "id": "nyk-atl-nyk-11-0-run",
                        "unitType": "insight",
                        "eyebrow": "THE FIRST SWING",
                        "headline": "New York answers Atlanta’s start with 11 straight.",
                        "dek": "Brunson and McBride finish the run after the Hawks go five up.",
                        "scoreLockup": "NYK 16–10 ATL · Q1 · 6:24",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "New York run",
                                "value": "11–0"
                            },
                            {
                                "label": "Score after",
                                "value": "NYK +6"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "event-start",
                    "id": "nyk-atl-tip",
                    "availableAtUtc": "2026-04-06T23:13:00Z",
                    "display": {
                        "id": "nyk-atl-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Knicks–Hawks is underway, with East seeding on the line.",
                        "dek": null,
                        "scoreLockup": "NYK 0–0 ATL · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "nyk-atl-jesser-pregame-matchup",
                    "availableAtUtc": "2026-04-06T23:01:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-pregame-matchup",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Pregame",
                            "relationshipLabel": "On tonight’s matchup",
                            "format": "text",
                            "statement": "Atlanta brings four straight into a 50-win Knicks team. Nobody gets a warm-up tonight—this one starts loud 👀"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "gallery",
                    "id": "nyk-atl-east-race-carousel",
                    "availableAtUtc": "2026-04-06T22:17:00Z",
                    "display": {
                        "id": "nyk-atl-east-race-carousel",
                        "unitType": "gallery",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "The night begins in the tunnel.",
                        "dek": "Karl-Anthony Towns and Jalen Johnson arrive at State Farm Arena before New York and Atlanta meet.",
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "portrait",
                            "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc8a2f7e-6690-4057-a2d5-46f166c4dc31-getty-2269581028.jpg",
                            "frameCount": 2,
                            "imageUrls": [
                                "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc8a2f7e-6690-4057-a2d5-46f166c4dc31-getty-2269581028.jpg",
                                "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc5f2bb3-07da-489e-8d9f-1fe242c1937d-getty-2269580834.jpg"
                            ]
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "nyk-atl-brunson-pregame-source",
                    "availableAtUtc": "2026-04-06T22:13:00.000Z",
                    "display": {
                        "id": "nyk-atl-brunson-pregame-source",
                        "unitType": "source-video",
                        "eyebrow": "PLAYER TO WATCH",
                        "headline": "Brunson brings 26.0 points and 6.7 assists per game into Atlanta.",
                        "dek": "Atlanta has to contain New York’s leading scorer and playmaker.",
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://storyteller-assets.nba.com/assets/pages/d180db88-1617-5b52-b6cb-3a2073ed79d8/90604b05-5ed3-3b44-34c0-3a2073ee9856/Playcard_Thumbnail.jpeg",
                            "playbackUrl": "https://storyteller-assets.nba.com/assets/pages/d180db88-1617-5b52-b6cb-3a2073ed79d8/69a0cca7-3dc0-8d88-2780-3a2073ee9aec/asset.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    }
                },
                {
                    "kind": "authored-card",
                    "id": "nyk-atl-pregame-article-card",
                    "availableAtUtc": "2026-04-06T21:30:00Z",
                    "display": {
                        "id": "nyk-atl-pregame-article-card",
                        "unitType": "card",
                        "eyebrow": null,
                        "headline": "Knicks, Hawks get the first move in the East race",
                        "dek": "New York starts Monday one game clear of Cleveland; Atlanta holds a two-game edge over Philadelphia and Toronto.",
                        "scoreLockup": "NYK @ ATL · 7:00 p.m. ET",
                        "action": "Read preview",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "square",
                            "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/96922571-d717-4a20-8ded-8ce543bb2789-getty-2269581088.jpg"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "card"
                    },
                    "interaction": {
                        "destination": {
                            "type": "article",
                            "id": "article-nyk-atl-pregame-2026-04-06",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Read pregame preview for New York Knicks at Atlanta Hawks"
                    }
                }
            ]
        },
        {
            "gameId": "0022501144",
            "matchup": "Detroit Pistons at Orlando Magic",
            "editorialRole": "Near-final compression",
            "governingQuestion": "How did Orlando turn pressure into control?",
            "anchorState": "DET 107–123 ORL · Q4 · 55.2",
            "finalState": "DET 107–123 ORL · FINAL",
            "entryVideoCandidateIds": {
                "anchor": "det-orl-paolo-dunk-clip",
                "end": "det-orl-paolo-dunk-clip"
            },
            "anchor": [
                {
                    "id": "det-orl-paolo-dunk-clip",
                    "availableAtUtc": "2026-04-07T00:50:07.2822256Z",
                    "display": {
                        "id": "det-orl-paolo-dunk-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Banchero clears the lane and throws it down.",
                        "dek": "His 25th point stretches Orlando’s lead to 21 midway through the third.",
                        "scoreLockup": "DET 63–84 ORL · Q3 · 5:50",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": 17,
                            "shares": 2
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "12878501-1b0f-788d-6c4c-3a207797d777",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Banchero clears the lane and throws it down. in the full-screen player"
                    }
                },
                {
                    "kind": "live-event-status",
                    "id": "det-orl-live-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "det-orl-live-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "Orlando has stopped Detroit’s comeback.",
                        "dek": "The Magic answer a rally that cut their lead to three and restore a 16-point cushion.",
                        "scoreLockup": "DET 107–123 ORL · Q4 · 55.2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "kind": "official-social-source",
                    "id": "det-orl-paolo-social",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "det-orl-paolo-social",
                        "unitType": "social",
                        "eyebrow": "PLAYER WATCH",
                        "headline": "Banchero owns the first half.",
                        "dek": "Twenty-one points lift Orlando into a 14-point halftime lead.",
                        "scoreLockup": "DET 55–69 ORL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-live-story-snapshot",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "det-orl-live-story-snapshot",
                        "unitType": "story-slice",
                        "eyebrow": "FOLLOW LIVE",
                        "headline": "Banchero and the defense put Orlando in control.",
                        "dek": "Banchero scores 21 by halftime as the Magic force 12 first-half turnovers.",
                        "scoreLockup": "DET 107–123 ORL · Q4 · 55.2",
                        "action": "Follow live",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story-snapshot",
                            "id": "4981dbb8-56e8-cc0d-387b-3a20500cb3eb@2026-04-07T01:35:00Z",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Banchero and the defense put Orlando in control."
                    }
                },
                {
                    "kind": "contextual-odds",
                    "id": "0022501144-contextual-live-odds",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "0022501144-contextual-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "DET 107–123 ORL · Q4 · 55.2",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:0022501144",
                            "subject": "Paolo Banchero",
                            "marketLine": "Over 34.5 points",
                            "progress": "31 PTS",
                            "progressSummary": "Needs 4 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:0022501144:demonstrator"
                        },
                        "accessibleName": "Live odds. DET 107–123 ORL · Q4 · 55.2. Paolo Banchero. 31 PTS current. Over 34.5 points selection. Needs 4 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    }
                },
                {
                    "id": "det-orl-jenkins-three-clip",
                    "availableAtUtc": "2026-04-07T01:31:50.6128395Z",
                    "display": {
                        "id": "det-orl-jenkins-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Jenkins keeps Detroit’s rally alive.",
                        "dek": "The three cuts Orlando’s lead to four with 4:07 left.",
                        "scoreLockup": "DET 105–109 ORL · Q4 · 4:07",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "804d3eb5-f647-b26a-1705-3a2077be0f9f",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Jenkins keeps Detroit’s rally alive. in the full-screen player"
                    }
                },
                {
                    "kind": "momentum-swing",
                    "id": "det-orl-late-rally",
                    "availableAtUtc": "2026-04-07T01:31:50.6128395Z",
                    "occurredAtUtc": "2026-04-07T01:31:50.6128395Z",
                    "display": {
                        "id": "det-orl-late-rally",
                        "unitType": "run",
                        "eyebrow": "GAME CHANGER",
                        "headline": "Orlando answers Detroit’s charge.",
                        "dek": "Detroit gets within four; the Magic respond 10–0 before the final minute.",
                        "scoreLockup": null,
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Largest deficit",
                                "value": "26"
                            },
                            {
                                "label": "Closest margin",
                                "value": "4"
                            },
                            {
                                "label": "Orlando answer",
                                "value": "10–0"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-q4-open",
                    "availableAtUtc": "2026-04-07T01:02:00Z",
                    "occurredAtUtc": "2026-04-07T01:02:00Z",
                    "display": {
                        "id": "det-orl-q4-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q4",
                        "headline": "Detroit has 12 minutes to erase 22.",
                        "dek": "Orlando’s 13 steals and seven blocks have controlled the game.",
                        "scoreLockup": "DET 76–98 ORL · START Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-q3",
                    "availableAtUtc": "2026-04-07T01:00:00Z",
                    "display": {
                        "id": "det-orl-q3",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q3",
                        "headline": "Orlando’s defense stretches the lead to 22.",
                        "dek": "Thirteen steals and seven blocks hold Detroit to 76 through three.",
                        "scoreLockup": "DET 76–98 ORL · END Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-bane-swat-clip",
                    "availableAtUtc": "2026-04-07T00:40:49.7592031Z",
                    "display": {
                        "id": "det-orl-bane-swat-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Bane erases the shot at the rim.",
                        "dek": "His second block protects a 16-point Orlando lead early in the third.",
                        "scoreLockup": "DET 59–75 ORL · Q3 · 9:20",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "c3d4d517-f27d-8ab3-9a1b-3a20778f5c58",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Bane erases the shot at the rim. in the full-screen player"
                    }
                },
                {
                    "id": "det-orl-q3-open",
                    "availableAtUtc": "2026-04-07T00:34:00Z",
                    "occurredAtUtc": "2026-04-07T00:34:00Z",
                    "display": {
                        "id": "det-orl-q3-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q3",
                        "headline": "Can Detroit protect the ball?",
                        "dek": "Twelve first-half turnovers have given Orlando control.",
                        "scoreLockup": "DET 55–69 ORL · START Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-paolo-and1-clip",
                    "availableAtUtc": "2026-04-07T00:21:31.340541Z",
                    "display": {
                        "id": "det-orl-paolo-and1-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Banchero finishes through contact.",
                        "dek": "The three-point play gives him 21 and pushes Orlando’s lead to 14 before halftime.",
                        "scoreLockup": "DET 55–69 ORL · Q2 · 0:18.8",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "6d684bea-4639-abea-3811-3a20777dae7b",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Banchero finishes through contact. in the full-screen player"
                    }
                },
                {
                    "id": "det-orl-half",
                    "availableAtUtc": "2026-04-07T00:19:00Z",
                    "display": {
                        "id": "det-orl-half",
                        "unitType": "checkpoint",
                        "eyebrow": "HALFTIME",
                        "headline": "Orlando’s pressure breaks the half open.",
                        "dek": "Banchero has 21, Bane is 4-for-4 from three, and the Magic force 12 turnovers.",
                        "scoreLockup": "DET 55–69 ORL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-half-pressure",
                    "availableAtUtc": "2026-04-07T00:19:00Z",
                    "occurredAtUtc": "2026-04-07T00:19:00Z",
                    "display": {
                        "id": "det-orl-half-pressure",
                        "unitType": "insight",
                        "eyebrow": "THE STORY SO FAR",
                        "headline": "Twelve turnovers tell the first-half story.",
                        "dek": "Orlando converts defensive pressure into a 14-point halftime lead.",
                        "scoreLockup": "DET 55–69 ORL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-paolo-burst",
                    "availableAtUtc": "2026-04-07T00:19:00Z",
                    "occurredAtUtc": "2026-04-07T00:19:00Z",
                    "display": {
                        "id": "det-orl-paolo-burst",
                        "unitType": "player",
                        "eyebrow": "PLAYER WATCH",
                        "headline": "Banchero takes over before the break.",
                        "dek": "His 21 first-half points put Orlando up 14.",
                        "scoreLockup": "DET 55–69 ORL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-q2-open",
                    "availableAtUtc": "2026-04-06T23:46:00Z",
                    "occurredAtUtc": "2026-04-06T23:46:00Z",
                    "display": {
                        "id": "det-orl-q2-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q2",
                        "headline": "Can Detroit contain Banchero?",
                        "dek": "Paolo starts the second with 10 and Orlando up two.",
                        "scoreLockup": "DET 28–30 ORL · START Q2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-q1",
                    "availableAtUtc": "2026-04-06T23:44:00Z",
                    "display": {
                        "id": "det-orl-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "Banchero gives Orlando the early edge.",
                        "dek": "Paolo scores 10 as the Magic lead 30–28 after one.",
                        "scoreLockup": "DET 28–30 ORL · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-tip",
                    "availableAtUtc": "2026-04-06T23:12:00Z",
                    "display": {
                        "id": "det-orl-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Detroit and Orlando are underway",
                        "dek": null,
                        "scoreLockup": "DET 0–0 ORL · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501144-standings-pregame",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "0022501144-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "The East leader visits ninth-place Orlando.",
                        "dek": "Detroit begins the night four games clear; Orlando is trying to climb into the play-in pack.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "DET",
                                        "name": "Pistons",
                                        "rank": "1",
                                        "record": "57–21",
                                        "percentage": ".731",
                                        "gamesBack": "—",
                                        "result": null
                                    },
                                    {
                                        "code": "ORL",
                                        "name": "Magic",
                                        "rank": "9",
                                        "record": "42–36",
                                        "percentage": ".538",
                                        "gamesBack": "15",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "id": "det-orl-pregame",
                    "availableAtUtc": "2026-04-06T22:12:00.000Z",
                    "display": {
                        "id": "det-orl-pregame",
                        "unitType": "pregame",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Orlando starts ninth in the East.",
                        "dek": "Detroit brings the conference’s best record to Kia Center; the Magic are chasing a higher Play-In seed.",
                        "scoreLockup": "DET @ ORL · 7:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-essentials",
                    "availableAtUtc": "2026-04-06T22:12:00.000Z",
                    "display": {
                        "id": "det-orl-essentials",
                        "unitType": "essentials",
                        "eyebrow": "GAME GUIDE",
                        "headline": "Orlando starts ninth; Detroit arrives short-handed.",
                        "dek": "Kia Center · 7:00 p.m. ET · The Magic can gain ground in the East against the conference leaders.",
                        "scoreLockup": "DET @ ORL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-paolo-pregame-source",
                    "availableAtUtc": "2026-04-06T22:12:00.000Z",
                    "display": {
                        "id": "det-orl-paolo-pregame-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Paolo before tip",
                        "dek": "Banchero works through his final warm-up reps at Kia Center.",
                        "scoreLockup": "DET @ ORL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-locker-room-source",
                    "availableAtUtc": "2026-04-06T22:12:00.000Z",
                    "display": {
                        "id": "det-orl-locker-room-source",
                        "unitType": "source-image",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Inside Orlando’s locker room.",
                        "dek": "The Magic get set for Detroit at Kia Center.",
                        "scoreLockup": "DET @ ORL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                }
            ],
            "end": [
                {
                    "id": "det-orl-paolo-dunk-clip",
                    "availableAtUtc": "2026-04-07T00:50:07.2822256Z",
                    "display": {
                        "id": "det-orl-paolo-dunk-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Banchero clears the lane and throws it down.",
                        "dek": "His 25th point stretches Orlando’s lead to 21 midway through the third.",
                        "scoreLockup": "DET 63–84 ORL · Q3 · 5:50",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": 17,
                            "shares": 2
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "12878501-1b0f-788d-6c4c-3a207797d777",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Banchero clears the lane and throws it down. in the full-screen player"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501144-standings-final",
                    "availableAtUtc": "2026-04-07T04:46:01Z",
                    "display": {
                        "id": "0022501144-standings-final",
                        "unitType": "standings",
                        "eyebrow": "AFTER THE NIGHT",
                        "headline": "Orlando joins the East’s three-team tie.",
                        "dek": "The Magic move to 43–36 after handing the conference leader its 22nd loss.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "After the last final · 12:46 a.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "DET",
                                        "name": "Pistons",
                                        "rank": "1",
                                        "record": "57–22",
                                        "percentage": ".722",
                                        "gamesBack": "—",
                                        "result": "L"
                                    },
                                    {
                                        "code": "ORL",
                                        "name": "Magic",
                                        "rank": "T7",
                                        "record": "43–36",
                                        "percentage": ".544",
                                        "gamesBack": "14",
                                        "result": "W"
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "id": "det-orl-final",
                    "availableAtUtc": "2026-04-07T01:37:00Z",
                    "display": {
                        "id": "det-orl-final",
                        "unitType": "checkpoint",
                        "eyebrow": "FINAL",
                        "headline": "Magic close it out, 123–107.",
                        "dek": "Detroit finishes with 21 turnovers, and Orlando stops the rally with a 10–0 answer.",
                        "scoreLockup": "DET 107–123 ORL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-game-story",
                    "availableAtUtc": "2026-04-07T01:37:00Z",
                    "display": {
                        "id": "det-orl-game-story",
                        "unitType": "story",
                        "eyebrow": "GAME STORY",
                        "headline": "Magic Beat Pistons Behind Banchero",
                        "dek": "Relive Banchero’s 31 and the defensive pressure that put Orlando in control.",
                        "scoreLockup": "DET 107–123 ORL · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "4981dbb8-56e8-cc0d-387b-3a20500cb3eb",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Magic Beat Pistons Behind Banchero"
                    }
                },
                {
                    "id": "det-orl-gallery",
                    "availableAtUtc": "2026-04-07T01:37:00Z",
                    "display": {
                        "id": "det-orl-gallery",
                        "unitType": "gallery",
                        "eyebrow": "PHOTOS",
                        "headline": "How Orlando built a 26-point lead—and kept the win.",
                        "dek": "From Banchero’s hot start to the 10–0 answer that stopped Detroit’s rally.",
                        "scoreLockup": "DET 107–123 ORL · FINAL",
                        "action": "Swipe",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 3
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "kind": "game-flow",
                    "id": "det-orl-game-flow",
                    "availableAtUtc": "2026-04-07T01:37:00Z",
                    "display": {
                        "id": "det-orl-game-flow",
                        "unitType": "flow",
                        "eyebrow": "HOW IT HAPPENED",
                        "headline": "Orlando nearly loses a 26-point lead—then shuts the door.",
                        "dek": "Detroit gets within four before a 10–0 Magic answer restores control.",
                        "scoreLockup": "DET 107–123 ORL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "flowPoints": [
                            {
                                "label": "HALF",
                                "value": "ORL +14"
                            },
                            {
                                "label": "HIGH",
                                "value": "ORL +26"
                            },
                            {
                                "label": "LATE Q4",
                                "value": "ORL +4"
                            },
                            {
                                "label": "ANSWER",
                                "value": "ORL 10–0"
                            },
                            {
                                "label": "FINAL",
                                "value": "ORL +16"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "kind": "evidence-receipt",
                    "id": "det-orl-defense-receipt",
                    "availableAtUtc": "2026-04-07T01:37:00Z",
                    "display": {
                        "id": "det-orl-defense-receipt",
                        "unitType": "receipt",
                        "eyebrow": "BY THE NUMBERS",
                        "headline": "Orlando piles up 25 steals and blocks.",
                        "dek": "The Magic set season highs in both and win their third straight.",
                        "scoreLockup": "DET 107–123 ORL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Orlando steals",
                                "value": "16"
                            },
                            {
                                "label": "Orlando blocks",
                                "value": "9"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-defense",
                    "availableAtUtc": "2026-04-07T01:37:00Z",
                    "display": {
                        "id": "det-orl-defense",
                        "unitType": "insight",
                        "eyebrow": "DEFENSIVE PRESSURE",
                        "headline": "Sixteen steals. Nine blocks.",
                        "dek": "The season-high totals power Orlando’s third straight win.",
                        "scoreLockup": "DET 107–123 ORL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-photo-stat",
                    "availableAtUtc": "2026-04-07T01:37:00Z",
                    "display": {
                        "id": "det-orl-photo-stat",
                        "unitType": "photo",
                        "eyebrow": "PHOTO STORY",
                        "headline": "Banchero’s 31 sets Orlando’s tone.",
                        "dek": "The Magic force 21 turnovers and win their third straight.",
                        "scoreLockup": "DET 107–123 ORL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-top-plays-story",
                    "availableAtUtc": "2026-04-07T01:37:00Z",
                    "display": {
                        "id": "det-orl-top-plays-story",
                        "unitType": "story-package",
                        "eyebrow": "WATCH MORE",
                        "headline": "Orlando’s top plays",
                        "dek": "Banchero’s 31 and Orlando’s 16 steals lead the winning reel.",
                        "scoreLockup": "DET 107–123 ORL · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "852d474a-acb6-e596-68d0-3a2077d029fe",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Orlando’s top plays"
                    }
                },
                {
                    "id": "det-orl-bane-late-block-clip",
                    "availableAtUtc": "2026-04-07T01:35:12.3184722Z",
                    "display": {
                        "id": "det-orl-bane-late-block-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Bane turns Detroit away at the rim.",
                        "dek": "His third block protects a 14-point Orlando lead with 2:20 left.",
                        "scoreLockup": "DET 105–119 ORL · Q4 · 2:20",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "c1ffa0f8-a97b-4b70-698b-3a2077c126b1",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Bane turns Detroit away at the rim. in the full-screen player"
                    }
                },
                {
                    "kind": "live-event-status",
                    "id": "det-orl-live-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "det-orl-live-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "Orlando has stopped Detroit’s comeback.",
                        "dek": "The Magic answer a rally that cut their lead to three and restore a 16-point cushion.",
                        "scoreLockup": "DET 107–123 ORL · Q4 · 55.2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "kind": "official-social-source",
                    "id": "det-orl-paolo-social",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "det-orl-paolo-social",
                        "unitType": "social",
                        "eyebrow": "PLAYER WATCH",
                        "headline": "Banchero owns the first half.",
                        "dek": "Twenty-one points lift Orlando into a 14-point halftime lead.",
                        "scoreLockup": "DET 55–69 ORL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-live-story-snapshot",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "det-orl-live-story-snapshot",
                        "unitType": "story-slice",
                        "eyebrow": "FOLLOW LIVE",
                        "headline": "Banchero and the defense put Orlando in control.",
                        "dek": "Banchero scores 21 by halftime as the Magic force 12 first-half turnovers.",
                        "scoreLockup": "DET 107–123 ORL · Q4 · 55.2",
                        "action": "Follow live",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story-snapshot",
                            "id": "4981dbb8-56e8-cc0d-387b-3a20500cb3eb@2026-04-07T01:35:00Z",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Banchero and the defense put Orlando in control."
                    }
                },
                {
                    "id": "det-orl-jenkins-three-clip",
                    "availableAtUtc": "2026-04-07T01:31:50.6128395Z",
                    "display": {
                        "id": "det-orl-jenkins-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Jenkins keeps Detroit’s rally alive.",
                        "dek": "The three cuts Orlando’s lead to four with 4:07 left.",
                        "scoreLockup": "DET 105–109 ORL · Q4 · 4:07",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "804d3eb5-f647-b26a-1705-3a2077be0f9f",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Jenkins keeps Detroit’s rally alive. in the full-screen player"
                    }
                },
                {
                    "kind": "momentum-swing",
                    "id": "det-orl-late-rally",
                    "availableAtUtc": "2026-04-07T01:31:50.6128395Z",
                    "occurredAtUtc": "2026-04-07T01:31:50.6128395Z",
                    "display": {
                        "id": "det-orl-late-rally",
                        "unitType": "run",
                        "eyebrow": "GAME CHANGER",
                        "headline": "Orlando answers Detroit’s charge.",
                        "dek": "Detroit gets within four; the Magic respond 10–0 before the final minute.",
                        "scoreLockup": null,
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Largest deficit",
                                "value": "26"
                            },
                            {
                                "label": "Closest margin",
                                "value": "4"
                            },
                            {
                                "label": "Orlando answer",
                                "value": "10–0"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-q4-open",
                    "availableAtUtc": "2026-04-07T01:02:00Z",
                    "occurredAtUtc": "2026-04-07T01:02:00Z",
                    "display": {
                        "id": "det-orl-q4-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q4",
                        "headline": "Detroit has 12 minutes to erase 22.",
                        "dek": "Orlando’s 13 steals and seven blocks have controlled the game.",
                        "scoreLockup": "DET 76–98 ORL · START Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-q3",
                    "availableAtUtc": "2026-04-07T01:00:00Z",
                    "display": {
                        "id": "det-orl-q3",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q3",
                        "headline": "Orlando’s defense stretches the lead to 22.",
                        "dek": "Thirteen steals and seven blocks hold Detroit to 76 through three.",
                        "scoreLockup": "DET 76–98 ORL · END Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-bane-swat-clip",
                    "availableAtUtc": "2026-04-07T00:40:49.7592031Z",
                    "display": {
                        "id": "det-orl-bane-swat-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Bane erases the shot at the rim.",
                        "dek": "His second block protects a 16-point Orlando lead early in the third.",
                        "scoreLockup": "DET 59–75 ORL · Q3 · 9:20",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "c3d4d517-f27d-8ab3-9a1b-3a20778f5c58",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Bane erases the shot at the rim. in the full-screen player"
                    }
                },
                {
                    "id": "det-orl-q3-open",
                    "availableAtUtc": "2026-04-07T00:34:00Z",
                    "occurredAtUtc": "2026-04-07T00:34:00Z",
                    "display": {
                        "id": "det-orl-q3-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q3",
                        "headline": "Can Detroit protect the ball?",
                        "dek": "Twelve first-half turnovers have given Orlando control.",
                        "scoreLockup": "DET 55–69 ORL · START Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-paolo-and1-clip",
                    "availableAtUtc": "2026-04-07T00:21:31.340541Z",
                    "display": {
                        "id": "det-orl-paolo-and1-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Banchero finishes through contact.",
                        "dek": "The three-point play gives him 21 and pushes Orlando’s lead to 14 before halftime.",
                        "scoreLockup": "DET 55–69 ORL · Q2 · 0:18.8",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "6d684bea-4639-abea-3811-3a20777dae7b",
                            "gameId": "0022501144"
                        },
                        "accessibleName": "Open Banchero finishes through contact. in the full-screen player"
                    }
                },
                {
                    "id": "det-orl-half",
                    "availableAtUtc": "2026-04-07T00:19:00Z",
                    "display": {
                        "id": "det-orl-half",
                        "unitType": "checkpoint",
                        "eyebrow": "HALFTIME",
                        "headline": "Orlando’s pressure breaks the half open.",
                        "dek": "Banchero has 21, Bane is 4-for-4 from three, and the Magic force 12 turnovers.",
                        "scoreLockup": "DET 55–69 ORL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-half-pressure",
                    "availableAtUtc": "2026-04-07T00:19:00Z",
                    "occurredAtUtc": "2026-04-07T00:19:00Z",
                    "display": {
                        "id": "det-orl-half-pressure",
                        "unitType": "insight",
                        "eyebrow": "THE STORY SO FAR",
                        "headline": "Twelve turnovers tell the first-half story.",
                        "dek": "Orlando converts defensive pressure into a 14-point halftime lead.",
                        "scoreLockup": "DET 55–69 ORL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-paolo-burst",
                    "availableAtUtc": "2026-04-07T00:19:00Z",
                    "occurredAtUtc": "2026-04-07T00:19:00Z",
                    "display": {
                        "id": "det-orl-paolo-burst",
                        "unitType": "player",
                        "eyebrow": "PLAYER WATCH",
                        "headline": "Banchero takes over before the break.",
                        "dek": "His 21 first-half points put Orlando up 14.",
                        "scoreLockup": "DET 55–69 ORL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-q2-open",
                    "availableAtUtc": "2026-04-06T23:46:00Z",
                    "occurredAtUtc": "2026-04-06T23:46:00Z",
                    "display": {
                        "id": "det-orl-q2-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q2",
                        "headline": "Can Detroit contain Banchero?",
                        "dek": "Paolo starts the second with 10 and Orlando up two.",
                        "scoreLockup": "DET 28–30 ORL · START Q2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-q1",
                    "availableAtUtc": "2026-04-06T23:44:00Z",
                    "display": {
                        "id": "det-orl-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "Banchero gives Orlando the early edge.",
                        "dek": "Paolo scores 10 as the Magic lead 30–28 after one.",
                        "scoreLockup": "DET 28–30 ORL · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-tip",
                    "availableAtUtc": "2026-04-06T23:12:00Z",
                    "display": {
                        "id": "det-orl-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Detroit and Orlando are underway",
                        "dek": null,
                        "scoreLockup": "DET 0–0 ORL · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501144-standings-pregame",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "0022501144-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "The East leader visits ninth-place Orlando.",
                        "dek": "Detroit begins the night four games clear; Orlando is trying to climb into the play-in pack.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "DET",
                                        "name": "Pistons",
                                        "rank": "1",
                                        "record": "57–21",
                                        "percentage": ".731",
                                        "gamesBack": "—",
                                        "result": null
                                    },
                                    {
                                        "code": "ORL",
                                        "name": "Magic",
                                        "rank": "9",
                                        "record": "42–36",
                                        "percentage": ".538",
                                        "gamesBack": "15",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "id": "det-orl-pregame",
                    "availableAtUtc": "2026-04-06T22:12:00.000Z",
                    "display": {
                        "id": "det-orl-pregame",
                        "unitType": "pregame",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Orlando starts ninth in the East.",
                        "dek": "Detroit brings the conference’s best record to Kia Center; the Magic are chasing a higher Play-In seed.",
                        "scoreLockup": "DET @ ORL · 7:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-essentials",
                    "availableAtUtc": "2026-04-06T22:12:00.000Z",
                    "display": {
                        "id": "det-orl-essentials",
                        "unitType": "essentials",
                        "eyebrow": "GAME GUIDE",
                        "headline": "Orlando starts ninth; Detroit arrives short-handed.",
                        "dek": "Kia Center · 7:00 p.m. ET · The Magic can gain ground in the East against the conference leaders.",
                        "scoreLockup": "DET @ ORL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-paolo-pregame-source",
                    "availableAtUtc": "2026-04-06T22:12:00.000Z",
                    "display": {
                        "id": "det-orl-paolo-pregame-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Paolo before tip",
                        "dek": "Banchero works through his final warm-up reps at Kia Center.",
                        "scoreLockup": "DET @ ORL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                },
                {
                    "id": "det-orl-locker-room-source",
                    "availableAtUtc": "2026-04-06T22:12:00.000Z",
                    "display": {
                        "id": "det-orl-locker-room-source",
                        "unitType": "source-image",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Inside Orlando’s locker room.",
                        "dek": "The Magic get set for Detroit at Kia Center.",
                        "scoreLockup": "DET @ ORL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    }
                }
            ]
        },
        {
            "gameId": "0022501145",
            "matchup": "Cleveland Cavaliers at Memphis Grizzlies",
            "editorialRole": "Comeback, then record collision",
            "governingQuestion": "Can Memphis’ three-point volume overcome Cleveland’s response?",
            "anchorState": "CLE 89–77 MEM · Q3 · 4:49",
            "finalState": "CLE 142–126 MEM · FINAL",
            "entryVideoCandidateIds": {
                "anchor": "cle-mem-mobley-dunk-clip",
                "end": "cle-mem-record-three-clip"
            },
            "anchor": [
                {
                    "id": "cle-mem-mobley-dunk-clip",
                    "availableAtUtc": "2026-04-07T01:32:16.3529053Z",
                    "display": {
                        "id": "cle-mem-mobley-dunk-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Mobley hammers home Cleveland’s comeback.",
                        "dek": "The alley-oop gives Cleveland a six-point lead after it trailed by 17.",
                        "scoreLockup": "CLE 80–74 MEM · Q3 · 8:08",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "e78d99a8-52e4-a2a2-e739-3a2077be75d0",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Mobley hammers home Cleveland’s comeback. in the full-screen player"
                    }
                },
                {
                    "id": "cle-mem-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "cle-mem-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "Cleveland has turned 17 down into 12 up.",
                        "dek": "A 31–12 second-quarter run flipped the game.",
                        "scoreLockup": "CLE 89–77 MEM · Q3 · 4:49",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-live-story-snapshot",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "cle-mem-live-story-snapshot",
                        "unitType": "story-slice",
                        "eyebrow": "FOLLOW LIVE",
                        "headline": "Memphis opens with ten threes. Cleveland answers.",
                        "dek": "A 31–12 response turns a 17-point deficit into a halftime lead.",
                        "scoreLockup": "CLE 89–77 MEM · Q3 · 4:49",
                        "action": "Follow live",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story-snapshot",
                            "id": "9edf2454-015f-28a7-9247-3a20500cae6e@2026-04-07T01:35:00Z",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Memphis opens with ten threes. Cleveland answers."
                    }
                },
                {
                    "kind": "contextual-odds",
                    "id": "0022501145-contextual-live-odds",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "0022501145-contextual-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "CLE 89–77 MEM · Q3 · 4:49",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:0022501145",
                            "subject": "Dennis Schröder",
                            "marketLine": "Over 19.5 points",
                            "progress": "17 PTS",
                            "progressSummary": "Needs 3 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:0022501145:demonstrator"
                        },
                        "accessibleName": "Live odds. CLE 89–77 MEM · Q3 · 4:49. Dennis Schröder. 17 PTS current. Over 19.5 points selection. Needs 3 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    }
                },
                {
                    "id": "cle-mem-q3-open",
                    "availableAtUtc": "2026-04-07T01:21:00Z",
                    "occurredAtUtc": "2026-04-07T01:21:00Z",
                    "display": {
                        "id": "cle-mem-q3-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q3",
                        "headline": "The deficit is gone. Can Cleveland build?",
                        "dek": "A 31–12 response sends the Cavaliers into the third up four.",
                        "scoreLockup": "CLE 68–64 MEM · START Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-half",
                    "availableAtUtc": "2026-04-07T01:05:00Z",
                    "display": {
                        "id": "cle-mem-half",
                        "unitType": "checkpoint",
                        "eyebrow": "HALFTIME",
                        "headline": "Cleveland erases 17 down before halftime.",
                        "dek": "A 31–12 swing gives the Cavaliers a 68–64 lead.",
                        "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "kind": "momentum-swing",
                    "id": "cle-mem-halftime-comeback",
                    "availableAtUtc": "2026-04-07T01:05:00Z",
                    "occurredAtUtc": "2026-04-07T01:05:00Z",
                    "display": {
                        "id": "cle-mem-halftime-comeback",
                        "unitType": "run",
                        "eyebrow": "GAME CHANGER",
                        "headline": "A 31–12 run flips a 17-point deficit.",
                        "dek": "Cleveland turns Memphis’s ten-three opening quarter into a four-point halftime lead.",
                        "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Largest deficit",
                                "value": "17"
                            },
                            {
                                "label": "Cleveland run",
                                "value": "31–12"
                            },
                            {
                                "label": "Halftime lead",
                                "value": "+4"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-team-burst",
                    "availableAtUtc": "2026-04-07T01:05:00Z",
                    "occurredAtUtc": "2026-04-07T01:05:00Z",
                    "display": {
                        "id": "cle-mem-team-burst",
                        "unitType": "player",
                        "eyebrow": "GAME CHANGER",
                        "headline": "Cleveland turns 17 down into four up.",
                        "dek": "A 31–12 second-quarter run erases Memphis’s hot start.",
                        "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-whitehead-three-clip",
                    "availableAtUtc": "2026-04-07T01:03:15.7677866Z",
                    "display": {
                        "id": "cle-mem-whitehead-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Whitehead adds another Memphis three.",
                        "dek": "His fourth make from deep restores an 11-point lead before halftime.",
                        "scoreLockup": "CLE 44–55 MEM · Q2 · 4:47",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "d0f91a8c-e6ff-b61f-4a55-3a2077a3e69c",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Whitehead adds another Memphis three. in the full-screen player"
                    }
                },
                {
                    "id": "cle-mem-allen-and1-clip",
                    "availableAtUtc": "2026-04-07T00:56:33.116848Z",
                    "display": {
                        "id": "cle-mem-allen-and1-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Allen muscles through for the and-one.",
                        "dek": "The three-point play cuts Memphis’s lead to eight with 4:56 left in the half.",
                        "scoreLockup": "CLE 44–52 MEM · Q2 · 4:56",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "39ae3bc8-17a8-663b-7756-3a20779dc078",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Allen muscles through for the and-one. in the full-screen player"
                    }
                },
                {
                    "kind": "period-orientation",
                    "id": "cle-mem-q2-open",
                    "availableAtUtc": "2026-04-07T00:38:00Z",
                    "occurredAtUtc": "2026-04-07T00:38:00Z",
                    "display": {
                        "id": "cle-mem-q2-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q2",
                        "headline": "Ten threes have Cleveland chasing.",
                        "dek": "Seven Grizzlies have connected; Memphis leads by 12.",
                        "scoreLockup": "CLE 24–36 MEM · START Q2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-q1",
                    "availableAtUtc": "2026-04-07T00:35:00Z",
                    "display": {
                        "id": "cle-mem-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "Memphis rains in 10 threes.",
                        "dek": "Seven Grizzlies hit from deep as Memphis leads 36–24.",
                        "scoreLockup": "CLE 24–36 MEM · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-tip",
                    "availableAtUtc": "2026-04-07T00:11:00Z",
                    "display": {
                        "id": "cle-mem-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Cleveland and Memphis are underway",
                        "dek": null,
                        "scoreLockup": "CLE 0–0 MEM · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-pregame",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "cle-mem-pregame",
                        "unitType": "pregame",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Memphis closes its home schedule against Cleveland.",
                        "dek": "A Fan Appreciation Night backdrop meets Cleveland’s pursuit of 50 wins.",
                        "scoreLockup": "CLE @ MEM · 8:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-essentials",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "cle-mem-essentials",
                        "unitType": "essentials",
                        "eyebrow": "GAME GUIDE",
                        "headline": "Memphis closes at home; Cleveland chases win No. 50.",
                        "dek": "FedExForum · 8:00 p.m. ET · Fan Appreciation Night meets a milestone chance for the Cavaliers.",
                        "scoreLockup": "CLE @ MEM · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-mobley-pregame-source",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "cle-mem-mobley-pregame-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Mobley arrives at FedExForum.",
                        "dek": "Cleveland can reach 50 wins in Memphis’s home finale.",
                        "scoreLockup": "CLE @ MEM · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-locker-room-source",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "cle-mem-locker-room-source",
                        "unitType": "source-image",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Inside Cleveland’s locker room.",
                        "dek": "The Cavaliers get set for Memphis’s home finale.",
                        "scoreLockup": "CLE @ MEM · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501145-standings-pregame",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "0022501145-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "Fourth in the East meets 11th in the West.",
                        "dek": "Cleveland is chasing third; Memphis begins the night tied with Dallas.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "CLE",
                                        "name": "Cavaliers",
                                        "rank": "4",
                                        "record": "49–29",
                                        "percentage": ".628",
                                        "gamesBack": "8",
                                        "result": null
                                    }
                                ]
                            },
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "MEM",
                                        "name": "Grizzlies",
                                        "rank": "T11",
                                        "record": "25–53",
                                        "percentage": ".321",
                                        "gamesBack": "37",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                }
            ],
            "end": [
                {
                    "id": "cle-mem-record-three-clip",
                    "availableAtUtc": "2026-04-07T02:16:08.5335405Z",
                    "display": {
                        "id": "cle-mem-record-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Bal hits Memphis’s record-tying 29th three.",
                        "dek": "The make ties the NBA single-game record with 1:41 left.",
                        "scoreLockup": "CLE 136–126 MEM · Q4 · 1:41",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": 17,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "456dd37e-923d-2353-9fdd-3a2077e69f7d",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Bal hits Memphis’s record-tying 29th three. in the full-screen player"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501145-standings-final",
                    "availableAtUtc": "2026-04-07T04:46:01Z",
                    "display": {
                        "id": "0022501145-standings-final",
                        "unitType": "standings",
                        "eyebrow": "AFTER THE NIGHT",
                        "headline": "Cleveland reaches 50 wins and stays fourth.",
                        "dek": "The Cavaliers cut their gap to seven games; Memphis drops into a tie for 12th.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "After the last final · 12:46 a.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "CLE",
                                        "name": "Cavaliers",
                                        "rank": "4",
                                        "record": "50–29",
                                        "percentage": ".633",
                                        "gamesBack": "7",
                                        "result": "W"
                                    }
                                ]
                            },
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "MEM",
                                        "name": "Grizzlies",
                                        "rank": "T12",
                                        "record": "25–54",
                                        "percentage": ".316",
                                        "gamesBack": "37.5",
                                        "result": "L"
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "id": "cle-mem-final",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-final",
                        "unitType": "checkpoint",
                        "eyebrow": "FINAL",
                        "headline": "Cleveland reaches 50 with a season-high 142.",
                        "dek": "The Cavaliers shoot 58.4% and hand out a season-high 36 assists.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-game-story",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-game-story",
                        "unitType": "story",
                        "eyebrow": "GAME STORY",
                        "headline": "Cavaliers Rally Past Grizzlies",
                        "dek": "Relive Cleveland’s comeback and Memphis’ record-tying night from three.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "9edf2454-015f-28a7-9247-3a20500cae6e",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Cavaliers Rally Past Grizzlies"
                    }
                },
                {
                    "id": "cle-mem-gallery",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-gallery",
                        "unitType": "gallery",
                        "eyebrow": "PHOTOS",
                        "headline": "A record barrage meets Cleveland’s comeback.",
                        "dek": "Memphis hits 29 threes; the Cavaliers climb from 17 down to win No. 50.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "Swipe",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 3
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-game-flow",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-game-flow",
                        "unitType": "flow",
                        "eyebrow": "HOW IT HAPPENED",
                        "headline": "Seventeen down becomes a season-high 142.",
                        "dek": "A 31–12 second-quarter run erases the deficit; Cleveland leads by 11 after three and wins by 16.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "kind": "record",
                    "id": "cle-mem-record-29-threes",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-record-29-threes",
                        "unitType": "record",
                        "eyebrow": "RECORD",
                        "headline": "Memphis ties the NBA record with 29 threes.",
                        "dek": "All nine Grizzlies who played hit at least one.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Memphis threes",
                                "value": "29"
                            },
                            {
                                "label": "Cleveland threes",
                                "value": "23"
                            },
                            {
                                "label": "Combined threes",
                                "value": "52"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "kind": "milestone",
                    "id": "cle-mem-fifty-wins",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-fifty-wins",
                        "unitType": "milestone",
                        "eyebrow": "MILESTONE",
                        "headline": "Fifty wins, and home court secured.",
                        "dek": "A 17-point comeback and season-high 142 secure Cleveland’s first-round advantage.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Cleveland wins",
                                "value": "50"
                            },
                            {
                                "label": "Franchise occurrence",
                                "value": "14th"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-insight-receipt",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-insight-receipt",
                        "unitType": "receipt",
                        "eyebrow": "BY THE NUMBERS",
                        "headline": "Memphis hits 29 threes. Cleveland scores 142.",
                        "dek": "Together they make 52 threes in a 268-point game.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Cleveland points",
                                "value": "142"
                            },
                            {
                                "label": "Memphis threes",
                                "value": "29"
                            },
                            {
                                "label": "Combined threes",
                                "value": "52"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-photo-stat",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-photo-stat",
                        "unitType": "photo",
                        "eyebrow": "PHOTO STORY",
                        "headline": "Mobley scores 24 in win No. 50.",
                        "dek": "Cleveland climbs from 17 down to win by 16.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-cle-top-plays-story",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-cle-top-plays-story",
                        "unitType": "story-package",
                        "eyebrow": "WATCH MORE",
                        "headline": "Cleveland’s top plays",
                        "dek": "From 17 down to win No. 50: the Cavaliers’ best from Memphis.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "1add8ee3-22d3-1102-a69c-3a2077f4de6d",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Cleveland’s top plays"
                    }
                },
                {
                    "id": "cle-mem-mem-top-plays-story",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-mem-top-plays-story",
                        "unitType": "story-package",
                        "eyebrow": "WATCH MORE",
                        "headline": "Memphis’s top plays",
                        "dek": "Nine Grizzlies connect from deep as Memphis matches the NBA record.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "71726cdc-078e-d85d-f77a-3a2077f55f93",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Memphis’s top plays"
                    }
                },
                {
                    "kind": "story-package",
                    "id": "cle-mem-29-threes-story",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-29-threes-story",
                        "unitType": "story-package",
                        "eyebrow": "WATCH MORE",
                        "headline": "All 29 Memphis threes",
                        "dek": "Nine Grizzlies contribute to the record-tying total.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "65113432-5711-6f04-5748-3a2077f686aa",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open All 29 Memphis threes"
                    }
                },
                {
                    "id": "cle-mem-q4-open",
                    "availableAtUtc": "2026-04-07T01:51:00Z",
                    "occurredAtUtc": "2026-04-07T01:51:00Z",
                    "display": {
                        "id": "cle-mem-q4-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q4",
                        "headline": "Memphis needs one more barrage.",
                        "dek": "An 8–0 close cuts Cleveland’s lead to 11 with a quarter to play.",
                        "scoreLockup": "CLE 101–90 MEM · START Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-q3",
                    "availableAtUtc": "2026-04-07T01:49:00Z",
                    "display": {
                        "id": "cle-mem-q3",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q3",
                        "headline": "Cleveland keeps control; Memphis keeps firing.",
                        "dek": "The Cavaliers lead 101–90 after three despite an 8–0 Memphis close.",
                        "scoreLockup": "CLE 101–90 MEM · END Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-schroder-three-clip",
                    "availableAtUtc": "2026-04-07T01:42:33.9245027Z",
                    "display": {
                        "id": "cle-mem-schroder-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Schröder pulls up from deep.",
                        "dek": "The make pushes Cleveland’s lead to 12 midway through the third.",
                        "scoreLockup": "CLE 89–77 MEM · Q3 · 5:02",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "a4e11fe3-42dc-8800-080e-3a2077c7e318",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Schröder pulls up from deep. in the full-screen player"
                    }
                },
                {
                    "id": "cle-mem-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "cle-mem-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "Cleveland has turned 17 down into 12 up.",
                        "dek": "A 31–12 second-quarter run flipped the game.",
                        "scoreLockup": "CLE 89–77 MEM · Q3 · 4:49",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-live-story-snapshot",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "cle-mem-live-story-snapshot",
                        "unitType": "story-slice",
                        "eyebrow": "FOLLOW LIVE",
                        "headline": "Memphis opens with ten threes. Cleveland answers.",
                        "dek": "A 31–12 response turns a 17-point deficit into a halftime lead.",
                        "scoreLockup": "CLE 89–77 MEM · Q3 · 4:49",
                        "action": "Follow live",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story-snapshot",
                            "id": "9edf2454-015f-28a7-9247-3a20500cae6e@2026-04-07T01:35:00Z",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Memphis opens with ten threes. Cleveland answers."
                    }
                },
                {
                    "id": "cle-mem-mobley-dunk-clip",
                    "availableAtUtc": "2026-04-07T01:32:16.3529053Z",
                    "display": {
                        "id": "cle-mem-mobley-dunk-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Mobley hammers home Cleveland’s comeback.",
                        "dek": "The alley-oop gives Cleveland a six-point lead after it trailed by 17.",
                        "scoreLockup": "CLE 80–74 MEM · Q3 · 8:08",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "e78d99a8-52e4-a2a2-e739-3a2077be75d0",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Mobley hammers home Cleveland’s comeback. in the full-screen player"
                    }
                },
                {
                    "id": "cle-mem-q3-open",
                    "availableAtUtc": "2026-04-07T01:21:00Z",
                    "occurredAtUtc": "2026-04-07T01:21:00Z",
                    "display": {
                        "id": "cle-mem-q3-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q3",
                        "headline": "The deficit is gone. Can Cleveland build?",
                        "dek": "A 31–12 response sends the Cavaliers into the third up four.",
                        "scoreLockup": "CLE 68–64 MEM · START Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-half",
                    "availableAtUtc": "2026-04-07T01:05:00Z",
                    "display": {
                        "id": "cle-mem-half",
                        "unitType": "checkpoint",
                        "eyebrow": "HALFTIME",
                        "headline": "Cleveland erases 17 down before halftime.",
                        "dek": "A 31–12 swing gives the Cavaliers a 68–64 lead.",
                        "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "kind": "momentum-swing",
                    "id": "cle-mem-halftime-comeback",
                    "availableAtUtc": "2026-04-07T01:05:00Z",
                    "occurredAtUtc": "2026-04-07T01:05:00Z",
                    "display": {
                        "id": "cle-mem-halftime-comeback",
                        "unitType": "run",
                        "eyebrow": "GAME CHANGER",
                        "headline": "A 31–12 run flips a 17-point deficit.",
                        "dek": "Cleveland turns Memphis’s ten-three opening quarter into a four-point halftime lead.",
                        "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Largest deficit",
                                "value": "17"
                            },
                            {
                                "label": "Cleveland run",
                                "value": "31–12"
                            },
                            {
                                "label": "Halftime lead",
                                "value": "+4"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-team-burst",
                    "availableAtUtc": "2026-04-07T01:05:00Z",
                    "occurredAtUtc": "2026-04-07T01:05:00Z",
                    "display": {
                        "id": "cle-mem-team-burst",
                        "unitType": "player",
                        "eyebrow": "GAME CHANGER",
                        "headline": "Cleveland turns 17 down into four up.",
                        "dek": "A 31–12 second-quarter run erases Memphis’s hot start.",
                        "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-whitehead-three-clip",
                    "availableAtUtc": "2026-04-07T01:03:15.7677866Z",
                    "display": {
                        "id": "cle-mem-whitehead-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Whitehead adds another Memphis three.",
                        "dek": "His fourth make from deep restores an 11-point lead before halftime.",
                        "scoreLockup": "CLE 44–55 MEM · Q2 · 4:47",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "d0f91a8c-e6ff-b61f-4a55-3a2077a3e69c",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Whitehead adds another Memphis three. in the full-screen player"
                    }
                },
                {
                    "id": "cle-mem-allen-and1-clip",
                    "availableAtUtc": "2026-04-07T00:56:33.116848Z",
                    "display": {
                        "id": "cle-mem-allen-and1-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Allen muscles through for the and-one.",
                        "dek": "The three-point play cuts Memphis’s lead to eight with 4:56 left in the half.",
                        "scoreLockup": "CLE 44–52 MEM · Q2 · 4:56",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "39ae3bc8-17a8-663b-7756-3a20779dc078",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open Allen muscles through for the and-one. in the full-screen player"
                    }
                },
                {
                    "kind": "period-orientation",
                    "id": "cle-mem-q2-open",
                    "availableAtUtc": "2026-04-07T00:38:00Z",
                    "occurredAtUtc": "2026-04-07T00:38:00Z",
                    "display": {
                        "id": "cle-mem-q2-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q2",
                        "headline": "Ten threes have Cleveland chasing.",
                        "dek": "Seven Grizzlies have connected; Memphis leads by 12.",
                        "scoreLockup": "CLE 24–36 MEM · START Q2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-q1",
                    "availableAtUtc": "2026-04-07T00:35:00Z",
                    "display": {
                        "id": "cle-mem-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "Memphis rains in 10 threes.",
                        "dek": "Seven Grizzlies hit from deep as Memphis leads 36–24.",
                        "scoreLockup": "CLE 24–36 MEM · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-tip",
                    "availableAtUtc": "2026-04-07T00:11:00Z",
                    "display": {
                        "id": "cle-mem-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Cleveland and Memphis are underway",
                        "dek": null,
                        "scoreLockup": "CLE 0–0 MEM · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-pregame",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "cle-mem-pregame",
                        "unitType": "pregame",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Memphis closes its home schedule against Cleveland.",
                        "dek": "A Fan Appreciation Night backdrop meets Cleveland’s pursuit of 50 wins.",
                        "scoreLockup": "CLE @ MEM · 8:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-essentials",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "cle-mem-essentials",
                        "unitType": "essentials",
                        "eyebrow": "GAME GUIDE",
                        "headline": "Memphis closes at home; Cleveland chases win No. 50.",
                        "dek": "FedExForum · 8:00 p.m. ET · Fan Appreciation Night meets a milestone chance for the Cavaliers.",
                        "scoreLockup": "CLE @ MEM · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-mobley-pregame-source",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "cle-mem-mobley-pregame-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Mobley arrives at FedExForum.",
                        "dek": "Cleveland can reach 50 wins in Memphis’s home finale.",
                        "scoreLockup": "CLE @ MEM · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "id": "cle-mem-locker-room-source",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "cle-mem-locker-room-source",
                        "unitType": "source-image",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Inside Cleveland’s locker room.",
                        "dek": "The Cavaliers get set for Memphis’s home finale.",
                        "scoreLockup": "CLE @ MEM · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501145-standings-pregame",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "0022501145-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "Fourth in the East meets 11th in the West.",
                        "dek": "Cleveland is chasing third; Memphis begins the night tied with Dallas.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "CLE",
                                        "name": "Cavaliers",
                                        "rank": "4",
                                        "record": "49–29",
                                        "percentage": ".628",
                                        "gamesBack": "8",
                                        "result": null
                                    }
                                ]
                            },
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "MEM",
                                        "name": "Grizzlies",
                                        "rank": "T11",
                                        "record": "25–53",
                                        "percentage": ".321",
                                        "gamesBack": "37",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                }
            ]
        },
        {
            "gameId": "0022501146",
            "matchup": "Philadelphia 76ers at San Antonio Spurs",
            "editorialRole": "Star matchup becomes a playmaking story",
            "governingQuestion": "Can Philadelphia close the gap, and who drives San Antonio after halftime?",
            "anchorState": "PHI 65–74 SAS · Q3 · 8:17",
            "finalState": "PHI 102–115 SAS · FINAL",
            "entryVideoCandidateIds": {
                "anchor": "phi-sas-castle-wemby-social",
                "end": "phi-sas-castle-wemby-social"
            },
            "anchor": [
                {
                    "kind": "official-social-source",
                    "id": "phi-sas-castle-wemby-social",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "phi-sas-castle-wemby-social",
                        "unitType": "social",
                        "eyebrow": null,
                        "headline": "Castle freezes his defender, then finds Wembanyama above the rim.",
                        "dek": "The one-handed finish puts San Antonio ahead with 6:21 left in the first.",
                        "scoreLockup": "PHI 15–16 SAS · Q1 · 6:21",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "phi-sas-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "San Antonio’s passing is pulling Philadelphia apart.",
                        "dek": "The Spurs have 23 assists on 30 makes; Castle has eight.",
                        "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "story-snapshot",
                    "id": "phi-sas-all-access-story",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "phi-sas-all-access-story",
                        "unitType": "story-slice",
                        "eyebrow": "FOLLOW LIVE",
                        "headline": "From the tunnel to San Antonio’s nine-point lead.",
                        "dek": "See arrivals, warmups, crowd atmosphere and live action at Frost Bank Center.",
                        "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                        "action": "Follow live",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story-snapshot",
                            "id": "4701c6e4-c661-46e7-234b-3a2073da5482@2026-04-07T01:35:00Z",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open From the tunnel to San Antonio’s nine-point lead."
                    }
                },
                {
                    "id": "phi-sas-live-story-snapshot",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "phi-sas-live-story-snapshot",
                        "unitType": "story-slice",
                        "eyebrow": "FOLLOW LIVE",
                        "headline": "San Antonio’s night, from the tunnel to the third.",
                        "dek": "See arrivals, warmups and live action as the Spurs build a nine-point lead.",
                        "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                        "action": "Follow live",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story-snapshot",
                            "id": "8bc8d022-f0af-662b-3761-3a20500ca56c@2026-04-07T01:35:00Z",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open San Antonio’s night, from the tunnel to the third."
                    }
                },
                {
                    "kind": "contextual-odds",
                    "id": "0022501146-contextual-live-odds",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "0022501146-contextual-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:0022501146",
                            "subject": "Joel Embiid",
                            "marketLine": "Over 29.5 points",
                            "progress": "25 PTS",
                            "progressSummary": "Needs 5 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:0022501146:demonstrator"
                        },
                        "accessibleName": "Live odds. PHI 65–74 SAS · Q3 · 8:17. Joel Embiid. 25 PTS current. Over 29.5 points selection. Needs 5 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    }
                },
                {
                    "id": "phi-sas-q3-open",
                    "availableAtUtc": "2026-04-07T01:26:00Z",
                    "occurredAtUtc": "2026-04-07T01:26:00Z",
                    "display": {
                        "id": "phi-sas-q3-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q3",
                        "headline": "Who drives San Antonio after halftime?",
                        "dek": null,
                        "scoreLockup": "PHI 55–62 SAS · START Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-embiid-three-clip",
                    "availableAtUtc": "2026-04-07T01:11:33.5922256Z",
                    "display": {
                        "id": "phi-sas-embiid-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Embiid steps out and knocks down the three.",
                        "dek": "His 20th point pulls Philadelphia within five before halftime.",
                        "scoreLockup": "PHI 54–59 SAS · Q2 · 1:06",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "0ef3941e-f4e0-2d90-2689-3a2077ab7b58",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Embiid steps out and knocks down the three. in the full-screen player"
                    }
                },
                {
                    "kind": "period-checkpoint",
                    "id": "phi-sas-half",
                    "availableAtUtc": "2026-04-07T01:11:00Z",
                    "display": {
                        "id": "phi-sas-half",
                        "unitType": "checkpoint",
                        "eyebrow": "HALFTIME",
                        "headline": "Wemby and Embiid own the half.",
                        "dek": "Wembanyama has 17, five and three blocks; Embiid has 20.",
                        "scoreLockup": "PHI 55–62 SAS · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "player-performance",
                    "id": "phi-sas-embiid-burst",
                    "availableAtUtc": "2026-04-07T01:11:00Z",
                    "occurredAtUtc": "2026-04-07T01:11:00Z",
                    "display": {
                        "id": "phi-sas-embiid-burst",
                        "unitType": "player",
                        "eyebrow": "PLAYER WATCH",
                        "headline": "Embiid keeps Philadelphia within reach.",
                        "dek": "He scores 20 before halftime, but San Antonio leads by seven.",
                        "scoreLockup": "PHI 55–62 SAS · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "First-half points",
                                "value": "20"
                            },
                            {
                                "label": "First-quarter blocks",
                                "value": "2"
                            },
                            {
                                "label": "Halftime margin",
                                "value": "SAS +7"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "phi-sas-wemby-dunk-clip",
                    "availableAtUtc": "2026-04-07T01:05:23.7892618Z",
                    "display": {
                        "id": "phi-sas-wemby-dunk-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Vassell lifts it. Wembanyama finishes with two hands.",
                        "dek": "The alley-oop puts San Antonio ahead with 4:50 left in the half.",
                        "scoreLockup": "PHI 49–51 SAS · Q2 · 4:50",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "95e60eee-ffd2-6f06-d30b-3a2077a5da3a",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Vassell lifts it. Wembanyama finishes with two hands. in the full-screen player"
                    }
                },
                {
                    "id": "phi-sas-q2-open",
                    "availableAtUtc": "2026-04-07T00:39:00Z",
                    "occurredAtUtc": "2026-04-07T00:39:00Z",
                    "display": {
                        "id": "phi-sas-q2-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q2",
                        "headline": "One point separates the big-man duel.",
                        "dek": "Embiid and Wembanyama have two blocks each; George leads all scorers with 11.",
                        "scoreLockup": "PHI 28–29 SAS · START Q2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-wemby-block-clip",
                    "availableAtUtc": "2026-04-07T00:38:33.5247374Z",
                    "display": {
                        "id": "phi-sas-wemby-block-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Wembanyama turns Embiid away at the rim.",
                        "dek": "His second block keeps San Antonio within one late in the first.",
                        "scoreLockup": "PHI 26–25 SAS · Q1 · 1:40",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "5076e737-9009-2649-ce88-3a20778d4879",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Wembanyama turns Embiid away at the rim. in the full-screen player"
                    }
                },
                {
                    "kind": "game-insight",
                    "id": "phi-sas-q1-duel",
                    "availableAtUtc": "2026-04-07T00:36:00Z",
                    "occurredAtUtc": "2026-04-07T00:36:00Z",
                    "display": {
                        "id": "phi-sas-q1-duel",
                        "unitType": "insight",
                        "eyebrow": "END Q1",
                        "headline": "Embiid and Wembanyama trade two blocks each.",
                        "dek": "San Antonio takes a 29–28 lead out of the opening quarter.",
                        "scoreLockup": "PHI 28–29 SAS · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Embiid blocks",
                                "value": "2"
                            },
                            {
                                "label": "Wemby blocks",
                                "value": "2"
                            },
                            {
                                "label": "Q1 margin",
                                "value": "SAS +1"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-q1",
                    "availableAtUtc": "2026-04-07T00:36:00Z",
                    "display": {
                        "id": "phi-sas-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "The bigs trade blocks; San Antonio leads by one.",
                        "dek": "Paul George scores 11; Wembanyama has nine and two blocks.",
                        "scoreLockup": "PHI 28–29 SAS · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-castle-assist-clip",
                    "availableAtUtc": "2026-04-07T00:26:53.4732344Z",
                    "display": {
                        "id": "phi-sas-castle-assist-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Castle drops the pass into the paint.",
                        "dek": "His second assist puts San Antonio ahead midway through the first.",
                        "scoreLockup": "PHI 15–16 SAS · Q1 · 6:21",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "d50e6870-7822-03f7-9903-3a20778299bd",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Castle drops the pass into the paint. in the full-screen player"
                    }
                },
                {
                    "kind": "event-start",
                    "id": "phi-sas-tip",
                    "availableAtUtc": "2026-04-07T00:11:00Z",
                    "display": {
                        "id": "phi-sas-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Philadelphia and San Antonio are underway",
                        "dek": null,
                        "scoreLockup": "PHI 0–0 SAS · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-arena-love-source",
                    "availableAtUtc": "2026-04-07T00:08:34Z",
                    "display": {
                        "id": "phi-sas-arena-love-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "San Antonio shows Wemby love",
                        "dek": "The Frost Bank Center crowd welcomes him through warmups.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-wemby-locking-in-source",
                    "availableAtUtc": "2026-04-06T23:29:00Z",
                    "display": {
                        "id": "phi-sas-wemby-locking-in-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Wemby locks in",
                        "dek": "Final warm-up reps before the night’s biggest individual matchup.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-pregame-slams-source",
                    "availableAtUtc": "2026-04-06T23:18:04Z",
                    "display": {
                        "id": "phi-sas-pregame-slams-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Warmups turn into a dunk show.",
                        "dek": "Philadelphia and San Antonio trade above-the-rim finishes before tip.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-maxey-halfcourt-source",
                    "availableAtUtc": "2026-04-06T23:18:04Z",
                    "display": {
                        "id": "phi-sas-maxey-halfcourt-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Maxey splashes one from half court",
                        "dek": "The shot drops during Philadelphia’s warmups in San Antonio.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "pregame-scene-setter",
                    "id": "phi-sas-pregame",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "phi-sas-pregame",
                        "unitType": "pregame",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Embiid and Wembanyama meet in San Antonio.",
                        "dek": "Philadelphia starts sixth in the East; San Antonio starts second in the West.",
                        "scoreLockup": "PHI @ SAS · 8:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-essentials",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "phi-sas-essentials",
                        "unitType": "essentials",
                        "eyebrow": "GAME GUIDE",
                        "headline": "San Antonio puts win No. 60 in reach.",
                        "dek": "The Spurs enter 59–19; Philadelphia arrives 43–35.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Tip",
                                "value": "8:00 p.m. ET"
                            },
                            {
                                "label": "Arena",
                                "value": "Frost Bank"
                            },
                            {
                                "label": "Watch",
                                "value": "League Pass"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501146-standings-pregame",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "0022501146-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "Sixth in the East meets second in the West.",
                        "dek": "Philadelphia begins in the final automatic playoff place; San Antonio is chasing Oklahoma City.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "PHI",
                                        "name": "76ers",
                                        "rank": "6",
                                        "record": "43–35",
                                        "percentage": ".551",
                                        "gamesBack": "14",
                                        "result": null
                                    }
                                ]
                            },
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "SAS",
                                        "name": "Spurs",
                                        "rank": "2",
                                        "record": "59–19",
                                        "percentage": ".756",
                                        "gamesBack": "3",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "captioned-image",
                    "id": "phi-sas-castle-warmup-source",
                    "availableAtUtc": "2026-04-06T22:44:35Z",
                    "display": {
                        "id": "phi-sas-castle-warmup-source",
                        "unitType": "source-image",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Castle’s final reps before tip.",
                        "dek": "San Antonio is one win from 60 as Castle gets loose.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "phi-sas-philly-arrival-source",
                    "availableAtUtc": "2026-04-06T22:44:35Z",
                    "display": {
                        "id": "phi-sas-philly-arrival-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Philly is in the building",
                        "dek": "Philadelphia arrives in San Antonio before the big-man matchup.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-rookies-source",
                    "availableAtUtc": "2026-04-06T22:44:35Z",
                    "display": {
                        "id": "phi-sas-rookies-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "The rookies meet before tip.",
                        "dek": "The opposing rookies share a quick word before the Spurs and 76ers take the floor.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                }
            ],
            "end": [
                {
                    "kind": "official-social-source",
                    "id": "phi-sas-castle-wemby-social",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "phi-sas-castle-wemby-social",
                        "unitType": "social",
                        "eyebrow": null,
                        "headline": "Castle freezes his defender, then finds Wembanyama above the rim.",
                        "dek": "The one-handed finish puts San Antonio ahead with 6:21 left in the first.",
                        "scoreLockup": "PHI 15–16 SAS · Q1 · 6:21",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501146-standings-final",
                    "availableAtUtc": "2026-04-07T04:46:01Z",
                    "display": {
                        "id": "0022501146-standings-final",
                        "unitType": "standings",
                        "eyebrow": "AFTER THE NIGHT",
                        "headline": "San Antonio reaches 60. Philadelphia joins the East tie.",
                        "dek": "The Spurs cut Oklahoma City’s lead to 2.5 games; the 76ers fall into a three-team tie.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "After the last final · 12:46 a.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "PHI",
                                        "name": "76ers",
                                        "rank": "T7",
                                        "record": "43–36",
                                        "percentage": ".544",
                                        "gamesBack": "14",
                                        "result": "L"
                                    }
                                ]
                            },
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "SAS",
                                        "name": "Spurs",
                                        "rank": "2",
                                        "record": "60–19",
                                        "percentage": ".759",
                                        "gamesBack": "2.5",
                                        "result": "W"
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "id": "phi-sas-final",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-final",
                        "unitType": "checkpoint",
                        "eyebrow": "FINAL",
                        "headline": "San Antonio reaches 60 wins.",
                        "dek": "The Spurs beat Philadelphia 115–102 despite Embiid’s 34 points and 12 rebounds.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-game-story",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-game-story",
                        "unitType": "story",
                        "eyebrow": "GAME STORY",
                        "headline": "Castle’s triple-double carries San Antonio past Philadelphia.",
                        "dek": "Relive Embiid’s 34, Wembanyama’s early exit and Castle’s second-half command.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "8bc8d022-f0af-662b-3761-3a20500ca56c",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Castle’s triple-double carries San Antonio past Philadelphia."
                    }
                },
                {
                    "id": "phi-sas-gallery",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-gallery",
                        "unitType": "gallery",
                        "eyebrow": "PHOTOS",
                        "headline": "Embiid starts it. Castle finishes it.",
                        "dek": "Wembanyama’s exit changes the matchup between those two performances.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 3
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-game-flow",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-game-flow",
                        "unitType": "flow",
                        "eyebrow": "HOW IT HAPPENED",
                        "headline": "San Antonio answers every Philadelphia push",
                        "dek": "San Antonio opens the third 10–0, Philadelphia answers 8–0, and the Spurs pull away again.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "milestone",
                    "id": "phi-sas-castle-triple-double",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-castle-triple-double",
                        "unitType": "milestone",
                        "eyebrow": "MILESTONE",
                        "headline": "Castle’s fifth triple-double: 19, 10 and 13.",
                        "dek": "He takes control after halftime and carries San Antonio to its 60th win.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Points",
                                "value": "19"
                            },
                            {
                                "label": "Rebounds",
                                "value": "10"
                            },
                            {
                                "label": "Assists",
                                "value": "13"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "official-status",
                    "id": "phi-sas-wemby-injury",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-wemby-injury",
                        "unitType": "status",
                        "eyebrow": "STATUS UPDATE",
                        "headline": "Wembanyama exits with a left rib contusion.",
                        "dek": "Wembanyama plays 15:40 before leaving the game.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-castle-impact",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-castle-impact",
                        "unitType": "receipt",
                        "eyebrow": "BY THE NUMBERS",
                        "headline": "Castle fills every column in the win.",
                        "dek": "His 19-point, 10-rebound, 13-assist triple-double carries San Antonio to win No. 60.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Points",
                                "value": "19"
                            },
                            {
                                "label": "Rebounds",
                                "value": "10"
                            },
                            {
                                "label": "Assists",
                                "value": "13"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-photo-stat",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-photo-stat",
                        "unitType": "photo",
                        "eyebrow": "PHOTO STORY",
                        "headline": "Embiid and Wembanyama set the first-half tone.",
                        "dek": "Embiid scores 20; Wembanyama has 17 before leaving with a rib contusion.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-phi-top-plays-story",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-phi-top-plays-story",
                        "unitType": "story-package",
                        "eyebrow": "WATCH MORE",
                        "headline": "Philadelphia’s top plays",
                        "dek": "Embiid’s 34 points and 12 rebounds lead Philadelphia’s best work.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "17e7a04b-6659-2e9d-e1fe-3a2077ffa42b",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Philadelphia’s top plays"
                    }
                },
                {
                    "id": "phi-sas-sas-top-plays-story",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-sas-top-plays-story",
                        "unitType": "story-package",
                        "eyebrow": "WATCH MORE",
                        "headline": "San Antonio’s top plays",
                        "dek": "Watch the plays that carried San Antonio to its 60th win.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "44ee2953-7be7-9ef8-6b51-3a2077ffd44b",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open San Antonio’s top plays"
                    }
                },
                {
                    "id": "phi-sas-q4-open",
                    "availableAtUtc": "2026-04-07T02:00:00Z",
                    "occurredAtUtc": "2026-04-07T02:00:00Z",
                    "display": {
                        "id": "phi-sas-q4-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q4",
                        "headline": "Castle has one quarter to finish the job",
                        "dek": "San Antonio leads seven and its guard is closing in on a triple-double.",
                        "scoreLockup": "PHI 85–92 SAS · START Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-q3",
                    "availableAtUtc": "2026-04-07T01:57:00Z",
                    "display": {
                        "id": "phi-sas-q3",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q3",
                        "headline": "Castle drives San Antonio through the third.",
                        "dek": "The Spurs lead 92–85 as Castle closes in on a triple-double.",
                        "scoreLockup": "PHI 85–92 SAS · END Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-castle-three-clip",
                    "availableAtUtc": "2026-04-07T01:47:15.6872909Z",
                    "display": {
                        "id": "phi-sas-castle-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Castle steps into the three.",
                        "dek": "His 13th point pushes San Antonio’s lead to 11 midway through the third.",
                        "scoreLockup": "PHI 70–81 SAS · Q3 · 6:19",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "24c0b833-9c37-50f9-5624-3a2077cc2e23",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Castle steps into the three. in the full-screen player"
                    }
                },
                {
                    "id": "phi-sas-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "phi-sas-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "San Antonio’s passing is pulling Philadelphia apart.",
                        "dek": "The Spurs have 23 assists on 30 makes; Castle has eight.",
                        "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "story-snapshot",
                    "id": "phi-sas-all-access-story",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "phi-sas-all-access-story",
                        "unitType": "story-slice",
                        "eyebrow": "FOLLOW LIVE",
                        "headline": "From the tunnel to San Antonio’s nine-point lead.",
                        "dek": "See arrivals, warmups, crowd atmosphere and live action at Frost Bank Center.",
                        "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                        "action": "Follow live",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story-snapshot",
                            "id": "4701c6e4-c661-46e7-234b-3a2073da5482@2026-04-07T01:35:00Z",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open From the tunnel to San Antonio’s nine-point lead."
                    }
                },
                {
                    "id": "phi-sas-live-story-snapshot",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "phi-sas-live-story-snapshot",
                        "unitType": "story-slice",
                        "eyebrow": "FOLLOW LIVE",
                        "headline": "San Antonio’s night, from the tunnel to the third.",
                        "dek": "See arrivals, warmups and live action as the Spurs build a nine-point lead.",
                        "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                        "action": "Follow live",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "story-snapshot",
                            "id": "8bc8d022-f0af-662b-3761-3a20500ca56c@2026-04-07T01:35:00Z",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open San Antonio’s night, from the tunnel to the third."
                    }
                },
                {
                    "id": "phi-sas-q3-open",
                    "availableAtUtc": "2026-04-07T01:26:00Z",
                    "occurredAtUtc": "2026-04-07T01:26:00Z",
                    "display": {
                        "id": "phi-sas-q3-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q3",
                        "headline": "Who drives San Antonio after halftime?",
                        "dek": null,
                        "scoreLockup": "PHI 55–62 SAS · START Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-embiid-three-clip",
                    "availableAtUtc": "2026-04-07T01:11:33.5922256Z",
                    "display": {
                        "id": "phi-sas-embiid-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Embiid steps out and knocks down the three.",
                        "dek": "His 20th point pulls Philadelphia within five before halftime.",
                        "scoreLockup": "PHI 54–59 SAS · Q2 · 1:06",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "0ef3941e-f4e0-2d90-2689-3a2077ab7b58",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Embiid steps out and knocks down the three. in the full-screen player"
                    }
                },
                {
                    "kind": "period-checkpoint",
                    "id": "phi-sas-half",
                    "availableAtUtc": "2026-04-07T01:11:00Z",
                    "display": {
                        "id": "phi-sas-half",
                        "unitType": "checkpoint",
                        "eyebrow": "HALFTIME",
                        "headline": "Wemby and Embiid own the half.",
                        "dek": "Wembanyama has 17, five and three blocks; Embiid has 20.",
                        "scoreLockup": "PHI 55–62 SAS · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "player-performance",
                    "id": "phi-sas-embiid-burst",
                    "availableAtUtc": "2026-04-07T01:11:00Z",
                    "occurredAtUtc": "2026-04-07T01:11:00Z",
                    "display": {
                        "id": "phi-sas-embiid-burst",
                        "unitType": "player",
                        "eyebrow": "PLAYER WATCH",
                        "headline": "Embiid keeps Philadelphia within reach.",
                        "dek": "He scores 20 before halftime, but San Antonio leads by seven.",
                        "scoreLockup": "PHI 55–62 SAS · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "First-half points",
                                "value": "20"
                            },
                            {
                                "label": "First-quarter blocks",
                                "value": "2"
                            },
                            {
                                "label": "Halftime margin",
                                "value": "SAS +7"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "phi-sas-wemby-dunk-clip",
                    "availableAtUtc": "2026-04-07T01:05:23.7892618Z",
                    "display": {
                        "id": "phi-sas-wemby-dunk-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Vassell lifts it. Wembanyama finishes with two hands.",
                        "dek": "The alley-oop puts San Antonio ahead with 4:50 left in the half.",
                        "scoreLockup": "PHI 49–51 SAS · Q2 · 4:50",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "95e60eee-ffd2-6f06-d30b-3a2077a5da3a",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Vassell lifts it. Wembanyama finishes with two hands. in the full-screen player"
                    }
                },
                {
                    "id": "phi-sas-q2-open",
                    "availableAtUtc": "2026-04-07T00:39:00Z",
                    "occurredAtUtc": "2026-04-07T00:39:00Z",
                    "display": {
                        "id": "phi-sas-q2-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q2",
                        "headline": "One point separates the big-man duel.",
                        "dek": "Embiid and Wembanyama have two blocks each; George leads all scorers with 11.",
                        "scoreLockup": "PHI 28–29 SAS · START Q2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-wemby-block-clip",
                    "availableAtUtc": "2026-04-07T00:38:33.5247374Z",
                    "display": {
                        "id": "phi-sas-wemby-block-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Wembanyama turns Embiid away at the rim.",
                        "dek": "His second block keeps San Antonio within one late in the first.",
                        "scoreLockup": "PHI 26–25 SAS · Q1 · 1:40",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "5076e737-9009-2649-ce88-3a20778d4879",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Wembanyama turns Embiid away at the rim. in the full-screen player"
                    }
                },
                {
                    "kind": "game-insight",
                    "id": "phi-sas-q1-duel",
                    "availableAtUtc": "2026-04-07T00:36:00Z",
                    "occurredAtUtc": "2026-04-07T00:36:00Z",
                    "display": {
                        "id": "phi-sas-q1-duel",
                        "unitType": "insight",
                        "eyebrow": "END Q1",
                        "headline": "Embiid and Wembanyama trade two blocks each.",
                        "dek": "San Antonio takes a 29–28 lead out of the opening quarter.",
                        "scoreLockup": "PHI 28–29 SAS · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Embiid blocks",
                                "value": "2"
                            },
                            {
                                "label": "Wemby blocks",
                                "value": "2"
                            },
                            {
                                "label": "Q1 margin",
                                "value": "SAS +1"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-q1",
                    "availableAtUtc": "2026-04-07T00:36:00Z",
                    "display": {
                        "id": "phi-sas-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "The bigs trade blocks; San Antonio leads by one.",
                        "dek": "Paul George scores 11; Wembanyama has nine and two blocks.",
                        "scoreLockup": "PHI 28–29 SAS · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-castle-assist-clip",
                    "availableAtUtc": "2026-04-07T00:26:53.4732344Z",
                    "display": {
                        "id": "phi-sas-castle-assist-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Castle drops the pass into the paint.",
                        "dek": "His second assist puts San Antonio ahead midway through the first.",
                        "scoreLockup": "PHI 15–16 SAS · Q1 · 6:21",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "d50e6870-7822-03f7-9903-3a20778299bd",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Castle drops the pass into the paint. in the full-screen player"
                    }
                },
                {
                    "kind": "event-start",
                    "id": "phi-sas-tip",
                    "availableAtUtc": "2026-04-07T00:11:00Z",
                    "display": {
                        "id": "phi-sas-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Philadelphia and San Antonio are underway",
                        "dek": null,
                        "scoreLockup": "PHI 0–0 SAS · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-arena-love-source",
                    "availableAtUtc": "2026-04-07T00:08:34Z",
                    "display": {
                        "id": "phi-sas-arena-love-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "San Antonio shows Wemby love",
                        "dek": "The Frost Bank Center crowd welcomes him through warmups.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-wemby-locking-in-source",
                    "availableAtUtc": "2026-04-06T23:29:00Z",
                    "display": {
                        "id": "phi-sas-wemby-locking-in-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Wemby locks in",
                        "dek": "Final warm-up reps before the night’s biggest individual matchup.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-pregame-slams-source",
                    "availableAtUtc": "2026-04-06T23:18:04Z",
                    "display": {
                        "id": "phi-sas-pregame-slams-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Warmups turn into a dunk show.",
                        "dek": "Philadelphia and San Antonio trade above-the-rim finishes before tip.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-maxey-halfcourt-source",
                    "availableAtUtc": "2026-04-06T23:18:04Z",
                    "display": {
                        "id": "phi-sas-maxey-halfcourt-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Maxey splashes one from half court",
                        "dek": "The shot drops during Philadelphia’s warmups in San Antonio.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "pregame-scene-setter",
                    "id": "phi-sas-pregame",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "phi-sas-pregame",
                        "unitType": "pregame",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Embiid and Wembanyama meet in San Antonio.",
                        "dek": "Philadelphia starts sixth in the East; San Antonio starts second in the West.",
                        "scoreLockup": "PHI @ SAS · 8:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-essentials",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "phi-sas-essentials",
                        "unitType": "essentials",
                        "eyebrow": "GAME GUIDE",
                        "headline": "San Antonio puts win No. 60 in reach.",
                        "dek": "The Spurs enter 59–19; Philadelphia arrives 43–35.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Tip",
                                "value": "8:00 p.m. ET"
                            },
                            {
                                "label": "Arena",
                                "value": "Frost Bank"
                            },
                            {
                                "label": "Watch",
                                "value": "League Pass"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501146-standings-pregame",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "0022501146-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "Sixth in the East meets second in the West.",
                        "dek": "Philadelphia begins in the final automatic playoff place; San Antonio is chasing Oklahoma City.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "PHI",
                                        "name": "76ers",
                                        "rank": "6",
                                        "record": "43–35",
                                        "percentage": ".551",
                                        "gamesBack": "14",
                                        "result": null
                                    }
                                ]
                            },
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "SAS",
                                        "name": "Spurs",
                                        "rank": "2",
                                        "record": "59–19",
                                        "percentage": ".756",
                                        "gamesBack": "3",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "captioned-image",
                    "id": "phi-sas-castle-warmup-source",
                    "availableAtUtc": "2026-04-06T22:44:35Z",
                    "display": {
                        "id": "phi-sas-castle-warmup-source",
                        "unitType": "source-image",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Castle’s final reps before tip.",
                        "dek": "San Antonio is one win from 60 as Castle gets loose.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "phi-sas-philly-arrival-source",
                    "availableAtUtc": "2026-04-06T22:44:35Z",
                    "display": {
                        "id": "phi-sas-philly-arrival-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Philly is in the building",
                        "dek": "Philadelphia arrives in San Antonio before the big-man matchup.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                },
                {
                    "id": "phi-sas-rookies-source",
                    "availableAtUtc": "2026-04-06T22:44:35Z",
                    "display": {
                        "id": "phi-sas-rookies-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "The rookies meet before tip.",
                        "dek": "The opposing rookies share a quick word before the Spurs and 76ers take the floor.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": null
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    }
                }
            ]
        },
        {
            "gameId": "0022501147",
            "matchup": "Portland Trail Blazers at Denver Nuggets",
            "editorialRole": "Emerging game that becomes the late-night epic",
            "governingQuestion": "Will Portland’s hot shooting hold up?",
            "anchorState": "POR 35–31 DEN · Q1 · 0:00",
            "finalState": "POR 132–137 DEN · FINAL/OT",
            "entryVideoCandidateIds": {
                "anchor": "por-den-camara-three-clip",
                "end": "por-den-jokic-ot-clip"
            },
            "anchor": [
                {
                    "kind": "catch-up-summary",
                    "id": "por-den-catch-up",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "por-den-catch-up",
                        "unitType": "catch-up",
                        "eyebrow": "CATCH UP",
                        "headline": "Portland’s shooting has Denver chasing.",
                        "dek": null,
                        "scoreLockup": null,
                        "action": null,
                        "bullets": [
                            "Portland has made nine threes to Denver’s one.",
                            "Camara and Thybulle combine to start 7-for-7 from deep.",
                            "Jokić’s 12 points, six rebounds and four assists keep Denver close.",
                            "Portland’s shooting has set the terms; Denver’s answer has to come inside."
                        ],
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "bullets"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "live-event-status",
                    "id": "por-den-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "por-den-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "Nine threes give Portland the early edge.",
                        "dek": "Denver is 1-for-7 from deep, but Jokić’s 12 points keep the Nuggets within four.",
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "live"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "por-den-jesser-q1-shooting-barrage",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "por-den-jesser-q1-shooting-barrage",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q1 · 0:00",
                            "relationshipLabel": "On Portland’s opening barrage",
                            "format": "text",
                            "statement": "Camara and Thybulle are the ones going perfect from deep? The scouting report is officially on fire. Denver has to stop waiting for this to fix itself."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "contextual-odds",
                    "id": "0022501147-contextual-live-odds",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "0022501147-contextual-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:0022501147",
                            "subject": "Nikola Jokić",
                            "marketLine": "Over 19.5 points",
                            "progress": "12 PTS",
                            "progressSummary": "Needs 8 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:0022501147:demonstrator"
                        },
                        "accessibleName": "Live odds. POR 35–31 DEN · Q1 · 0:00. Nikola Jokić. 12 PTS current. Over 19.5 points selection. Needs 8 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    }
                },
                {
                    "kind": "captioned-image",
                    "id": "por-den-camara-live-photo",
                    "availableAtUtc": "2026-04-07T01:32:28.9981794Z",
                    "display": {
                        "id": "por-den-camara-live-photo",
                        "unitType": "source-image",
                        "eyebrow": "FIRST QUARTER",
                        "headline": "Camara has Denver scrambling.",
                        "dek": "Four threes in less than nine minutes turn Portland’s fast start into an immediate problem for Denver.",
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "por-den-camara-three-clip",
                    "availableAtUtc": "2026-04-07T01:32:27.3778765Z",
                    "display": {
                        "id": "por-den-camara-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Camara starts 4-for-4 from deep.",
                        "dek": "His fourth make gives him 12 points before the quarter is over.",
                        "scoreLockup": "POR 30–23 DEN · Q1 · 3:24",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "5445169b-f7b6-e3d0-6792-3a2077bea035",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Camara starts 4-for-4 from deep. in the full-screen player"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "por-den-clingan-three-clip",
                    "availableAtUtc": "2026-04-07T01:27:26.7448463Z",
                    "display": {
                        "id": "por-den-clingan-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Clingan joins Portland’s opening barrage.",
                        "dek": "The seven-footer’s make gives Portland a four-point lead midway through the first.",
                        "scoreLockup": "POR 21–17 DEN · Q1 · 5:37",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "f753c2ee-381f-d425-a966-3a2077ba0a29",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Clingan joins Portland’s opening barrage. in the full-screen player"
                    }
                },
                {
                    "kind": "event-start",
                    "id": "por-den-tip",
                    "availableAtUtc": "2026-04-07T01:11:00Z",
                    "display": {
                        "id": "por-den-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Portland and Denver are underway",
                        "dek": null,
                        "scoreLockup": "POR 0–0 DEN · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "por-den-opening-atmosphere-source",
                    "availableAtUtc": "2026-04-07T01:01:22Z",
                    "display": {
                        "id": "por-den-opening-atmosphere-source",
                        "unitType": "source-video",
                        "eyebrow": "GAME ON",
                        "headline": "The late game tips at Ball Arena.",
                        "dek": "Hear Portland’s opening possession from courtside.",
                        "scoreLockup": "POR @ DEN · Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "por-den-jesser-pregame-expectation",
                    "availableAtUtc": "2026-04-07T00:12:00Z",
                    "display": {
                        "id": "por-den-jesser-pregame-expectation",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR @ DEN · 9:00 p.m. ET",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Pregame",
                            "relationshipLabel": "On Denver chasing nine straight",
                            "format": "text",
                            "statement": "Eight straight puts Denver in that weird spot where everybody expects number nine. I’m watching the first five minutes: do they come out sharp, or play like the night already owes them something?"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "game-day-essentials",
                    "id": "por-den-essentials",
                    "availableAtUtc": "2026-04-07T00:11:00.000Z",
                    "display": {
                        "id": "por-den-essentials",
                        "unitType": "essentials",
                        "eyebrow": "GAME GUIDE",
                        "headline": "Denver brings an eight-game streak into the finale.",
                        "dek": "The Nuggets enter 50–28; Portland arrives 40–38.",
                        "scoreLockup": "POR @ DEN · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Tip",
                                "value": "9:00 p.m. ET"
                            },
                            {
                                "label": "Arena",
                                "value": "Ball Arena"
                            },
                            {
                                "label": "Watch",
                                "value": "League Pass"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "pregame-scene-setter",
                    "id": "por-den-pregame",
                    "availableAtUtc": "2026-04-07T00:11:00.000Z",
                    "display": {
                        "id": "por-den-pregame",
                        "unitType": "pregame",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Denver chases a ninth straight win.",
                        "dek": "The final game of the slate tips at Ball Arena.",
                        "scoreLockup": "POR @ DEN · 9:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "gallery",
                    "id": "por-den-arrivals-gallery-source",
                    "availableAtUtc": "2026-04-06T23:47:00Z",
                    "display": {
                        "id": "por-den-arrivals-gallery-source",
                        "unitType": "gallery",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Portland arrives at Ball Arena.",
                        "dek": "Tunnel arrivals give way to warmups before the night’s final tip.",
                        "scoreLockup": "POR @ DEN · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 13
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501147-standings-pregame",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "0022501147-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "Two Western races frame the late game.",
                        "dek": "Denver starts tied for third; Portland starts tied for eighth.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "DEN",
                                        "name": "Nuggets",
                                        "rank": "T3",
                                        "record": "50–28",
                                        "percentage": ".641",
                                        "gamesBack": "12",
                                        "result": null
                                    },
                                    {
                                        "code": "POR",
                                        "name": "Trail Blazers",
                                        "rank": "T8",
                                        "record": "40–38",
                                        "percentage": ".513",
                                        "gamesBack": "22",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                }
            ],
            "end": [
                {
                    "kind": "final-outcome",
                    "id": "por-den-final",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-final",
                        "unitType": "checkpoint",
                        "eyebrow": "FINAL",
                        "headline": "Denver finishes a 16-point fourth-quarter comeback in overtime.",
                        "dek": "Nikola Jokić posts 35 points, 14 rebounds and 13 assists as the Nuggets win their ninth straight.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "por-den-jesser-final-consequence",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-jesser-final-consequence",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Final · OT",
                            "relationshipLabel": "On how Denver won its ninth straight",
                            "format": "text",
                            "statement": "Twenty-five threes and Portland still lost. That sentence should not be legal. Denver has won nine straight, and this one might have been the meanest."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "ranked-video-recap",
                    "id": "por-den-jokic-ot-clip",
                    "availableAtUtc": "2026-04-07T03:54:15.5547311Z",
                    "display": {
                        "id": "por-den-jokic-ot-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Jokić pushes Denver seven clear in overtime.",
                        "dek": "His 35-point triple-double has the Nuggets closing on a ninth straight win.",
                        "scoreLockup": "POR 130–137 DEN · OT · 1:26",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": 53,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "8b5b797c-1747-17f3-a784-3a2078407463",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Jokić pushes Denver seven clear in overtime. in the full-screen player"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "por-den-jesser-ot-seven-clear",
                    "availableAtUtc": "2026-04-07T03:46:26Z",
                    "display": {
                        "id": "por-den-jesser-ot-seven-clear",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 130–137 DEN · OT · 1:26",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "OT · 1:26",
                            "relationshipLabel": "On Jokić taking over overtime",
                            "format": "text",
                            "statement": "Jokić. Of course it’s Jokić. Overtime is chaos for everybody else and he still looks like he’s choosing from a menu. Seven up now feels enormous."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "complete-story",
                    "id": "por-den-game-story",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-game-story",
                        "unitType": "story",
                        "eyebrow": "GAME STORY",
                        "headline": "Denver storms back to beat Portland in overtime.",
                        "dek": "Relive Portland’s record 25 threes and Denver forcing overtime after trailing by 16 in the fourth.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story"
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "38ec1b86-4776-291b-ccf2-3a20500cbfe9",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Denver storms back to beat Portland in overtime."
                    }
                },
                {
                    "kind": "possession-sequence",
                    "id": "por-den-final-sequence",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-final-sequence",
                        "unitType": "sequence",
                        "eyebrow": "THE FINISH",
                        "headline": "Three baskets turn regulation twice.",
                        "dek": null,
                        "scoreLockup": "POR 125–125 DEN · END Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "sequenceSteps": [
                            {
                                "label": "1:12",
                                "headline": "Gordon hits the corner three",
                                "state": "123–123"
                            },
                            {
                                "label": "Next Denver trip",
                                "headline": "Gordon puts Denver ahead",
                                "state": "DEN 125–123"
                            },
                            {
                                "label": "Final Portland trip",
                                "headline": "Avdija forces overtime",
                                "state": "125–125"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "sequence"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501147-standings-final",
                    "availableAtUtc": "2026-04-07T04:46:01Z",
                    "display": {
                        "id": "0022501147-standings-final",
                        "unitType": "standings",
                        "eyebrow": "AFTER THE NIGHT",
                        "headline": "Denver moves clear in third. Portland slips to ninth.",
                        "dek": "The overtime win breaks Denver’s tie with the Lakers; Portland falls behind the Clippers.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "After the last final · 12:46 a.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "DEN",
                                        "name": "Nuggets",
                                        "rank": "3",
                                        "record": "51–28",
                                        "percentage": ".646",
                                        "gamesBack": "11.5",
                                        "result": "W"
                                    },
                                    {
                                        "code": "POR",
                                        "name": "Trail Blazers",
                                        "rank": "9",
                                        "record": "40–39",
                                        "percentage": ".506",
                                        "gamesBack": "22.5",
                                        "result": "L"
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "gallery",
                    "id": "por-den-jokic-final-carousel-source",
                    "availableAtUtc": "2026-04-07T04:28:00Z",
                    "display": {
                        "id": "por-den-jokic-final-carousel-source",
                        "unitType": "gallery",
                        "eyebrow": null,
                        "headline": "Jokić finishes the comeback with 35, 14 and 13.",
                        "dek": "Denver erases a 16-point fourth-quarter deficit, then outscores Portland 12–7 in overtime.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 9
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "game-insight",
                    "id": "por-den-team-shape",
                    "availableAtUtc": "2026-04-07T03:48:44Z",
                    "display": {
                        "id": "por-den-team-shape",
                        "unitType": "insight",
                        "eyebrow": "TWO WAYS TO SCORE",
                        "headline": "Portland wins the arc. Denver owns everything inside it.",
                        "dek": "The Blazers make 25 threes, but the Nuggets answer with a 66–32 edge in the paint and a 30–15 second-chance advantage.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Portland threes",
                                "value": "25"
                            },
                            {
                                "label": "Paint",
                                "value": "DEN 66–32"
                            },
                            {
                                "label": "Second chance",
                                "value": "DEN 30–15"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "por-den-jesser-attributed-text",
                    "availableAtUtc": "2026-04-07T03:36:00Z",
                    "display": {
                        "id": "por-den-jesser-attributed-text",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 125–125 DEN · END Q4",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "END Q4",
                            "relationshipLabel": "On the overtime-forcing sequence",
                            "format": "text",
                            "statement": "16 down in the fourth and now we’re going to OT?! This game is ridiculous 😭"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "urgent-game-update",
                    "id": "por-den-regulation-tie",
                    "availableAtUtc": "2026-04-07T03:35:00Z",
                    "display": {
                        "id": "por-den-regulation-tie",
                        "unitType": "urgent",
                        "eyebrow": "OVERTIME",
                        "headline": "Avdija answers Gordon; regulation ends level.",
                        "dek": "Gordon ties it at 123, scores again, then Avdija’s layup sends the game to overtime at 125.",
                        "scoreLockup": "POR 125–125 DEN · END Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "live"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "por-den-gordon-tie-clip",
                    "availableAtUtc": "2026-04-07T03:32:07.9430558Z",
                    "display": {
                        "id": "por-den-gordon-tie-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Gordon’s corner three makes it 123–123.",
                        "dek": "Denver has erased a 16-point fourth-quarter deficit with 1:12 left.",
                        "scoreLockup": "POR 123–123 DEN · Q4 · 1:12",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "f5724d72-adeb-9f53-a055-3a20782c31e0",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Gordon’s corner three makes it 123–123. in the full-screen player"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "por-den-jesser-q4-one-possession",
                    "availableAtUtc": "2026-04-07T03:29:00Z",
                    "display": {
                        "id": "por-den-jesser-q4-one-possession",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 119–116 DEN · Q4 · 2:51",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 2:51",
                            "relationshipLabel": "On Denver making it one possession",
                            "format": "text",
                            "statement": "Okay, now it’s real. Portland was up 16 in this quarter, Denver is within three, and every empty Blazers trip feels twice as loud. Ball Arena knows what’s happening."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "period-orientation",
                    "id": "por-den-q4-open",
                    "availableAtUtc": "2026-04-07T02:57:00Z",
                    "occurredAtUtc": "2026-04-07T02:57:00Z",
                    "display": {
                        "id": "por-den-q4-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q4",
                        "headline": "Denver has twelve minutes to save the streak",
                        "dek": "Portland leads by 14 after making 20 threes.",
                        "scoreLockup": "POR 101–87 DEN · START Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "period-checkpoint",
                    "id": "por-den-q3",
                    "availableAtUtc": "2026-04-07T02:54:00Z",
                    "display": {
                        "id": "por-den-q3",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q3",
                        "headline": "Portland hits 20 threes through three.",
                        "dek": null,
                        "scoreLockup": "POR 101–87 DEN · END Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "por-den-camara-later-clip",
                    "availableAtUtc": "2026-04-07T02:49:23.4566259Z",
                    "display": {
                        "id": "por-den-camara-later-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Camara drills his eighth three.",
                        "dek": "He reaches 28 points and stretches Portland’s lead to 17.",
                        "scoreLockup": "POR 95–78 DEN · Q3 · 2:48",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "252bc6fa-6f0c-4ee9-757c-3a207805102d",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Camara drills his eighth three. in the full-screen player"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "por-den-jesser-q3-counterpunch",
                    "availableAtUtc": "2026-04-07T02:40:00Z",
                    "display": {
                        "id": "por-den-jesser-q3-counterpunch",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 81–73 DEN · Q3 · 7:06",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q3 · 7:06",
                            "relationshipLabel": "On Portland answering Denver’s 9–0 push",
                            "format": "text",
                            "statement": "Denver finally gets the building up and Camara answers on the very next trip. That three is louder than the nine points before it."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "momentum-swing",
                    "id": "por-den-q3-nine-zero-push",
                    "availableAtUtc": "2026-04-07T02:39:00Z",
                    "occurredAtUtc": "2026-04-07T02:39:00Z",
                    "display": {
                        "id": "por-den-q3-nine-zero-push",
                        "unitType": "checkpoint",
                        "eyebrow": "GAME UPDATE",
                        "headline": "Denver’s first real push cuts the gap to five.",
                        "dek": "Hardaway starts it from deep; Jokić and Gordon finish a 9–0 run at the rim.",
                        "scoreLockup": "POR 78–73 DEN · Q3 · 7:17",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Starting gap",
                                "value": "14"
                            },
                            {
                                "label": "Denver run",
                                "value": "9–0"
                            },
                            {
                                "label": "Margin after",
                                "value": "POR +5"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "period-checkpoint",
                    "id": "por-den-half",
                    "availableAtUtc": "2026-04-07T02:14:00Z",
                    "display": {
                        "id": "por-den-half",
                        "unitType": "checkpoint",
                        "eyebrow": "HALFTIME",
                        "headline": "Sixteen threes send Portland to the half up 14.",
                        "dek": "Camara has 20 and the Blazers have assists on 18 of 21 field goals.",
                        "scoreLockup": "POR 72–58 DEN · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "por-den-jesser-q2-answer",
                    "availableAtUtc": "2026-04-07T01:54:00Z",
                    "display": {
                        "id": "por-den-jesser-q2-answer",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 53–49 DEN · Q2 · 6:23",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q2 · 6:23",
                            "relationshipLabel": "On Denver’s first answer",
                            "format": "text",
                            "statement": "Denver just cut thirteen to four with Jokić watching. Now he checks back in. That’s the first time this game has felt like it might actually change temperature."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "momentum-swing",
                    "id": "por-den-q2-nine-zero-answer",
                    "availableAtUtc": "2026-04-07T01:53:00Z",
                    "occurredAtUtc": "2026-04-07T01:53:00Z",
                    "display": {
                        "id": "por-den-q2-nine-zero-answer",
                        "unitType": "checkpoint",
                        "eyebrow": "GAME UPDATE",
                        "headline": "Denver answers a 13-point gap with nine straight.",
                        "dek": "Four straight Denver scores cut Portland’s lead to four before Jokić returns.",
                        "scoreLockup": "POR 53–49 DEN · Q2 · 6:23",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Portland lead",
                                "value": "13"
                            },
                            {
                                "label": "Denver answer",
                                "value": "9–0"
                            },
                            {
                                "label": "Margin after",
                                "value": "POR +4"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "period-orientation",
                    "id": "por-den-q2-open",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "occurredAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "por-den-q2-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q2",
                        "headline": "Can Portland keep shooting like this?",
                        "dek": "Nine first-quarter threes have created a four-point lead.",
                        "scoreLockup": "POR 35–31 DEN · START Q2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "por-den-jesser-q1-shooting-barrage",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "por-den-jesser-q1-shooting-barrage",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q1 · 0:00",
                            "relationshipLabel": "On Portland’s opening barrage",
                            "format": "text",
                            "statement": "Camara and Thybulle are the ones going perfect from deep? The scouting report is officially on fire. Denver has to stop waiting for this to fix itself."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "period-checkpoint",
                    "id": "por-den-q1",
                    "availableAtUtc": "2026-04-07T01:36:00Z",
                    "display": {
                        "id": "por-den-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "Camara and Thybulle torch Denver from deep.",
                        "dek": "They combine to go 7-for-7 as Portland scores 35 in the opening quarter.",
                        "scoreLockup": "POR 35–31 DEN · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "live-event-status",
                    "id": "por-den-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "por-den-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "Nine threes give Portland the early edge.",
                        "dek": "Denver is 1-for-7 from deep, but Jokić’s 12 points keep the Nuggets within four.",
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "live"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "captioned-image",
                    "id": "por-den-camara-live-photo",
                    "availableAtUtc": "2026-04-07T01:32:28.9981794Z",
                    "display": {
                        "id": "por-den-camara-live-photo",
                        "unitType": "source-image",
                        "eyebrow": "FIRST QUARTER",
                        "headline": "Camara has Denver scrambling.",
                        "dek": "Four threes in less than nine minutes turn Portland’s fast start into an immediate problem for Denver.",
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "por-den-thybulle-three-clip",
                    "availableAtUtc": "2026-04-07T01:35:37.4488343Z",
                    "display": {
                        "id": "por-den-thybulle-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Thybulle starts 3-for-3 from deep.",
                        "dek": "He and Camara are 7-for-7 from deep late in the first.",
                        "scoreLockup": "POR 33–27 DEN · Q1 · 1:54",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "25b31b3e-0603-1b3c-3728-3a2077c1866d",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Thybulle starts 3-for-3 from deep. in the full-screen player"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "por-den-camara-three-clip",
                    "availableAtUtc": "2026-04-07T01:32:27.3778765Z",
                    "display": {
                        "id": "por-den-camara-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Camara starts 4-for-4 from deep.",
                        "dek": "His fourth make gives him 12 points before the quarter is over.",
                        "scoreLockup": "POR 30–23 DEN · Q1 · 3:24",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "5445169b-f7b6-e3d0-6792-3a2077bea035",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Camara starts 4-for-4 from deep. in the full-screen player"
                    }
                },
                {
                    "kind": "vertical-clip",
                    "id": "por-den-clingan-three-clip",
                    "availableAtUtc": "2026-04-07T01:27:26.7448463Z",
                    "display": {
                        "id": "por-den-clingan-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Clingan joins Portland’s opening barrage.",
                        "dek": "The seven-footer’s make gives Portland a four-point lead midway through the first.",
                        "scoreLockup": "POR 21–17 DEN · Q1 · 5:37",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "f753c2ee-381f-d425-a966-3a2077ba0a29",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Clingan joins Portland’s opening barrage. in the full-screen player"
                    }
                },
                {
                    "kind": "event-start",
                    "id": "por-den-tip",
                    "availableAtUtc": "2026-04-07T01:11:00Z",
                    "display": {
                        "id": "por-den-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Portland and Denver are underway",
                        "dek": null,
                        "scoreLockup": "POR 0–0 DEN · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "source-video",
                    "id": "por-den-opening-atmosphere-source",
                    "availableAtUtc": "2026-04-07T01:01:22Z",
                    "display": {
                        "id": "por-den-opening-atmosphere-source",
                        "unitType": "source-video",
                        "eyebrow": "GAME ON",
                        "headline": "The late game tips at Ball Arena.",
                        "dek": "Hear Portland’s opening possession from courtside.",
                        "scoreLockup": "POR @ DEN · Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "attributed-commentary",
                    "id": "por-den-jesser-pregame-expectation",
                    "availableAtUtc": "2026-04-07T00:12:00Z",
                    "display": {
                        "id": "por-den-jesser-pregame-expectation",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR @ DEN · 9:00 p.m. ET",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Pregame",
                            "relationshipLabel": "On Denver chasing nine straight",
                            "format": "text",
                            "statement": "Eight straight puts Denver in that weird spot where everybody expects number nine. I’m watching the first five minutes: do they come out sharp, or play like the night already owes them something?"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                },
                {
                    "kind": "game-day-essentials",
                    "id": "por-den-essentials",
                    "availableAtUtc": "2026-04-07T00:11:00.000Z",
                    "display": {
                        "id": "por-den-essentials",
                        "unitType": "essentials",
                        "eyebrow": "GAME GUIDE",
                        "headline": "Denver brings an eight-game streak into the finale.",
                        "dek": "The Nuggets enter 50–28; Portland arrives 40–38.",
                        "scoreLockup": "POR @ DEN · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Tip",
                                "value": "9:00 p.m. ET"
                            },
                            {
                                "label": "Arena",
                                "value": "Ball Arena"
                            },
                            {
                                "label": "Watch",
                                "value": "League Pass"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "pregame-scene-setter",
                    "id": "por-den-pregame",
                    "availableAtUtc": "2026-04-07T00:11:00.000Z",
                    "display": {
                        "id": "por-den-pregame",
                        "unitType": "pregame",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Denver chases a ninth straight win.",
                        "dek": "The final game of the slate tips at Ball Arena.",
                        "scoreLockup": "POR @ DEN · 9:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "gallery",
                    "id": "por-den-arrivals-gallery-source",
                    "availableAtUtc": "2026-04-06T23:47:00Z",
                    "display": {
                        "id": "por-den-arrivals-gallery-source",
                        "unitType": "gallery",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Portland arrives at Ball Arena.",
                        "dek": "Tunnel arrivals give way to warmups before the night’s final tip.",
                        "scoreLockup": "POR @ DEN · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 13
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    }
                },
                {
                    "kind": "standings",
                    "id": "0022501147-standings-pregame",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "0022501147-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "Two Western races frame the late game.",
                        "dek": "Denver starts tied for third; Portland starts tied for eighth.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "DEN",
                                        "name": "Nuggets",
                                        "rank": "T3",
                                        "record": "50–28",
                                        "percentage": ".641",
                                        "gamesBack": "12",
                                        "result": null
                                    },
                                    {
                                        "code": "POR",
                                        "name": "Trail Blazers",
                                        "rank": "T8",
                                        "record": "40–38",
                                        "percentage": ".513",
                                        "gamesBack": "22",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    }
                }
            ]
        }
    ],
    "catalogue": [
        {
            "code": "FU-01",
            "name": "Stories tray",
            "cadence": "System",
            "surfaces": [
                "Home"
            ],
            "group": "Above the feed",
            "visual": "story-circles",
            "editorialJob": "Keep live games, access coverage and completed Game Stories one tap away without consuming feed positions.",
            "publishWhen": "Six editorial-recency circles at arrival; update independently as Stories change state.",
            "destination": "Open an anchor-safe live Story snapshot, All Access Story or complete Game Story.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Keep the six most useful live, access and completed Story destinations one tap away above Home.",
                "fields": {
                    "eyebrow": "null; never render STORIES.",
                    "headline": "null.",
                    "dek": "null.",
                    "scoreOrBody": "Exactly six ordered circles. Each has a fan label (NYK–ATL, All Access), a compact current status (LIVE · Q4, FINAL · OT, PHI–SAS) and seen/update state. Do not expose Story type or source.",
                    "action": "The circle itself is the action; no row-level CTA copy."
                }
            },
            "examples": [
                {
                    "id": "stories-tray-arrival",
                    "label": "Arrival state",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "stories-tray-arrival",
                        "unitType": "stories-tray",
                        "eyebrow": "STORIES",
                        "headline": null,
                        "dek": null,
                        "scoreLockup": null,
                        "action": null,
                        "media": null,
                        "stories": [
                            {
                                "id": "stories-nyk-atl-live",
                                "label": "NYK–ATL",
                                "monogram": "NYK",
                                "thumbnail": {
                                    "primary": "NYK",
                                    "secondary": "ATL"
                                },
                                "status": "LIVE · Q4",
                                "state": "unseen",
                                "destination": {
                                    "type": "story-snapshot",
                                    "id": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9@2026-04-07T01:35:00Z"
                                }
                            },
                            {
                                "id": "stories-det-orl-live",
                                "label": "DET–ORL",
                                "monogram": "ORL",
                                "thumbnail": {
                                    "primary": "DET",
                                    "secondary": "ORL"
                                },
                                "status": "LIVE · Q4",
                                "state": "updated",
                                "destination": {
                                    "type": "story-snapshot",
                                    "id": "4981dbb8-56e8-cc0d-387b-3a20500cb3eb@2026-04-07T01:35:00Z"
                                }
                            },
                            {
                                "id": "stories-cle-mem-live",
                                "label": "CLE–MEM",
                                "monogram": "CLE",
                                "thumbnail": {
                                    "primary": "CLE",
                                    "secondary": "MEM"
                                },
                                "status": "LIVE · Q3",
                                "state": "unseen",
                                "destination": {
                                    "type": "story-snapshot",
                                    "id": "9edf2454-015f-28a7-9247-3a20500cae6e@2026-04-07T01:35:00Z"
                                }
                            },
                            {
                                "id": "stories-phi-sas-live",
                                "label": "PHI–SAS",
                                "monogram": "SAS",
                                "thumbnail": {
                                    "primary": "PHI",
                                    "secondary": "SAS"
                                },
                                "status": "LIVE · Q3",
                                "state": "updated",
                                "destination": {
                                    "type": "story-snapshot",
                                    "id": "8bc8d022-f0af-662b-3761-3a20500ca56c@2026-04-07T01:35:00Z"
                                }
                            },
                            {
                                "id": "stories-phi-sas-access",
                                "label": "All Access",
                                "monogram": "AA",
                                "thumbnail": {
                                    "primary": "PHI",
                                    "secondary": "SAS"
                                },
                                "status": "PHI–SAS",
                                "state": "unseen",
                                "destination": {
                                    "type": "story-snapshot",
                                    "id": "4701c6e4-c661-46e7-234b-3a2073da5482@2026-04-07T01:35:00Z"
                                }
                            },
                            {
                                "id": "stories-por-den-live",
                                "label": "POR–DEN",
                                "monogram": "DEN",
                                "thumbnail": {
                                    "primary": "POR",
                                    "secondary": "DEN"
                                },
                                "status": "LIVE · Q1",
                                "state": "unseen",
                                "destination": {
                                    "type": "game-screen",
                                    "id": "0022501147"
                                }
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story-circles"
                    },
                    "interaction": {
                        "destination": {
                            "type": "none"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "arrival",
                        "editorialJob": "story destinations",
                        "classification": "system-chrome",
                        "sourceKind": "story-destinations",
                        "sourceId": null,
                        "destinationType": "story"
                    },
                    "order": 0,
                    "kind": "stories-tray"
                },
                {
                    "id": "stories-tray-end",
                    "label": "End state",
                    "availableAtUtc": "2026-04-07T05:30:00Z",
                    "display": {
                        "id": "stories-tray-end",
                        "unitType": "stories-tray",
                        "eyebrow": "STORIES",
                        "headline": null,
                        "dek": null,
                        "scoreLockup": null,
                        "action": null,
                        "media": null,
                        "stories": [
                            {
                                "id": "stories-por-den-final",
                                "label": "POR–DEN",
                                "monogram": "DEN",
                                "thumbnail": {
                                    "primary": "POR",
                                    "secondary": "DEN"
                                },
                                "status": "FINAL · OT",
                                "state": "unseen",
                                "destination": {
                                    "type": "story",
                                    "id": "38ec1b86-4776-291b-ccf2-3a20500cbfe9"
                                }
                            },
                            {
                                "id": "stories-phi-sas-final",
                                "label": "PHI–SAS",
                                "monogram": "SAS",
                                "thumbnail": {
                                    "primary": "PHI",
                                    "secondary": "SAS"
                                },
                                "status": "FINAL",
                                "state": "unseen",
                                "destination": {
                                    "type": "story",
                                    "id": "8bc8d022-f0af-662b-3761-3a20500ca56c"
                                }
                            },
                            {
                                "id": "stories-cle-mem-final",
                                "label": "CLE–MEM",
                                "monogram": "CLE",
                                "thumbnail": {
                                    "primary": "CLE",
                                    "secondary": "MEM"
                                },
                                "status": "FINAL",
                                "state": "updated",
                                "destination": {
                                    "type": "story",
                                    "id": "9edf2454-015f-28a7-9247-3a20500cae6e"
                                }
                            },
                            {
                                "id": "stories-det-orl-final",
                                "label": "DET–ORL",
                                "monogram": "ORL",
                                "thumbnail": {
                                    "primary": "DET",
                                    "secondary": "ORL"
                                },
                                "status": "FINAL",
                                "state": "seen",
                                "destination": {
                                    "type": "story",
                                    "id": "4981dbb8-56e8-cc0d-387b-3a20500cb3eb"
                                }
                            },
                            {
                                "id": "stories-nyk-atl-final",
                                "label": "NYK–ATL",
                                "monogram": "NYK",
                                "thumbnail": {
                                    "primary": "NYK",
                                    "secondary": "ATL"
                                },
                                "status": "FINAL",
                                "state": "seen",
                                "destination": {
                                    "type": "story",
                                    "id": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9"
                                }
                            },
                            {
                                "id": "stories-phi-sas-access",
                                "label": "All Access",
                                "monogram": "AA",
                                "thumbnail": {
                                    "primary": "PHI",
                                    "secondary": "SAS"
                                },
                                "status": "PHI–SAS",
                                "state": "seen",
                                "destination": {
                                    "type": "story-snapshot",
                                    "id": "4701c6e4-c661-46e7-234b-3a2073da5482@2026-04-07T01:35:00Z"
                                }
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story-circles"
                    },
                    "interaction": {
                        "destination": {
                            "type": "none"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "end",
                        "editorialJob": "story destinations",
                        "classification": "system-chrome",
                        "sourceKind": "story-destinations",
                        "sourceId": null,
                        "destinationType": "story"
                    },
                    "order": 1,
                    "kind": "stories-tray"
                }
            ],
            "kind": "stories-tray",
            "displayName": "Stories tray",
            "legacyCode": "FU-01",
            "definitionRevision": 1
        },
        {
            "code": "FU-02",
            "name": "Night opener",
            "cadence": "Baseline",
            "surfaces": [
                "Home"
            ],
            "group": "Orient the night and the game",
            "visual": "slate",
            "editorialJob": "Let the fan scan the complete night in tip-time order and choose a game without leaving the feed blind.",
            "publishWhen": "Once before the earliest tip, after matchup, pregame records, venue and broadcaster data are official. Retain that publication-time state in scrollback.",
            "destination": "Each game row opens that matchup’s Game Screen Feed.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Orient the fan to all games tonight or only those still to start.",
                "fields": {
                    "eyebrow": "NBA TONIGHT for the full slate; UP NEXT for a remaining-games subset.",
                    "headline": "Plain count and state: Five games tonight or Three games still to come.",
                    "dek": "Timezone only when needed (All times ET); otherwise null. Never narrate row times.",
                    "scoreOrBody": "One chronological stacked list. Every row uses official tip time, both team names and pregame records, arena and location. The visible Watch provider is resolved for the declared viewer: Peacock for the national game and League Pass for verified local-only games when the viewer is out of market. Keep raw broadcaster arrays in source evidence, not consumer copy.",
                    "action": "Full opener: null. Remaining subset: View games."
                }
            },
            "examples": [
                {
                    "id": "night-open",
                    "label": "Whole night · pregame",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "night-open",
                        "unitType": "slate",
                        "eyebrow": "NBA TONIGHT",
                        "headline": "Five games tonight",
                        "dek": "All times ET",
                        "scoreLockup": null,
                        "action": null,
                        "games": [
                            {
                                "gameId": "0022501143",
                                "time": "7:00 PM",
                                "phase": "pregame",
                                "away": {
                                    "name": "Knicks",
                                    "record": "50–28",
                                    "finalRecord": "51–28"
                                },
                                "home": {
                                    "name": "Hawks",
                                    "record": "45–33",
                                    "finalRecord": "45–34"
                                },
                                "venue": "State Farm Arena",
                                "location": "Atlanta, GA",
                                "broadcasters": [
                                    "Peacock"
                                ]
                            },
                            {
                                "gameId": "0022501144",
                                "time": "7:00 PM",
                                "phase": "pregame",
                                "away": {
                                    "name": "Pistons",
                                    "record": "57–21",
                                    "finalRecord": "57–22"
                                },
                                "home": {
                                    "name": "Magic",
                                    "record": "42–36",
                                    "finalRecord": "43–36"
                                },
                                "venue": "Kia Center",
                                "location": "Orlando, FL",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501145",
                                "time": "8:00 PM",
                                "phase": "pregame",
                                "away": {
                                    "name": "Cavaliers",
                                    "record": "49–29",
                                    "finalRecord": "50–29"
                                },
                                "home": {
                                    "name": "Grizzlies",
                                    "record": "25–53",
                                    "finalRecord": "25–54"
                                },
                                "venue": "FedExForum",
                                "location": "Memphis, TN",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501146",
                                "time": "8:00 PM",
                                "phase": "pregame",
                                "away": {
                                    "name": "76ers",
                                    "record": "43–35",
                                    "finalRecord": "43–36"
                                },
                                "home": {
                                    "name": "Spurs",
                                    "record": "59–19",
                                    "finalRecord": "60–19"
                                },
                                "venue": "Frost Bank Center",
                                "location": "San Antonio, TX",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501147",
                                "time": "9:00 PM",
                                "phase": "pregame",
                                "away": {
                                    "name": "Trail Blazers",
                                    "record": "40–38",
                                    "finalRecord": "40–39"
                                },
                                "home": {
                                    "name": "Nuggets",
                                    "record": "50–28",
                                    "finalRecord": "51–28"
                                },
                                "venue": "Ball Arena",
                                "location": "Denver, CO",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            }
                        ],
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "slate"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-list"
                        },
                        "accessibleName": "Open games"
                    },
                    "review": {
                        "candidateId": "night-open",
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "pregame",
                        "editorialJob": "night orientation",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "schedule",
                        "sourceId": "2026-04-06-five-game-slate",
                        "destinationType": "game-companion-list"
                    },
                    "order": 0,
                    "kind": "event-slate"
                },
                {
                    "id": "remaining-night-slate",
                    "label": "Whole night · later window",
                    "availableAtUtc": "2026-04-06T23:45:00Z",
                    "display": {
                        "id": "remaining-night-slate",
                        "unitType": "slate",
                        "eyebrow": "UP NEXT",
                        "headline": "Three games still to come",
                        "dek": null,
                        "scoreLockup": null,
                        "action": "View games",
                        "games": [
                            {
                                "gameId": "0022501145",
                                "time": "8:00 PM",
                                "phase": "pregame",
                                "away": {
                                    "name": "Cavaliers",
                                    "record": "49–29",
                                    "finalRecord": "50–29"
                                },
                                "home": {
                                    "name": "Grizzlies",
                                    "record": "25–53",
                                    "finalRecord": "25–54"
                                },
                                "venue": "FedExForum",
                                "location": "Memphis, TN",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501146",
                                "time": "8:00 PM",
                                "phase": "pregame",
                                "away": {
                                    "name": "76ers",
                                    "record": "43–35",
                                    "finalRecord": "43–36"
                                },
                                "home": {
                                    "name": "Spurs",
                                    "record": "59–19",
                                    "finalRecord": "60–19"
                                },
                                "venue": "Frost Bank Center",
                                "location": "San Antonio, TX",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501147",
                                "time": "9:00 PM",
                                "phase": "pregame",
                                "away": {
                                    "name": "Trail Blazers",
                                    "record": "40–38",
                                    "finalRecord": "40–39"
                                },
                                "home": {
                                    "name": "Nuggets",
                                    "record": "50–28",
                                    "finalRecord": "51–28"
                                },
                                "venue": "Ball Arena",
                                "location": "Denver, CO",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            }
                        ],
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "slate"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-list"
                        },
                        "accessibleName": "Open games"
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "later pregame",
                        "editorialJob": "remaining-night orientation",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "schedule",
                        "sourceId": "2026-04-06-five-game-slate",
                        "destinationType": "game-companion-list"
                    },
                    "order": 1,
                    "kind": "event-slate"
                }
            ],
            "kind": "event-slate",
            "displayName": "Event slate",
            "legacyCode": "FU-02",
            "definitionRevision": 1
        },
        {
            "code": "FU-03",
            "name": "Live night board",
            "cadence": "System",
            "surfaces": [
                "Home"
            ],
            "group": "Orient the night and the game",
            "visual": "scoreboard",
            "editorialJob": "Show every live score while identifying the game that currently deserves attention.",
            "publishWhen": "Refresh automatically from official state; editorial emphasis can change without deleting earlier feed history.",
            "destination": "Tap a matchup to open its Game Screen Feed.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Show the whole night’s current score state or the most important verified consequences after the finals.",
                "fields": {
                    "eyebrow": "NBA TONIGHT while live; AROUND THE LEAGUE after the night.",
                    "headline": "Live: game count/state (Five games live). Final: lead with the two largest consequences, not “what changed.”",
                    "dek": "Live: identify the highest-leverage current game. Final: add a different streak, record or standings consequence.",
                    "scoreOrBody": "Ordered rows with official abbreviations, scores and live period/clock or FINAL/FINAL · OT. Never use WHOLE NIGHT as a score lockup.",
                    "action": "View games."
                }
            },
            "examples": [
                {
                    "id": "night-live-five",
                    "label": "Whole night · at-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "night-live-five",
                        "unitType": "scoreboard",
                        "eyebrow": "NBA TONIGHT",
                        "headline": "Five games live",
                        "dek": "New York leads Atlanta by one with 1.2 seconds left.",
                        "scoreLockup": null,
                        "action": "View games",
                        "games": [
                            {
                                "gameId": "0022501143",
                                "state": "Q4 · 1.2",
                                "phase": "live",
                                "emphasis": true,
                                "away": {
                                    "name": "Knicks",
                                    "record": "50–28",
                                    "finalRecord": "51–28",
                                    "code": "NYK",
                                    "score": "106"
                                },
                                "home": {
                                    "name": "Hawks",
                                    "record": "45–33",
                                    "finalRecord": "45–34",
                                    "code": "ATL",
                                    "score": "105"
                                },
                                "venue": "State Farm Arena",
                                "location": "Atlanta, GA",
                                "broadcasters": [
                                    "Peacock"
                                ]
                            },
                            {
                                "gameId": "0022501144",
                                "state": "Q4 · 55.2",
                                "phase": "live",
                                "emphasis": false,
                                "away": {
                                    "name": "Pistons",
                                    "record": "57–21",
                                    "finalRecord": "57–22",
                                    "code": "DET",
                                    "score": "107"
                                },
                                "home": {
                                    "name": "Magic",
                                    "record": "42–36",
                                    "finalRecord": "43–36",
                                    "code": "ORL",
                                    "score": "123"
                                },
                                "venue": "Kia Center",
                                "location": "Orlando, FL",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501145",
                                "state": "Q3 · 4:49",
                                "phase": "live",
                                "emphasis": false,
                                "away": {
                                    "name": "Cavaliers",
                                    "record": "49–29",
                                    "finalRecord": "50–29",
                                    "code": "CLE",
                                    "score": "89"
                                },
                                "home": {
                                    "name": "Grizzlies",
                                    "record": "25–53",
                                    "finalRecord": "25–54",
                                    "code": "MEM",
                                    "score": "77"
                                },
                                "venue": "FedExForum",
                                "location": "Memphis, TN",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501146",
                                "state": "Q3 · 8:17",
                                "phase": "live",
                                "emphasis": false,
                                "away": {
                                    "name": "76ers",
                                    "record": "43–35",
                                    "finalRecord": "43–36",
                                    "code": "PHI",
                                    "score": "65"
                                },
                                "home": {
                                    "name": "Spurs",
                                    "record": "59–19",
                                    "finalRecord": "60–19",
                                    "code": "SAS",
                                    "score": "74"
                                },
                                "venue": "Frost Bank Center",
                                "location": "San Antonio, TX",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501147",
                                "state": "Q1 · 0:00",
                                "phase": "live",
                                "emphasis": false,
                                "away": {
                                    "name": "Trail Blazers",
                                    "record": "40–38",
                                    "finalRecord": "40–39",
                                    "code": "POR",
                                    "score": "35"
                                },
                                "home": {
                                    "name": "Nuggets",
                                    "record": "50–28",
                                    "finalRecord": "51–28",
                                    "code": "DEN",
                                    "score": "31"
                                },
                                "venue": "Ball Arena",
                                "location": "Denver, CO",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            }
                        ],
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "scoreboard"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": "night-live-five",
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "night state",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "night",
                        "sourceId": "2026-04-07T01:35:00Z",
                        "destinationType": "inline"
                    },
                    "order": 0,
                    "kind": "live-scoreboard"
                },
                {
                    "id": "night-standings-consequence",
                    "label": "Whole night · post-anchor",
                    "availableAtUtc": "2026-04-07T04:46:01Z",
                    "display": {
                        "id": "night-standings-consequence",
                        "unitType": "scoreboard",
                        "eyebrow": "AROUND THE LEAGUE",
                        "headline": "Denver gets nine straight. San Antonio gets win No. 60.",
                        "dek": "New York, Cleveland and Orlando each make it three wins in a row.",
                        "scoreLockup": null,
                        "action": "View games",
                        "games": [
                            {
                                "gameId": "0022501143",
                                "state": "FINAL",
                                "phase": "final",
                                "emphasis": false,
                                "away": {
                                    "name": "Knicks",
                                    "record": "50–28",
                                    "finalRecord": "51–28",
                                    "code": "NYK",
                                    "score": "108"
                                },
                                "home": {
                                    "name": "Hawks",
                                    "record": "45–33",
                                    "finalRecord": "45–34",
                                    "code": "ATL",
                                    "score": "105"
                                },
                                "venue": "State Farm Arena",
                                "location": "Atlanta, GA",
                                "broadcasters": [
                                    "Peacock"
                                ]
                            },
                            {
                                "gameId": "0022501144",
                                "state": "FINAL",
                                "phase": "final",
                                "emphasis": false,
                                "away": {
                                    "name": "Pistons",
                                    "record": "57–21",
                                    "finalRecord": "57–22",
                                    "code": "DET",
                                    "score": "107"
                                },
                                "home": {
                                    "name": "Magic",
                                    "record": "42–36",
                                    "finalRecord": "43–36",
                                    "code": "ORL",
                                    "score": "123"
                                },
                                "venue": "Kia Center",
                                "location": "Orlando, FL",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501145",
                                "state": "FINAL",
                                "phase": "final",
                                "emphasis": false,
                                "away": {
                                    "name": "Cavaliers",
                                    "record": "49–29",
                                    "finalRecord": "50–29",
                                    "code": "CLE",
                                    "score": "142"
                                },
                                "home": {
                                    "name": "Grizzlies",
                                    "record": "25–53",
                                    "finalRecord": "25–54",
                                    "code": "MEM",
                                    "score": "126"
                                },
                                "venue": "FedExForum",
                                "location": "Memphis, TN",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501146",
                                "state": "FINAL",
                                "phase": "final",
                                "emphasis": false,
                                "away": {
                                    "name": "76ers",
                                    "record": "43–35",
                                    "finalRecord": "43–36",
                                    "code": "PHI",
                                    "score": "102"
                                },
                                "home": {
                                    "name": "Spurs",
                                    "record": "59–19",
                                    "finalRecord": "60–19",
                                    "code": "SAS",
                                    "score": "115"
                                },
                                "venue": "Frost Bank Center",
                                "location": "San Antonio, TX",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            },
                            {
                                "gameId": "0022501147",
                                "state": "FINAL · OT",
                                "phase": "final",
                                "emphasis": false,
                                "away": {
                                    "name": "Trail Blazers",
                                    "record": "40–38",
                                    "finalRecord": "40–39",
                                    "code": "POR",
                                    "score": "132"
                                },
                                "home": {
                                    "name": "Nuggets",
                                    "record": "50–28",
                                    "finalRecord": "51–28",
                                    "code": "DEN",
                                    "score": "137"
                                },
                                "venue": "Ball Arena",
                                "location": "Denver, CO",
                                "broadcasters": [
                                    "League Pass"
                                ]
                            }
                        ],
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "scoreboard"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": "night-standings-consequence",
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "engagement-validated aftermath",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "2041376930759364845",
                        "destinationType": "inline"
                    },
                    "order": 1,
                    "kind": "live-scoreboard"
                }
            ],
            "kind": "live-scoreboard",
            "displayName": "Live scoreboard",
            "legacyCode": "FU-03",
            "definitionRevision": 1
        },
        {
            "code": "FU-04",
            "name": "Pregame scene-setter",
            "cadence": "Baseline",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Orient the night and the game",
            "visual": "editorial",
            "editorialJob": "State the stakes and emotional setup before the first basketball event.",
            "publishWhen": "Before tip when matchup, streak, standings or return context is verified.",
            "destination": "Open the relevant Game Screen Feed.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Establish why this matchup is worth entering before tip.",
                "fields": {
                    "eyebrow": "BEFORE THE GAME.",
                    "headline": "One verified differentiator: player matchup, standings place, streak, milestone chase or venue/window.",
                    "dek": "One different verified stake. Never repeat both player names or call something “the biggest” without proof.",
                    "scoreOrBody": "Matchup plus official tip time; no later score or result.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "por-den-pregame",
                    "label": "POR @ DEN · pregame",
                    "availableAtUtc": "2026-04-07T00:11:00.000Z",
                    "display": {
                        "id": "por-den-pregame",
                        "unitType": "pregame",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Denver chases a ninth straight win.",
                        "dek": "The final game of the slate tips at Ball Arena.",
                        "scoreLockup": "POR @ DEN · 9:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-pregame",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "pregame",
                        "editorialJob": "pregame setup",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "pregame-scene-setter"
                },
                {
                    "id": "phi-sas-pregame",
                    "label": "PHI @ SAS · pregame",
                    "availableAtUtc": "2026-04-06T23:11:00.000Z",
                    "display": {
                        "id": "phi-sas-pregame",
                        "unitType": "pregame",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Embiid and Wembanyama meet in San Antonio.",
                        "dek": "Philadelphia starts sixth in the East; San Antonio starts second in the West.",
                        "scoreLockup": "PHI @ SAS · 8:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-pregame",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "pregame",
                        "editorialJob": "pregame setup",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501146",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "pregame-scene-setter"
                },
                {
                    "id": "nyk-atl-pregame-form-vs-record",
                    "label": "NYK @ ATL · pregame",
                    "availableAtUtc": "2026-04-06T23:00:00Z",
                    "display": {
                        "id": "nyk-atl-pregame-form-vs-record",
                        "unitType": "editorial",
                        "eyebrow": "BEFORE TIP-OFF",
                        "headline": "Atlanta is hot. New York still has the edge.",
                        "dek": "The Hawks have won four straight. The Knicks arrive 50–28, five wins clear of Atlanta, but have lost three of their last five.",
                        "scoreLockup": "NYK @ ATL · 7:00 p.m. ET",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-pregame-form-vs-record",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "pregame",
                        "editorialJob": "pregame summary",
                        "classification": "source-backed-spec-example",
                        "sourceKind": "api.nba.com",
                        "sourceId": "source-receipts/game-0022501143.json#nyk-atl-pregame-form-vs-record",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "pregame-scene-setter"
                }
            ],
            "kind": "pregame-scene-setter",
            "displayName": "Pregame scene-setter",
            "legacyCode": "FU-04",
            "definitionRevision": 1
        },
        {
            "code": "FU-05",
            "name": "Game-day essentials",
            "cadence": "Baseline",
            "surfaces": [
                "Game Feed"
            ],
            "group": "Orient the night and the game",
            "visual": "data",
            "editorialJob": "Pin venue, time, availability and the minimum context needed to follow the game.",
            "publishWhen": "Before tip; correct in place if official availability changes.",
            "destination": "Inline reference with optional team or status detail.",
            "deliveryStrategy": "Native structured metrics first. Add a server-rendered visual when the treatment exceeds shared primitives; a WebView is not the default.",
            "writingGuidance": {
                "overall": "Give the minimum complete game-day utility layer.",
                "fields": {
                    "eyebrow": "GAME GUIDE.",
                    "headline": "The game’s primary verified stake.",
                    "dek": "Pregame records or one other fact not already in the headline/metrics.",
                    "scoreOrBody": "Matchup state plus exactly three labelled metrics: Tip, full official Arena, viewer-correct Watch.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-essentials",
                    "label": "NYK @ ATL · pregame",
                    "availableAtUtc": "2026-04-06T22:13:00.000Z",
                    "display": {
                        "id": "nyk-atl-essentials",
                        "unitType": "essentials",
                        "eyebrow": "GAME GUIDE",
                        "headline": "Third meets fifth in the East.",
                        "dek": "New York starts the night 50–28; Atlanta is 45–33.",
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Tip",
                                "value": "7:00 p.m. ET"
                            },
                            {
                                "label": "Arena",
                                "value": "State Farm Arena"
                            },
                            {
                                "label": "Watch",
                                "value": "Peacock"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-essentials",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "pregame",
                        "editorialJob": "game-day essentials",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "game-day-essentials"
                },
                {
                    "id": "por-den-essentials",
                    "label": "POR @ DEN · pregame",
                    "availableAtUtc": "2026-04-07T00:11:00.000Z",
                    "display": {
                        "id": "por-den-essentials",
                        "unitType": "essentials",
                        "eyebrow": "GAME GUIDE",
                        "headline": "Denver brings an eight-game streak into the finale.",
                        "dek": "The Nuggets enter 50–28; Portland arrives 40–38.",
                        "scoreLockup": "POR @ DEN · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Tip",
                                "value": "9:00 p.m. ET"
                            },
                            {
                                "label": "Arena",
                                "value": "Ball Arena"
                            },
                            {
                                "label": "Watch",
                                "value": "League Pass"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-essentials",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "pregame",
                        "editorialJob": "game-day essentials",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "game-day-essentials"
                }
            ],
            "kind": "game-day-essentials",
            "displayName": "Game-day essentials",
            "legacyCode": "FU-05",
            "definitionRevision": 1
        },
        {
            "code": "FU-06",
            "name": "Opening tip",
            "cadence": "Baseline",
            "surfaces": [
                "Game Screen Feed"
            ],
            "group": "Orient the night and the game",
            "visual": "score",
            "editorialJob": "Start the official game chronology even when no highlight exists yet.",
            "publishWhen": "At 0–0 when the official game state moves to live.",
            "destination": "Inline; establishes the live boundary in Game Screen Feed.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Mark the beginning of the game chronology without publishing a generic template sentence.",
                "fields": {
                    "eyebrow": "GAME ON.",
                    "headline": "Use the game’s distinguishing verified matchup fact; city/team names alone are insufficient.",
                    "dek": "Usually null; use only for one additional legal fact.",
                    "scoreOrBody": "Exact official 0–0 · Q1 · 12:00 lockup.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-tip",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-06T23:13:00Z",
                    "display": {
                        "id": "nyk-atl-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Knicks–Hawks is underway, with East seeding on the line.",
                        "dek": null,
                        "scoreLockup": "NYK 0–0 ATL · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-tip",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "opening tip",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "event-start"
                },
                {
                    "id": "phi-sas-tip",
                    "label": "PHI @ SAS · at-anchor",
                    "availableAtUtc": "2026-04-07T00:11:00Z",
                    "display": {
                        "id": "phi-sas-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Philadelphia and San Antonio are underway",
                        "dek": null,
                        "scoreLockup": "PHI 0–0 SAS · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-tip",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "opening tip",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501146",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "event-start"
                },
                {
                    "id": "por-den-tip",
                    "label": "POR @ DEN · at-anchor",
                    "availableAtUtc": "2026-04-07T01:11:00Z",
                    "display": {
                        "id": "por-den-tip",
                        "unitType": "tip",
                        "eyebrow": "GAME ON",
                        "headline": "Portland and Denver are underway",
                        "dek": null,
                        "scoreLockup": "POR 0–0 DEN · Q1 · 12:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-tip",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "opening tip",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "event-start"
                }
            ],
            "kind": "event-start",
            "displayName": "Event start",
            "legacyCode": "FU-06",
            "definitionRevision": 1
        },
        {
            "code": "FU-07",
            "name": "Live game lockup",
            "cadence": "System",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Orient the night and the game",
            "visual": "live",
            "editorialJob": "Make the most urgent score, clock and possession context unmistakable.",
            "publishWhen": "Continuously update while live; Home only promotes it when the state is editorially urgent.",
            "destination": "Open the live Game Screen Feed.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Tell the fan the immediate possession-level decision and why it matters.",
                "fields": {
                    "eyebrow": "null; the red dot and score lockup own live status.",
                    "headline": "One current decision or completed swing in present-tense fan language.",
                    "dek": "One separate consequence or cause; no assumed ending.",
                    "scoreOrBody": "Exact official team abbreviations, score, quarter and clock.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-live-anchor",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "nyk-atl-live-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "Atlanta has one possession.",
                        "dek": "Anunoby made both after the review; McCollum answered from three. Brunson is headed to the line with 1.2 seconds left.",
                        "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "live"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-live-anchor",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "urgent live state",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "live-event-status"
                },
                {
                    "id": "det-orl-live-anchor",
                    "label": "DET @ ORL · at-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "det-orl-live-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "Orlando has stopped Detroit’s comeback.",
                        "dek": "The Magic answer a rally that cut their lead to three and restore a 16-point cushion.",
                        "scoreLockup": "DET 107–123 ORL · Q4 · 55.2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "live"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    },
                    "review": {
                        "candidateId": "det-orl-live-anchor",
                        "gameId": "0022501144",
                        "game": "DET @ ORL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "near-final live state",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501144",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "live-event-status"
                },
                {
                    "id": "por-den-anchor",
                    "label": "POR @ DEN · at-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "por-den-anchor",
                        "unitType": "live",
                        "eyebrow": null,
                        "headline": "Nine threes give Portland the early edge.",
                        "dek": "Denver is 1-for-7 from deep, but Jokić’s 12 points keep the Nuggets within four.",
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "live"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-anchor",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "live game state",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "live-event-status"
                }
            ],
            "kind": "live-event-status",
            "displayName": "Live event status",
            "legacyCode": "FU-07",
            "definitionRevision": 1
        },
        {
            "code": "FU-08",
            "name": "Quarter-opening question",
            "cadence": "Baseline",
            "surfaces": [
                "Game Screen Feed"
            ],
            "group": "Orient the night and the game",
            "visual": "editorial",
            "editorialJob": "Turn the previous period into a clear question for the next one.",
            "publishWhen": "At the start of Q2, Q3 and Q4 after the preceding checkpoint is official.",
            "destination": "Inline narrative bridge inside Game Screen Feed.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Turn the completed prior period into the next live question.",
                "fields": {
                    "eyebrow": "START Q2, START Q3 or START Q4.",
                    "headline": "One answerable basketball question or terse margin frame.",
                    "dek": "The completed run/stat that creates the question; no suspense filler.",
                    "scoreOrBody": "Official period-boundary score plus START Qn.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-q4-open",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T00:59:00Z",
                    "occurredAtUtc": "2026-04-07T00:59:00Z",
                    "display": {
                        "id": "nyk-atl-q4-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q4",
                        "headline": "Two points. Twelve minutes.",
                        "dek": "New York closed the third 17–6 to take back the lead.",
                        "scoreLockup": "NYK 81–79 ATL · START Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-q4-open",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "quarter-open question",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "period-orientation"
                },
                {
                    "id": "cle-mem-q2-open",
                    "label": "CLE @ MEM · at-anchor",
                    "availableAtUtc": "2026-04-07T00:38:00Z",
                    "occurredAtUtc": "2026-04-07T00:38:00Z",
                    "display": {
                        "id": "cle-mem-q2-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q2",
                        "headline": "Ten threes have Cleveland chasing.",
                        "dek": "Seven Grizzlies have connected; Memphis leads by 12.",
                        "scoreLockup": "CLE 24–36 MEM · START Q2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    },
                    "review": {
                        "candidateId": "cle-mem-q2-open",
                        "gameId": "0022501145",
                        "game": "CLE @ MEM",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "quarter-open question",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501145",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "period-orientation"
                },
                {
                    "id": "por-den-q2-open",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "occurredAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "por-den-q2-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q2",
                        "headline": "Can Portland keep shooting like this?",
                        "dek": "Nine first-quarter threes have created a four-point lead.",
                        "scoreLockup": "POR 35–31 DEN · START Q2",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-q2-open",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "quarter-open question",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "period-orientation"
                },
                {
                    "id": "por-den-q4-open",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T02:57:00Z",
                    "occurredAtUtc": "2026-04-07T02:57:00Z",
                    "display": {
                        "id": "por-den-q4-open",
                        "unitType": "orientation",
                        "eyebrow": "START Q4",
                        "headline": "Denver has twelve minutes to save the streak",
                        "dek": "Portland leads by 14 after making 20 threes.",
                        "scoreLockup": "POR 101–87 DEN · START Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "editorial"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-q4-open",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "quarter-open question",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 3,
                    "kind": "period-orientation"
                }
            ],
            "kind": "period-orientation",
            "displayName": "Period orientation",
            "legacyCode": "FU-08",
            "definitionRevision": 1
        },
        {
            "code": "FU-36",
            "name": "Catch Up",
            "cadence": "Entry-dependent",
            "surfaces": [
                "Game Screen Feed"
            ],
            "group": "Orient the night and the game",
            "visual": "bullets",
            "editorialJob": "Bring a late-arriving or returning fan up to speed with two to five ordered points before the live chronology continues.",
            "publishWhen": "Present at the top of a qualifying Game Screen Feed visit when meaningful game context has been missed; suppress quick repeat visits and omit it when there is nothing material to catch up on.",
            "destination": "Inline session-entry summary. It scrolls with the feed; newer chronological items can arrive above it.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Bring a late-arriving or returning fan up to speed before live chronology continues.",
                "fields": {
                    "eyebrow": "CATCH UP; do not add a redundant LIVE.",
                    "headline": "Use a stable, direct title such as The game so far; do not manufacture drama.",
                    "dek": "Usually omit. The ordered bullets are the supporting body.",
                    "scoreOrBody": "Two to five bullets: current state, defining swing, leading performers, then one material team cause or unresolved question. Each bullet carries one distinct idea. Avoid a separate score pill when the game header already shows it.",
                    "action": "No action; this is an inline orientation unit that scrolls with the feed."
                }
            },
            "examples": [
                {
                    "id": "cle-mem-q3-catch-up",
                    "label": "CLE @ MEM · end Q3",
                    "availableAtUtc": "2026-04-07T01:48:20.100Z",
                    "display": {
                        "id": "cle-mem-q3-catch-up",
                        "unitType": "catch-up",
                        "eyebrow": "CATCH UP",
                        "headline": "Cleveland has turned a 17-point hole into control.",
                        "dek": null,
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "bullets": [
                            "Cleveland flipped the game with a 31–12 close to the first half.",
                            "The Cavaliers lead paint points 54–24 and second-chance points 19–8.",
                            "Memphis is still alive through 19 made threes."
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "bullets"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    },
                    "review": {
                        "candidateId": "cle-mem-q3-catch-up",
                        "gameId": "0022501145",
                        "game": "CLE @ MEM",
                        "availabilityPhase": "end Q3",
                        "editorialJob": "initial game-entry summary",
                        "classification": "source-backed-spec-example",
                        "sourceKind": "api.nba.com",
                        "sourceId": "source-receipts/game-0022501145.json#cle-mem-q3-catch-up",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "catch-up-summary"
                },
                {
                    "id": "nyk-atl-catch-up",
                    "label": "NYK @ ATL · late arrival",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "nyk-atl-catch-up",
                        "unitType": "catch-up",
                        "eyebrow": "CATCH UP",
                        "headline": "How the lead changed hands",
                        "dek": null,
                        "scoreLockup": null,
                        "action": null,
                        "bullets": [
                            "Atlanta closed the final 8:14 of the half on a 21–10 run; Alexander-Walker scored 10 of those points to reach 20.",
                            "New York answered with a 17–6 run to take an 81–79 lead into the fourth.",
                            "Brunson has 28 points and 13 assists; Alexander-Walker has 36 points and seven threes.",
                            "New York has 52 paint points and 29 assists; Atlanta has 16 threes and 19 offensive rebounds."
                        ],
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "bullets"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "anchor",
                        "editorialJob": "session-entry catch-up",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "official-game-stats",
                        "sourceId": "game-screen-checkpoints:0022501143:anchor",
                        "destinationType": "inline"
                    },
                    "order": 1,
                    "kind": "catch-up-summary"
                },
                {
                    "id": "por-den-catch-up",
                    "label": "POR @ DEN · late arrival",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "por-den-catch-up",
                        "unitType": "catch-up",
                        "eyebrow": "CATCH UP",
                        "headline": "Portland’s shooting has Denver chasing.",
                        "dek": null,
                        "scoreLockup": null,
                        "action": null,
                        "bullets": [
                            "Portland has made nine threes to Denver’s one.",
                            "Camara and Thybulle combine to start 7-for-7 from deep.",
                            "Jokić’s 12 points, six rebounds and four assists keep Denver close.",
                            "Portland’s shooting has set the terms; Denver’s answer has to come inside."
                        ],
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "bullets"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "anchor",
                        "editorialJob": "session-entry catch-up",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "official-game-stats",
                        "sourceId": "game-screen-checkpoints:0022501147:anchor",
                        "destinationType": "inline"
                    },
                    "order": 2,
                    "kind": "catch-up-summary"
                }
            ],
            "kind": "catch-up-summary",
            "displayName": "Catch Up summary",
            "legacyCode": "FU-36",
            "definitionRevision": 1
        },
        {
            "code": "FU-37",
            "name": "Contextual live odds",
            "cadence": "Resolved",
            "surfaces": [
                "Game Screen Feed"
            ],
            "group": "Orient the night and the game",
            "visual": "contextual-odds",
            "editorialJob": "Surface one provider-attributed market that is materially connected to what is happening in the game now.",
            "publishWhen": "Only after the server has resolved viewer and provider eligibility and selected one relevant Pregame or Live market. Omit when the market identity, line, status or destination is absent.",
            "destination": "An open unit emits the typed game-odds host intent. A suspended or closed unit states that status and is not presented as actionable.",
            "deliveryStrategy": "Open implementation assessment. Preserve the same semantic payload, hierarchy and destination on every platform.",
            "writingGuidance": {
                "overall": "Surface one provider-attributed live market that is editorially connected to what is happening in the game now.",
                "fields": {
                    "eyebrow": "LIVE ODDS when the unit is in play. Do not use BETTING or GAMBLING as an editorial label.",
                    "headline": "Name the participant or subject directly. Do not add promotional language or claim that a market is a good bet.",
                    "dek": "State the single resolved selection and line exactly as supplied, such as Over 24.5 points. Do not rewrite odds terminology.",
                    "scoreOrBody": "Show exact live game context, then label the current progress and resolved selection separately. Supply one grammatical plain-language relationship such as Needs 2 more points to clear the line; this is resolved upstream and is not calculated by the renderer. Keep market status secondary and retain clear provider attribution. The upstream decision selects the one market because it is relevant to the game story; the writer and renderer do not pick from raw markets.",
                    "action": "An open unit can take the fan to the typed wider game-odds destination. A suspended or closed market states that condition and is not presented as actionable."
                }
            },
            "examples": [
                {
                    "id": "bos-nyk-brunson-live-odds",
                    "label": "BOS @ NYK · live player line",
                    "availableAtUtc": "2026-07-29T00:00:00Z",
                    "display": {
                        "id": "bos-nyk-brunson-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "BOS 99–99 NYK · Q4 · 5:24",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:jalen-brunson:over-24.5",
                            "subject": "Jalen Brunson",
                            "marketLine": "Over 24.5 points",
                            "progress": "13 PTS",
                            "progressSummary": "Needs 12 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:bos-nyk:live-reference"
                        },
                        "accessibleName": "Live odds. Boston 99, New York 99, fourth quarter, 5 minutes 24 seconds. Jalen Brunson. 13 points current. Over 24.5 points selection. Needs 12 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": null,
                        "game": "BOS @ NYK",
                        "availabilityPhase": "live",
                        "editorialJob": "contextual live player market",
                        "classification": "repackaged-source",
                        "sourceKind": "user-supplied-fanduel-reference",
                        "sourceId": "fanduel-live-overlay:bos-nyk:q4-5:24",
                        "destinationType": "open-game-odds"
                    },
                    "order": 0,
                    "kind": "contextual-odds"
                },
                {
                    "id": "0022501143-contextual-live-odds",
                    "label": "NYK @ ATL · contextual live line",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "0022501143-contextual-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:0022501143",
                            "subject": "Jalen Brunson",
                            "marketLine": "Over 29.5 points",
                            "progress": "28 PTS",
                            "progressSummary": "Needs 2 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:0022501143:demonstrator"
                        },
                        "accessibleName": "Live odds. NYK 106–105 ATL · Q4 · 1.2. Jalen Brunson. 28 PTS current. Over 29.5 points selection. Needs 2 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "anchor",
                        "editorialJob": "contextual live player market",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "fixture-authored-live-odds:0022501143",
                        "destinationType": "open-game-odds"
                    },
                    "order": 1,
                    "kind": "contextual-odds"
                },
                {
                    "id": "0022501144-contextual-live-odds",
                    "label": "DET @ ORL · contextual live line",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "0022501144-contextual-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "DET 107–123 ORL · Q4 · 55.2",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:0022501144",
                            "subject": "Paolo Banchero",
                            "marketLine": "Over 34.5 points",
                            "progress": "31 PTS",
                            "progressSummary": "Needs 4 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:0022501144:demonstrator"
                        },
                        "accessibleName": "Live odds. DET 107–123 ORL · Q4 · 55.2. Paolo Banchero. 31 PTS current. Over 34.5 points selection. Needs 4 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501144",
                        "game": "DET @ ORL",
                        "availabilityPhase": "anchor",
                        "editorialJob": "contextual live player market",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "fixture-authored-live-odds:0022501144",
                        "destinationType": "open-game-odds"
                    },
                    "order": 2,
                    "kind": "contextual-odds"
                },
                {
                    "id": "0022501145-contextual-live-odds",
                    "label": "CLE @ MEM · contextual live line",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "0022501145-contextual-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "CLE 89–77 MEM · Q3 · 4:49",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:0022501145",
                            "subject": "Dennis Schröder",
                            "marketLine": "Over 19.5 points",
                            "progress": "17 PTS",
                            "progressSummary": "Needs 3 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:0022501145:demonstrator"
                        },
                        "accessibleName": "Live odds. CLE 89–77 MEM · Q3 · 4:49. Dennis Schröder. 17 PTS current. Over 19.5 points selection. Needs 3 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501145",
                        "game": "CLE @ MEM",
                        "availabilityPhase": "anchor",
                        "editorialJob": "contextual live player market",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "fixture-authored-live-odds:0022501145",
                        "destinationType": "open-game-odds"
                    },
                    "order": 3,
                    "kind": "contextual-odds"
                },
                {
                    "id": "0022501146-contextual-live-odds",
                    "label": "PHI @ SAS · contextual live line",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "0022501146-contextual-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:0022501146",
                            "subject": "Joel Embiid",
                            "marketLine": "Over 29.5 points",
                            "progress": "25 PTS",
                            "progressSummary": "Needs 5 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:0022501146:demonstrator"
                        },
                        "accessibleName": "Live odds. PHI 65–74 SAS · Q3 · 8:17. Joel Embiid. 25 PTS current. Over 29.5 points selection. Needs 5 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "anchor",
                        "editorialJob": "contextual live player market",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "fixture-authored-live-odds:0022501146",
                        "destinationType": "open-game-odds"
                    },
                    "order": 4,
                    "kind": "contextual-odds"
                },
                {
                    "id": "0022501147-contextual-live-odds",
                    "label": "POR @ DEN · contextual live line",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "0022501147-contextual-live-odds",
                        "unitType": "game-odds",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": null,
                        "games": null,
                        "gameOdds": {
                            "providerName": "FanDuel",
                            "marketId": "player-points:0022501147",
                            "subject": "Nikola Jokić",
                            "marketLine": "Over 19.5 points",
                            "progress": "12 PTS",
                            "progressSummary": "Needs 8 more points to clear the line",
                            "status": "open"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "contextual-odds"
                    },
                    "interaction": {
                        "destination": {
                            "type": "open-game-odds",
                            "destinationId": "game-odds:0022501147:demonstrator"
                        },
                        "accessibleName": "Live odds. POR 35–31 DEN · Q1 · 0:00. Nikola Jokić. 12 PTS current. Over 19.5 points selection. Needs 8 more points to clear the line. Market open. Powered by FanDuel. View live odds."
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "anchor",
                        "editorialJob": "contextual live player market",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "fixture-authored-live-odds:0022501147",
                        "destinationType": "open-game-odds"
                    },
                    "order": 5,
                    "kind": "contextual-odds"
                }
            ],
            "kind": "contextual-odds",
            "displayName": "Contextual odds",
            "legacyCode": "FU-37",
            "definitionRevision": 1
        },
        {
            "code": "FU-38",
            "name": "Ticket offer",
            "cadence": "Resolved",
            "surfaces": [
                "Game Feed",
                "Watch"
            ],
            "group": "Orient the night and the game",
            "visual": "ticket-offer",
            "editorialJob": "Give a fan one direct route to attend a scheduled game using the resolved matchup, localized date and venue.",
            "publishWhen": "Scheduled games only, and only when one server-resolved ticket offer has a valid destination.",
            "destination": "Emit the typed buy-tickets host intent. Reuse the same resolved offer in Game Feed and Watch.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Give a fan one clear route to buy tickets for a scheduled game.",
                "fields": {
                    "eyebrow": "Omit. The matchup, date/time, venue and action provide the context.",
                    "headline": "Use the resolved matchup label; do not add generic event hype.",
                    "dek": "Use the localized scheduled date/time and full venue as utility copy. Do not imply scarcity, price or availability beyond the resolved offer.",
                    "scoreOrBody": "Scheduled state only. Keep the same resolved matchup, date/time and venue when the offer appears in Game Feed or Watch.",
                    "action": "Buy Tickets, and only when the typed ticket destination exists."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-ticket-game-feed",
                    "label": "NYK @ ATL · Game Feed",
                    "availableAtUtc": "2026-04-06T22:00:00Z",
                    "display": {
                        "id": "nyk-atl-ticket-game-feed",
                        "unitType": "ticket-offer",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "ticketOffer": {
                            "matchup": "NYK @ ATL",
                            "localizedDateTime": "Mon, Apr 6, 2026 · 7:00 p.m. ET",
                            "venue": "State Farm Arena",
                            "actionLabel": "Buy Tickets"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "ticket-offer"
                    },
                    "interaction": {
                        "destination": {
                            "type": "buy-game-tickets",
                            "destinationId": "ticket-offer:0022501143:2026-04-06"
                        },
                        "accessibleName": "Buy tickets for New York Knicks at Atlanta Hawks on Monday, April 6 at State Farm Arena"
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "scheduled",
                        "editorialJob": "scheduled ticket route",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "official-game-schedule",
                        "sourceId": "game:0022501143:pregame",
                        "destinationType": "buy-game-tickets"
                    },
                    "order": 0,
                    "kind": "ticket-offer"
                },
                {
                    "id": "nyk-atl-ticket-watch",
                    "label": "NYK @ ATL · Watch",
                    "availableAtUtc": "2026-04-06T22:00:00Z",
                    "display": {
                        "id": "nyk-atl-ticket-watch",
                        "unitType": "ticket-offer",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "ticketOffer": {
                            "matchup": "NYK @ ATL",
                            "localizedDateTime": "Mon, Apr 6, 2026 · 7:00 p.m. ET",
                            "venue": "State Farm Arena",
                            "actionLabel": "Buy Tickets"
                        },
                        "media": null
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "ticket-offer"
                    },
                    "interaction": {
                        "destination": {
                            "type": "buy-game-tickets",
                            "destinationId": "ticket-offer:0022501143:2026-04-06"
                        },
                        "accessibleName": "Buy tickets for New York Knicks at Atlanta Hawks on Monday, April 6 at State Farm Arena"
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "scheduled",
                        "editorialJob": "scheduled ticket route",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "official-game-schedule",
                        "sourceId": "game:0022501143:pregame",
                        "destinationType": "buy-game-tickets"
                    },
                    "order": 1,
                    "kind": "ticket-offer"
                }
            ],
            "kind": "ticket-offer",
            "displayName": "Ticket offer",
            "legacyCode": "FU-38",
            "definitionRevision": 1
        },
        {
            "code": "FU-09",
            "name": "Period checkpoint",
            "cadence": "Baseline",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Publish the lifecycle spine",
            "visual": "score",
            "editorialJob": "Summarize score, leading character and game shape at Q1, halftime and Q3.",
            "publishWhen": "Only after the official period-end event; each checkpoint is retained in scrollback.",
            "destination": "Open the Game Screen Feed at the corresponding period.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Explain the completed Q1, halftime or Q3 result.",
                "fields": {
                    "eyebrow": "END Q1, HALFTIME or END Q3.",
                    "headline": "The player/team action that shaped the period.",
                    "dek": "Exact proof: one run, performer line or team stat. Label every number.",
                    "scoreOrBody": "Official boundary score plus boundary label.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-q1",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-06T23:42:00Z",
                    "display": {
                        "id": "nyk-atl-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "Bridges’ tip gives New York the edge after one.",
                        "dek": "Five lead changes and two ties leave the Knicks up one.",
                        "scoreLockup": "NYK 32–31 ATL · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-q1",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "Q1 checkpoint",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "period-checkpoint"
                },
                {
                    "id": "phi-sas-half",
                    "label": "PHI @ SAS · at-anchor",
                    "availableAtUtc": "2026-04-07T01:11:00Z",
                    "display": {
                        "id": "phi-sas-half",
                        "unitType": "checkpoint",
                        "eyebrow": "HALFTIME",
                        "headline": "Wemby and Embiid own the half.",
                        "dek": "Wembanyama has 17, five and three blocks; Embiid has 20.",
                        "scoreLockup": "PHI 55–62 SAS · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-half",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "halftime checkpoint",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501146",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "period-checkpoint"
                },
                {
                    "id": "nyk-atl-q3",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T00:56:00Z",
                    "display": {
                        "id": "nyk-atl-q3",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q3",
                        "headline": "New York takes the lead back.",
                        "dek": "The Knicks close the quarter on a 17–6 run; Towns scores 14 in the third.",
                        "scoreLockup": "NYK 81–79 ATL · END Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-q3",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "Q3 checkpoint",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "period-checkpoint"
                },
                {
                    "id": "por-den-q1",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T01:36:00Z",
                    "display": {
                        "id": "por-den-q1",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q1",
                        "headline": "Camara and Thybulle torch Denver from deep.",
                        "dek": "They combine to go 7-for-7 as Portland scores 35 in the opening quarter.",
                        "scoreLockup": "POR 35–31 DEN · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-q1",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "Q1 checkpoint",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 3,
                    "kind": "period-checkpoint"
                },
                {
                    "id": "por-den-half",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T02:14:00Z",
                    "display": {
                        "id": "por-den-half",
                        "unitType": "checkpoint",
                        "eyebrow": "HALFTIME",
                        "headline": "Sixteen threes send Portland to the half up 14.",
                        "dek": "Camara has 20 and the Blazers have assists on 18 of 21 field goals.",
                        "scoreLockup": "POR 72–58 DEN · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-half",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "halftime checkpoint",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 4,
                    "kind": "period-checkpoint"
                },
                {
                    "id": "por-den-q3",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T02:54:00Z",
                    "display": {
                        "id": "por-den-q3",
                        "unitType": "checkpoint",
                        "eyebrow": "END Q3",
                        "headline": "Portland hits 20 threes through three.",
                        "dek": null,
                        "scoreLockup": "POR 101–87 DEN · END Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-q3",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "Q3 checkpoint",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 5,
                    "kind": "period-checkpoint"
                },
                {
                    "id": "det-orl-halftime-takeaways",
                    "label": "DET @ ORL · halftime",
                    "availableAtUtc": "2026-04-07T00:18:27.1Z",
                    "display": {
                        "id": "det-orl-halftime-takeaways",
                        "unitType": "checkpoint",
                        "eyebrow": "HALFTIME",
                        "headline": "Orlando is making every Detroit mistake hurt.",
                        "dek": "The Magic lead by 14 after turning 12 Pistons turnovers into a 20–6 points-off-turnovers edge.",
                        "scoreLockup": "DET 55–69 ORL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    },
                    "review": {
                        "candidateId": "det-orl-halftime-takeaways",
                        "gameId": "0022501144",
                        "game": "DET @ ORL",
                        "availabilityPhase": "halftime",
                        "editorialJob": "timeout, quarter and halftime summary",
                        "classification": "source-backed-spec-example",
                        "sourceKind": "api.nba.com",
                        "sourceId": "source-receipts/game-0022501144.json#det-orl-halftime-takeaways",
                        "destinationType": "game-companion"
                    },
                    "order": 6,
                    "kind": "period-checkpoint"
                }
            ],
            "kind": "period-checkpoint",
            "displayName": "Period checkpoint",
            "legacyCode": "FU-09",
            "definitionRevision": 1
        },
        {
            "code": "FU-10",
            "name": "Final + consequence",
            "cadence": "Baseline",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Publish the lifecycle spine",
            "visual": "score",
            "editorialJob": "Close the score and state the result’s most important consequence, not merely repeat the box score.",
            "publishWhen": "After official final state and any essential review, overtime or diagnosis is resolved.",
            "destination": "Open the completed Game Screen Feed or Game Story.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "State how the game ended and its most important consequence.",
                "fields": {
                    "eyebrow": "FINAL.",
                    "headline": "Result shape or decisive ending; do not simply repeat the final score.",
                    "dek": "Top verified performer, record, streak or standings consequence—one idea only.",
                    "scoreOrBody": "Official final score plus FINAL or FINAL/OT.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "por-den-final",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-final",
                        "unitType": "checkpoint",
                        "eyebrow": "FINAL",
                        "headline": "Denver finishes a 16-point fourth-quarter comeback in overtime.",
                        "dek": "Nikola Jokić posts 35 points, 14 rebounds and 13 assists as the Nuggets win their ninth straight.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-final",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "final checkpoint",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "final-outcome"
                },
                {
                    "id": "nyk-atl-final",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "nyk-atl-final",
                        "unitType": "checkpoint",
                        "eyebrow": "FINAL",
                        "headline": "New York ends Atlanta’s 13-game home streak.",
                        "dek": "Brunson scores 17 in the fourth as the Knicks win their third straight.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "score"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-final",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "final checkpoint",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "final-outcome"
                }
            ],
            "kind": "final-outcome",
            "displayName": "Final outcome",
            "legacyCode": "FU-10",
            "definitionRevision": 1
        },
        {
            "code": "FU-39",
            "name": "Attributed commentary",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Show the source layer",
            "visual": "attributed-commentary",
            "editorialJob": "Place a timely outside voice among AI-generated game coverage, with unmistakable contributor identity, role, media form and relationship to the exact moment.",
            "publishWhen": "At five to ten genuinely different story beats across a commissioned game, when that voice adds reaction, interpretation or personality. Space the posts across the game; never turn them into routine possession rows or a second play-by-play stream.",
            "destination": "Text remains inline. Audio and video use the exact contributed media while preserving the game and moment context.",
            "deliveryStrategy": "Native shared attribution for contributor, role/source, timing, game-moment relationship and text, audio or video form. Contributor intake remains independent of this consumer contract.",
            "writingGuidance": {
                "overall": "Insert clearly attributed external colour commentary among AI-generated units when the voice adds genuinely useful reaction, interpretation or personality. When one personality is commissioned across a game, programme five to ten distinct contributions across the full story rather than one token appearance or a second play-by-play stream.",
                "fields": {
                    "eyebrow": "Use a specific relationship label such as ON THE LATE BUCKET, ON THE 12–2 RUN or ON THE FINISH. Do not add a generic COMMENTARY or WATCH label.",
                    "headline": "Use the contributor's display name as the natural byline. Add a role, account or source only when it is verified, useful fan-facing attribution; never append internal classifications such as creator commentary, broadcaster audio or former-player video. The canonical demonstrator examples are Jesser text at NYK 104–102 ATL · Q4 · 0:29, Mike Breen audio at PHI 65–74 SAS · Q3 · 8:17 and Carmelo Anthony video at DET 107–123 ORL · Q4 · 55.2.",
                    "dek": "Preserve the supplied contribution's meaning, cadence and point of view. Light edit for factual accuracy and clarity, but do not smooth distinctive voices into NBA Pulse house copy. First-person reactions, fragments, emphatic punctuation, slang and occasional emoji are valid when authentic to the contributor and moment. Storypilot posts may inform tone only; they are never evidence that a voice commented on a demonstrator game.",
                    "scoreOrBody": "Show the exact game moment or earned connected sequence, contribution time, media form and the contributor's distinct point of view. The contribution should add reaction, opinion, humour or specialist observation rather than repeat score copy or clean editorial analysis. Across a commissioned game, distribute five to ten posts among setup, tactical swings, emotional turns, decisive sequences and final consequence; do not cluster them around one run or turn routine possessions into attributed rows. A final-whistle reflection from the commissioned commentator is valid; do not use this unit for active-player, coach or locker-room reaction.",
                    "action": "Text remains inline. Show Play audio or Watch commentary only when the exact contributed media and its resolved playback behavior exist."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-jesser-attributed-text",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T01:33:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-attributed-text",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 104–102 ATL · Q4 · 0:29",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 0:29",
                            "relationshipLabel": "On Brunson’s late bucket",
                            "format": "text",
                            "statement": "WOW! I can’t believe he got to that spot that clean 😮‍💨 Brunson gets Atlanta leaning, rejects the screen and walks right into it. Cold."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on an exceptional live play",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:not-an-actual-post",
                        "destinationType": "inline"
                    },
                    "order": 0,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "phi-sas-breen-attributed-audio",
                    "label": "Mike Breen · demonstrator-original audio",
                    "availableAtUtc": "2026-04-07T01:24:00Z",
                    "display": {
                        "id": "phi-sas-breen-attributed-audio",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "broadcaster:mike-breen",
                            "displayName": "Mike Breen",
                            "publishedAtLabel": "Q3 · 8:17",
                            "relationshipLabel": "On the Castle–Wembanyama lob",
                            "format": "audio",
                            "statement": "Castle draws the second defender — what a pass! Wembanyama never breaks stride. Beautifully done.",
                            "mediaDuration": "0:38"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "live",
                        "editorialJob": "broadcaster perspective on a connected live action",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:mike-breen:audio:not-an-actual-recording",
                        "destinationType": "inline"
                    },
                    "order": 1,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "det-orl-carmelo-anthony-attributed-video",
                    "label": "Carmelo Anthony · demonstrator-original video",
                    "availableAtUtc": "2026-04-07T01:34:00Z",
                    "display": {
                        "id": "det-orl-carmelo-anthony-attributed-video",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "DET 107–123 ORL · Q4 · 55.2",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "analyst:carmelo-anthony",
                            "displayName": "Carmelo Anthony",
                            "publishedAtLabel": "Q4 · 55.2",
                            "relationshipLabel": "On Banchero’s late dunk",
                            "format": "video",
                            "statement": "That’s the stuff I watch. Paolo shifts him once, gets him leaning and that lane is his. Everybody sees the dunk; the footwork makes it happen.",
                            "mediaDuration": "1:12"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501144",
                        "game": "DET @ ORL",
                        "availabilityPhase": "live",
                        "editorialJob": "former-player perspective on live scoring craft",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:carmelo-anthony:video:not-an-actual-video",
                        "destinationType": "inline"
                    },
                    "order": 2,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "por-den-jesser-attributed-text",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T03:36:00Z",
                    "display": {
                        "id": "por-den-jesser-attributed-text",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 125–125 DEN · END Q4",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "END Q4",
                            "relationshipLabel": "On the overtime-forcing sequence",
                            "format": "text",
                            "statement": "16 down in the fourth and now we’re going to OT?! This game is ridiculous 😭"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "postgame",
                        "editorialJob": "creator perspective on the regulation finish",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:por-den-overtime-scenario",
                        "destinationType": "inline"
                    },
                    "order": 3,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "nyk-atl-jesser-pregame-matchup",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-06T23:01:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-pregame-matchup",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Pregame",
                            "relationshipLabel": "On tonight’s matchup",
                            "format": "text",
                            "statement": "Atlanta brings four straight into a 50-win Knicks team. Nobody gets a warm-up tonight—this one starts loud 👀"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "pregame",
                        "editorialJob": "creator perspective on the pregame stakes",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:nyk-atl-jesser-pregame-matchup",
                        "destinationType": "inline"
                    },
                    "order": 4,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "nyk-atl-jesser-q1-knicks-counter",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-06T23:27:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-q1-knicks-counter",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 16–10 ATL · Q1 · 6:24",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q1 · 6:24",
                            "relationshipLabel": "On the 11–0 run",
                            "format": "text",
                            "statement": "Down five, then 11 straight?? That’s the fastest ‘we’re fine’ you’ll ever see. Brunson and McBride just changed the temperature in here."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on New York's first run",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:nyk-atl-jesser-q1-knicks-counter",
                        "destinationType": "inline"
                    },
                    "order": 5,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "nyk-atl-jesser-q2-hawks-answer",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T00:04:15Z",
                    "display": {
                        "id": "nyk-atl-jesser-q2-hawks-answer",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 43–46 ATL · Q2 · 5:57",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q2 · 5:57",
                            "relationshipLabel": "On Atlanta’s answer",
                            "format": "text",
                            "statement": "Seven-point lead, gone. Atlanta didn’t just answer—it stole the energy right back. This building is awake now."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on Atlanta's second-quarter answer",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:nyk-atl-jesser-q2-hawks-answer",
                        "destinationType": "inline"
                    },
                    "order": 6,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "nyk-atl-jesser-halftime-extra-possessions",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T00:14:15Z",
                    "display": {
                        "id": "nyk-atl-jesser-halftime-extra-possessions",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Halftime",
                            "relationshipLabel": "At halftime",
                            "format": "text",
                            "statement": "Twelve offensive rebounds in one half is not a stat, it’s a cry for help 😭 New York shot it better and still trails. Somebody has to put a body on somebody."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on Atlanta's extra possessions",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:nyk-atl-jesser-halftime-extra-possessions",
                        "destinationType": "inline"
                    },
                    "order": 7,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "nyk-atl-jesser-q3-whiplash",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T00:56:30Z",
                    "display": {
                        "id": "nyk-atl-jesser-q3-whiplash",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 81–79 ATL · END Q3",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "End Q3",
                            "relationshipLabel": "On the third-quarter whiplash",
                            "format": "text",
                            "statement": "Jalen Johnson tried to end a man’s whole career and New York has the lead by the buzzer?? This game has zero respect for momentum and I love it."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on the third-quarter reversal",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:nyk-atl-jesser-q3-whiplash",
                        "destinationType": "inline"
                    },
                    "order": 8,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "nyk-atl-jesser-naw-seventh-three",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T01:26:30Z",
                    "display": {
                        "id": "nyk-atl-jesser-naw-seventh-three",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 95–100 ATL · Q4 · 3:15",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 3:15",
                            "relationshipLabel": "On Alexander-Walker’s seventh three",
                            "format": "text",
                            "statement": "SEVEN threes. I have run out of things to yell. New York needs to take this personally right now."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on Alexander-Walker's shooting",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:nyk-atl-jesser-naw-seventh-three",
                        "destinationType": "inline"
                    },
                    "order": 9,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "nyk-atl-jesser-final-possession",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-final-possession",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 1.2",
                            "relationshipLabel": "On Atlanta’s last possession",
                            "format": "text",
                            "statement": "ONE point. ONE possession. 1.2 seconds. Atlanta has one chance to steal this, and New York has one job: do not give up a clean look 😮‍💨"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on Atlanta's final possession",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:nyk-atl-jesser-final-possession",
                        "destinationType": "inline"
                    },
                    "order": 10,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "nyk-atl-jesser-final-review",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T01:39:00Z",
                    "display": {
                        "id": "nyk-atl-jesser-final-review",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Final",
                            "relationshipLabel": "On the final review",
                            "format": "text",
                            "statement": "That half-court shot went in and STILL didn’t count. Knicks fans just aged five years in five seconds 😭 Brunson walks out with the win anyway. Ridiculous."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "postgame",
                        "editorialJob": "creator perspective on the final review",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:nyk-atl-jesser-final-review",
                        "destinationType": "inline"
                    },
                    "order": 11,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "por-den-jesser-pregame-expectation",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T00:12:00Z",
                    "display": {
                        "id": "por-den-jesser-pregame-expectation",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR @ DEN · 9:00 p.m. ET",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Pregame",
                            "relationshipLabel": "On Denver chasing nine straight",
                            "format": "text",
                            "statement": "Eight straight puts Denver in that weird spot where everybody expects number nine. I’m watching the first five minutes: do they come out sharp, or play like the night already owes them something?"
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "pregame",
                        "editorialJob": "creator perspective on Denver's pregame pressure",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:por-den-jesser-pregame-expectation",
                        "destinationType": "inline"
                    },
                    "order": 12,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "por-den-jesser-q1-shooting-barrage",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "por-den-jesser-q1-shooting-barrage",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q1 · 0:00",
                            "relationshipLabel": "On Portland’s opening barrage",
                            "format": "text",
                            "statement": "Camara and Thybulle are the ones going perfect from deep? The scouting report is officially on fire. Denver has to stop waiting for this to fix itself."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on Portland's opening shooting",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:por-den-jesser-q1-shooting-barrage",
                        "destinationType": "inline"
                    },
                    "order": 13,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "por-den-jesser-q2-answer",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T01:54:00Z",
                    "display": {
                        "id": "por-den-jesser-q2-answer",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 53–49 DEN · Q2 · 6:23",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q2 · 6:23",
                            "relationshipLabel": "On Denver’s first answer",
                            "format": "text",
                            "statement": "Denver just cut thirteen to four with Jokić watching. Now he checks back in. That’s the first time this game has felt like it might actually change temperature."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on Denver's second-quarter answer",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:por-den-jesser-q2-answer",
                        "destinationType": "inline"
                    },
                    "order": 14,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "por-den-jesser-q3-counterpunch",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T02:40:00Z",
                    "display": {
                        "id": "por-den-jesser-q3-counterpunch",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 81–73 DEN · Q3 · 7:06",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q3 · 7:06",
                            "relationshipLabel": "On Portland answering Denver’s 9–0 push",
                            "format": "text",
                            "statement": "Denver finally gets the building up and Camara answers on the very next trip. That three is louder than the nine points before it."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on Portland's third-quarter answer",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:por-den-jesser-q3-counterpunch",
                        "destinationType": "inline"
                    },
                    "order": 15,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "por-den-jesser-q4-one-possession",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T03:29:00Z",
                    "display": {
                        "id": "por-den-jesser-q4-one-possession",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 119–116 DEN · Q4 · 2:51",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Q4 · 2:51",
                            "relationshipLabel": "On Denver making it one possession",
                            "format": "text",
                            "statement": "Okay, now it’s real. Portland was up 16 in this quarter, Denver is within three, and every empty Blazers trip feels twice as loud. Ball Arena knows what’s happening."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "live",
                        "editorialJob": "creator perspective on Denver's fourth-quarter comeback",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:por-den-jesser-q4-one-possession",
                        "destinationType": "inline"
                    },
                    "order": 16,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "por-den-jesser-ot-seven-clear",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T03:46:26Z",
                    "display": {
                        "id": "por-den-jesser-ot-seven-clear",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 130–137 DEN · OT · 1:26",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "OT · 1:26",
                            "relationshipLabel": "On Jokić taking over overtime",
                            "format": "text",
                            "statement": "Jokić. Of course it’s Jokić. Overtime is chaos for everybody else and he still looks like he’s choosing from a menu. Seven up now feels enormous."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "postgame",
                        "editorialJob": "creator perspective on Jokic's overtime control",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:por-den-jesser-ot-seven-clear",
                        "destinationType": "inline"
                    },
                    "order": 17,
                    "kind": "attributed-commentary"
                },
                {
                    "id": "por-den-jesser-final-consequence",
                    "label": "Jesser · demonstrator-original text",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-jesser-final-consequence",
                        "unitType": "attributed-commentary",
                        "eyebrow": null,
                        "headline": null,
                        "dek": null,
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": null,
                        "attributedCommentary": {
                            "contributorIdentity": "creator:jesser",
                            "displayName": "Jesser",
                            "publishedAtLabel": "Final · OT",
                            "relationshipLabel": "On how Denver won its ninth straight",
                            "format": "text",
                            "statement": "Twenty-five threes and Portland still lost. That sentence should not be legal. Denver has won nine straight, and this one might have been the meanest."
                        },
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "attributed-commentary"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "postgame",
                        "editorialJob": "creator perspective on the final consequence",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "demonstrator-fixture",
                        "sourceId": "demonstrator-original:jesser:text:por-den-jesser-final-consequence",
                        "destinationType": "inline"
                    },
                    "order": 18,
                    "kind": "attributed-commentary"
                }
            ],
            "kind": "attributed-commentary",
            "displayName": "Attributed commentary",
            "legacyCode": "FU-39",
            "definitionRevision": 1
        },
        {
            "code": "FU-11",
            "name": "Native vertical Clip",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Show the source layer",
            "visual": "vertical-video",
            "editorialJob": "Deliver a playable action moment in its strongest existing Storyteller-native form.",
            "publishWhen": "When a verified play earns replay value; engagement helps rank equally truthful clips.",
            "destination": "Play the exact Storyteller Clip.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Make the visible play legible in-feed at its original moment.",
                "fields": {
                    "eyebrow": "null; do not label video as VIDEO or LIVE.",
                    "headline": "Name the player, action and—when useful—immediate effect.",
                    "dek": "Required for feed presentation. Add the play’s immediate score/state consequence or one other verified fact the picture cannot supply. Never mention a later foul, review, comeback or result.",
                    "scoreOrBody": "Exact score, period and clock at the Clip event, retained unchanged after the game.",
                    "action": "null; tapping the media opens the player."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-brunson-bucket-clip",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T01:32:23.8500897Z",
                    "display": {
                        "id": "nyk-atl-brunson-bucket-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Brunson’s step-back puts New York ahead.",
                        "dek": "He creates room and knocks down the 18-footer with 29 seconds left.",
                        "scoreLockup": "NYK 104–102 ATL · Q4 · 0:29",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": 42,
                            "shares": 12
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "a2ab872c-313e-149e-b249-3a2077be939c",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Brunson’s step-back puts New York ahead. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "nyk-atl-brunson-bucket-clip",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "a2ab872c-313e-149e-b249-3a2077be939c",
                        "destinationType": "clip"
                    },
                    "order": 0,
                    "kind": "vertical-clip"
                },
                {
                    "id": "phi-sas-wemby-dunk-clip",
                    "label": "PHI @ SAS · at-anchor",
                    "availableAtUtc": "2026-04-07T01:05:23.7892618Z",
                    "display": {
                        "id": "phi-sas-wemby-dunk-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Vassell lifts it. Wembanyama finishes with two hands.",
                        "dek": "The alley-oop puts San Antonio ahead with 4:50 left in the half.",
                        "scoreLockup": "PHI 49–51 SAS · Q2 · 4:50",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "95e60eee-ffd2-6f06-d30b-3a2077a5da3a",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open Vassell lifts it. Wembanyama finishes with two hands. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "phi-sas-wemby-dunk-clip",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "95e60eee-ffd2-6f06-d30b-3a2077a5da3a",
                        "destinationType": "clip"
                    },
                    "order": 1,
                    "kind": "vertical-clip"
                },
                {
                    "id": "nyk-atl-naw-three-clip",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T01:26:02.4211074Z",
                    "display": {
                        "id": "nyk-atl-naw-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "NAW splashes the three in a frantic fourth.",
                        "dek": "His seventh make from deep keeps Atlanta in front late.",
                        "scoreLockup": "NYK 95–100 ATL · Q4 · 3:15",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "3760a47f-6aac-9545-4895-3a2077b8bfd8",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open NAW splashes the three in a frantic fourth. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "nyk-atl-naw-three-clip",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "3760a47f-6aac-9545-4895-3a2077b8bfd8",
                        "destinationType": "clip"
                    },
                    "order": 2,
                    "kind": "vertical-clip"
                },
                {
                    "id": "nyk-atl-kat-three-clip",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T00:47:16.0739212Z",
                    "display": {
                        "id": "nyk-atl-kat-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Towns cuts into Atlanta’s lead from deep.",
                        "dek": "The make trims a seven-point deficit to four midway through the third.",
                        "scoreLockup": "NYK 69–73 ATL · Q3 · 5:23",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "eb63b845-2fde-98b4-18d3-3a20779541b0",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Towns cuts into Atlanta’s lead from deep. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "nyk-atl-kat-three-clip",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "eb63b845-2fde-98b4-18d3-3a20779541b0",
                        "destinationType": "clip"
                    },
                    "order": 3,
                    "kind": "vertical-clip"
                },
                {
                    "id": "nyk-atl-naw-q1-answer",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-06T23:38:06.0514689Z",
                    "occurredAtUtc": "2026-04-06T23:30:50Z",
                    "display": {
                        "id": "nyk-atl-naw-q1-answer",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Alexander-Walker pulls Atlanta back in front.",
                        "dek": "Eight points in 78 seconds—from the line, a step-back and a three—turn a five-point deficit into a one-point lead.",
                        "scoreLockup": "NYK 24–25 ATL · Q1 · 3:35",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "44e97989-2632-3911-714d-3a207755edac",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Alexander-Walker pulls Atlanta back in front. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "nyk-atl-naw-q1-answer",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "44e97989-2632-3911-714d-3a207755edac",
                        "destinationType": "clip"
                    },
                    "order": 4,
                    "kind": "vertical-clip"
                },
                {
                    "id": "nyk-atl-clarkson-q2-clip",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-06T23:55:17.7974053Z",
                    "occurredAtUtc": "2026-04-06T23:52:13Z",
                    "display": {
                        "id": "nyk-atl-clarkson-q2-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "New York’s bench opens a seven-point gap.",
                        "dek": "McBride’s three and Clarkson’s three-point play lead an 11–5 start to the second.",
                        "scoreLockup": "NYK 43–36 ATL · Q2 · 8:14",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "fa8a5d58-6626-ca4b-2942-3a207765ac78",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open New York’s bench opens a seven-point gap. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "nyk-atl-clarkson-q2-clip",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "fa8a5d58-6626-ca4b-2942-3a207765ac78",
                        "destinationType": "clip"
                    },
                    "order": 5,
                    "kind": "vertical-clip"
                },
                {
                    "id": "nyk-atl-atl-10-0-run",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T00:03:52.3239316Z",
                    "occurredAtUtc": "2026-04-06T23:59:15Z",
                    "display": {
                        "id": "nyk-atl-atl-10-0-run",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Atlanta answers with 10 straight.",
                        "dek": "Okongwu starts it from three; Alexander-Walker scores five as the Hawks turn seven down into a 46–43 lead.",
                        "scoreLockup": "NYK 43–46 ATL · Q2 · 5:57",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "34fc8f4d-a5bc-617d-2f01-3a20776d8544",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Atlanta answers with 10 straight. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "nyk-atl-atl-10-0-run",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "34fc8f4d-a5bc-617d-2f01-3a20776d8544",
                        "destinationType": "clip"
                    },
                    "order": 6,
                    "kind": "vertical-clip"
                },
                {
                    "id": "nyk-atl-brunson-q3-lead-clip",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T00:57:07.2113466Z",
                    "occurredAtUtc": "2026-04-07T00:52:35Z",
                    "display": {
                        "id": "nyk-atl-brunson-q3-lead-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Brunson gives New York breathing room.",
                        "dek": "His three stretches the Knicks’ first lead of the half to four.",
                        "scoreLockup": "NYK 79–75 ATL · Q3 · 1:27",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "52f7cad9-8c5c-1f7d-407b-3a20779e46c0",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Brunson gives New York breathing room. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "nyk-atl-brunson-q3-lead-clip",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "52f7cad9-8c5c-1f7d-407b-3a20779e46c0",
                        "destinationType": "clip"
                    },
                    "order": 7,
                    "kind": "vertical-clip"
                },
                {
                    "id": "por-den-camara-three-clip",
                    "label": "POR @ DEN · at-anchor",
                    "availableAtUtc": "2026-04-07T01:32:27.3778765Z",
                    "display": {
                        "id": "por-den-camara-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Camara starts 4-for-4 from deep.",
                        "dek": "His fourth make gives him 12 points before the quarter is over.",
                        "scoreLockup": "POR 30–23 DEN · Q1 · 3:24",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "5445169b-f7b6-e3d0-6792-3a2077bea035",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Camara starts 4-for-4 from deep. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "por-den-camara-three-clip",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "5445169b-f7b6-e3d0-6792-3a2077bea035",
                        "destinationType": "clip"
                    },
                    "order": 8,
                    "kind": "vertical-clip"
                },
                {
                    "id": "por-den-clingan-three-clip",
                    "label": "POR @ DEN · at-anchor",
                    "availableAtUtc": "2026-04-07T01:27:26.7448463Z",
                    "display": {
                        "id": "por-den-clingan-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Clingan joins Portland’s opening barrage.",
                        "dek": "The seven-footer’s make gives Portland a four-point lead midway through the first.",
                        "scoreLockup": "POR 21–17 DEN · Q1 · 5:37",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "f753c2ee-381f-d425-a966-3a2077ba0a29",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Clingan joins Portland’s opening barrage. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "por-den-clingan-three-clip",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "f753c2ee-381f-d425-a966-3a2077ba0a29",
                        "destinationType": "clip"
                    },
                    "order": 9,
                    "kind": "vertical-clip"
                },
                {
                    "id": "por-den-thybulle-three-clip",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T01:35:37.4488343Z",
                    "display": {
                        "id": "por-den-thybulle-three-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Thybulle starts 3-for-3 from deep.",
                        "dek": "He and Camara are 7-for-7 from deep late in the first.",
                        "scoreLockup": "POR 33–27 DEN · Q1 · 1:54",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "25b31b3e-0603-1b3c-3728-3a2077c1866d",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Thybulle starts 3-for-3 from deep. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "por-den-thybulle-three-clip",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "25b31b3e-0603-1b3c-3728-3a2077c1866d",
                        "destinationType": "clip"
                    },
                    "order": 10,
                    "kind": "vertical-clip"
                },
                {
                    "id": "por-den-camara-later-clip",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T02:49:23.4566259Z",
                    "display": {
                        "id": "por-den-camara-later-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Camara drills his eighth three.",
                        "dek": "He reaches 28 points and stretches Portland’s lead to 17.",
                        "scoreLockup": "POR 95–78 DEN · Q3 · 2:48",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "252bc6fa-6f0c-4ee9-757c-3a207805102d",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Camara drills his eighth three. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "por-den-camara-later-clip",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "252bc6fa-6f0c-4ee9-757c-3a207805102d",
                        "destinationType": "clip"
                    },
                    "order": 11,
                    "kind": "vertical-clip"
                },
                {
                    "id": "por-den-gordon-tie-clip",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:32:07.9430558Z",
                    "display": {
                        "id": "por-den-gordon-tie-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Gordon’s corner three makes it 123–123.",
                        "dek": "Denver has erased a 16-point fourth-quarter deficit with 1:12 left.",
                        "scoreLockup": "POR 123–123 DEN · Q4 · 1:12",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "f5724d72-adeb-9f53-a055-3a20782c31e0",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Gordon’s corner three makes it 123–123. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "por-den-gordon-tie-clip",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "f5724d72-adeb-9f53-a055-3a20782c31e0",
                        "destinationType": "clip"
                    },
                    "order": 12,
                    "kind": "vertical-clip"
                }
            ],
            "kind": "vertical-clip",
            "displayName": "Vertical Clip",
            "legacyCode": "FU-11",
            "definitionRevision": 1
        },
        {
            "code": "FU-12",
            "name": "Indexed source video",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Show the source layer",
            "visual": "vertical-video",
            "editorialJob": "Use arrivals, warmups, arena reaction, behind-the-scenes footage or source action before it is trapped in a rendered Story page.",
            "publishWhen": "When source meaning, timing, quality and rights are known and the scene improves the night’s rhythm.",
            "destination": "Inline playback or the Game Screen Feed; preserve exact source identity.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Give a useful fan frame to verified raw/source video without exposing where it came from.",
                "fields": {
                    "eyebrow": "Phase only when useful (BEFORE THE GAME); otherwise null. Never SOURCE, REPACKAGED or WATCH.",
                    "headline": "Describe exactly what the fan sees: arrival, warmup, arena, player or action.",
                    "dek": "Add one different verified player/place/time detail; never repeat “arrives,” “inside” or “before tip” from the headline.",
                    "scoreOrBody": "Exact matchup/pregame state or event-time score.",
                    "action": "Follow game when it opens the Game Screen; otherwise the normal media interaction."
                }
            },
            "examples": [
                {
                    "id": "phi-sas-philly-arrival-source",
                    "label": "PHI @ SAS · pregame",
                    "availableAtUtc": "2026-04-06T22:44:35Z",
                    "display": {
                        "id": "phi-sas-philly-arrival-source",
                        "unitType": "source-video",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Philly is in the building",
                        "dek": "Philadelphia arrives in San Antonio before the big-man matchup.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-philly-arrival-source",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "pregame",
                        "editorialJob": "semantic source routing",
                        "classification": "repackaged-source",
                        "sourceKind": "story-page",
                        "sourceId": "9562602f-6046-a264-efe3-3a207724f666",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "source-video"
                },
                {
                    "id": "nyk-atl-brunson-pregame-source",
                    "label": "NYK @ ATL · pregame",
                    "availableAtUtc": "2026-04-06T22:13:00.000Z",
                    "display": {
                        "id": "nyk-atl-brunson-pregame-source",
                        "unitType": "source-video",
                        "eyebrow": "PLAYER TO WATCH",
                        "headline": "Brunson brings 26.0 points and 6.7 assists per game into Atlanta.",
                        "dek": "Atlanta has to contain New York’s leading scorer and playmaker.",
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://storyteller-assets.nba.com/assets/pages/d180db88-1617-5b52-b6cb-3a2073ed79d8/90604b05-5ed3-3b44-34c0-3a2073ee9856/Playcard_Thumbnail.jpeg",
                            "playbackUrl": "https://storyteller-assets.nba.com/assets/pages/d180db88-1617-5b52-b6cb-3a2073ed79d8/69a0cca7-3dc0-8d88-2780-3a2073ee9aec/asset.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-brunson-pregame-source",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "pregame",
                        "editorialJob": "semantic source routing",
                        "classification": "repackaged-source",
                        "sourceKind": "story-page",
                        "sourceId": "d180db88-1617-5b52-b6cb-3a2073ed79d8",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "source-video"
                },
                {
                    "id": "nyk-atl-robinson-hustle-source",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T01:27:11Z",
                    "occurredAtUtc": "2026-04-07T01:11:52Z",
                    "display": {
                        "id": "nyk-atl-robinson-hustle-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "Robinson does the dirty work at both ends.",
                        "dek": "He blocks a three, then wins two offensive rebounds and tips in the tying basket.",
                        "scoreLockup": "NYK 91–91 ATL · Q4 · 5:28",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869708573119115243/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869708573119115243/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-robinson-hustle-source",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "engagement-validated setup",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "3869708573119115243",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "source-video"
                },
                {
                    "id": "nyk-atl-jalen-johnson-poster-source",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T01:02:42Z",
                    "occurredAtUtc": "2026-04-07T00:39:02Z",
                    "display": {
                        "id": "nyk-atl-jalen-johnson-poster-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "Jalen Johnson detonates at the rim.",
                        "dek": "The driving dunk gives Atlanta a 10-point lead midway through the third.",
                        "scoreLockup": "NYK 61–71 ATL · Q3 · 6:44",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869696247502280917/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869696247502280917/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-jalen-johnson-poster-source",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "engagement-validated setup",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "3869696247502280917",
                        "destinationType": "game-companion"
                    },
                    "order": 3,
                    "kind": "source-video"
                },
                {
                    "id": "nyk-atl-naw-blender-source",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T00:13:02Z",
                    "occurredAtUtc": "2026-04-07T00:13:02Z",
                    "display": {
                        "id": "nyk-atl-naw-blender-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "NAW takes New York through the blender.",
                        "dek": "Alexander-Walker scores 10 during Atlanta’s 21–10 finish and reaches 20 by halftime.",
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869669830534761975/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869669830534761975/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-naw-blender-source",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "engagement-validated setup",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "3869669830534761975",
                        "destinationType": "game-companion"
                    },
                    "order": 4,
                    "kind": "source-video"
                },
                {
                    "id": "nyk-atl-brunson-q4-takeover-source",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T01:51:56Z",
                    "display": {
                        "id": "nyk-atl-brunson-q4-takeover-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "Seventeen in the fourth.",
                        "dek": "He ties it, puts New York ahead twice and closes the win at the line.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869720602551146626/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869720602551146626/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-brunson-q4-takeover-source",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "engagement-validated aftermath",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "3869720602551146626",
                        "destinationType": "game-companion"
                    },
                    "order": 5,
                    "kind": "source-video"
                },
                {
                    "id": "nyk-atl-cj-halfcourt-near-miss-source",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T02:31:34Z",
                    "display": {
                        "id": "nyk-atl-cj-halfcourt-near-miss-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "The heave goes in. The review takes it away.",
                        "dek": "McCollum appears to steal it at the buzzer, but replay shows the ball left his hand too late.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869740974629227263/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869740974629227263/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-cj-halfcourt-near-miss-source",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "engagement-validated aftermath",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "3869740974629227263",
                        "destinationType": "game-companion"
                    },
                    "order": 6,
                    "kind": "source-video"
                },
                {
                    "id": "nyk-atl-fantastic-finish-source",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T03:35:03Z",
                    "display": {
                        "id": "nyk-atl-fantastic-finish-source",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "Brunson, McCollum and one last review.",
                        "dek": "A step-back, McCollum’s answer, Brunson’s free throws and an overturned heave settle it in the final 29 seconds.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null,
                            "posterUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869772281266994148/vid_1_thumb.jpg",
                            "playbackUrl": "https://assets.usestorypilot.com/posts/nba/instagram/2026/04/07/instagram_3869772281266994148/vid_1.mp4"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-fantastic-finish-source",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "engagement-validated aftermath",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "3869772281266994148",
                        "destinationType": "game-companion"
                    },
                    "order": 7,
                    "kind": "source-video"
                },
                {
                    "id": "por-den-opening-atmosphere-source",
                    "label": "POR @ DEN · at-anchor",
                    "availableAtUtc": "2026-04-07T01:01:22Z",
                    "display": {
                        "id": "por-den-opening-atmosphere-source",
                        "unitType": "source-video",
                        "eyebrow": "GAME ON",
                        "headline": "The late game tips at Ball Arena.",
                        "dek": "Hear Portland’s opening possession from courtside.",
                        "scoreLockup": "POR @ DEN · Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "vertical-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-opening-atmosphere-source",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "engagement-validated setup",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "3869695243922221164",
                        "destinationType": "game-companion"
                    },
                    "order": 8,
                    "kind": "source-video"
                }
            ],
            "kind": "source-video",
            "displayName": "Source video",
            "legacyCode": "FU-12",
            "definitionRevision": 1
        },
        {
            "code": "FU-13",
            "name": "Indexed captioned still",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Show the source layer",
            "visual": "wide-image",
            "editorialJob": "Reuse an NBA-captioned Story image as contextual photography rather than treating the rendered page as the only asset.",
            "publishWhen": "When subject, scene, time and rights are resolved from the source page.",
            "destination": "Inline image treatment or Game Screen Feed.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Turn one sourced image into a specific, timely scene.",
                "fields": {
                    "eyebrow": "Use the real game phase only when useful (BEFORE THE GAME, HALFTIME); never label the asset or its source.",
                    "headline": "Name the person, place or action the image actually establishes.",
                    "dek": "Add one verified stake or piece of context that is not already visible.",
                    "scoreOrBody": "Score/state: Show the exact applicable state (PREGAME, a verified live checkpoint or FINAL); do not manufacture an event score from a later state.",
                    "action": "Name the fan destination, normally Follow game."
                }
            },
            "examples": [
                {
                    "id": "phi-sas-castle-warmup-source",
                    "label": "PHI @ SAS · pregame",
                    "availableAtUtc": "2026-04-06T22:44:35Z",
                    "display": {
                        "id": "phi-sas-castle-warmup-source",
                        "unitType": "source-image",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Castle’s final reps before tip.",
                        "dek": "San Antonio is one win from 60 as Castle gets loose.",
                        "scoreLockup": "PHI @ SAS · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-castle-warmup-source",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "pregame",
                        "editorialJob": "semantic source routing",
                        "classification": "repackaged-source",
                        "sourceKind": "story-page",
                        "sourceId": "70036893-e0e9-3b49-276c-3a207724f65b",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "captioned-image"
                },
                {
                    "id": "nyk-atl-locker-room-source",
                    "label": "NYK @ ATL · pregame",
                    "availableAtUtc": "2026-04-06T22:13:00.000Z",
                    "display": {
                        "id": "nyk-atl-locker-room-source",
                        "unitType": "source-image",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Inside New York’s locker room.",
                        "dek": "The Knicks get set in Atlanta with a third straight win in reach.",
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-locker-room-source",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "pregame",
                        "editorialJob": "semantic source routing",
                        "classification": "repackaged-source",
                        "sourceKind": "story-page",
                        "sourceId": "c98f1180-24ab-e8aa-e1dd-3a2073ed79f2",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "captioned-image"
                },
                {
                    "id": "nyk-atl-brunson-naw-photo",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T00:14:42Z",
                    "occurredAtUtc": "2026-04-07T00:14:42Z",
                    "display": {
                        "id": "nyk-atl-brunson-naw-photo",
                        "unitType": "source-image",
                        "eyebrow": "HALFTIME",
                        "headline": "Atlanta turns a seven-point hole into a halftime lead.",
                        "dek": "A 21–10 close gives the Hawks a 57–53 edge at the break.",
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide",
                            "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/07/07cc15e7-4b58-468d-af28-9b6288a21839-getty-2269586567.jpg"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-brunson-naw-photo",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "semantic source routing",
                        "classification": "repackaged-source",
                        "sourceKind": "story-page",
                        "sourceId": "c088fa11-a249-6d99-1446-3a207777768c",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "captioned-image"
                },
                {
                    "id": "nyk-atl-brunson-finish-photo",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T03:08:09.8884871Z",
                    "display": {
                        "id": "nyk-atl-brunson-finish-photo",
                        "unitType": "source-image",
                        "eyebrow": "FINAL",
                        "headline": "Brunson gets downhill when Atlanta needs a stop.",
                        "dek": null,
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-brunson-finish-photo",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "photographic aftermath",
                        "classification": "repackaged-source",
                        "sourceKind": "getty",
                        "sourceId": "2270147288",
                        "destinationType": "game-companion"
                    },
                    "order": 3,
                    "kind": "captioned-image"
                },
                {
                    "id": "por-den-camara-live-photo",
                    "label": "POR @ DEN · at-anchor",
                    "availableAtUtc": "2026-04-07T01:32:28.9981794Z",
                    "display": {
                        "id": "por-den-camara-live-photo",
                        "unitType": "source-image",
                        "eyebrow": "FIRST QUARTER",
                        "headline": "Camara has Denver scrambling.",
                        "dek": "Four threes in less than nine minutes turn Portland’s fast start into an immediate problem for Denver.",
                        "scoreLockup": "POR 35–31 DEN · Q1 · 0:00",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-camara-live-photo",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "photographic live context",
                        "classification": "repackaged-source",
                        "sourceKind": "getty",
                        "sourceId": "2269590457",
                        "destinationType": "game-companion"
                    },
                    "order": 4,
                    "kind": "captioned-image"
                },
                {
                    "id": "por-den-celebration-photo",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T04:04:56.7809874Z",
                    "display": {
                        "id": "por-den-celebration-photo",
                        "unitType": "source-image",
                        "eyebrow": "FINAL",
                        "headline": "Denver gets the last word in overtime.",
                        "dek": "Murray, Gordon and Jokić turn a 16-point fourth-quarter deficit into a ninth straight win.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-celebration-photo",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "photographic aftermath",
                        "classification": "repackaged-source",
                        "sourceKind": "getty",
                        "sourceId": "2269594053",
                        "destinationType": "game-companion"
                    },
                    "order": 5,
                    "kind": "captioned-image"
                }
            ],
            "kind": "captioned-image",
            "displayName": "Captioned image",
            "legacyCode": "FU-13",
            "definitionRevision": 1
        },
        {
            "code": "FU-14",
            "name": "Photo + stat composite",
            "cadence": "Planned · rights-gated",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Show the source layer",
            "visual": "wide-image",
            "editorialJob": "Bring energy to a stat-led story by attaching an exact-game photograph and NBA-authored context.",
            "publishWhen": "After the stat is official and the exact image is approved for the intended use.",
            "destination": "Inline evidence unit; optional player/game detail.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Make a player or team performance feel human and consequential by pairing a strong image with the number that matters.",
                "fields": {
                    "eyebrow": "Omit by default; use a phase label only when it improves orientation.",
                    "headline": "State what the performance changed, achieved or nearly achieved.",
                    "dek": "Supply the defining statistic and its game consequence; do not restate the headline.",
                    "scoreOrBody": "Score/state: Use the exact checkpoint the performance claim describes, including overtime notation where relevant.",
                    "action": "Send the fan to the game context with Follow game."
                }
            },
            "examples": [
                {
                    "id": "por-den-photo-stat",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-photo-stat",
                        "unitType": "photo",
                        "eyebrow": "PHOTO STORY",
                        "headline": "Camara’s 30-point night ends in overtime.",
                        "dek": "His eight threes set a Portland mark, but Denver rallies from 16 down.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-photo-stat",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "Getty plus evidence",
                        "classification": "repackaged-source",
                        "sourceKind": "getty",
                        "sourceId": "2269590457",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "photo-stat-composite"
                },
                {
                    "id": "nyk-atl-photo-stat",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "nyk-atl-photo-stat",
                        "unitType": "photo",
                        "eyebrow": "PHOTO STORY",
                        "headline": "Brunson scores 17 in the fourth.",
                        "dek": "He finishes with 30 points and 13 assists.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-image"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-photo-stat",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "Getty plus evidence",
                        "classification": "repackaged-source",
                        "sourceKind": "getty",
                        "sourceId": "2269586567",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "photo-stat-composite"
                }
            ],
            "kind": "photo-stat-composite",
            "displayName": "Photo and stat composite",
            "legacyCode": "FU-14",
            "definitionRevision": 1
        },
        {
            "code": "FU-15",
            "name": "Official social source",
            "cadence": "Optional",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Show the source layer",
            "visual": "social",
            "editorialJob": "Borrow official league voice or media when it adds something the native feed does not already express.",
            "publishWhen": "Selectively, after chronology and source quality are verified; never as a substitute for basketball truth.",
            "destination": "Prefer native inline treatment; external-post behavior is a deliberate exception.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Bring a strong official moment into the feed as a standalone basketball story, using the underlying video or image when it carries the value and never reproducing social-post chrome.",
                "fields": {
                    "eyebrow": "Use a genuine editorial lens such as PLAYER WATCH only when it adds meaning; otherwise omit it.",
                    "headline": "Preserve authored voice only when it remains clear out of context; otherwise name the play in direct fan language.",
                    "dek": "Explain why the moment matters now: the live line, run, lead or matchup consequence.",
                    "scoreOrBody": "Match the underlying media to its exact official play state. If exact state is not verified, omit the score rather than attaching a later checkpoint.",
                    "action": "Use Follow game for the surrounding live or completed game."
                }
            },
            "examples": [
                {
                    "id": "det-orl-paolo-social",
                    "label": "DET @ ORL · at-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "det-orl-paolo-social",
                        "unitType": "social",
                        "eyebrow": "PLAYER WATCH",
                        "headline": "Banchero owns the first half.",
                        "dek": "Twenty-one points lift Orlando into a 14-point halftime lead.",
                        "scoreLockup": "DET 55–69 ORL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "social"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    },
                    "review": {
                        "candidateId": "det-orl-paolo-social",
                        "gameId": "0022501144",
                        "game": "DET @ ORL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "official voice",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "instagram_3869683168195440802",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "official-social-source"
                },
                {
                    "id": "phi-sas-castle-wemby-social",
                    "label": "PHI @ SAS · at-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "phi-sas-castle-wemby-social",
                        "unitType": "social",
                        "eyebrow": null,
                        "headline": "Castle freezes his defender, then finds Wembanyama above the rim.",
                        "dek": "The one-handed finish puts San Antonio ahead with 6:21 left in the first.",
                        "scoreLockup": "PHI 15–16 SAS · Q1 · 6:21",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "social"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-castle-wemby-social",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "official voice",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "instagram_3869685783049544945",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "official-social-source"
                }
            ],
            "kind": "official-social-source",
            "displayName": "Official social source",
            "legacyCode": "FU-15",
            "definitionRevision": 1
        },
        {
            "code": "FU-16",
            "name": "Native Storyteller Card",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Show the source layer",
            "visual": "card",
            "editorialJob": "Use a media-led Storyteller Card when its authored package and typed destination add value beyond the media alone.",
            "publishWhen": "When the resolved media, copy and exact destination are legally available at the publication checkpoint.",
            "destination": "Open the exact typed destination; Article Cards name the exact reading outcome.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Use a Card when its authored package and exact destination add value beyond the underlying media alone. A Card may open an Article, Story, Clip or another typed destination.",
                "fields": {
                    "eyebrow": "Omit; the Card treatment already establishes the format.",
                    "headline": "Keep a strong authored title when it remains accurate and clear out of context. For a demonstrator-original Article, state the real tension or consequence without generic preview language.",
                    "dek": "Add the defining stake, line, run or result. Do not announce that the destination is a preview or recap when the action already makes that clear.",
                    "scoreOrBody": "Score/state: Freeze the Card to the destination's publication checkpoint. Use scheduled matchup context before tip, the verified single-game result after final, or a dated slate label for a multi-game recap.",
                    "action": "Name the exact reading or destination outcome: Read preview, Read recap, Read More, Follow game or Watch recap. Do not use a generic Open action."
                }
            },
            "examples": [
                {
                    "id": "por-den-comeback-card",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:54:46Z",
                    "display": {
                        "id": "por-den-comeback-card",
                        "unitType": "card",
                        "eyebrow": null,
                        "headline": "Nuggets Storm Back 💪",
                        "dek": "Denver erases a 16-point fourth-quarter deficit, then finishes its ninth straight win in overtime.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "square",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "card"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-comeback-card",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "postgame consequence",
                        "classification": "existing-native",
                        "sourceKind": "card",
                        "sourceId": "3d9ad61f-9721-d48b-1603-3a207830d481",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "authored-card"
                },
                {
                    "id": "brunson-jokic-recap-card",
                    "label": "Whole night · recap",
                    "availableAtUtc": "2026-04-07T05:30:00Z",
                    "display": {
                        "id": "brunson-jokic-recap-card",
                        "unitType": "card",
                        "eyebrow": null,
                        "headline": "Brunson & Joker Shine 🤩",
                        "dek": "Brunson closes with 30 and 13; Jokić posts 35, 14 and 13 in Denver’s overtime win.",
                        "scoreLockup": "APRIL 6 · RECAP",
                        "action": "Watch recap",
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "square"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "card"
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "361b86cb-8c0e-b026-f744-3a2076ea90c2",
                            "gameId": null
                        },
                        "accessibleName": "Open Brunson & Joker Shine 🤩"
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "postgame",
                        "editorialJob": "night recap",
                        "classification": "existing-native",
                        "sourceKind": "card",
                        "sourceId": "361b86cb-8c0e-b026-f744-3a2076ea90c2",
                        "destinationType": "story"
                    },
                    "order": 1,
                    "kind": "authored-card"
                },
                {
                    "id": "nyk-atl-pregame-article-card",
                    "label": "NYK @ ATL · pregame article",
                    "availableAtUtc": "2026-04-06T21:30:00Z",
                    "display": {
                        "id": "nyk-atl-pregame-article-card",
                        "unitType": "card",
                        "eyebrow": null,
                        "headline": "Knicks, Hawks get the first move in the East race",
                        "dek": "New York starts Monday one game clear of Cleveland; Atlanta holds a two-game edge over Philadelphia and Toronto.",
                        "scoreLockup": "NYK @ ATL · 7:00 p.m. ET",
                        "action": "Read preview",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "square",
                            "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/96922571-d717-4a20-8ded-8ce543bb2789-getty-2269581088.jpg"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "card"
                    },
                    "interaction": {
                        "destination": {
                            "type": "article",
                            "id": "article-nyk-atl-pregame-2026-04-06",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Read pregame preview for New York Knicks at Atlanta Hawks"
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "pregame",
                        "editorialJob": "pregame article destination",
                        "classification": "demonstrator-original",
                        "sourceKind": "article",
                        "sourceId": "article-nyk-atl-pregame-2026-04-06",
                        "destinationType": "article"
                    },
                    "order": 2,
                    "kind": "authored-card"
                },
                {
                    "id": "nyk-atl-postgame-recap-card",
                    "label": "NYK @ ATL · postgame recap",
                    "availableAtUtc": "2026-04-07T03:08:09.8884871Z",
                    "display": {
                        "id": "nyk-atl-postgame-recap-card",
                        "unitType": "card",
                        "eyebrow": null,
                        "headline": "Brunson’s fourth quarter lifts New York past Atlanta",
                        "dek": "He scores 17 in the fourth as the Knicks survive McCollum’s late answer and a reviewed heave.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Read recap",
                        "games": null,
                        "media": {
                            "type": "image",
                            "aspect": "wide"
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "card"
                    },
                    "interaction": {
                        "destination": {
                            "type": "article",
                            "id": "article-nyk-atl-postgame-2026-04-07",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Read the New York Knicks at Atlanta Hawks game recap"
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "postgame",
                        "editorialJob": "postgame recap destination",
                        "classification": "demonstrator-original",
                        "sourceKind": "article",
                        "sourceId": "article-nyk-atl-postgame-2026-04-07",
                        "destinationType": "article"
                    },
                    "order": 3,
                    "kind": "authored-card"
                }
            ],
            "kind": "authored-card",
            "displayName": "Authored Card",
            "legacyCode": "FU-16",
            "definitionRevision": 1
        },
        {
            "code": "FU-17",
            "name": "Curated gallery / carousel",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Show the source layer",
            "visual": "gallery",
            "editorialJob": "Build a short visual sequence for stakes, atmosphere, a game arc or the night’s defining performers.",
            "publishWhen": "When two or more images form one editorial thought; final binaries remain rights-gated.",
            "destination": "Swipe inline; optional deep link to game or Story.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Let a sequence of images reveal a matchup, turning point or night-wide arc.",
                "fields": {
                    "eyebrow": "Omit unless a real phase is essential to understanding the set.",
                    "headline": "Name the story the images collectively tell, not the number of slides or subjects.",
                    "dek": "Identify the decisive performances or turning points that make the sequence worth swiping.",
                    "scoreOrBody": "Score/state: Use the exact common frame for the gallery, such as PREGAME or WHOLE NIGHT; never mix incompatible states under one lockup.",
                    "action": "Use Swipe, because the immediate destination is the gallery."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-east-race-carousel",
                    "label": "NYK @ ATL · pregame",
                    "availableAtUtc": "2026-04-06T22:17:00Z",
                    "display": {
                        "id": "nyk-atl-east-race-carousel",
                        "unitType": "gallery",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "The night begins in the tunnel.",
                        "dek": "Karl-Anthony Towns and Jalen Johnson arrive at State Farm Arena before New York and Atlanta meet.",
                        "scoreLockup": "NYK @ ATL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "portrait",
                            "imageUrl": "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc8a2f7e-6690-4057-a2d5-46f166c4dc31-getty-2269581028.jpg",
                            "frameCount": 2,
                            "imageUrls": [
                                "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc8a2f7e-6690-4057-a2d5-46f166c4dc31-getty-2269581028.jpg",
                                "https://assets.usestorypilot.com/assets/media-originals/NBA/2026/04/06/cc5f2bb3-07da-489e-8d9f-1fe242c1937d-getty-2269580834.jpg"
                            ]
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-east-race-carousel",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "pregame",
                        "editorialJob": "pregame human texture",
                        "classification": "repackaged-source",
                        "sourceKind": "getty",
                        "sourceId": "2269586567",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "gallery"
                },
                {
                    "id": "night-winners-carousel",
                    "label": "Whole night · post-anchor",
                    "availableAtUtc": "2026-04-07T04:37:01Z",
                    "display": {
                        "id": "night-winners-carousel",
                        "unitType": "gallery",
                        "eyebrow": null,
                        "headline": "The performances that decided the night.",
                        "dek": "Brunson owns the fourth, Banchero scores 31, Castle posts a triple-double and Jokić completes Denver’s comeback; Schröder helps Cleveland reach 50 wins.",
                        "scoreLockup": "WHOLE NIGHT",
                        "action": "Swipe",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 5
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": "night-winners-carousel",
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "engagement-validated aftermath",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "instagram_3869804119599666314",
                        "destinationType": "inline"
                    },
                    "order": 1,
                    "kind": "gallery"
                },
                {
                    "id": "por-den-arrivals-gallery-source",
                    "label": "POR @ DEN · pregame",
                    "availableAtUtc": "2026-04-06T23:47:00Z",
                    "display": {
                        "id": "por-den-arrivals-gallery-source",
                        "unitType": "gallery",
                        "eyebrow": "BEFORE THE GAME",
                        "headline": "Portland arrives at Ball Arena.",
                        "dek": "Tunnel arrivals give way to warmups before the night’s final tip.",
                        "scoreLockup": "POR @ DEN · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 13
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-arrivals-gallery-source",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "pregame",
                        "editorialJob": "engagement-validated setup",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "3869658287801611378",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "gallery"
                },
                {
                    "id": "por-den-jokic-final-carousel-source",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T04:28:00Z",
                    "display": {
                        "id": "por-den-jokic-final-carousel-source",
                        "unitType": "gallery",
                        "eyebrow": null,
                        "headline": "Jokić finishes the comeback with 35, 14 and 13.",
                        "dek": "Denver erases a 16-point fourth-quarter deficit, then outscores Portland 12–7 in overtime.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 9
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-jokic-final-carousel-source",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "engagement-validated aftermath",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "3869799582184804257",
                        "destinationType": "game-companion"
                    },
                    "order": 3,
                    "kind": "gallery"
                }
            ],
            "kind": "gallery",
            "displayName": "Gallery",
            "legacyCode": "FU-17",
            "definitionRevision": 1
        },
        {
            "code": "FU-18",
            "name": "Run / momentum swing",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "data",
            "editorialJob": "Name the scoring run that changed control of the game.",
            "publishWhen": "When the run is both verified and narratively material, not for every small lead change.",
            "destination": "Open the relevant stretch in Game Screen Feed.",
            "deliveryStrategy": "Native structured metrics first. Add a server-rendered visual when the treatment exceeds shared primitives; a WebView is not the default.",
            "writingGuidance": {
                "overall": "Explain a material run or momentum swing and its scoreboard effect.",
                "fields": {
                    "eyebrow": "GAME CHANGER, reserved for a genuinely consequential swing.",
                    "headline": "Lead with the verified run or reversal when it is the story.",
                    "dek": "Connect the before-and-after states in plain basketball language.",
                    "scoreOrBody": "Score/state: Use the exact boundary state that closes the run; use no lockup if that state has not been receipted. Structured body: Show two or three non-duplicative measures: prior deficit, run size and resulting margin.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "cle-mem-halftime-comeback",
                    "label": "CLE @ MEM · at-anchor",
                    "availableAtUtc": "2026-04-07T01:05:00Z",
                    "occurredAtUtc": "2026-04-07T01:05:00Z",
                    "display": {
                        "id": "cle-mem-halftime-comeback",
                        "unitType": "run",
                        "eyebrow": "GAME CHANGER",
                        "headline": "A 31–12 run flips a 17-point deficit.",
                        "dek": "Cleveland turns Memphis’s ten-three opening quarter into a four-point halftime lead.",
                        "scoreLockup": "CLE 68–64 MEM · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Largest deficit",
                                "value": "17"
                            },
                            {
                                "label": "Cleveland run",
                                "value": "31–12"
                            },
                            {
                                "label": "Halftime lead",
                                "value": "+4"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    },
                    "review": {
                        "candidateId": "cle-mem-halftime-comeback",
                        "gameId": "0022501145",
                        "game": "CLE @ MEM",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "game-shape explanation",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501145",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "momentum-swing"
                },
                {
                    "id": "det-orl-late-rally",
                    "label": "DET @ ORL · at-anchor",
                    "availableAtUtc": "2026-04-07T01:31:50.6128395Z",
                    "occurredAtUtc": "2026-04-07T01:31:50.6128395Z",
                    "display": {
                        "id": "det-orl-late-rally",
                        "unitType": "run",
                        "eyebrow": "GAME CHANGER",
                        "headline": "Orlando answers Detroit’s charge.",
                        "dek": "Detroit gets within four; the Magic respond 10–0 before the final minute.",
                        "scoreLockup": null,
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Largest deficit",
                                "value": "26"
                            },
                            {
                                "label": "Closest margin",
                                "value": "4"
                            },
                            {
                                "label": "Orlando answer",
                                "value": "10–0"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    },
                    "review": {
                        "candidateId": "det-orl-late-rally",
                        "gameId": "0022501144",
                        "game": "DET @ ORL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "false comeback",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501144",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "momentum-swing"
                },
                {
                    "id": "nyk-atl-q3-run",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T00:56:00Z",
                    "occurredAtUtc": "2026-04-07T00:56:00Z",
                    "display": {
                        "id": "nyk-atl-q3-run",
                        "unitType": "insight",
                        "eyebrow": "THE STORY SO FAR",
                        "headline": "The six-minute swing that reset the game.",
                        "dek": "New York closes the third 17–6; Towns scores 14 in the quarter.",
                        "scoreLockup": "NYK 81–79 ATL · END Q3",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Closing stretch",
                                "value": "NYK 17–6"
                            },
                            {
                                "label": "Third quarter",
                                "value": "NYK 28–22"
                            },
                            {
                                "label": "Resulting lead",
                                "value": "NYK +2"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-q3-run",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "game-shape explanation",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "momentum-swing"
                },
                {
                    "id": "nyk-atl-nyk-11-0-run",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-06T23:26:34Z",
                    "occurredAtUtc": "2026-04-06T23:26:34Z",
                    "display": {
                        "id": "nyk-atl-nyk-11-0-run",
                        "unitType": "insight",
                        "eyebrow": "THE FIRST SWING",
                        "headline": "New York answers Atlanta’s start with 11 straight.",
                        "dek": "Brunson and McBride finish the run after the Hawks go five up.",
                        "scoreLockup": "NYK 16–10 ATL · Q1 · 6:24",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "New York run",
                                "value": "11–0"
                            },
                            {
                                "label": "Score after",
                                "value": "NYK +6"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-nyk-11-0-run",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "game-shape explanation",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 3,
                    "kind": "momentum-swing"
                },
                {
                    "id": "por-den-q2-nine-zero-answer",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T01:53:00Z",
                    "occurredAtUtc": "2026-04-07T01:53:00Z",
                    "display": {
                        "id": "por-den-q2-nine-zero-answer",
                        "unitType": "checkpoint",
                        "eyebrow": "GAME UPDATE",
                        "headline": "Denver answers a 13-point gap with nine straight.",
                        "dek": "Four straight Denver scores cut Portland’s lead to four before Jokić returns.",
                        "scoreLockup": "POR 53–49 DEN · Q2 · 6:23",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Portland lead",
                                "value": "13"
                            },
                            {
                                "label": "Denver answer",
                                "value": "9–0"
                            },
                            {
                                "label": "Margin after",
                                "value": "POR +4"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-q2-nine-zero-answer",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "game-shape explanation",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 4,
                    "kind": "momentum-swing"
                },
                {
                    "id": "por-den-q3-nine-zero-push",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T02:39:00Z",
                    "occurredAtUtc": "2026-04-07T02:39:00Z",
                    "display": {
                        "id": "por-den-q3-nine-zero-push",
                        "unitType": "checkpoint",
                        "eyebrow": "GAME UPDATE",
                        "headline": "Denver’s first real push cuts the gap to five.",
                        "dek": "Hardaway starts it from deep; Jokić and Gordon finish a 9–0 run at the rim.",
                        "scoreLockup": "POR 78–73 DEN · Q3 · 7:17",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Starting gap",
                                "value": "14"
                            },
                            {
                                "label": "Denver run",
                                "value": "9–0"
                            },
                            {
                                "label": "Margin after",
                                "value": "POR +5"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-q3-nine-zero-push",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "game-shape explanation",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 5,
                    "kind": "momentum-swing"
                }
            ],
            "kind": "momentum-swing",
            "displayName": "Momentum swing",
            "legacyCode": "FU-18",
            "definitionRevision": 1
        },
        {
            "code": "FU-19",
            "name": "Analytical game insight",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "data",
            "editorialJob": "Explain a decisive phase with a bounded stat and plain-language editorial claim.",
            "publishWhen": "When official data proves the claim; omit tracking or causality the source set cannot support.",
            "destination": "Inline explanation or expanded Game Screen Feed evidence.",
            "deliveryStrategy": "Native structured metrics first. Add a server-rendered visual when the treatment exceeds shared primitives; a WebView is not the default.",
            "writingGuidance": {
                "overall": "Explain why a period or game turned out as it did.",
                "fields": {
                    "eyebrow": "Name the evidence window (END Q1, FOURTH QUARTER, FINAL); never use vague packaging such as THE STORY SO FAR.",
                    "headline": "Make one basketball conclusion from the evidence.",
                    "dek": "State the supporting performance or sequence and its consequence, without production or officiating language.",
                    "scoreOrBody": "Score/state: Match the close of the evidence window exactly. Structured body: Use a small set of proof points that can be compared at a glance and do not repeat the dek.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-brunson-fourth",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "nyk-atl-brunson-fourth",
                        "unitType": "insight",
                        "eyebrow": "FOURTH QUARTER",
                        "headline": "Brunson owns the fourth.",
                        "dek": "He scores 17 in the period, including the go-ahead basket and two free throws in the final 1.2 seconds.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Fourth quarter",
                                "value": "17 PTS"
                            },
                            {
                                "label": "Game total",
                                "value": "30 PTS"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-brunson-fourth",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "star consequence",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "game-insight"
                },
                {
                    "id": "phi-sas-q1-duel",
                    "label": "PHI @ SAS · at-anchor",
                    "availableAtUtc": "2026-04-07T00:36:00Z",
                    "occurredAtUtc": "2026-04-07T00:36:00Z",
                    "display": {
                        "id": "phi-sas-q1-duel",
                        "unitType": "insight",
                        "eyebrow": "END Q1",
                        "headline": "Embiid and Wembanyama trade two blocks each.",
                        "dek": "San Antonio takes a 29–28 lead out of the opening quarter.",
                        "scoreLockup": "PHI 28–29 SAS · END Q1",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Embiid blocks",
                                "value": "2"
                            },
                            {
                                "label": "Wemby blocks",
                                "value": "2"
                            },
                            {
                                "label": "Q1 margin",
                                "value": "SAS +1"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-q1-duel",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "star matchup",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501146",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "game-insight"
                },
                {
                    "id": "nyk-atl-halftime-four-factors",
                    "label": "NYK @ ATL · halftime",
                    "availableAtUtc": "2026-04-07T00:12:34Z",
                    "display": {
                        "id": "nyk-atl-halftime-four-factors",
                        "unitType": "insight",
                        "eyebrow": "WHY ATLANTA LEADS",
                        "headline": "Atlanta turns extra chances into the lead.",
                        "dek": "New York has the shooting edge, but Atlanta owns the offensive glass and protects the ball better.",
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Effective FG",
                                "value": "NYK 64.9–49.0%"
                            },
                            {
                                "label": "Off. reb. rate",
                                "value": "ATL 53.1–29.4%"
                            },
                            {
                                "label": "Turnover rate",
                                "value": "ATL 16.3–25.0%"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-halftime-four-factors",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "halftime",
                        "editorialJob": "Four Factors summary",
                        "classification": "source-backed-spec-example",
                        "sourceKind": "api.nba.com",
                        "sourceId": "source-receipts/game-0022501143.json#nyk-atl-halftime-four-factors",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "game-insight"
                },
                {
                    "id": "por-den-team-shape",
                    "label": "POR @ DEN · postgame",
                    "availableAtUtc": "2026-04-07T03:48:44Z",
                    "display": {
                        "id": "por-den-team-shape",
                        "unitType": "insight",
                        "eyebrow": "TWO WAYS TO SCORE",
                        "headline": "Portland wins the arc. Denver owns everything inside it.",
                        "dek": "The Blazers make 25 threes, but the Nuggets answer with a 66–32 edge in the paint and a 30–15 second-chance advantage.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Portland threes",
                                "value": "25"
                            },
                            {
                                "label": "Paint",
                                "value": "DEN 66–32"
                            },
                            {
                                "label": "Second chance",
                                "value": "DEN 30–15"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "data"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-team-shape",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "postgame",
                        "editorialJob": "team-performance summary",
                        "classification": "source-backed-spec-example",
                        "sourceKind": "api.nba.com",
                        "sourceId": "source-receipts/game-0022501147.json#por-den-team-shape",
                        "destinationType": "game-companion"
                    },
                    "order": 3,
                    "kind": "game-insight"
                }
            ],
            "kind": "game-insight",
            "displayName": "Game insight",
            "legacyCode": "FU-19",
            "definitionRevision": 1
        },
        {
            "code": "FU-20",
            "name": "Authored player performance",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "player",
            "editorialJob": "Tell the shape of a player’s game with a burst, role, stat and best raw moment—without opening a generic play-after-play Player Story.",
            "publishWhen": "When the performance changes the game or clearly resonates; photography and video can strengthen the unit.",
            "destination": "Inline or Game Screen Feed detail; current generic Player Story destinations stay excluded.",
            "deliveryStrategy": "Native structured metrics first. Add a server-rendered visual when the treatment exceeds shared primitives; a WebView is not the default.",
            "writingGuidance": {
                "overall": "Show how one player's line is shaping the team result.",
                "fields": {
                    "eyebrow": "PLAYER WATCH, only while the unit remains genuinely player-led.",
                    "headline": "State the player's role in the game, not merely that the player has a large number.",
                    "dek": "Give the defining line and the distinct scoreboard or momentum consequence.",
                    "scoreOrBody": "Score/state: Use the exact period boundary or live state represented by the player line. Structured body: Select two or three complementary measures; do not repeat the same fact in headline, dek and metrics.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-naw-burst",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T00:13:02Z",
                    "occurredAtUtc": "2026-04-07T00:13:02Z",
                    "display": {
                        "id": "nyk-atl-naw-burst",
                        "unitType": "player",
                        "eyebrow": "PLAYER WATCH",
                        "headline": "Alexander-Walker reaches 20 by halftime.",
                        "dek": "Atlanta turns a seven-point deficit into a four-point lead with a 21–10 close.",
                        "scoreLockup": "NYK 53–57 ATL · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "First-half points",
                                "value": "20"
                            },
                            {
                                "label": "Closing run",
                                "value": "ATL 21–10"
                            },
                            {
                                "label": "Halftime margin",
                                "value": "ATL +4"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "player"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-naw-burst",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "player scoring burst",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "player-performance"
                },
                {
                    "id": "phi-sas-embiid-burst",
                    "label": "PHI @ SAS · at-anchor",
                    "availableAtUtc": "2026-04-07T01:11:00Z",
                    "occurredAtUtc": "2026-04-07T01:11:00Z",
                    "display": {
                        "id": "phi-sas-embiid-burst",
                        "unitType": "player",
                        "eyebrow": "PLAYER WATCH",
                        "headline": "Embiid keeps Philadelphia within reach.",
                        "dek": "He scores 20 before halftime, but San Antonio leads by seven.",
                        "scoreLockup": "PHI 55–62 SAS · HALFTIME",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "First-half points",
                                "value": "20"
                            },
                            {
                                "label": "First-quarter blocks",
                                "value": "2"
                            },
                            {
                                "label": "Halftime margin",
                                "value": "SAS +7"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "player"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-embiid-burst",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "player scoring burst",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501146",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "player-performance"
                },
                {
                    "id": "nyk-atl-naw-18",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T00:06:17Z",
                    "occurredAtUtc": "2026-04-07T00:06:17Z",
                    "display": {
                        "id": "nyk-atl-naw-18",
                        "unitType": "player",
                        "eyebrow": "PLAYER WATCH",
                        "headline": "Alexander-Walker keeps pressing the advantage.",
                        "dek": "His second three of the quarter gives him 18 points and Atlanta its biggest lead of the half.",
                        "scoreLockup": "NYK 47–53 ATL · Q2 · 3:44",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Points",
                                "value": "18"
                            },
                            {
                                "label": "Atlanta lead",
                                "value": "+6"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "player"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-naw-18",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "player scoring burst",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "player-performance"
                },
                {
                    "id": "phi-sas-castle-player-performance",
                    "label": "PHI @ SAS · postgame",
                    "availableAtUtc": "2026-04-07T02:31:13Z",
                    "display": {
                        "id": "phi-sas-castle-player-performance",
                        "unitType": "player",
                        "eyebrow": "CASTLE TRIPLE-DOUBLE",
                        "headline": "Castle conducts San Antonio’s win.",
                        "dek": "He finishes with 19 points, 10 rebounds and 13 assists—5.7 assists above his pregame season average.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Points",
                                "value": "19"
                            },
                            {
                                "label": "Rebounds",
                                "value": "10"
                            },
                            {
                                "label": "Assists",
                                "value": "13"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "player"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-castle-triple-double",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "postgame",
                        "editorialJob": "player-performance summary",
                        "classification": "source-backed-spec-example",
                        "sourceKind": "api.nba.com",
                        "sourceId": "source-receipts/game-0022501146.json#phi-sas-castle-triple-double",
                        "destinationType": "game-companion"
                    },
                    "order": 3,
                    "kind": "player-performance"
                }
            ],
            "kind": "player-performance",
            "displayName": "Player performance",
            "legacyCode": "FU-20",
            "definitionRevision": 1
        },
        {
            "code": "FU-21",
            "name": "Clutch / overtime alert",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "live",
            "editorialJob": "Interrupt the normal rhythm for a true state change that demands immediate attention.",
            "publishWhen": "For overtime, a last-possession finish or an exceptional live swing—not routine close scores.",
            "destination": "Open the live Game Screen Feed.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Deliver the fastest legible update at a live inflection point.",
                "fields": {
                    "eyebrow": "Omit for an ordinary live alert; use a material phase such as OVERTIME only when it changes the meaning.",
                    "headline": "State the immediate fact or stake in one short sentence.",
                    "dek": "Add the next consequence or tension; while live, do not imply an ending that has not happened.",
                    "scoreOrBody": "Score/state: Always use the exact official current state, including clock and period when live.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "por-den-regulation-tie",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:35:00Z",
                    "display": {
                        "id": "por-den-regulation-tie",
                        "unitType": "urgent",
                        "eyebrow": "OVERTIME",
                        "headline": "Avdija answers Gordon; regulation ends level.",
                        "dek": "Gordon ties it at 123, scores again, then Avdija’s layup sends the game to overtime at 125.",
                        "scoreLockup": "POR 125–125 DEN · END Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "live"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-regulation-tie",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "overtime transition",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "urgent-game-update"
                }
            ],
            "kind": "urgent-game-update",
            "displayName": "Urgent game update",
            "legacyCode": "FU-21",
            "definitionRevision": 1
        },
        {
            "code": "FU-22",
            "name": "Possession sequence / court map",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "sequence",
            "editorialJob": "Reconstruct a decisive finish in order when one highlight cannot explain it, adding court position when verified coordinates exist.",
            "publishWhen": "After the sequence is official; use the ordered timeline without coordinates until a verified spatial source is available.",
            "destination": "Expand inline or open the exact Game Screen Feed sequence.",
            "deliveryStrategy": "Evaluate native versus rendered media. Prefer native for live updates, interaction, accessibility or responsive fidelity; prefer a high-resolution rendered image or video when authored visual complexity and cross-platform consistency dominate.",
            "writingGuidance": {
                "overall": "Make a dense clutch sequence understandable in chronological order.",
                "fields": {
                    "eyebrow": "THE FINISH only after the finish is known; use the actual phase for an unresolved sequence.",
                    "headline": "Frame what the ordered possessions changed or decided.",
                    "dek": "Omit by default; use only for verified context absent from the rows.",
                    "scoreOrBody": "Score/state: Show the verified boundary or final state for the complete sequence. Structured body: Each row carries time, action and resulting score; preserve official order and omit any clock that is not known exactly.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-brunson-seven-straight",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T01:23:26Z",
                    "occurredAtUtc": "2026-04-07T01:23:26Z",
                    "display": {
                        "id": "nyk-atl-brunson-seven-straight",
                        "unitType": "sequence",
                        "eyebrow": "THE TURN",
                        "headline": "Seven straight from Brunson flips it.",
                        "dek": "Three scores in 53 seconds turn a five-point hole into a 102–100 New York lead.",
                        "scoreLockup": "NYK 102–100 ATL · Q4 · 2:01",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "sequenceSteps": [
                            {
                                "label": "3:35",
                                "headline": "Brunson starts the answer",
                                "state": "ATL +2"
                            },
                            {
                                "label": "2:36",
                                "headline": "Brunson ties it",
                                "state": "100–100"
                            },
                            {
                                "label": "2:01",
                                "headline": "Brunson puts New York ahead",
                                "state": "NYK +2"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "sequence"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-brunson-seven-straight",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "connected scoring sequence",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "possession-sequence"
                },
                {
                    "id": "nyk-atl-final-sequence",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "nyk-atl-final-sequence",
                        "unitType": "sequence",
                        "eyebrow": "THE FINISH",
                        "headline": "How the final 1.2 seconds decided it.",
                        "dek": null,
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "sequenceSteps": [
                            {
                                "label": "1.2",
                                "headline": "Atlanta fouls",
                                "state": "NYK 106–105"
                            },
                            {
                                "label": "1.2",
                                "headline": "Brunson makes both",
                                "state": "NYK 108–105"
                            },
                            {
                                "label": "0.0",
                                "headline": "McCollum’s heave is late",
                                "state": "FINAL"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "sequence"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-final-sequence",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "possession sequence",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "possession-sequence"
                },
                {
                    "id": "por-den-final-sequence",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-final-sequence",
                        "unitType": "sequence",
                        "eyebrow": "THE FINISH",
                        "headline": "Three baskets turn regulation twice.",
                        "dek": null,
                        "scoreLockup": "POR 125–125 DEN · END Q4",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "sequenceSteps": [
                            {
                                "label": "1:12",
                                "headline": "Gordon hits the corner three",
                                "state": "123–123"
                            },
                            {
                                "label": "Next Denver trip",
                                "headline": "Gordon puts Denver ahead",
                                "state": "DEN 125–123"
                            },
                            {
                                "label": "Final Portland trip",
                                "headline": "Avdija forces overtime",
                                "state": "125–125"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "sequence"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-final-sequence",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "possession sequence",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "possession-sequence"
                }
            ],
            "kind": "possession-sequence",
            "displayName": "Possession sequence",
            "legacyCode": "FU-22",
            "definitionRevision": 1
        },
        {
            "code": "FU-23",
            "name": "Game-flow story",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "flow",
            "editorialJob": "Show control, high-water marks and the game’s decisive reversals across time.",
            "publishWhen": "Usually postgame, after official scoring flow can support the complete arc.",
            "destination": "Expand the visual inside Game Screen Feed.",
            "deliveryStrategy": "Evaluate native versus rendered media. Prefer native for live updates, interaction, accessibility or responsive fidelity; prefer a high-resolution rendered image or video when authored visual complexity and cross-platform consistency dominate.",
            "writingGuidance": {
                "overall": "Compress the full shape of a game into a scannable progression.",
                "fields": {
                    "eyebrow": "HOW IT HAPPENED.",
                    "headline": "Name the central arc or reversal.",
                    "dek": "Identify the decisive run, response or mechanism that produced it.",
                    "scoreOrBody": "Score/state: Use the verified final state, with overtime notation when applicable. Structured body: Present ordered checkpoints with consistent labels and margins so the lead changes can be read without the prose.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "por-den-game-flow",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-game-flow",
                        "unitType": "flow",
                        "eyebrow": "HOW IT HAPPENED",
                        "headline": "Sixteen down becomes five up",
                        "dek": "Portland leads by 16 in the fourth before Denver forces overtime and takes over there.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "flowPoints": [
                            {
                                "label": "Q1",
                                "value": "POR +4"
                            },
                            {
                                "label": "HALF",
                                "value": "POR +14"
                            },
                            {
                                "label": "Q4 HIGH",
                                "value": "POR +16"
                            },
                            {
                                "label": "REGULATION",
                                "value": "TIED"
                            },
                            {
                                "label": "FINAL/OT",
                                "value": "DEN +5"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "flow"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-game-flow",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "game-flow story",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "game-flow"
                },
                {
                    "id": "det-orl-game-flow",
                    "label": "DET @ ORL · post-anchor",
                    "availableAtUtc": "2026-04-07T01:37:00Z",
                    "display": {
                        "id": "det-orl-game-flow",
                        "unitType": "flow",
                        "eyebrow": "HOW IT HAPPENED",
                        "headline": "Orlando nearly loses a 26-point lead—then shuts the door.",
                        "dek": "Detroit gets within four before a 10–0 Magic answer restores control.",
                        "scoreLockup": "DET 107–123 ORL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "flowPoints": [
                            {
                                "label": "HALF",
                                "value": "ORL +14"
                            },
                            {
                                "label": "HIGH",
                                "value": "ORL +26"
                            },
                            {
                                "label": "LATE Q4",
                                "value": "ORL +4"
                            },
                            {
                                "label": "ANSWER",
                                "value": "ORL 10–0"
                            },
                            {
                                "label": "FINAL",
                                "value": "ORL +16"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "flow"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    },
                    "review": {
                        "candidateId": "det-orl-game-flow",
                        "gameId": "0022501144",
                        "game": "DET @ ORL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "game-flow story",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501144",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "game-flow"
                },
                {
                    "id": "nyk-atl-game-flow",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "nyk-atl-game-flow",
                        "unitType": "flow",
                        "eyebrow": "HOW IT HAPPENED",
                        "headline": "Atlanta’s half. New York’s third. Brunson’s fourth.",
                        "dek": "Atlanta closes the half 21–10; New York answers 17–6 after the break; Brunson controls the finish.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "flowPoints": [
                            {
                                "label": "Q1",
                                "value": "NYK +1"
                            },
                            {
                                "label": "HALF",
                                "value": "ATL +4"
                            },
                            {
                                "label": "Q3",
                                "value": "NYK +2"
                            },
                            {
                                "label": "FINAL",
                                "value": "NYK +3"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "flow"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-game-flow",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "game-flow story",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501143",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "game-flow"
                }
            ],
            "kind": "game-flow",
            "displayName": "Game flow",
            "legacyCode": "FU-23",
            "definitionRevision": 1
        },
        {
            "code": "FU-24",
            "name": "Evidence receipt / invisible impact",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "receipt",
            "editorialJob": "Make defense, playmaking or team work visible through a small set of verified numbers.",
            "publishWhen": "When the numbers explain the outcome and do not imply unsupported lineup or tracking causality.",
            "destination": "Inline receipt with optional box-score detail.",
            "deliveryStrategy": "Native structured metrics first. Add a server-rendered visual when the treatment exceeds shared primitives; a WebView is not the default.",
            "writingGuidance": {
                "overall": "Make a generated insight immediately understandable and visibly supported by a few decisive numbers.",
                "fields": {
                    "eyebrow": "BY THE NUMBERS.",
                    "headline": "Translate the evidence into a concrete basketball claim; do not hide the numbers behind metaphor.",
                    "dek": "Explain the result or significance the measures produced.",
                    "scoreOrBody": "Score/state: Match the exact game boundary covered by the evidence. Structured body: Show the minimum sufficient labelled measures with clear units; claim a record or ranking only when that claim is independently proven.",
                    "action": "Follow game."
                }
            },
            "examples": [
                {
                    "id": "det-orl-defense-receipt",
                    "label": "DET @ ORL · post-anchor",
                    "availableAtUtc": "2026-04-07T01:37:00Z",
                    "display": {
                        "id": "det-orl-defense-receipt",
                        "unitType": "receipt",
                        "eyebrow": "BY THE NUMBERS",
                        "headline": "Orlando piles up 25 steals and blocks.",
                        "dek": "The Magic set season highs in both and win their third straight.",
                        "scoreLockup": "DET 107–123 ORL · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Orlando steals",
                                "value": "16"
                            },
                            {
                                "label": "Orlando blocks",
                                "value": "9"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "receipt"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    },
                    "review": {
                        "candidateId": "det-orl-defense-receipt",
                        "gameId": "0022501144",
                        "game": "DET @ ORL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "invisible impact",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501144",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "evidence-receipt"
                },
                {
                    "id": "por-den-insight-receipt",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-insight-receipt",
                        "unitType": "receipt",
                        "eyebrow": "BY THE NUMBERS",
                        "headline": "Jokić’s night goes beyond the triple-double.",
                        "dek": "Denver needs every part of it to erase a 16-point lead and win in overtime.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Steals",
                                "value": "5"
                            },
                            {
                                "label": "Blocks",
                                "value": "2"
                            },
                            {
                                "label": "Triple-double",
                                "value": "35 · 14 · 13"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "receipt"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-insight-receipt",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "NBA insight explained",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "evidence-receipt"
                },
                {
                    "id": "cle-mem-point-breakdown",
                    "label": "CLE @ MEM · postgame",
                    "availableAtUtc": "2026-04-07T02:19:24.300Z",
                    "display": {
                        "id": "cle-mem-point-breakdown",
                        "unitType": "receipt",
                        "eyebrow": "WHERE CLEVELAND WON IT",
                        "headline": "Cleveland turns the paint into the difference.",
                        "dek": "The Cavaliers outscore Memphis 76–30 in the paint—the largest gap across the four NBA point sources.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Paint",
                                "value": "CLE 76–30"
                            },
                            {
                                "label": "Second chance",
                                "value": "CLE 21–15"
                            },
                            {
                                "label": "Fast break",
                                "value": "CLE 11–10"
                            },
                            {
                                "label": "Off turnovers",
                                "value": "MEM 17–14"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "receipt"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    },
                    "review": {
                        "candidateId": "cle-mem-point-breakdown",
                        "gameId": "0022501145",
                        "game": "CLE @ MEM",
                        "availabilityPhase": "postgame",
                        "editorialJob": "point-breakdown summary",
                        "classification": "source-backed-spec-example",
                        "sourceKind": "api.nba.com",
                        "sourceId": "source-receipts/game-0022501145.json#cle-mem-point-breakdown",
                        "destinationType": "game-companion"
                    },
                    "order": 2,
                    "kind": "evidence-receipt"
                }
            ],
            "kind": "evidence-receipt",
            "displayName": "Evidence receipt",
            "legacyCode": "FU-24",
            "definitionRevision": 1
        },
        {
            "code": "FU-34",
            "name": "Shot profile comparison",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "comparison",
            "editorialJob": "Compare where two players or teams create shots so a tactical contrast reads as a story rather than a dashboard.",
            "publishWhen": "When official shot-zone or tracking data proves a meaningful contrast; do not infer location or shot type from a standard box score.",
            "destination": "Inline comparison with optional expansion into Game Screen Stats.",
            "deliveryStrategy": "Evaluate native versus rendered media. Prefer native for live updates, interaction, accessibility or responsive fidelity; prefer a high-resolution rendered image or video when authored visual complexity and cross-platform consistency dominate.",
            "writingGuidance": {
                "overall": "Explain how shot location or shot type is shaping a matchup.",
                "fields": {
                    "eyebrow": "SHOT PROFILE.",
                    "headline": "State the clearest style or efficiency advantage.",
                    "dek": "Explain what that advantage offsets, enables or exposes using verified game evidence.",
                    "scoreOrBody": "Exact current/final state plus comparable metrics with subject, shot type, volume and rate. Do not mix unlike denominators.",
                    "action": "Follow game when tied to a live game; otherwise no action."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-rim-profile",
                    "label": "NYK @ ATL · live",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "nyk-atl-rim-profile",
                        "unitType": "shot-profile",
                        "eyebrow": "SHOT PROFILE",
                        "headline": "New York is finishing at 75% at the rim.",
                        "dek": "That efficiency helps offset Atlanta’s 16 threes and 19 offensive rebounds.",
                        "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "NYK · AT RIM",
                                "value": "24 · 75.0%"
                            },
                            {
                                "label": "ATL · AT RIM",
                                "value": "26 · 42.3%"
                            }
                        ],
                        "subjects": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "comparison"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open NYK @ ATL game"
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "anchor",
                        "editorialJob": "shot-profile comparison",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "official-game-stats",
                        "sourceId": "game-screen-checkpoints:0022501143:anchor:shotProfile",
                        "destinationType": "game-screen"
                    },
                    "order": 0,
                    "kind": "shot-profile-comparison"
                },
                {
                    "id": "reference-pull-up-profile",
                    "label": "IND @ OKC · final",
                    "availableAtUtc": "2026-04-07T05:30:00Z",
                    "display": {
                        "id": "reference-pull-up-profile",
                        "unitType": "shot-profile",
                        "eyebrow": "SHOT PROFILE",
                        "headline": "Nembhard makes five of eight pull-ups.",
                        "dek": "Gilgeous-Alexander takes twice as many and hits seven of 16.",
                        "scoreLockup": "IND 117–114 OKC · FINAL",
                        "action": null,
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "SGA · OKC · PULL-UPS",
                                "value": "7/16 · 44%"
                            },
                            {
                                "label": "NEMBHARD · IND · PULL-UPS",
                                "value": "5/8 · 63%"
                            }
                        ],
                        "subjects": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "comparison"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": null,
                        "game": "IND @ OKC",
                        "availabilityPhase": "postgame",
                        "editorialJob": "shot-profile comparison",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "reference-demonstrator",
                        "sourceId": "FI-09",
                        "destinationType": "inline"
                    },
                    "order": 1,
                    "kind": "shot-profile-comparison"
                }
            ],
            "kind": "shot-profile-comparison",
            "displayName": "Shot profile comparison",
            "legacyCode": "FU-34",
            "definitionRevision": 1
        },
        {
            "code": "FU-35",
            "name": "Lineup impact",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "lineup",
            "editorialJob": "Show the five-player group and bounded stint numbers behind a run, comeback or close.",
            "publishWhen": "After a verified lineup stint completes and its minutes, scoring and plus-minus are available; describe the stint, not unproved causality.",
            "destination": "Inline lineup receipt with optional expansion into Game Screen Box or Stats.",
            "deliveryStrategy": "Evaluate native versus rendered media. Prefer native for live updates, interaction, accessibility or responsive fidelity; prefer a high-resolution rendered image or video when authored visual complexity and cross-platform consistency dominate.",
            "writingGuidance": {
                "overall": "Show what a verified five-player unit did together over a bounded stint.",
                "fields": {
                    "eyebrow": "LINEUP SHIFT.",
                    "headline": "State the unit's verified impact, duration or plus/minus.",
                    "dek": "Interpret only displayed evidence; do not infer spacing, shot quality or causality without tracking proof.",
                    "scoreOrBody": "Body must name all five players and show stint duration, plus/minus and the few metrics that explain it.",
                    "action": "Usually no action; add Follow game only when the destination adds lineup context."
                }
            },
            "examples": [
                {
                    "id": "reference-nyk-lineup-impact",
                    "label": "NYK · comeback stint",
                    "availableAtUtc": "2026-04-07T05:30:00Z",
                    "display": {
                        "id": "reference-nyk-lineup-impact",
                        "unitType": "lineup-impact",
                        "eyebrow": "LINEUP SHIFT",
                        "headline": "New York’s five-man unit goes plus-15 in seven minutes.",
                        "dek": "The group shoots 8-for-11 with six assists and four threes.",
                        "scoreLockup": "NYK · 7:00 MIN · +15",
                        "action": null,
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "FIELD GOALS",
                                "value": "8/11"
                            },
                            {
                                "label": "THREES",
                                "value": "4/4"
                            },
                            {
                                "label": "ASSISTS",
                                "value": "6"
                            }
                        ],
                        "subjects": [
                            "Towns",
                            "Anunoby",
                            "Hart",
                            "Brunson",
                            "Alvarado"
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "lineup"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": null,
                        "game": "NYK",
                        "availabilityPhase": "postgame",
                        "editorialJob": "lineup impact",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "reference-demonstrator",
                        "sourceId": "FI-11",
                        "destinationType": "inline"
                    },
                    "order": 0,
                    "kind": "lineup-impact"
                },
                {
                    "id": "reference-lal-lineup-impact",
                    "label": "LAL · closing stint",
                    "availableAtUtc": "2026-04-07T05:30:00Z",
                    "display": {
                        "id": "reference-lal-lineup-impact",
                        "unitType": "lineup-impact",
                        "eyebrow": "LINEUP SHIFT",
                        "headline": "The Lakers’ closing unit goes plus-17 in 5.1 minutes.",
                        "dek": "The group shoots 8-for-10 and records seven assists.",
                        "scoreLockup": "LAL · 5.1 MIN · +17",
                        "action": null,
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "FIELD GOALS",
                                "value": "8/10"
                            },
                            {
                                "label": "THREES",
                                "value": "4/6"
                            },
                            {
                                "label": "ASSISTS",
                                "value": "7"
                            }
                        ],
                        "subjects": [
                            "Kaluma",
                            "Carr",
                            "Suder",
                            "Okereke",
                            "Kyle III"
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "lineup"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": null,
                        "game": "LAL",
                        "availabilityPhase": "postgame",
                        "editorialJob": "lineup impact",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "reference-demonstrator",
                        "sourceId": "FI-11",
                        "destinationType": "inline"
                    },
                    "order": 1,
                    "kind": "lineup-impact"
                }
            ],
            "kind": "lineup-impact",
            "displayName": "Lineup impact",
            "legacyCode": "FU-35",
            "definitionRevision": 1
        },
        {
            "code": "FU-25",
            "name": "Record",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "record",
            "editorialJob": "Elevate a verified league, franchise or season record into a consequence unit.",
            "publishWhen": "Only when the record is official and its exact scope is known.",
            "destination": "Inline context or specialist package.",
            "deliveryStrategy": "Native structured metrics first. Add a server-rendered visual when the treatment exceeds shared primitives; a WebView is not the default.",
            "writingGuidance": {
                "overall": "Explain a newly official league, franchise, team or player record and why it matters.",
                "fields": {
                    "eyebrow": "Use RECORD only after the record and its scope are official.",
                    "headline": "Name the subject, exact number and scope.",
                    "dek": "Add the leading contributor, contradiction or game consequence; never restate the number.",
                    "scoreOrBody": "Final or exact post-achievement state. Metrics should label the record value, comparison and contributor in fan language.",
                    "action": "Follow game for game context; View story only when the destination is a record package."
                }
            },
            "examples": [
                {
                    "id": "cle-mem-record-29-threes",
                    "label": "CLE @ MEM · post-anchor",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-record-29-threes",
                        "unitType": "record",
                        "eyebrow": "RECORD",
                        "headline": "Memphis ties the NBA record with 29 threes.",
                        "dek": "All nine Grizzlies who played hit at least one.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Memphis threes",
                                "value": "29"
                            },
                            {
                                "label": "Cleveland threes",
                                "value": "23"
                            },
                            {
                                "label": "Combined threes",
                                "value": "52"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "record"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    },
                    "review": {
                        "candidateId": "cle-mem-record-29-threes",
                        "gameId": "0022501145",
                        "game": "CLE @ MEM",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "record consequence",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501145",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "record"
                },
                {
                    "id": "por-den-record-threes",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-record-threes",
                        "unitType": "record",
                        "eyebrow": "RECORD",
                        "headline": "Portland makes 25 threes—and still loses.",
                        "dek": "The Blazers set a franchise record from deep, but Denver survives the barrage and takes over inside.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Portland threes",
                                "value": "25"
                            },
                            {
                                "label": "Camara threes",
                                "value": "8"
                            },
                            {
                                "label": "Camara points",
                                "value": "30"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "record"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501147",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Portland Trail Blazers at Denver Nuggets game"
                    },
                    "review": {
                        "candidateId": "por-den-record-threes",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "record consequence",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501147",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "record"
                }
            ],
            "kind": "record",
            "displayName": "Record",
            "legacyCode": "FU-25",
            "definitionRevision": 1
        },
        {
            "code": "FU-26",
            "name": "Milestone",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "record",
            "editorialJob": "Give a player or team achievement a clear place in the night’s hierarchy.",
            "publishWhen": "When the milestone is official and consequential enough to stand apart from the final.",
            "destination": "Inline context, player detail or specialist package.",
            "deliveryStrategy": "Native structured metrics first. Add a server-rendered visual when the treatment exceeds shared primitives; a WebView is not the default.",
            "writingGuidance": {
                "overall": "Mark an official career, season or team threshold.",
                "fields": {
                    "eyebrow": "MILESTONE; a more specific approved label may replace it when clearer.",
                    "headline": "State the achievement in one line.",
                    "dek": "Explain how it was reached or what it secured.",
                    "scoreOrBody": "Use only the state at or after official confirmation. Tiles support the achievement but do not replace prose context.",
                    "action": "Use the honest next fan job: usually Follow game or View story."
                }
            },
            "examples": [
                {
                    "id": "phi-sas-castle-triple-double",
                    "label": "PHI @ SAS · post-anchor",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-castle-triple-double",
                        "unitType": "milestone",
                        "eyebrow": "MILESTONE",
                        "headline": "Castle’s fifth triple-double: 19, 10 and 13.",
                        "dek": "He takes control after halftime and carries San Antonio to its 60th win.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Points",
                                "value": "19"
                            },
                            {
                                "label": "Rebounds",
                                "value": "10"
                            },
                            {
                                "label": "Assists",
                                "value": "13"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "record"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-castle-triple-double",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "player milestone",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501146",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "milestone"
                },
                {
                    "id": "cle-mem-fifty-wins",
                    "label": "CLE @ MEM · post-anchor",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-fifty-wins",
                        "unitType": "milestone",
                        "eyebrow": "MILESTONE",
                        "headline": "Fifty wins, and home court secured.",
                        "dek": "A 17-point comeback and season-high 142 secure Cleveland’s first-round advantage.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null,
                        "metrics": [
                            {
                                "label": "Cleveland wins",
                                "value": "50"
                            },
                            {
                                "label": "Franchise occurrence",
                                "value": "14th"
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "record"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501145",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Cleveland Cavaliers at Memphis Grizzlies game"
                    },
                    "review": {
                        "candidateId": "cle-mem-fifty-wins",
                        "gameId": "0022501145",
                        "game": "CLE @ MEM",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "standings consequence",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501145",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "milestone"
                }
            ],
            "kind": "milestone",
            "displayName": "Milestone",
            "legacyCode": "FU-26",
            "definitionRevision": 1
        },
        {
            "code": "FU-27",
            "name": "Official status / injury",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Explain what mattered",
            "visual": "status",
            "editorialJob": "Update the game narrative when an official status change materially alters it.",
            "publishWhen": "Only after official diagnosis or status language exists; never backfill it into an earlier state.",
            "destination": "Inline update with team/game context.",
            "deliveryStrategy": "Native shared structure. Live state, resizing, interaction and accessibility make platform rendering important.",
            "writingGuidance": {
                "overall": "Deliver material confirmed availability, injury or return information.",
                "fields": {
                    "eyebrow": "STATUS UPDATE; never use a diagnostic label before confirmation.",
                    "headline": "Name the player/team and confirmed change.",
                    "dek": "Give minutes, availability effect or immediate team consequence; avoid medical inference.",
                    "scoreOrBody": "Pregame matchup for availability, exact live state for an in-game exit, final only for a postgame diagnosis. No speculative structured rows.",
                    "action": "Follow game; use View story only for a genuine official update destination."
                }
            },
            "examples": [
                {
                    "id": "phi-sas-wemby-injury",
                    "label": "PHI @ SAS · post-anchor",
                    "availableAtUtc": "2026-04-07T02:31:00Z",
                    "display": {
                        "id": "phi-sas-wemby-injury",
                        "unitType": "status",
                        "eyebrow": "STATUS UPDATE",
                        "headline": "Wembanyama exits with a left rib contusion.",
                        "dek": "Wembanyama plays 15:40 before leaving the game.",
                        "scoreLockup": "PHI 102–115 SAS · FINAL",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "status"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501146",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Philadelphia 76ers at San Antonio Spurs game"
                    },
                    "review": {
                        "candidateId": "phi-sas-wemby-injury",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "official status update",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501146",
                        "destinationType": "game-companion"
                    },
                    "order": 0,
                    "kind": "official-status"
                },
                {
                    "id": "det-orl-availability-status",
                    "label": "DET @ ORL · pregame",
                    "availableAtUtc": "2026-04-06T22:12:00.000Z",
                    "display": {
                        "id": "det-orl-availability-status",
                        "unitType": "status",
                        "eyebrow": "STATUS UPDATE",
                        "headline": "Detroit is shorthanded in Orlando.",
                        "dek": "The confirmed absences leave the Pistons short of their usual rotation.",
                        "scoreLockup": "DET @ ORL · PREGAME",
                        "action": "Follow game",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "status"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501144",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open Detroit Pistons at Orlando Magic game"
                    },
                    "review": {
                        "candidateId": "det-orl-essentials",
                        "gameId": "0022501144",
                        "game": "DET @ ORL",
                        "availabilityPhase": "pregame",
                        "editorialJob": "official availability update",
                        "classification": "repackaged-source",
                        "sourceKind": "official",
                        "sourceId": "0022501144",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "official-status"
                }
            ],
            "kind": "official-status",
            "displayName": "Official status",
            "legacyCode": "FU-27",
            "definitionRevision": 1
        },
        {
            "code": "FU-28",
            "name": "Anchor-safe live Story snapshot",
            "cadence": "System",
            "surfaces": [
                "Stories tray",
                "Home"
            ],
            "group": "Open deeper coverage",
            "visual": "story",
            "editorialJob": "Let fans follow the complete live narrative without leaking pages created after the current checkpoint.",
            "publishWhen": "Regenerate at deterministic cutoffs from exact legal Story pages.",
            "destination": "Open the bounded Story rendition.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Offer a time-bounded deeper narrative without leaking later Story pages.",
                "fields": {
                    "eyebrow": "FOLLOW LIVE while active; change only when the destination itself changes state.",
                    "headline": "Lead with the current basketball situation, not “inside,” “coverage” or page count.",
                    "dek": "Explain the access or narrative span the fan will get and tie it to the current state.",
                    "scoreOrBody": "Use the snapshot boundary's exact current state. The page set must be frozen at the same timestamp as the copy.",
                    "action": "Follow live."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-live-story-snapshot",
                    "label": "NYK @ ATL · at-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "nyk-atl-live-story-snapshot",
                        "unitType": "story-slice",
                        "eyebrow": "FOLLOW LIVE",
                        "headline": "The whole night from inside State Farm Arena.",
                        "dek": "Go from New York’s arrival to the final possession, with every big play in between.",
                        "scoreLockup": "NYK 106–105 ATL · Q4 · 1.2",
                        "action": "Follow live",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story"
                    },
                    "interaction": {
                        "destination": {
                            "type": "story-snapshot",
                            "id": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9@2026-04-07T01:35:00Z",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open The whole night from inside State Farm Arena."
                    },
                    "review": {
                        "candidateId": "nyk-atl-live-story-snapshot",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "follow the live narrative",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "story-slice",
                        "sourceId": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9",
                        "destinationType": "story-snapshot"
                    },
                    "order": 0,
                    "kind": "story-snapshot"
                },
                {
                    "id": "phi-sas-all-access-story",
                    "label": "PHI @ SAS · at-anchor",
                    "availableAtUtc": "2026-04-07T01:35:00Z",
                    "display": {
                        "id": "phi-sas-all-access-story",
                        "unitType": "story-slice",
                        "eyebrow": "FOLLOW LIVE",
                        "headline": "From the tunnel to San Antonio’s nine-point lead.",
                        "dek": "See arrivals, warmups, crowd atmosphere and live action at Frost Bank Center.",
                        "scoreLockup": "PHI 65–74 SAS · Q3 · 8:17",
                        "action": "Follow live",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story"
                    },
                    "interaction": {
                        "destination": {
                            "type": "story-snapshot",
                            "id": "4701c6e4-c661-46e7-234b-3a2073da5482@2026-04-07T01:35:00Z",
                            "gameId": "0022501146"
                        },
                        "accessibleName": "Open From the tunnel to San Antonio’s nine-point lead."
                    },
                    "review": {
                        "candidateId": "phi-sas-all-access-story",
                        "gameId": "0022501146",
                        "game": "PHI @ SAS",
                        "availabilityPhase": "at-anchor",
                        "editorialJob": "native access destination",
                        "classification": "repackaged-source",
                        "sourceKind": "story",
                        "sourceId": "4701c6e4-c661-46e7-234b-3a2073da5482",
                        "destinationType": "story-snapshot"
                    },
                    "order": 1,
                    "kind": "story-snapshot"
                }
            ],
            "kind": "story-snapshot",
            "displayName": "Story snapshot",
            "legacyCode": "FU-28",
            "definitionRevision": 1
        },
        {
            "code": "FU-29",
            "name": "Specialist / top-plays package",
            "cadence": "Earned",
            "surfaces": [
                "Home",
                "Game Screen Feed"
            ],
            "group": "Open deeper coverage",
            "visual": "story",
            "editorialJob": "Collect one clearly authored viewing job: every three, every assist, a duel, or a team’s top plays.",
            "publishWhen": "After the package is complete and its theme adds more than a generic Player Story.",
            "destination": "Open the exact specialist Story.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Offer a focused replay package with a narrower viewing job than the full game Story.",
                "fields": {
                    "eyebrow": "WATCH MORE or another specific viewing cue.",
                    "headline": "Name the complete package plainly: all threes, one player's plays, one decisive sequence.",
                    "dek": "Add the contributor, record or reason this focused reel matters; do not repeat “all/every.”",
                    "scoreOrBody": "Final or the exact completed boundary that makes the package legal. Structured body is the playable Story itself.",
                    "action": "View story."
                }
            },
            "examples": [
                {
                    "id": "cle-mem-29-threes-story",
                    "label": "CLE @ MEM · post-anchor",
                    "availableAtUtc": "2026-04-07T02:20:00Z",
                    "display": {
                        "id": "cle-mem-29-threes-story",
                        "unitType": "story-package",
                        "eyebrow": "WATCH MORE",
                        "headline": "All 29 Memphis threes",
                        "dek": "Nine Grizzlies contribute to the record-tying total.",
                        "scoreLockup": "CLE 142–126 MEM · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story"
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "65113432-5711-6f04-5748-3a2077f686aa",
                            "gameId": "0022501145"
                        },
                        "accessibleName": "Open All 29 Memphis threes"
                    },
                    "review": {
                        "candidateId": "cle-mem-29-threes-story",
                        "gameId": "0022501145",
                        "game": "CLE @ MEM",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "specialist aftermath package",
                        "classification": "existing-native",
                        "sourceKind": "story-package",
                        "sourceId": "65113432-5711-6f04-5748-3a2077f686aa",
                        "destinationType": "story"
                    },
                    "order": 0,
                    "kind": "story-package"
                },
                {
                    "id": "por-den-portland-25-threes-story",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-portland-25-threes-story",
                        "unitType": "story-package",
                        "eyebrow": "WATCH MORE",
                        "headline": "All 25 Portland threes",
                        "dek": "Camara supplies eight in Portland’s franchise-record shooting night.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story"
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "a9aca63a-6e28-cdb2-0b99-3a20784b9cb4",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open All 25 Portland threes"
                    },
                    "review": {
                        "candidateId": "por-den-portland-25-threes-story",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "specialist aftermath package",
                        "classification": "existing-native",
                        "sourceKind": "story-package",
                        "sourceId": "a9aca63a-6e28-cdb2-0b99-3a20784b9cb4",
                        "destinationType": "story"
                    },
                    "order": 1,
                    "kind": "story-package"
                },
                {
                    "id": "por-den-den-top-plays-story",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-den-top-plays-story",
                        "unitType": "story-package",
                        "eyebrow": "WATCH MORE",
                        "headline": "Denver’s top plays",
                        "dek": "Watch the decisive plays from Denver’s overtime comeback.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story"
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "2f495374-afd6-02f2-6086-3a207848a076",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Denver’s top plays"
                    },
                    "review": {
                        "candidateId": "por-den-den-top-plays-story",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "specialist aftermath package",
                        "classification": "existing-native",
                        "sourceKind": "story-package",
                        "sourceId": "2f495374-afd6-02f2-6086-3a207848a076",
                        "destinationType": "story"
                    },
                    "order": 2,
                    "kind": "story-package"
                }
            ],
            "kind": "story-package",
            "displayName": "Story package",
            "legacyCode": "FU-29",
            "definitionRevision": 1
        },
        {
            "code": "FU-30",
            "name": "Complete Game Story",
            "cadence": "Baseline after final",
            "surfaces": [
                "Stories tray",
                "Home",
                "Game Screen Feed"
            ],
            "group": "Open deeper coverage",
            "visual": "story",
            "editorialJob": "Provide the broad, durable destination for the full game after the live state is complete.",
            "publishWhen": "After final when the exact Story is published and its page set has been read back.",
            "destination": "Open the exact existing Storyteller Game Story.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Open the complete narrative after the game result is official.",
                "fields": {
                    "eyebrow": "GAME STORY.",
                    "headline": "State the result, deciding player or defining reversal; do not inherit a weak native title blindly.",
                    "dek": "Establish the two or three major acts a fan will relive.",
                    "scoreOrBody": "Final score only. Never route the current final bundle from an earlier live unit.",
                    "action": "View story."
                }
            },
            "examples": [
                {
                    "id": "nyk-atl-game-story",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "nyk-atl-game-story",
                        "unitType": "story",
                        "eyebrow": "GAME STORY",
                        "headline": "Knicks Win Thriller In Atlanta",
                        "dek": "Relive Atlanta’s halftime surge, New York’s third-quarter answer and every turn of the finish.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story"
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9",
                            "gameId": "0022501143"
                        },
                        "accessibleName": "Open Knicks Win Thriller In Atlanta"
                    },
                    "review": {
                        "candidateId": "nyk-atl-game-story",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "full-game narrative",
                        "classification": "existing-native",
                        "sourceKind": "story",
                        "sourceId": "381d5fa3-5233-76ec-2aaa-3a20500cc0e9",
                        "destinationType": "story"
                    },
                    "order": 0,
                    "kind": "complete-story"
                },
                {
                    "id": "por-den-game-story",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:49:00Z",
                    "display": {
                        "id": "por-den-game-story",
                        "unitType": "story",
                        "eyebrow": "GAME STORY",
                        "headline": "Denver storms back to beat Portland in overtime.",
                        "dek": "Relive Portland’s record 25 threes and Denver forcing overtime after trailing by 16 in the fourth.",
                        "scoreLockup": "POR 132–137 DEN · FINAL/OT",
                        "action": "View story",
                        "games": null,
                        "media": null
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "story"
                    },
                    "interaction": {
                        "destination": {
                            "type": "story",
                            "id": "38ec1b86-4776-291b-ccf2-3a20500cbfe9",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Denver storms back to beat Portland in overtime."
                    },
                    "review": {
                        "candidateId": "por-den-game-story",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "full-game narrative",
                        "classification": "existing-native",
                        "sourceKind": "story",
                        "sourceId": "38ec1b86-4776-291b-ccf2-3a20500cbfe9",
                        "destinationType": "story"
                    },
                    "order": 1,
                    "kind": "complete-story"
                }
            ],
            "kind": "complete-story",
            "displayName": "Complete Story",
            "legacyCode": "FU-30",
            "definitionRevision": 1
        },
        {
            "code": "FU-31",
            "name": "Winners carousel",
            "cadence": "Earned after finals",
            "surfaces": [
                "Home"
            ],
            "group": "Close the whole night",
            "visual": "gallery",
            "editorialJob": "Close the slate with one visual editorial hierarchy across its defining performers.",
            "publishWhen": "After the relevant finals and source posts are legal; choose one capstone, not a five-card quota.",
            "destination": "Swipe inline; each frame can open its Game Screen Feed.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Turn a set of images into a coherent visual account rather than a photo inventory.",
                "fields": {
                    "eyebrow": "PHOTOS when useful; omit if the visual treatment is self-evident and space is tighter.",
                    "headline": "Name the visual arc, subject or reversal.",
                    "dek": "Name the specific people and turns represented; avoid “frames,” “coverage” and internal abbreviations.",
                    "scoreOrBody": "Retain the exact game state legal for the selected images. The image order must match the promised arc.",
                    "action": "Swipe when the carousel is inline; otherwise use the honest destination action."
                }
            },
            "examples": [
                {
                    "id": "night-winners-carousel",
                    "label": "Whole night · post-anchor",
                    "availableAtUtc": "2026-04-07T04:37:01Z",
                    "display": {
                        "id": "night-winners-carousel",
                        "unitType": "gallery",
                        "eyebrow": null,
                        "headline": "The performances that decided the night.",
                        "dek": "Brunson owns the fourth, Banchero scores 31, Castle posts a triple-double and Jokić completes Denver’s comeback; Schröder helps Cleveland reach 50 wins.",
                        "scoreLockup": "WHOLE NIGHT",
                        "action": "Swipe",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 5
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": "night-winners-carousel",
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "engagement-validated aftermath",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "instagram_3869804119599666314",
                        "destinationType": "inline"
                    },
                    "order": 0,
                    "kind": "winner-gallery"
                },
                {
                    "id": "nyk-atl-gallery",
                    "label": "NYK @ ATL · post-anchor",
                    "availableAtUtc": "2026-04-07T01:38:00Z",
                    "display": {
                        "id": "nyk-atl-gallery",
                        "unitType": "gallery",
                        "eyebrow": null,
                        "headline": "The finish in three frames.",
                        "dek": "NAW’s scoring night, Brunson’s fourth quarter and the final heave in three frames.",
                        "scoreLockup": "NYK 108–105 ATL · FINAL",
                        "action": "Swipe",
                        "games": null,
                        "media": {
                            "type": "gallery",
                            "aspect": "wide",
                            "frameCount": 3
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "gallery"
                    },
                    "interaction": {
                        "destination": {
                            "type": "game-screen",
                            "gameId": "0022501143",
                            "mode": "feed",
                            "entry": "top"
                        },
                        "accessibleName": "Open New York Knicks at Atlanta Hawks game"
                    },
                    "review": {
                        "candidateId": "nyk-atl-gallery",
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "end-of-game gallery",
                        "classification": "repackaged-source",
                        "sourceKind": "getty",
                        "sourceId": "2269586567",
                        "destinationType": "game-companion"
                    },
                    "order": 1,
                    "kind": "winner-gallery"
                }
            ],
            "kind": "winner-gallery",
            "displayName": "Winner gallery",
            "legacyCode": "FU-31",
            "definitionRevision": 1
        },
        {
            "code": "FU-32",
            "name": "Standings snapshot",
            "cadence": "Baseline + official refresh",
            "surfaces": [
                "Home",
                "Game Feed"
            ],
            "group": "Close the whole night",
            "visual": "standings",
            "editorialJob": "Orient the fan to where the night’s teams stand before play, after official results, or within one game.",
            "publishWhen": "Publish the pregame snapshot before the first tip and retain it unchanged; publish a new final snapshot only after the standings source refreshes.",
            "destination": "Inline context; a later implementation can open the complete standings screen.",
            "deliveryStrategy": "Native shared structure with conference groups and a compact two-team mode.",
            "writingGuidance": {
                "overall": "Orient the fan before a game/night or explain how completed results changed the table.",
                "fields": {
                    "eyebrow": "AS IT STANDS pregame/live; a clear postgame label such as AFTER THE NIGHT after all relevant finals.",
                    "headline": "State the matchup stake or largest standings consequence.",
                    "dek": "Add one or two changes not obvious from scanning the rows; do not explain table notation.",
                    "scoreOrBody": "Always show an explicit “as of” boundary. Rows need conference, rank including ties, team, record, percentage and games back; postgame rows may add W/L.",
                    "action": "Usually no action. Add View standings only when there is a real deeper destination."
                }
            },
            "examples": [
                {
                    "id": "night-standings-pregame",
                    "label": "Whole night · before tip",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "night-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "Where tonight’s ten teams stand.",
                        "dek": "Detroit leads the East; San Antonio starts second in the West.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "DET",
                                        "name": "Pistons",
                                        "rank": "1",
                                        "record": "57–21",
                                        "percentage": ".731",
                                        "gamesBack": "—",
                                        "result": null
                                    },
                                    {
                                        "code": "NYK",
                                        "name": "Knicks",
                                        "rank": "3",
                                        "record": "50–28",
                                        "percentage": ".641",
                                        "gamesBack": "7",
                                        "result": null
                                    },
                                    {
                                        "code": "CLE",
                                        "name": "Cavaliers",
                                        "rank": "4",
                                        "record": "49–29",
                                        "percentage": ".628",
                                        "gamesBack": "8",
                                        "result": null
                                    },
                                    {
                                        "code": "ATL",
                                        "name": "Hawks",
                                        "rank": "5",
                                        "record": "45–33",
                                        "percentage": ".577",
                                        "gamesBack": "12",
                                        "result": null
                                    },
                                    {
                                        "code": "PHI",
                                        "name": "76ers",
                                        "rank": "6",
                                        "record": "43–35",
                                        "percentage": ".551",
                                        "gamesBack": "14",
                                        "result": null
                                    },
                                    {
                                        "code": "ORL",
                                        "name": "Magic",
                                        "rank": "9",
                                        "record": "42–36",
                                        "percentage": ".538",
                                        "gamesBack": "15",
                                        "result": null
                                    }
                                ]
                            },
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "SAS",
                                        "name": "Spurs",
                                        "rank": "2",
                                        "record": "59–19",
                                        "percentage": ".756",
                                        "gamesBack": "3",
                                        "result": null
                                    },
                                    {
                                        "code": "DEN",
                                        "name": "Nuggets",
                                        "rank": "T3",
                                        "record": "50–28",
                                        "percentage": ".641",
                                        "gamesBack": "12",
                                        "result": null
                                    },
                                    {
                                        "code": "POR",
                                        "name": "Trail Blazers",
                                        "rank": "T8",
                                        "record": "40–38",
                                        "percentage": ".513",
                                        "gamesBack": "22",
                                        "result": null
                                    },
                                    {
                                        "code": "MEM",
                                        "name": "Grizzlies",
                                        "rank": "T11",
                                        "record": "25–53",
                                        "percentage": ".321",
                                        "gamesBack": "37",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "pregame",
                        "editorialJob": "night standings orientation",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "standings",
                        "sourceId": "nba-2026-04-06-standings-snapshots",
                        "destinationType": "inline"
                    },
                    "order": 0,
                    "kind": "standings"
                },
                {
                    "id": "night-standings-final",
                    "label": "Whole night · after finals",
                    "availableAtUtc": "2026-04-07T04:46:01Z",
                    "display": {
                        "id": "night-standings-final",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "San Antonio reaches 60. Denver takes third.",
                        "dek": "Orlando climbs into a three-way tie for seventh in the East.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "After the last final · 12:46 a.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "DET",
                                        "name": "Pistons",
                                        "rank": "1",
                                        "record": "57–22",
                                        "percentage": ".722",
                                        "gamesBack": "—",
                                        "result": "L"
                                    },
                                    {
                                        "code": "NYK",
                                        "name": "Knicks",
                                        "rank": "3",
                                        "record": "51–28",
                                        "percentage": ".646",
                                        "gamesBack": "6",
                                        "result": "W"
                                    },
                                    {
                                        "code": "CLE",
                                        "name": "Cavaliers",
                                        "rank": "4",
                                        "record": "50–29",
                                        "percentage": ".633",
                                        "gamesBack": "7",
                                        "result": "W"
                                    },
                                    {
                                        "code": "ATL",
                                        "name": "Hawks",
                                        "rank": "5",
                                        "record": "45–34",
                                        "percentage": ".570",
                                        "gamesBack": "12",
                                        "result": "L"
                                    },
                                    {
                                        "code": "ORL",
                                        "name": "Magic",
                                        "rank": "T7",
                                        "record": "43–36",
                                        "percentage": ".544",
                                        "gamesBack": "14",
                                        "result": "W"
                                    },
                                    {
                                        "code": "PHI",
                                        "name": "76ers",
                                        "rank": "T7",
                                        "record": "43–36",
                                        "percentage": ".544",
                                        "gamesBack": "14",
                                        "result": "L"
                                    }
                                ]
                            },
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "SAS",
                                        "name": "Spurs",
                                        "rank": "2",
                                        "record": "60–19",
                                        "percentage": ".759",
                                        "gamesBack": "2.5",
                                        "result": "W"
                                    },
                                    {
                                        "code": "DEN",
                                        "name": "Nuggets",
                                        "rank": "3",
                                        "record": "51–28",
                                        "percentage": ".646",
                                        "gamesBack": "11.5",
                                        "result": "W"
                                    },
                                    {
                                        "code": "POR",
                                        "name": "Trail Blazers",
                                        "rank": "9",
                                        "record": "40–39",
                                        "percentage": ".506",
                                        "gamesBack": "22.5",
                                        "result": "L"
                                    },
                                    {
                                        "code": "MEM",
                                        "name": "Grizzlies",
                                        "rank": "T12",
                                        "record": "25–54",
                                        "percentage": ".316",
                                        "gamesBack": "37.5",
                                        "result": "L"
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "postgame",
                        "editorialJob": "night standings orientation",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "standings",
                        "sourceId": "nba-2026-04-06-standings-snapshots",
                        "destinationType": "inline"
                    },
                    "order": 1,
                    "kind": "standings"
                },
                {
                    "id": "0022501143-standings-pregame",
                    "label": "NYK @ ATL · before tip",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "0022501143-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "Two top-five East teams meet in Atlanta.",
                        "dek": "New York can strengthen its hold on third; Atlanta is protecting a top-six place.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "NYK",
                                        "name": "Knicks",
                                        "rank": "3",
                                        "record": "50–28",
                                        "percentage": ".641",
                                        "gamesBack": "7",
                                        "result": null
                                    },
                                    {
                                        "code": "ATL",
                                        "name": "Hawks",
                                        "rank": "5",
                                        "record": "45–33",
                                        "percentage": ".577",
                                        "gamesBack": "12",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "pregame",
                        "editorialJob": "game standings context",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "standings",
                        "sourceId": "nba-2026-04-06-standings-snapshots",
                        "destinationType": "inline"
                    },
                    "order": 2,
                    "kind": "standings"
                },
                {
                    "id": "0022501143-standings-final",
                    "label": "NYK @ ATL · after final",
                    "availableAtUtc": "2026-04-07T04:46:01Z",
                    "display": {
                        "id": "0022501143-standings-final",
                        "unitType": "standings",
                        "eyebrow": "AFTER THE NIGHT",
                        "headline": "New York tightens its grip on third.",
                        "dek": "The win moves the Knicks one game closer to Detroit; Atlanta stays fifth.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "After the last final · 12:46 a.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "EAST",
                                "rows": [
                                    {
                                        "code": "NYK",
                                        "name": "Knicks",
                                        "rank": "3",
                                        "record": "51–28",
                                        "percentage": ".646",
                                        "gamesBack": "6",
                                        "result": "W"
                                    },
                                    {
                                        "code": "ATL",
                                        "name": "Hawks",
                                        "rank": "5",
                                        "record": "45–34",
                                        "percentage": ".570",
                                        "gamesBack": "12",
                                        "result": "L"
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501143",
                        "game": "NYK @ ATL",
                        "availabilityPhase": "postgame",
                        "editorialJob": "game standings context",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "standings",
                        "sourceId": "nba-2026-04-06-standings-snapshots",
                        "destinationType": "inline"
                    },
                    "order": 3,
                    "kind": "standings"
                },
                {
                    "id": "0022501147-standings-pregame",
                    "label": "POR @ DEN · before tip",
                    "availableAtUtc": "2026-04-06T22:55:00Z",
                    "display": {
                        "id": "0022501147-standings-pregame",
                        "unitType": "standings",
                        "eyebrow": "AS IT STANDS",
                        "headline": "Two Western races frame the late game.",
                        "dek": "Denver starts tied for third; Portland starts tied for eighth.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "Before the first tip · 6:55 p.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "DEN",
                                        "name": "Nuggets",
                                        "rank": "T3",
                                        "record": "50–28",
                                        "percentage": ".641",
                                        "gamesBack": "12",
                                        "result": null
                                    },
                                    {
                                        "code": "POR",
                                        "name": "Trail Blazers",
                                        "rank": "T8",
                                        "record": "40–38",
                                        "percentage": ".513",
                                        "gamesBack": "22",
                                        "result": null
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "pregame",
                        "editorialJob": "game standings context",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "standings",
                        "sourceId": "nba-2026-04-06-standings-snapshots",
                        "destinationType": "inline"
                    },
                    "order": 4,
                    "kind": "standings"
                },
                {
                    "id": "0022501147-standings-final",
                    "label": "POR @ DEN · after final",
                    "availableAtUtc": "2026-04-07T04:46:01Z",
                    "display": {
                        "id": "0022501147-standings-final",
                        "unitType": "standings",
                        "eyebrow": "AFTER THE NIGHT",
                        "headline": "Denver moves clear in third. Portland slips to ninth.",
                        "dek": "The overtime win breaks Denver’s tie with the Lakers; Portland falls behind the Clippers.",
                        "scoreLockup": null,
                        "action": null,
                        "games": null,
                        "media": null,
                        "standingsAsOf": "After the last final · 12:46 a.m. ET",
                        "standingsGroups": [
                            {
                                "conference": "WEST",
                                "rows": [
                                    {
                                        "code": "DEN",
                                        "name": "Nuggets",
                                        "rank": "3",
                                        "record": "51–28",
                                        "percentage": ".646",
                                        "gamesBack": "11.5",
                                        "result": "W"
                                    },
                                    {
                                        "code": "POR",
                                        "name": "Trail Blazers",
                                        "rank": "9",
                                        "record": "40–39",
                                        "percentage": ".506",
                                        "gamesBack": "22.5",
                                        "result": "L"
                                    }
                                ]
                            }
                        ]
                    },
                    "presentation": {
                        "density": "compact",
                        "layout": "standings"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": null,
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "postgame",
                        "editorialJob": "game standings context",
                        "classification": "net-new-demonstrator",
                        "sourceKind": "standings",
                        "sourceId": "nba-2026-04-06-standings-snapshots",
                        "destinationType": "inline"
                    },
                    "order": 5,
                    "kind": "standings"
                }
            ],
            "kind": "standings",
            "displayName": "Standings",
            "legacyCode": "FU-32",
            "definitionRevision": 1
        },
        {
            "code": "FU-33",
            "name": "Nightly Top 10 video",
            "cadence": "Earned after finals",
            "surfaces": [
                "Home"
            ],
            "group": "Close the whole night",
            "visual": "wide-video",
            "editorialJob": "Provide a single video-first replay of the plays that survived the whole-night edit.",
            "publishWhen": "When the official package is complete and chronologically legal at the selected end checkpoint.",
            "destination": "Play inline with optional full-screen video.",
            "deliveryStrategy": "Native media shell using the source asset or Storyteller surface; keep playback and destination behavior native.",
            "writingGuidance": {
                "overall": "Present a playable video or ranked video collection whose meaning is clear without format chrome.",
                "fields": {
                    "eyebrow": "Omit VIDEO; use a basketball label only if it adds meaning.",
                    "headline": "Name the play, player or collection.",
                    "dek": "Add the consequence or the other plays that earn a collection; let obvious motion speak for format.",
                    "scoreOrBody": "A single live Clip requires exact-play state; otherwise use null. A completed nightly collection may use a whole-night state.",
                    "action": "Usually no inline action because tapping the video is the action; use a specific destination label only when separate."
                }
            },
            "examples": [
                {
                    "id": "night-top-ten-video",
                    "label": "Whole night · post-anchor",
                    "availableAtUtc": "2026-04-07T05:22:53Z",
                    "display": {
                        "id": "night-top-ten-video",
                        "unitType": "source-video",
                        "eyebrow": null,
                        "headline": "The night’s top ten",
                        "dek": "Jalen Johnson’s dunk and Jokić’s no-look baseball pass lead the countdown.",
                        "scoreLockup": "WHOLE NIGHT",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "wide",
                            "likes": null,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "inline"
                        },
                        "accessibleName": null
                    },
                    "review": {
                        "candidateId": "night-top-ten-video",
                        "gameId": null,
                        "game": "Whole night",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "engagement-validated aftermath",
                        "classification": "repackaged-source",
                        "sourceKind": "social",
                        "sourceId": "youtube_6X_qBZPoWg4",
                        "destinationType": "inline"
                    },
                    "order": 0,
                    "kind": "ranked-video-recap"
                },
                {
                    "id": "por-den-jokic-ot-clip",
                    "label": "POR @ DEN · post-anchor",
                    "availableAtUtc": "2026-04-07T03:54:15.5547311Z",
                    "display": {
                        "id": "por-den-jokic-ot-clip",
                        "unitType": "clip",
                        "eyebrow": null,
                        "headline": "Jokić pushes Denver seven clear in overtime.",
                        "dek": "His 35-point triple-double has the Nuggets closing on a ninth straight win.",
                        "scoreLockup": "POR 130–137 DEN · OT · 1:26",
                        "action": null,
                        "games": null,
                        "media": {
                            "type": "video",
                            "aspect": "portrait",
                            "likes": 53,
                            "shares": null
                        }
                    },
                    "presentation": {
                        "density": "comfortable",
                        "layout": "wide-video"
                    },
                    "interaction": {
                        "destination": {
                            "type": "clip",
                            "id": "8b5b797c-1747-17f3-a784-3a2078407463",
                            "gameId": "0022501147"
                        },
                        "accessibleName": "Open Jokić pushes Denver seven clear in overtime. in the full-screen player"
                    },
                    "review": {
                        "candidateId": "por-den-jokic-ot-clip",
                        "gameId": "0022501147",
                        "game": "POR @ DEN",
                        "availabilityPhase": "post-anchor",
                        "editorialJob": "this just happened",
                        "classification": "existing-native",
                        "sourceKind": "clip",
                        "sourceId": "8b5b797c-1747-17f3-a784-3a2078407463",
                        "destinationType": "clip"
                    },
                    "order": 1,
                    "kind": "ranked-video-recap"
                }
            ],
            "kind": "ranked-video-recap",
            "displayName": "Ranked video recap",
            "legacyCode": "FU-33",
            "definitionRevision": 1
        }
    ]
};
